import { Component, OnInit, ElementRef, Input, ViewChild, HostListener, Renderer2 } from '@angular/core';
import { TaskService } from 'src/app/services/task.service';
import * as Cesium from 'cesium';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as JSZipUtils from '../../../assets/script/jszip-utils.js';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
var turf = require('@turf/turf');
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSelect } from '@angular/material/select';
import { PopupService } from 'src/app/services/popup.service';
import { DownloadService } from 'src/app/services/download.service';
import { Subscription, firstValueFrom, forkJoin } from 'rxjs';
import { ANNOTATION, OPERATORS, POINT_TASKING, feedsConfig, VESSEL_PREDICTION, SOIL_MOISTURE_SAR_CLASS_MAP  } from 'src/app/services/constants';
import { BehaviorSubject } from 'rxjs';
import TIFFImageryProvider from 'tiff-imagery-provider';
import { DatePipe, formatDate, NgIf } from '@angular/common';
import html2canvas from 'html2canvas';
import { ReturnRefundComponent } from './return-refund/return-refund.component';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { ThemeService } from 'src/app/services/theme.service';
import { FilterPopupComponent } from './filter-popup/filter-popup.component';
import ScreenSpaceEventHandler from 'cesium/Source/Core/ScreenSpaceEventHandler';
import { WarningPopupComponent } from './warning-popup/warning-popup.component';
import { MatSlider, MatSliderChange } from '@angular/material/slider';
import { CreateTaskConfirmDialog } from './confirm-dialog/confirmdialog';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { UtilsService } from 'src/app/services/utils.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ChangeDetectorRef } from '@angular/core';
import {HelperService, FeedSection } from 'src/app/services/helper.service';
import type { FeatureCollection, Feature, Geometry, GeoJsonProperties } from 'geojson';

type FeatureProps = GeoJsonProperties & { _color?: string };
type FeedCache = { fc: FeatureCollection<Geometry, FeatureProps>; type?: string; color?: string; title: string };
import { GeoJsonDataSource, ColorGeometryInstanceAttribute, PolygonGeometry, GeometryInstance, Primitive } from 'cesium';
import { NCCI_DATA, NDRE_DATA,NDVI_DATA } from '../shared/constants/indices-color.constants';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { geoJsonToHierarchies } from '../shared/utils/geojson-polygon-hierarchy';
import { CollectionPopupComponent } from '../shared';
import { createCircleIcon } from '../shared/utils/circle-icon-service';
interface LegendItem {
  color: string;
  value?: number;
}

interface LegendData {
  minValue: number;
  maxValue: number;
  items: LegendItem[];
}

interface CustomEntity extends Cesium.Entity {
  isOriginal?: boolean;
  type?: string;
}

interface CustomGeoJsonDataSource extends Cesium.GeoJsonDataSource {
  type?: any;
  sensorId?: string;
  sceneId?: string;
  refreshId?: string;
}

interface AnnotatedDivElement extends HTMLDivElement {
  sceneId?: string;
}

interface FilterCriteria {
  destination?: string;
  flag?: string;
  length?: any;
  isGreater?: boolean;
  vesselType?: string;
  vesselSpeed?:any;
  isSpeedGreater?: boolean;
  vesselName?: string;
  MMSI?: any;
  IMO?: any;
}
interface Prediction {
  name: string;
  refreshId: string;
  vessel: string;
  mmsi: number;
  checked?: boolean;
}


type FeedPanel = { title: string; color?: string; sections: FeedSection[] };

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss']
})
export class CollectionsComponent implements OnInit {
  vessel =false;
  nonVesselFeeds: string[] = ['Flood extent - SAR', 'Tree crown detection and count',
    'Deforestation detection and area', 'Oil spill detection', 'Plantation blank spot detection - optical'
  ];
  offset = 0.01;
  opportunityId: any;
  feasibilityArray: any = [];
  selectedSites: any = [];
  projectSelected: any;
  dateRange: boolean = false;
  metaDataTooltip: any;
  taskSelected: boolean = false;
  uslBB: any;
  uslBBList: any = [];
  USLscnLyr: any = [];
  SpirescnLyr: any = [];
  RF: boolean = false;
  sceneBands: any;
  signalBands: any;
  bandTaskId: any;
  bandSensorId: any;
  signalSensorId: any;
  bandSelected: string = 'both';
  selectedStartDate: any;
  selectedEndDate: any;
  recurrentTask: boolean = false;
  isInIframe: boolean;
  sensorsIS: boolean = true;
  sceneSelected: any;
  leftBand: boolean = false;
  rightBand: boolean = false;
  taskCreatedDate: any;
  displayedIS: any;
  spire: boolean = false;
  sliderSelected: any;
  AISdata: boolean;
  imageLoaded: boolean = false;
  currentLongitude: number;
  currentLatitude: number;
  annotateClicked: boolean = false;
  currentTaskId: any;
  currentSensorId: any;
  sceneId: any;
  recurrentSlider: boolean = false;
  selectedMetric: string = 'kg';
  sourceRateArray: any = [];
  usl: boolean = false;
  imageryLayerMap = new Map();
  boundingBoxMap = new Map();
  datePlace: boolean = false;
  monthSelected: any;
  siteSelected: any;
  selectedSite: any;
  selecetedData: any;
  selectedDropdownType: string;
  currentCollectionIndex: any;
  currentSensorIndex: any;
  currentSceneIndex: any;
  currentEvent: { checked: boolean; };
  currentType: any;
  currentTask: any;
  currentSites: any;
  selectedType: any;
  dateDisable: boolean = false;
  downloadTooltip: any = '';
  tooltipDisabled: boolean = true;
  downloadedImage: string;
  createNewTaskHandler: any;
  selectedScene: any;
  noScene: boolean = true;
  audioAvailable: boolean = false;
  currentRfSignals: any = [];
  sensorLength: number = 0;
  selectedRecurrencyArray: any;
  demoView: boolean = false;
  dateSelected: boolean;
  feedInfo: boolean = false;
  feedSections: FeedSection[] = [];
  combinedFeedSections: FeedSection[] = [];
  feedData: string;
  legendContainer = document.getElementById('legend-container');
  currentSignal: any;
  filterStart: any;
  filterEnd: any;
  oilSpil: boolean;
  selectedOperator: any;
  shipTypes: { type: string; color: string; }[];
  displayedSpireData: any;
  spireJsonData: any;
  spireSensorId: any;
  vesselFilter: boolean;
  filterObject: any;
  refreshData: boolean;
  refreshFilterObject: any;
  lastVisibleEntities: any[] = [];
  toggleOptions(select: MatSelect): void {
    select.open();
  }
  isFirst = true;
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource: any[] = [];
  tableDataLength = 0;
  color = '#1059a9';
  CARTDATA: any[] = [];
  isVisible = false;
  expandedElement: any | null;
  currentUser: any;
  curOption: any;
  NAVLISTRT: any;
  tasktabs: any;
  tasksCount: any;
  userid: any;
  selectedSensors: any = [];
  selectedCost = 0;
  length = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [10, 20, 50];
  showFirstLastButtons = true;
  interval: any;
  refreshCount = 0;
  roll: any = 0;
  leftLayer: any;
  rightLayer: any;
  activeSliderLayer = null;
  preStatus = '00Nolayer';
  layer = 0;
  curStatus = '';
  imgLyrIndx = -1;
  baseLayer: any;
  hs: any;
  imageryViewModels: any = [];
  terrainViewModels = [];
  baseLayers: any = [];
  sliderLayers: any = [];
  showMe = true;
  @Input() accept = '.topojson, .geojson, .kml';
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('bandSelect') bandSelect: MatSelect;
  @ViewChild('slider') slider: MatSlider;
  fileAttr = 'Choose File';
  acceptFile = '.topojson, .geojson, .kml';
  selectedItems = 0;
  selectedSubDailyItems: any = [];
  selectedSubDailyItemValue = 1;
  collections: any;
  checked = true;
  drawingOn = false; // AT21 = false; satllogic = false;
  viewer: any;
  viewer2: any;
  scene: any;
  longLatStr: string = '';
  compassOverlay: any;
  latlonOverlay: any = document.createElement('div');
  sliderOverlay: any;
  acc: any;
  satEntity: any;
  datafile: any;
  imgUrls: any;
  dataForm: FormGroup | any;
  options: any;
  LEFTOPTIONS: any = [];
  RIGHTOPTIONS: any = [];
  selectedLeft: string;
  selectedRight: string;
  baseAlpha: any;
  FP: any;
  metadata: any;
  jump = false;
  panelOpenState = false;
  isExpanded: boolean[] = [];
  previousSelectionText: any = null;
  previousEndText: any = null;
  subDailyCount: any = null
  previousSelection: any = null;
  previousSelectedProject: any = null;
  previousSelectedTask: any = null;
  downloadedScene: any = [];
  downloadedSensor: any = [];
  refundRequestScenes: any = [];
  infoserviceModelType = 'feature extraction';
  nonImageryKey: string[] = [
    'Spire-RF',
    'USL',
    'Spire',
    'ClydeSpace'
  ]

  BASELAYERS = [
    {
      name: 'Bing Maps Aerial',
      url : new Cesium.ProviderViewModel({
        name: 'Bing Maps Aerial',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingAerial.png'
        ),
        tooltip: 'Bing Maps Aerial',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 2 });
        },
      })
    },
    {
      name: 'Sentinel-2',
      url: new Cesium.ProviderViewModel({
        name: 'Sentinel-2',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/sentinel-2.png'
        ),
        tooltip: 'Sentinel-2 cloudless',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3954 });
        },
      }),
    },
    {
      name: 'Natural Earth',
      url: new Cesium.ProviderViewModel({
        name: 'Natural Earth',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/naturalEarthII.png'
        ),
        tooltip: 'Blue Marble Next Generation July, 2004 imagery from NASA.',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3813 });
        },
      }),
    },
    {
      name: 'Bing Maps Road',
      url: new Cesium.ProviderViewModel({
        name: 'Bing Maps Road',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingRoads.png'
        ),
        tooltip: 'Bing Maps Road',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 4 });
        },
      }),
    },
    {
      name: 'OSM',
      url: new Cesium.ProviderViewModel({
        name: 'OpenStreetMap',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/openStreetMap.png'
        ),
        tooltip: 'Open Street Map.',
        creationFunction: function () {
          return new Cesium.OpenStreetMapImageryProvider({
            url: 'https://a.tile.openstreetmap.org/',
          });
        },
      }),
    },
  ];
  scnLyr: any = [];
  scnLyr2: any = [];
  collectionsData: any = undefined;
  collection: any;
  subDailyArray: any = [];
  subDailyFinalArray: any = [];
  sensorList: any
  collectionIndex: any;
  taskName: any;
  taskid: any;
  taskUuid: any;
  splitPosition: number;
  overlay: any = [100, 100];
  baseOverlay: any = 100;
  projectData: any;
  projectName: any;
  fail: number;
  cesiumToken: any;
  recurrencyOption: any;
  progress: any = 0;
  progressSubscription: Subscription;
  disable: boolean = true;
  freeze: boolean = false;
  mapLoad: boolean = false;
  fullCollection: any;
  filteredCollection: any = [];
  defaultSubdailyCount = 1;
  subDailyCountarray: any = [];
  OPERATOR: any;
  downloadObj: any;
  downloadClick: boolean;
  operatorArray: any = [];
  showDailyRecurrencyCheckboxes: boolean = false;
  maxSelections = 2;
  recurrencyArray: any = [];
  selectedValueSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedSensorSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedcompareSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedValue$ = this.selectedValueSubject.asObservable();
  selectedSensor$ = this.selectedSensorSubject.asObservable();
  selectedcompare$ = this.selectedcompareSubject.asObservable();
  selectedCheckboxes: any = [];
  SensorIndex: any = 0;
  selectionChange = new BehaviorSubject<any>('');
  subSelectionSelectionChange = new BehaviorSubject<any>('');
  selection: string = '14/06/2023 - 20/06/2023';

  selectionLabel: any = null;
  selectionLabelEnd: any = null;
  selectionLabels: any = '14/06/2023 - 20/06/2023';
  selectedSubdaily: any;
  selectedIndex: any = 0;
  left = 65;
  entitywidth1 = 65;
  entitywidth2 = 65;
  isDragging = false;
  initialX: number;
  initialY: number;
  public emissionMessage: string = '';
  showSubDailyList = false
  splitRightPostion = false
  splitLeftPostion = false
  taskCollection: any;
  selectedIS: boolean[] = [];
  selectedBand = 'X band';
  legendData: LegendData;
  ghglegend: string;
  scaleArray: any = [];
  legendColor: string;
  restoreRequestedSensors: any = [];
  darkTheme: boolean;
  tooltipImagePath: string;
  downloadImage: string;
  refundImage: string;
  feedLoaded: boolean = false;
  vesselData: any;
  timestamps: string[] = [];
  selectedData: any;
  sliderShow: boolean = false;
  days: number = 0;
  dateRangeArray: any[] = [];
  historicalVesselData: any[] = [];
  currentDataSources: { [key: string]: Cesium.GeoJsonDataSource | Cesium.CustomDataSource } = {};
  currentVessels: { [key: string]: Cesium.GeoJsonDataSource } = {};
  currentClydeVessels: { [key: string]: Cesium.GeoJsonDataSource } = {};
  previousIndex: number = -1;
  handler: ScreenSpaceEventHandler;
  handlers: ScreenSpaceEventHandler;
  rfHandler: ScreenSpaceEventHandler;
  signalhHandlers: ScreenSpaceEventHandler;
  audioClickHandler: ScreenSpaceEventHandler;
  imageType: string = 'png';
  clickedEntity: any = null;
  sliderView: boolean = false;
  timeseries: boolean = false;
  groupedScenes: any;
  sliderDateRangeArray: any[] = [];
  overlayVessel: any;
  currentIndex = 0;
  currentSliderValue: number = 0;
  overlayClydeVessel: any;
  activePopups: { entity: any, element: HTMLElement }[] = [];
  activeTooltips: any[] = [];
  private lastAnnotation: Cesium.Entity | null = null;
  private lastTooltip: HTMLDivElement | null = null;
  newTaskButtonClicked: boolean = false;
  selectedOptions: any[] = []; // Value added option
  currentProductLayer:any;
  currentEntity = null;
  currentDownloadingVADP: any;
  refundRequestVADP: any = [];
  audio = new Audio(); // Create an Audio object
  signalSelected: any = 'All';
  colorCode = {
    'ClydeSpace': 'Orange',
    'USL': 'Red',
    'Spire': 'Red',
    'Spire-RF': 'Yellowgreen'
  };
  recurrentColorCode = {
    0: 'YELLOWGREEN',
    1: 'ROSYBROWN',
  };
  refreshHistoryColor = {
    'ClydeSpace': 'Orange',
    'Spire': 'Red'
  };
  

  refundRequestSR: any = [];
  currentDownloadingSR:any;
  selectedSR:any = null;
  currentDownloadingIndices:any;
  selectedIndices:any = null;
  selectedRecurrency: any = null;
  refreshHandler: ScreenSpaceEventHandler;
  blankspot: boolean = false
  blankspotCount: any;
  blankspotArea: any;
  mouseMoveHandler: Cesium.ScreenSpaceEventHandler;
  ObservationValue: any;
  observationEnabled: boolean = false;
  checkedObservation: boolean = false;
  private hasZoomedToObservation = false;
  
  prediction: boolean = false;
  predictedVesselData: any;
  groupedVessels: { [key: string]: any[] } = {};
  pastPrediction:boolean = false;
  selectedPredictionId: string | null = null;
  progressing:boolean = false;
  loadCombinedFeed: boolean = false;
  ndreData: any = NDRE_DATA;
  ndviData: any = NDVI_DATA;

  checkedScenes :any ;
  private _selectedHistory: any = {};
  private observationMarkerEntities: Cesium.Entity[] = [];
  private geoByFeed = new Map<string, FeedCache>();
  private activeFeedKeys = new Set<string>();
  private isLayers = new Map<string, Cesium.DataSource>();   // you already use this
  private feedPanels = new Map<string, FeedPanel>();   
  private currentFilterDs?: Cesium.DataSource;  
  private getCollectionSub?: Subscription;
  

  private feedTitleOf(config?: { type?: string }, fallback?: string) {
    return fallback || config?.type || 'Information Service';
  }
  lastPosition: Cesium.Cartesian3 | null = null;
  positionVessel: any = [];
  private pathMemory: { [date: string]: Cesium.Cartesian3 } = {};
  private predictionSubscription: Subscription | null = null;
  predictionLastPoint: { lat: number; lon: number } | null = null;
  private observationMarkerEntity: Cesium.Entity | null = null;
  pastVesselData: any;
  previousLat: any;
  previousLon: any;
  livePreviousLat: any;
  livePreviousLon: any;
  livePredictedVesselData: any;
  ncciData: any = NCCI_DATA;
  constructor(
    private httpClient: HttpClient,
    private taskService: TaskService,
    private apiService: ApiService,
    private el: ElementRef,
    private fb: FormBuilder,
    private spinnerService: NgxSpinnerService,
    private popupService: PopupService,
    private downloadService: DownloadService,
    private renderer: Renderer2,
    private datePipe: DatePipe,
    private matdialog: MatDialog,
    private localStorageService: DataService,
    private themeService: ThemeService,
    private dialog: MatDialog,
    private authService: AuthService,
    private userService: UserService,
    private utilsService: UtilsService,
    private cdr: ChangeDetectorRef,
    private helperService: HelperService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    
    if (environment.demoView === 'true') {
      this.demoView = true;
    } else {
      this.demoView = false;
    }
    this.authService.getCurrentUser();
    const castUser = this.authService.castCurrentUser.subscribe(
      async (res: any) => {
        this.currentUser = await res;
        castUser.unsubscribe();
        this.loadUserDetails(this.currentUser?.id);
      }
    );
    this.iconRegistry.addSvgIcon(
    'navigation-dashed',
    this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/circle-yellow-green.png')
  );

    this.cesiumToken = environment.cesiumAccessToken;
    this.OPERATOR = OPERATORS;
    this.spinnerService.hide();
    this.disable = true;
    this.downloadObj = this.downloadService.getProgress();

    if (this.downloadObj?.progress && this.downloadObj?.downloadClick) {
      this.progress = this.downloadObj?.progress;
      this.downloadProgress(this.downloadObj);
    }
    this.progressSubscription = this.downloadService.getProgressObservable().subscribe(
      progress => {
        this.progress = progress?.progress;
        this.downloadProgress(progress);
      }
    );
    localStorage.removeItem('refund-request');
    localStorage.removeItem('scene-downloaded');
    localStorage.removeItem('restore-request');
    localStorage.removeItem('sensor-downloaded');

    this.isInIframe = this.themeService.isInIframe();

    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

    this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
    this.downloadImage = this.darkTheme ? '../../../assets/images/icon-dark.svg' : '../../../assets/images/icon-img.svg';
    this.refundImage = this.darkTheme ? '../../../assets/images/refund-dark.png' : '../../../assets/images/refund.png';
    this.downloadedImage = this.darkTheme ? '../../../assets/images/cloud_done_dark.svg' : '../../../assets/images/cloud_done.svg';
    });
  }

  get selectedHistory(): any {
    return this._selectedHistory;
  }

  set selectedHistory(value: any) {
    this._selectedHistory = value;
    if( this.ObservationValue && this.checkedObservation){
      this.renderObservation(this.ObservationValue);
    }
  }

  ngOnInit(): void {
this.progressing = false;
    this.selectionChange.subscribe((selectedValue: any) => {
      if (selectedValue && selectedValue?.start) {
        const start = this.formatDate(new Date(selectedValue?.start))
        const end = this.formatDate(new Date(selectedValue?.end));
        const combinedDate = `${start} - ${end}`;
        this.selectionLabel = new Date(selectedValue?.start);
        this.selectionLabelEnd = new Date(selectedValue?.end);
        this.selectionLabels = combinedDate;
      }

    });
    this.subSelectionSelectionChange.subscribe((selectedValue: any) => {
      this.selectedSubDailyItemValue = selectedValue
    });
    localStorage.removeItem('taskData');

    this.compassOverlay = document.getElementById('compass');
    this.baseLayers = [];
    this.baseAlpha = 1;
    this.BASELAYERS.forEach((elem) => {
      this.baseLayers.push(elem);
      this.imageryViewModels.push(elem.url);
    });
    this.dataForm = this.fb.group({
      datafile: ['', [Validators.required]],
    });
    var west = 40.0;
    var south = -20.0;
    var east = 120.0;
    var north = 70.0;
    var rectangle = Cesium.Rectangle.fromDegrees(west, south, east, north);
    Cesium.Ion.defaultAccessToken = this.cesiumToken;
    Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;
    Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;

    //Sentinel data
    // const worldTerrain =  Cesium.createWorldTerrain();
    const worldTerrain = Cesium.createWorldTerrain({ requestWaterMask: false }); 
    var credit = new Cesium.Credit(
      "<a style='padding-left: 3px; display:none;' class='credit'  target='_blank' href='https://tasking.eartheye.space'><img width='120px' src='assets/images/white-logo.png' alt='EarthEye'></a>"
    );
    const cesiumContainerNew = document.createElement('div');

    cesiumContainerNew.id = 'cesiumContainer1';
    document.getElementsByTagName('body')[0].appendChild(cesiumContainerNew);
    var credit = new Cesium.Credit(
      "<a style='padding-left: 3px' class='credit' target='_blank' href='https://tasking.eartheye.space'><img width='120px' src='assets/images/white-logo.png' alt='EarthEye'></a>"
    );




    // Fit a SingleTileImageryProvider inside the cutout on the lowest layer




    const viewer = new Cesium.Viewer('cesiumContainer1', {
      imageryProviderViewModels: this.imageryViewModels,
      terrainProviderViewModels: [],
      // imageryProvider: baseLayer,
      // terrainExaggeration: 2.0,
      // terrainProvider: worldTerrain,
      baseLayerPicker: true,
      geocoder: true,
      homeButton: true,
      // navigationHelpButton: false,
      fullscreenButton: true,
      selectionIndicator: true,
      shouldAnimate: true,
      animation: false,
      timeline: false,
      sceneModePicker: true,
      sceneMode: Cesium.SceneMode.SCENE2D,
    });

    this.viewer = viewer
    this.viewer.scene.globe.depthTestAgainstTerrain = true;
    this.viewer.scene.globe.enableLighting = true;

    const homeButton = this.el.nativeElement.querySelector('.cesium-home-button');
           
    if (homeButton) {
      this.renderer.listen(homeButton, 'click',  () => {        
        this.zoomToLocation();
      });
    }

    this.options = {
      camera: this.viewer.scene.camera,
      canvas: this.viewer.scene.canvas,
    };
    this.showLatLon();
    this.sliderOverlay = document.getElementById('slider');
    this.acc = document.getElementsByClassName('accordion');

    this.sliderOverlay.id = 'slider';
    this.sliderOverlay.className = 'noSlider';
    this.sliderOverlay.style['z-index'] = '0';
    this.viewer.container.appendChild(this.sliderOverlay);

    this.scene = this.viewer.scene;
    if (!this.scene.pickPositionSupported) {
      window.alert('This browser does not support pickPosition.');
    }

    if (!this.isInIframe) {
    this.viewer.scene.frameState.creditDisplay.addDefaultCredit(credit);
    }

    this.viewer.imageryProviderViewModels = this.imageryViewModels;

    this.options = {
      camera: this.viewer.scene.camera,
      canvas: this.viewer.scene.canvas,
    };
    this.showLatLon();
    this.sliderOverlay = document.getElementById('slider');
    this.acc = document.getElementsByClassName('accordion');
    this.sliderOverlay.id = 'slider';
    this.sliderOverlay.className = 'noSlider';
    this.sliderOverlay.style['z-index'] = '0';
    this.scene = this.viewer.scene;
    if (!this.scene.pickPositionSupported) {
      window.alert('This browser does not support pickPosition.');
    }

    if (!this.isInIframe) {
    this.viewer.scene.frameState.creditDisplay.addDefaultCredit(credit);
    }
    // For split screen
    const slider = document.getElementById('sliders') as HTMLCanvasElement;
    this.splitPosition = slider!.offsetLeft / slider!.parentElement!.offsetWidth
    viewer.scene.splitPosition = slider!.offsetLeft / slider!.parentElement!.offsetWidth;
    let handler = new Cesium.ScreenSpaceEventHandler(slider);


    let moveActive: boolean = false;

    let move = ((movement: any) => {
      const rightDiv = document.getElementsByClassName("split-heading-right");
      const leftDiv = document.getElementsByClassName("split-heading-left");
      const spliterDiv = document.getElementsByClassName("slider");

      if (!moveActive)
        return;
      const relativeOffset = movement.endPosition.x;

      if (slider.offsetLeft + relativeOffset >= 0 && slider.offsetLeft + relativeOffset <= slider!.parentElement!.offsetWidth) {

        const splitPosition = (slider.offsetLeft + relativeOffset) / slider.parentElement!.offsetWidth;
        slider.style.left = `${100.0 * splitPosition}%`;
        this.splitPosition = splitPosition;
        viewer.scene.splitPosition = splitPosition;

        // Hide or show entities based on split position

        if (viewer.scene.splitPosition > 0.5) {
          // Hide entities for the left side
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = true;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = false;
          }

          const rect1 = spliterDiv[0]?.getBoundingClientRect();
          const rect2 = leftDiv[0]?.getBoundingClientRect();
          if (((rect1?.left === 0 || rect1?.left > rect2?.left) && viewer.scene.splitPosition > 0.6)) {
            this.splitRightPostion = true
            this.splitLeftPostion = false
          } else {
            this.splitLeftPostion = true
          }


          // Hide more entities as needed
        } else if (viewer.scene.splitPosition < 0.5) {
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = false;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = true;
          }
          const rect1 = spliterDiv[0]?.getBoundingClientRect();
          const rect2 = rightDiv[0]?.getBoundingClientRect();
          if ((rect2?.right === 0 || rect1?.right < rect2?.right) && viewer.scene.splitPosition < 0.3) {
            this.splitRightPostion = false
            this.splitLeftPostion = true
          } else {
            this.splitRightPostion = true
          }
        }
      }

    });

    handler.setInputAction(() => { moveActive = true }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    handler.setInputAction(() => { moveActive = true }, Cesium.ScreenSpaceEventType.PINCH_START);

    handler.setInputAction(move, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    handler.setInputAction(move, Cesium.ScreenSpaceEventType.PINCH_MOVE);

    handler.setInputAction(() => { moveActive = false }, Cesium.ScreenSpaceEventType.LEFT_UP);

    handler.setInputAction(() => { moveActive = false }, Cesium.ScreenSpaceEventType.PINCH_END);


    viewer.screenSpaceEventHandler.setInputAction(function(click) {
      // Disable double-click behavior
      click.preventDefault();
    }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    this.addCursorPointerOnHover();
    this.destroyHandlers();
  }

  ngOnDestroy(): void {

    this.selectionChange.unsubscribe();
    this.destroyLegend();
  }
  getProjects() {
    this.apiService.getProjectName().subscribe((res: any) => {
      this.projectData = res.result;
      this.projectName = this.projectData[0]?.project;
      this.getCollections(res.result[0]?.projectid,0);
      this.projectSelected = res.result[0]?.projectid;
      this.collectionIndex = 0;
    });
  }

  addCursorPointerOnHover() {
    this.mouseMoveHandler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);

    this.mouseMoveHandler.setInputAction((movement) => {
      const pickedObject = this.viewer.scene.pick(movement.endPosition);
      if (Cesium.defined(pickedObject)) {
        this.viewer.canvas.style.cursor = 'pointer';
      } else {
        this.viewer.canvas.style.cursor = 'default';
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  getCollectionData(userId: any) {
    this.tableDataLength = 0;
    this.taskService.getCollections(userId).subscribe(
      (result: any) => {
        this.tableDataLength = result.results.length > 0 ? result.results.length : 0;
        this.dataSource = result.results;
        if (result.results.length > 0) {
          this.collectionsData = result.results;
          this.collections = [];
          let operators = [];
          result.results.forEach((item, index) => {
            const project = item.project;
            const taskname = item.taskname;
            const taskUuid = item.sensors[0]?.sensor_uuid;
            const taskId = item.id;
            let sensorName = item?.sensors?.[0]?.sensor;
            const target = JSON.parse(item.target);
            const sensors: any = [];

            item.sensors.forEach((sensor, i) => {
              const scenes: any = [];
              if (sensor?.scenes?.length > 0) {


                sensor?.scenes?.forEach((scene, index) => {
                  scene.checked = false;
                  let thumbnailUrl;

                  if (scene?.id != null) {
                    sensor.scenes[index] = scene;
                    thumbnailUrl =
                      environment.eeTaskServer +
                      '/' +
                      scene.thumbnailUrl || '';


                    const exists = scenes.find((sn: any) => sn.scene_id === scene?.scene_id)
                    if (!exists) {
                      scenes.push({
                        id: scene.id,
                        name: `Scene ${index + 1}`,
                        sceneIdx: index + 1,
                        footprint: scene.footprint,
                        metadata: scene.metadata,
                        metadata_tooltip: scene?.metadata_tooltip,
                        thumbnailUrl: thumbnailUrl,
                        previewUrl: scene.previewUrl,
                        downloadUrl: scene.downloadUrl,
                        checked: false,
                        color: 'primary',
                        scene_id: scene?.scene_id,
                        operatorKey: sensor?.operatorKey,
                        isName: scene?.isName,
                        png_footprint: scene?.png_footprint,
                        tif_footprint: scene?.tif_footprint,
                        legendScale: scene?.legendScale,
                        legend_min: scene?.legend_min,
                        legend_max: scene?.legend_max,
                        legend_long: scene?.legend_long,
                        legend_lat: scene?.legend_lat,
                        rawIQDownloaded : scene?.raw_iq_downloaded,
                        rawIQIncluded : scene?.raw_iq_included
                      });
                    }
                  }
                });
                if (scenes.length > 0) {
                  sensors.push({ name: sensor.sensor, scenes, checked: false, id: sensor?.sensor_uuid, downloadUrl: sensor?.downloadUrl,});
                }


              }
            });
            let taskCollection = item?.taskcollection;
            let captures = item?.captures;
            let sensorsName = item?.sensorsName;
            let info = item?.info;
            if (sensors.length > 0) {
              this.collections.push({
                project,
                taskname,
                target,
                sensors,
                taskId,
                sensorName,
                taskCollection,
                captures,
                sensorsName,
                info,
              });
              this.collection = this.collections[0];
              this.collectionIndex = 0;
              this.taskName = this.collections[0].taskname;
              this.taskid = this.collections[0].taskId;
              this.selectionChange.next(this.collection.recurrencyArray[0])

            }

          });
        } else {
          this.collectionsData = [];
        }
      },
      (err) => {
        return false;
      }
    );
  }

  showLatLon() {
    const viewer = this.viewer;
    const latLongOverlay = this.latlonOverlay;
    const canvas = this.viewer.canvas;
    viewer.container.appendChild(latLongOverlay);
    latLongOverlay.style.position = 'absolute';
    latLongOverlay.style['z-index'] = '10';
    latLongOverlay.style.right = '3px';
    latLongOverlay.style.bottom = '5px';
    latLongOverlay.style.height = '30px';
    latLongOverlay.style.width = 'fit-content';
    latLongOverlay.style['pointer-events'] = 'none';
    latLongOverlay.style.textAlign = 'center';
    latLongOverlay.style.justifyContent = 'center';
    latLongOverlay.style.padding = '5px 4px 0 4px';
    latLongOverlay.style.color = 'rgba(255, 255, 255, 1)';
    let mousePosition;
    const handler = new Cesium.ScreenSpaceEventHandler(canvas);
    const accuracy = 15;

    handler.setInputAction((movement) => {
      mousePosition = movement.endPosition;
      const cartesian = viewer.camera.pickEllipsoid(
        movement.endPosition,
        viewer.scene.globe.ellipsoid
      );
      if (cartesian) {
        const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

        const longString = Cesium.Math.toDegrees(cartographic.longitude).toFixed(accuracy);
        const latString = Cesium.Math.toDegrees(cartographic.latitude).toFixed(accuracy);
        const latitude = parseFloat(latString);
        const longitude = parseFloat(longString);

        const latitudeDMS = convertDecimalToDMS(latitude) + (latitude >= 0 ? 'N' : 'S');
        const longitudeDMS = convertDecimalToDMS(longitude) + (longitude >= 0 ? 'E' : 'W');

        function convertDecimalToDMS(decimal) {
          const degrees = Math.floor(Math.abs(decimal));
          const minutesDecimal = (Math.abs(decimal) - degrees) * 60;
          const minutes = Math.floor(minutesDecimal);
          const seconds = (minutesDecimal - minutes) * 60;
                
          const formattedDegrees = degrees !== 0 ? `${degrees}°` : '';
          const formattedMinutes = minutes !== 0 ? `${minutes}'` : '';
          const formattedSeconds = `${seconds.toFixed(1)}"`;
        
          return `${formattedDegrees}${formattedMinutes}${formattedSeconds}`;
        }

        this.longLatStr = 'Lng: ' + longitudeDMS + ', ' + 'Lat: ' + latitudeDMS;
        
        latLongOverlay.innerHTML =
          "<div style='padding:0px; padding-right: 30px'>" + this.longLatStr + '</div>';
      } else {
        this.longLatStr = '';
        latLongOverlay.innerHTML = "<div style='padding:0px;padding-right: 25px'>Out of Globe</div>";
      }
      this.roll = Cesium.Math.toDegrees(this.viewer.camera.heading).toFixed(0);
      if (this.roll > 359.5) this.roll = 0;
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  togglePanel() {
    this.showMe = !this.showMe;
  }

  zoomIn() {
    var height = this.viewer.camera.positionCartographic.height;
    this.viewer.camera.zoomIn(height / 2);
  }
  zoomOut() {
    var height = this.viewer.camera.positionCartographic.height;
    this.viewer.camera.zoomOut(height * 2);
  }
  moveUp() {
    var ellipsoid = this.viewer.scene.globe.ellipsoid;
    var cameraHeight = ellipsoid.cartesianToCartographic(
      this.viewer.camera.position
    ).height;
    var moveRate = cameraHeight / 10.0;
    this.viewer.camera.moveUp(moveRate);
  }
  moveDown() {
    var ellipsoid = this.viewer.scene.globe.ellipsoid;
    var cameraHeight = ellipsoid.cartesianToCartographic(
      this.viewer.camera.position
    ).height;
    var moveRate = cameraHeight / 10.0;
    this.viewer.camera.moveDown(moveRate);
  }
  moveLeft() {
    var ellipsoid = this.viewer.scene.globe.ellipsoid;
    var cameraHeight = ellipsoid.cartesianToCartographic(
      this.viewer.camera.position
    ).height;
    var moveRate = cameraHeight / 10.0;
    this.viewer.camera.moveLeft(moveRate);
  }
  moveRight() {
    var ellipsoid = this.viewer.scene.globe.ellipsoid;
    var cameraHeight = ellipsoid.cartesianToCartographic(
      this.viewer.camera.position
    ).height;
    var moveRate = cameraHeight / 10.0;
    this.viewer.camera.moveRight(moveRate);
  }

  ngAfterViewInit() {
    this.LEFTOPTIONS = [];
    this.RIGHTOPTIONS = [];
    this.initLegendContainer('cesiumContainer1');
  }
 
  topView() {
    const camera = this.viewer.camera;
    this.viewer.camera.setView({
      destination: this.viewer.camera.positionWC,
      orientation: {
        heading: camera.heading,
        pitch: camera.pitch,
        roll: Cesium.Math.toRadians(0),
      },
    });
  }

  removeTarget() {
    this.jump = !this.jump
    if (!this.jump) {
      this.viewer.entities.values.forEach((entity) => {
        if (entity.id === 'target') {
          this.viewer.entities.remove(entity);
        }
      });
    }
  }

  jump2target(indx: any, j: any, k: any) {
    if (!this.jump) {
      this.viewer.entities.values.forEach((entity) => {
        if (entity.id === 'target') {
          this.viewer.entities.remove(entity);
        }
      });
    } else {
    let fpPos: any, pts, dispName;
    if (j === undefined) {
      dispName = '';
      if (this.collections[indx]?.target?.type === 'Point') {
        pts = this.collections[indx]?.target?.coordinates;
      } else {
        pts = this.collections[indx]?.target?.coordinates[0];
      }
      // pts = JSON.parse(this.collections[indx].target).coordinates[0];
    } else {
      if (this.collections[indx]?.sensors[j]?.scenes[k]?.footprint === undefined)
        return;
      dispName = 'Scene ' + (k + 1);
      pts =
        this.collections[indx]?.sensors[j]?.scenes[k]?.footprint?.coordinates[0];
    }
    fpPos = pts.toString().split(',').map(Number);
    if (this.collections[indx]?.target?.type === 'Point') {
      var centroid = pts;
    } else {
      const polygon = turf.polygon([pts]);
      var centroid = turf.centroid(polygon).geometry.coordinates;
    }
    // this.viewer.entities.removeAll();
    var label = this.viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(centroid[0], centroid[1]),
      label: {
        text: dispName,
        font: '20px sans-serif',
        pixelOffset: new Cesium.Cartesian2(0.0, 20),
      },
    });
    if (pts?.length > 2) {
      this.FP = this.viewer.entities.add({
        id: 'target',
        name: dispName,
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArray(fpPos),
          clampToGround: true,
          material: new Cesium.PolylineOutlineMaterialProperty({
            outlineWidth: 3,
            outlineColor: Cesium.Color.WHITE,
          }),
        },
      });
    } else {
      return
      this.FP = this.viewer.entities.add({
        id: 'BB',
        position: Cesium.Cartesian3.fromDegrees(pts[0], pts[1]), //  bbPosition,
        billboard: {
          image: 'assets/images/marker-icon.png',
          show: true, // default
          // pixelOffset: new Cesium.Cartesian2(0, 5), // default: (0, 0)
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          // scale: 0.75, // default: 1.0
          // color: Cesium.Color.LIME, // default: WHITE
          // rotation: Cesium.Math.PI_OVER_FOUR, // default: 0.0
          alignedAxis: Cesium.Cartesian3.ZERO, // default
          width: 20, // default: undefined
          height: 30, // default: undefined
        },
      });
    }

    if (this.jump) this.viewer.zoomTo(this.FP);
    // if (this.jump || k) this.viewer.flyTo(this.FP, {duration: 3});
  }
  }

  chngAlpha(indx: any, alpha: any, sensor: any) {
    var allImageryLayers = this.viewer.imageryLayers._layers;
    var leftImageryLayers: any = [];
    var rightImageryLayers: any = [];
    let imageLayerCount = 0;
    let unShowSensor = sensor.scenes[0]?.operatorKey != OPERATORS.CLYDE && sensor.scenes[0]?.operatorKey != OPERATORS.SPIRE && sensor.scenes[0]?.operatorKey != OPERATORS.USL && sensor.scenes[0]?.operatorKey != OPERATORS.LBAND;

    for (var index = 0; index < allImageryLayers.length; index++) {
      var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url

      var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
      var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
      if (!isLeft && !isRight) {
        imageLayerCount = index
      }
      if (url !== undefined && isLeft) {
        leftImageryLayers.push(allImageryLayers[index]);
      }
      if (url !== undefined && isRight) {
        rightImageryLayers.push(allImageryLayers[index]);
      }

    }

    alpha = alpha / 100;
    const findSensor = this.selectedSensors
      .filter(function (el) {
        return el.index === indx;
      })
    if (indx < 0) {
      this.baseAlpha = alpha;
      if (imageLayerCount > 0) {
        let imageLayerCountSensorClick = 0;
        var count = this.viewer.imageryLayers.length - 1;
        this.selectedSensors.forEach((item: any, index: any) => {
          const findIndexsensor = item.scenes
            .filter(function (el) {

              return el.checked;
            })
          if (findIndexsensor.length > 0)
            imageLayerCountSensorClick = + findIndexsensor.length

        })
        this.viewer.imageryLayers.get(count - imageLayerCountSensorClick < 1 ? 0 : (count - imageLayerCountSensorClick)).alpha = alpha;

      } else
        this.viewer.imageryLayers.get(imageLayerCount).alpha = alpha;
    } else if (unShowSensor) {
       if (indx === 0) {
        for (var index = 0; index < leftImageryLayers.length; index++) {
          leftImageryLayers[index].alpha = alpha;
          // Do something with the entity
        }
      } else {
        for (var index = 0; index < rightImageryLayers.length; index++) {
          rightImageryLayers[index].alpha = alpha;
        }
  
      }
    }

  }
  raise(indx: any) {
    var element = this.collections[indx];
    this.collections.splice(indx, 1);
    this.collections.splice(indx - 1, 0, element);
  }
  lower(indx: any) {
    var element = this.collections[indx];
    this.collections.splice(indx, 1);
    this.collections.splice(indx + 1, 0, element);
  }
  baselayerChng(indx: any) {
    this.viewer._baseLayerPicker._viewModel.selectedImagery =
      this.imageryViewModels[indx];
    this.viewer.imageryLayers.get(0).alpha = this.baseAlpha;
  }

  async getFile(url: string) {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    const res = await this.httpClient
      .get(url, httpOptions)
      .toPromise()
      .catch((err: HttpErrorResponse) => {
        const error = err.error;
        return error;
      });
    return res;
  }
  async downloadAndZip(url: string): Promise<JSZip> {
    const response = await fetch(url);
    const data = await response.blob();
    const fileName: any = url.split('/').pop();
    const zip = new JSZip();
    zip.file(fileName, data);
    return zip;
  }
  async createZip(zipArray: JSZip[], zipName: string): Promise<void> {
    const zip = new JSZip();
    zipArray.forEach((z) => {
      const files = z.files;
      for (const fileName in files) {
        if (Object.prototype.hasOwnProperty.call(files, fileName)) {
          zip.file(fileName, files[fileName].async('blob'));
        }
      }
    });
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, `${zipName}.zip`);
  }
  getImage(taskId: any, sensorObj) {
    this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
      return res?.result;
    });
  }

private applyFeedFilter(fc: any, config: any): any {
  if (!fc) {
    return { type: 'FeatureCollection', features: [] };
  }

  const key = config?.filterKey || 'wake';
  return this.getFilteredData(fc, key);
}


async displayIS(scene: any, feed: any, sensors: any) {
  // ---------- basic config ----------
  const feedId = String(feed?._id);
  const config = this.getFeedConfig(feedId);
  const key    = this.getFeedKey(feed, config);
  this.feedInfo  = true;

  // If layer already added, just fly to it
  const existing = this.isLayers.get(key);
  if (existing) {
    try {
      await this.viewer.flyTo(existing, { duration: 2 });
    } catch {}
     this.feedInfo  = true;
    this.spinnerService.hide();
    this.mapLoad = false;
    return;
  }

  // ---------- base FeatureCollection ----------
  let baseFC: any = this.asFeatureCollection(scene);
  let filteredCollection: any = baseFC;
  let feedResult: any = feed?.feed_results;
  if (this.checkedScenes.length === 1) {
    const sceneId = this.checkedScenes[0].scene_id;
    const insightItem = feed.insightDatas?.find(
      (item: any) => item.sceneId === sceneId
    );
    const insightFC = baseFC;

    filteredCollection = this.applyFeedFilter(insightFC, config);
    feedResult = filteredCollection?.feed_results
      ?? insightItem?.insightFootprint?.feed_results
      ?? feed?.feed_results;
  }
  else if (
    this.checkedScenes.length > 1)  {
    if(feed &&feed?.modelType !== this.infoserviceModelType){
       const sensorObj = {
      customerid: this.currentUser?.id,
      sensorId: feed?.sensorId,
      taskId: this.currentTaskId,
      feedId: feed?._id,
    };
    const res: any = await firstValueFrom(
      this.apiService.getObjectDetectionData(sensorObj)
    );

    const apiFC = this.asFeatureCollection(res?.result?.feedData) || baseFC;

    filteredCollection = this.applyFeedFilter(apiFC, config);
    feedResult = filteredCollection?.feed_results
    }else{
      const insightItem = sensors?.find(
      (item: any) => item.id === feed?.sensorId
     );
       feedResult = insightItem?.feed_results;
    }
  }
  else {
    filteredCollection = this.applyFeedFilter(baseFC, config);
  }

  // ---------- no features? show message ----------
  if (!filteredCollection?.features?.length) {
    const formattedDate = formatDate(this.taskCreatedDate, 'dd/MM/yyyy', 'en-US');
    const msg =
      `There is no information extracted from the tasked data for ${this.taskName} ` +
      `submitted on ${formattedDate} as the observation of interest is not present.`;

    this.popupService.openPopup(CollectionPopupComponent, msg, '', '40%');
    this.spinnerService.hide();
    this.mapLoad = false;
    return;
  }
  // ---------- right-panel sections ----------
  const vm = this.helperService.buildFeedSections(config, feedResult);
  this.feedSections = vm.sections;

  const title = this.feedTitleOf(config, feed?.feedName || feed?.name);
  const color = config?.color;
  const baseColor = this.toCesiumColor(color).withAlpha(1.0);

  this.feedPanels.set(key, {
    title,
    color,
    sections: vm.sections,
  });
  this.rebuildCombined();

  // store for later (loosely typed to avoid TS noise)
  this.geoByFeed.set(key, {
    fc: filteredCollection as any,
    type: config?.type,
    color: config?.color,
    title,
  });
  this.activeFeedKeys.add(key);

  // ---------- Cesium setup ----------
  this.viewer.scene.globe.depthTestAgainstTerrain = false;
  const isMultiPoint = filteredCollection.features.some(
        (feature) => (feature.geometry?.type === "MultiPoint" || feature.geometry?.type === "Point")
      );

       if (isMultiPoint) {
      let data: any;
        data = this.viewer.dataSources.add(
          Cesium.GeoJsonDataSource.load(filteredCollection, {
            clampToGround: true, 
             markerSymbol: '',
             markerColor: Cesium.Color.TRANSPARENT,
          })
        );
        
        data.then((geoJsonDataSource) => {
          const entities = geoJsonDataSource.entities.values;
          entities.forEach((entity) => {
            if (entity.position) {
              // Apply custom point graphics for MultiPoint geometries
              entity.point = new Cesium.PointGraphics({
                pixelSize: 10, // Size of the circle
                color: baseColor, // Color of the point
                outlineWidth: 0, // No outline
              });
            }
          });
        });       
        this.isLayers.set(key, data);
         this.feedLoaded = true;
        this.spinnerService.hide();
        this.mapLoad = false;
      }

      try{

        const ds = await Cesium.GeoJsonDataSource.load(filteredCollection, {
    clampToGround: true,
    markerSymbol: '',
    markerColor: Cesium.Color.TRANSPARENT,
  });

  // Style points (for wake / vessels etc.)
  ds.entities.values.forEach((entity: any) => {
    if (entity.position) {
      entity.point = new Cesium.PointGraphics({
        pixelSize: 10,
        color: baseColor,
        outlineWidth: 0,
      });
    }
  });

   if (config?.colorMode === 'CLASS_BASED') {
    ds.entities.values.forEach((entity: any) => {
      const entityColor = this.resolveCesiumColor(
         config,
         entity,
         color
       );
       const labelKey = entity?.properties?.class?.getValue
      ? entity.properties.class.getValue()
      : entity?.properties?.class;
      entity.point = new Cesium.PointGraphics({
        pixelSize: 10,
        color: entityColor,
        outlineWidth: 0,
      });
      if (entity.polygon) {
      entity.polygon.material = entityColor;
      entity.polygon.outline = false;
    }

    if (entity.polyline) {
      entity.polyline.material = entityColor;
      entity.polyline.width = 2;
    }
  if (config?.type === 'Vessel-classification' && labelKey) {
  const labelText = config?.color?.[labelKey]?.label;

  if (labelText && entity.polyline) {
    const positions = entity.polyline.positions.getValue(
      Cesium.JulianDate.now(),
    );
    let minLat = Number.POSITIVE_INFINITY;
    let minLon = Number.POSITIVE_INFINITY;
    let maxLat = Number.NEGATIVE_INFINITY;
    let maxLon = Number.NEGATIVE_INFINITY;

    positions.forEach((p: any) => {
      const carto = Cesium.Cartographic.fromCartesian(p);

      const lat = Cesium.Math.toDegrees(carto.latitude);
      const lon = Cesium.Math.toDegrees(carto.longitude);

      minLat = Math.min(minLat, lat);
      maxLat = Math.max(maxLat, lat);
      minLon = Math.min(minLon, lon);
      maxLon = Math.max(maxLon, lon);
    });

    const labelPosition = Cesium.Cartesian3.fromDegrees(minLon, maxLat);

    entity.position = labelPosition;

    if (positions?.length) {
      entity.label = new Cesium.LabelGraphics({
        text: labelText,
        font: '13px sans-serif',
        fillColor: Cesium.Color.WHITE,
        backgroundColor: entityColor,
        showBackground: true,
        pixelOffset: new Cesium.Cartesian2(0, -5),
        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
        verticalOrigin: Cesium.VerticalOrigin.TOP,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      });
     }
    }
   }

  });
   } else {
  // Your existing style logic (polygons, lines, etc.)
  this.styleEntities(ds, baseColor);
   }

  await this.viewer.dataSources.add(ds);
  if (config?.colorMode === 'CLASS_BASED') {
  this.viewer.dataSources.lowerToBottom(ds);
  }
  if (config?.type === 'Soil Moisture - SAR') {
  this.showSoilMoistureLegend(config);
  }
  this.isLayers.set(key, ds);

  try {
    await this.viewer.flyTo(ds, { duration: 3 });
  } catch {}

  this.feedLoaded = true;
  this.spinnerService.hide();
  this.mapLoad = false;

   if (!(this as any)._feedTooltipBound) {
      (this as any)._feedTooltipBound = true;
      const tooltip = document.getElementById('feedTooltip');
      this.viewer.screenSpaceEventHandler.setInputAction((movement) => {
        const pickedObject = this.viewer.scene.pick(movement.endPosition);
        if (Cesium.defined(pickedObject) && Cesium.defined(pickedObject.id)) {
          const entity = pickedObject.id;
          if (entity.properties?.confidence && entity?.polyline?.positions) {
            const positions = entity.polyline.positions.getValue();
            const location  = this.getCentroid(positions);
            const [lng, lat] = location.replace(/[()]/g, '').split(',').map(Number);

            const confidence = entity.properties.confidence.getValue();
            let feedData = `<b>Lng  :</b>  ${lng}<br><b>Lat  :</b>  ${lat}<br><b>Confidence  :</b>  ${confidence}`;
            if (entity.properties.vessel_length) {
              const vesselLength = entity.properties.vessel_length.getValue();
              feedData = `<b>Lng  :</b>  ${lng}<br><b>Lat  :</b>  ${lat}<br><b>Vessel Length  :</b>  ${vesselLength}<br><b>Confidence  :</b>  ${confidence}`;
            }

            if (tooltip) {
              tooltip.style.display = 'block';
              tooltip.style.fontSize = '14px';
              tooltip.style.fontFamily = 'Barlow", sans-serif';
              tooltip.style.lineHeight = '1.7';
              tooltip.innerHTML = feedData;
              this.tooltipHandlers(tooltip, movement);
            }
          }
        } else if (tooltip) {
          tooltip.style.display = 'none';
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    }
      }catch{
      }

}

  private resolveCesiumColor(
  config: any,
  feature: any,
  fallbackColor: string
  ): Cesium.Color {
  // CLASS_BASED → per feature
  if (config?.colorMode === 'CLASS_BASED') {
    const classValue = feature?.properties?.class?.getValue
      ? feature.properties.class.getValue()
      : feature?.properties?.class;

    const hex =
      config?.color?.[classValue]?.color || fallbackColor;

    return this.toCesiumColor(hex);
  }

  // Default behavior (existing)
  return this.toCesiumColor(fallbackColor);
}

  showSoilMoistureLegend(soilConfig: any) {
  this.scaleArray = [];

  const classMap = SOIL_MOISTURE_SAR_CLASS_MAP

  Object.keys(classMap).forEach((key) => {
    const item = classMap[key];
    this.scaleArray.push({
      color: item.color,
      displayValue: item.label
    });
  });

  const soilLegendHtml = `
    <div style="
      display:flex;
      align-items:center;
      justify-content:space-between;
      font-weight:600;
      margin-bottom:8px;
    ">
      <span>Soil Moisture</span>
    </div>

    ${this.scaleArray
      .map(
        (item: any) => `
        <div style="display:flex;align-items:center;margin-bottom:4px;">
          <div style="
            width:18px;
            height:18px;
            margin-right:8px;
            border:1px solid white;
            background:${item.color};
          "></div>
          <span>${item.displayValue}</span>
        </div>
      `
      )
      .join('')}
  `;

  this.showLegend(soilLegendHtml);
}


private rebuildCombined() {
  const out: FeedSection[] = [];
  for (const { title, color, sections } of this.feedPanels.values()) {
    for (const s of sections) {
      out.push({
        show: s.show,
        className: s.className,
        style: s.style,
        items: [...s.items], // clone items to avoid side-effects
      });
    }
  }
  this.combinedFeedSections = out; // bump reference
  this.feedInfo = this.combinedFeedSections.length > 0;
}

// Add/replace a feed’s panel (use SAME key as overlays)
private addFeedPanel(key: string, title: string, color: string | undefined, sections: FeedSection[]) {
  const next = new Map(this.feedPanels);
  next.set(key, { title, color, sections });
  this.feedPanels = next;
  this.rebuildCombined();
}

// Remove a feed’s panel by key
private removeFeedPanel(key: string) {
  if (!this.feedPanels.has(key)) return;
  const next = new Map(this.feedPanels);
  next.delete(key);
  this.feedPanels = next;
  this.rebuildCombined();
}

private removeFromFiltered(feedKey: string, className?: string) {
  if (!this.currentFilterDs) return;

  const ents = [...this.currentFilterDs.entities.values]; // snapshot
  for (const e of ents) {
    const p: any = e.properties;
    if (!p) continue;

    // Cesium Property can be ConstantProperty or dynamic; handle both
    const pk = p._feedKey?.getValue ? p._feedKey.getValue(Cesium.JulianDate.now()) : p._feedKey;
    const cls = p._class?.getValue ? p._class.getValue(Cesium.JulianDate.now()) : p._class;

    if (pk === feedKey && (className ? cls === className : true)) {
      this.currentFilterDs.entities.remove(e);
    }
  }

  // If nothing left, remove the filtered overlay datasource
  if (this.currentFilterDs.entities.values.length === 0) {
    this.viewer.dataSources.remove(this.currentFilterDs, true);
    this.currentFilterDs = undefined;
  }

  // Refresh side panel counts from what's currently displayed
  this.rebuildCombined();
}


removeISOverlay(feed: any) {
  const key = String(feed?._id);
  const ds = this.isLayers.get(key);
  if (!ds) return;
  this.viewer.dataSources.remove(ds, true); // true => destroy
  this.isLayers.delete(key);
}


// Pull config from your constants file
private getFeedConfig(feedId: string) {
  return feedsConfig[feedId] ?? {};
}

// Prefer _id, fallback to name/type; must be stable per feed
private getFeedKey(feed: any, config: any) {
  return String(feed?._id ?? feed?.id ?? config?.type ?? Date.now());
}

// Robust CSS/named color → Cesium.Color
private toCesiumColor(input?: string): Cesium.Color {
  if (!input) return Cesium.Color.YELLOW;
  if (input.startsWith?.('#')) return Cesium.Color.fromCssColorString(input);
  const named = (Cesium.Color as any)[input];
  return named instanceof Cesium.Color ? named : Cesium.Color.fromCssColorString('#ffd166');
}

// Normalize to a FeatureCollection
private asFeatureCollection(x: any): FeatureCollection {
  if (x?.type === 'FeatureCollection') return x;
  if (x?.insightFootprint?.type === 'FeatureCollection') return x.insightFootprint;
  const features = x?.insightFootprint?.features ?? x?.features ?? [];
  return { type: 'FeatureCollection', features };
}

// Style all entity types so color consistently applies
private styleEntities(ds: Cesium.DataSource, baseColor: Cesium.Color) {
  const fill = baseColor.withAlpha(1.0);
    try { ds.clustering.enabled = false; } catch {} 
  for (const e of ds.entities.values) {
    if (e.point) {
      e.point.show = new Cesium.ConstantProperty(false); // hides the blue marker
    }
    // polylines
    if (e.polyline) {
      e.polyline.material = new Cesium.ColorMaterialProperty(baseColor);
      e.polyline.width = new Cesium.ConstantProperty(2.5); // ✅ wrap in ConstantProperty
      e.polyline.clampToGround = new Cesium.ConstantProperty(true); // ✅ wrap in ConstantProperty
    }

    // polygons
    if (e.polygon) {
      e.polygon.material = new Cesium.ColorMaterialProperty(fill);   // semi-transparent fill
      e.polygon.outline = new Cesium.ConstantProperty(true);
      e.polygon.outlineColor = new Cesium.ConstantProperty(baseColor);
      e.polygon.classificationType = new Cesium.ConstantProperty(
        Cesium.ClassificationType.TERRAIN
      );
    }
  }
}


//  New code end



  getCentroid(positions: any) {
    let totalX = 0, totalY = 0, totalZ = 0;
    let numPositions = positions.length;

    for (let i = 0; i < numPositions; i++) {
      totalX += positions[i].x;
      totalY += positions[i].y;
      totalZ += positions[i].z;
    }

    // Compute the average for each coordinate
    let centroidX = totalX / numPositions;
    let centroidY = totalY / numPositions;
    let centroidZ = totalZ / numPositions;
    let centroid = new Cesium.Cartesian3(centroidX, centroidY, centroidZ);

    // Geographic coordinates (longitude, latitude, height)
    let centroidCartographic = Cesium.Cartographic.fromCartesian(centroid);
    let longitude = Cesium.Math.toDegrees(centroidCartographic.longitude);
    let latitude = Cesium.Math.toDegrees(centroidCartographic.latitude);
    let height = centroidCartographic.height;

    return `(${longitude.toFixed(10)}, ${latitude.toFixed(10)})`
  }
  
  selectedSensor: any;
  vesselPolygon: any;
  displayAIS(scene: any, type: any, sensor: any) {
    let refreshCount;
    let timeExpired;
    let sensorId;
    let taskId
    let USLcoverage: any, BBpoints: any, isHistorical: boolean;

    sensorId = sensor.id;
    timeExpired = sensor.timeExpired;
    refreshCount = sensor.updatedRefreshes == 0 ? 0 : sensor.updatedRefreshes || sensor.noOfRefreshes;
    isHistorical = sensor?.isHistorical;

    if(!scene.aisAvailable) {
      const message = "AIS data is not available until the start of the time of interest (TOI)";
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    }
    else if(timeExpired) {
      const message = 'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    else if(sensor.operatorKey === OPERATORS.SPIRE && refreshCount > 0) {
        const coordinates = scene?.footprint?.coordinates[0]
        taskId = this.collection?.taskId;
    
        let newCoordinates = coordinates.map(coord => {
          return [coord[0], coord[1]];
        });
    
        newCoordinates = [newCoordinates];
        newCoordinates = JSON.stringify(newCoordinates);
    
        const encodedCoordinates = encodeURIComponent(newCoordinates);
        const startTime = encodeURIComponent(scene.openWindow)
        const endTime = encodeURIComponent(scene.closeWindow)
    
    
        const aisReq = {
          polygon: encodedCoordinates,
          startTime: startTime,
          endTime: endTime,
          type: type
        }
        if(type !== 'download') {
          this.spinnerService.show();
          this.mapLoad = true;
        }
    
        this.apiService.getAISData(aisReq, taskId).subscribe((res: any) => {
          if(type !== 'download') {
            this.spinnerService.show();
            this.mapLoad = true;
          }
          
          if (res?.msg === 'failed') {
            const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            this.spinnerService.hide();
            this.mapLoad = false;
            this.freeze = false;
            this.disable = false;
            const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
            this.downloadService.setProgress(sensorObj);
          } else if (res?.msg === 'success') {
            const resultVesselsNodes = res?.data?.vessels?.nodes ?? [];
            if(resultVesselsNodes.length === 0) {
              this.spinnerService.hide();
              this.mapLoad = false;
              this.freeze = false;
              this.disable = false;
              const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
              this.downloadService.setProgress(sensorObj);
              const message = 'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
              const type = 'AIS'
              this.popupService.openPopup(WarningPopupComponent, message, type, '40%');
            } else {
              const resultVessels = res?.data?.vessels?.nodes;
              const updatedAis = this.convertToGeoJSON(res.data,'display');
              if (this.isObservation(sensor)) {
                this.selectedHistory[res.newRefreshHistory.refreshId] = updatedAis;
              }
              if(type === 'display')  {
                const sensorIndex = this.collection.sensors.findIndex(sensor => sensor.id === sensorId);
                if (sensorIndex !== -1) {
                  if (!this.collection.sensors[sensorIndex].refreshHistory) {
                    this.collection.sensors[sensorIndex].refreshHistory = []; // Initialize if not present
                  }
                  this.collection.sensors[sensorIndex].refreshHistory.push(res.newRefreshHistory);
                }
                this.spireJsonData = JSON.parse(JSON.stringify(updatedAis));
                this.displayedSpireData = updatedAis;
                this.spireSensorId = sensor?.id;
                
                const selectData = Cesium.GeoJsonDataSource.load(updatedAis);
                const currentCrossImage = 'assets/images/yellow-cross.png';
                selectData.then((dataSource: CustomGeoJsonDataSource) => {
                  dataSource.sensorId = sensor?.id;
                  dataSource.name = 'spireDataSource';
                  const entities = dataSource.entities.values;
                  for (let j = 0; j < entities.length; j++) {
                    const entity = entities[j] as CustomEntity;
                    entity.name = 'vessel';
                    entity.type = 'spire';

                    // Get ship type from properties
                    if(entity.properties) {
                      const shipType = entity.properties['Ship Type'].getValue() || 'OTHER';
                      const iconColor = this.utilsService.getShipColor(shipType);
                      const course = entity.properties['Course']?.getValue(); // Get the course value
                      
                      // Create the icon with the appropriate color
                      const iconCanvas = this.createNavigationIcon(iconColor);
  
                      entity.billboard = new Cesium.BillboardGraphics({
                        image: iconCanvas.toDataURL(),
                        show: true,
                        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
                        alignedAxis: Cesium.Cartesian3.ZERO,
                        width: 24,
                        height: 24,
                        // Add rotation based on course
                        rotation: course ? Cesium.Math.toRadians(-course) : 0, // Negative because Material Icon 'navigation' points up by default
                        // Keep icon oriented with screen
                        pixelOffset: new Cesium.Cartesian2(0, 0),
                        // Ensure icon stays upright relative to screen
                        verticalOrigin: Cesium.VerticalOrigin.CENTER,
                        horizontalOrigin: Cesium.HorizontalOrigin.CENTER
                      });
                    }
                  }
        
                  this.spinnerService.hide();
                  this.mapLoad = false;
      
                  this.collection.sensors.map((sensor) => {
                    if (sensor.operatorKey === OPERATORS.SPIRE) {
                      if(sensor.updatedRefreshes) sensor.updatedRefreshes -= 1
                      else sensor.updatedRefreshes = sensor.noOfRefreshes - 1
                    }
                  })
        
                  this.viewer.dataSources.add(dataSource);
                  this.viewer.scene.globe.depthTestAgainstTerrain = false;
                  this.viewer.flyTo(dataSource, { duration: 3 });
                });
                
                let tooltip = document.getElementById('feedTooltip');
                if (this.handler) {
                  this.handler.destroy();
                }
                // Add click event listener            
                let previousEntity = null;
                this.handler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);
                this.handler.setInputAction((click) => {
                  const pickedObject = this.viewer.scene.pick(click.position);
                  if (Cesium.defined(pickedObject) && !this.prediction) {
                    const entity = pickedObject.id;
                    if (entity && entity.isOriginal !== false && entity?.type === 'spire') {
                      if (previousEntity) {
                        this.resetEntity(previousEntity);
                      }
                      this.previousIndex = -1;
                      this.handleClick(entity,isHistorical,taskId, sensor, resultVessels);
                      this.highlightEntity(entity);
                      this.clickedEntity = entity;
                      previousEntity = entity;
                    }
                  }
                }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  
                this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);

  
                // Add hover event listener for tooltip
                this.handler.setInputAction((movement) => {
                  const pickedObject = this.viewer.scene.pick(movement.endPosition);
                  const entity = pickedObject?.id;
                  
                  if (entity && entity.properties && entity?.name != 'annotation' && entity?.name != 'signal') {
                    if (tooltip) {                    
                    let content = '';
                    entity.properties.propertyNames.forEach(propertyName => {                      
                      content += `<strong>${propertyName} : </strong> ${entity.properties[propertyName]}<br>`;
                    });
                    tooltip.innerHTML = content;
                    tooltip.style.fontSize = '15px';
                    tooltip.style.fontFamily = 'Barlow", sans-serif';
                    tooltip.style.lineHeight = '1.8';
                    tooltip.style.display = 'block';
                    this.tooltipHandlers(tooltip, movement);
                  }
                } else if (tooltip) {
                  tooltip.style.display = 'none';
                }
                }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  
                if (scene?.operatorKey === this.OPERATOR.SPIRE) {
                  USLcoverage = scene?.footprint?.coordinates[0]
                  BBpoints = USLcoverage.toString().split(',').map(Number);
            
                  this.uslBB = this.viewer.entities.add({
                    sensorId: sensor?.id,
                    polyline: {
                      positions: Cesium.Cartesian3.fromDegreesArray(BBpoints),
                      clampToGround: true,
                      material: new Cesium.PolylineOutlineMaterialProperty({
                        outlineWidth: 3,
                        outlineColor: Cesium.Color.fromRandom({
                          alpha: 1.0,
                        }),
                      }),
                    },
                  });
                  this.uslBB.index = scene?.sceneIdx;
                  this.SpirescnLyr.push(this.uslBB);
                  this.setJsonData(scene,taskId,sensor?.id);
                }
            
                if (this.uslBB) {
                  this.viewer.zoomTo(this.uslBB);
                }
              } else if(type === 'download') {
                this.collection.sensors.map((sensor) => {
                  if (sensor.operatorKey === OPERATORS.SPIRE) {
                    if(sensor.updatedRefreshes) sensor.updatedRefreshes -= 1
                    else sensor.updatedRefreshes = sensor.noOfRefreshes - 1
                  }
                })
                const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick };
                this.downloadService.setProgress(sensorObj);
                const blob = new Blob([JSON.stringify(updatedAis)], {type: 'application/json'});
                const url = window.URL.createObjectURL(blob);
            
                const link = document.createElement('a');
                link.href = url;
                link.download = 'spire.geojson'; 
                link.click();
            
                // Clean up
                window.URL.revokeObjectURL(url);
                this.progress = 0;
                this.spinnerService.hide();
                this.freeze = false;
                this.disable = false;
              }
            }
          }
        });
      
    }
    else if(scene?.operatorKey !== this.OPERATOR.CLYDE) {
      const message = 'Your refresh count has been exhausted. Please re-task to continue receiving latest AIS information.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
  }

  displayAISClyde(scene: any, type: any, sensor: any) {
    let refreshCount;
    let timeExpired;
    let sensorId;
    let taskId
    let USLcoverage: any, BBpoints: any, isHistorical: boolean;

    sensorId = sensor.id;
    timeExpired = sensor.timeExpired;
    isHistorical = sensor?.isHistorical; 

    if(!scene.aisAvailable) {
      const message = "AIS data is not available until the start of the time of interest (TOI)";
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    } else if(timeExpired) {
      const message = 'The time of interest (TOI) has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    } else if(sensor.operatorKey === OPERATORS.CLYDE) {
        const coordinates = scene?.footprint?.coordinates[0]
        taskId = this.collection?.taskId;
    
        let newCoordinates = coordinates.map(coord => {
          return [coord[1], coord[0]];
        });
    
        newCoordinates = [newCoordinates];
        newCoordinates = JSON.stringify(newCoordinates);
    
        const encodedCoordinates = encodeURIComponent(newCoordinates);
        const startTime = encodeURIComponent(scene.openWindow)
        const endTime = encodeURIComponent(scene.closeWindow)
    
    
        const aisReq = {
          polygon: encodedCoordinates,
          startTime: startTime,
          endTime: endTime,
          type: type
        }
        if(type !== 'download') {
          this.spinnerService.show();
          this.mapLoad = true;
        }
  
          const input = JSON.parse(decodeURIComponent(aisReq.polygon)); 
          this.vesselPolygon = input[0]
            .map(pair => pair.reverse().join(' '))
            .join(', '); 
          aisReq.polygon = this.vesselPolygon  
    
          this.apiService.getClydeAISData(aisReq, taskId).subscribe((res: any) => {           
          if(type !== 'download') {
            this.spinnerService.show();
            this.mapLoad = true;
          }
          
          if (res?.msg === 'failed') {
            const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            this.spinnerService.hide();
            this.mapLoad = false;
            this.freeze = false;
            this.disable = false;
            const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
            this.downloadService.setProgress(sensorObj);
          } else if (res?.msg === 'Success') {
            if(res?.data?.length === 0) {             
              this.spinnerService.hide();
              this.mapLoad = false;
              this.freeze = false;
              this.disable = false;
              const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
              this.downloadService.setProgress(sensorObj);
              const message = 'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            } else {                            
              const updatedAis = this.convertToGeoJSON(res.data, 'CLYDE');
              if (this.isObservation(sensor)) {
                this.selectedHistory[res.newRefreshHistory.refreshId] = updatedAis;
              }
              if(type === 'display')  {
                let iconCanvas,iconUrl;
                const sensorIndex = this.collection.sensors.findIndex(sensor => sensor.id === sensorId);
                if (sensorIndex !== -1) {
                  if (!this.collection.sensors[sensorIndex].refreshHistory) {
                    this.collection.sensors[sensorIndex].refreshHistory = []; // Initialize if not present
                  }
                  this.collection.sensors[sensorIndex].refreshHistory.push(res.newRefreshHistory);
                }
                const selectData = Cesium.GeoJsonDataSource.load(updatedAis);
                const currentCrossImage = 'assets/images/orange-cross.png';
                iconCanvas = this.createNavigationIcon('orange');
                iconUrl = iconCanvas.toDataURL();

                selectData.then((dataSource: CustomGeoJsonDataSource) => {
                  dataSource.name = 'clydeDataSource';
                  dataSource.sensorId = sensor?.id;
                  const entities = dataSource.entities.values;
                  for (let j = 0; j < entities.length; j++) {
                    const entity = entities[j] as CustomEntity;
                    entity.name = 'vessel';
                    entity.type = 'clyde';
                    entity.billboard = new Cesium.BillboardGraphics({
                      image: iconUrl,
                      show: true,
                      eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
                      horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                      alignedAxis: Cesium.Cartesian3.ZERO,
                      width: 24,
                      height: 24,
                    });
                  }
        
                  this.spinnerService.hide();
                  this.mapLoad = false;
        
                  this.viewer.dataSources.add(dataSource);
                  this.viewer.scene.globe.depthTestAgainstTerrain = false;
                  this.viewer.flyTo(dataSource, { duration: 3 });
                });

                let tooltip = document.getElementById('feedTooltip');
                if (this.handlers) {
                  this.handlers.destroy();
                }
                // Add click event listener
                let previousEntity = null;
                this.handlers = new ScreenSpaceEventHandler(this.viewer.scene.canvas);
                this.handlers.setInputAction((click) => {

                  const pickedObject = this.viewer.scene.pick(click.position);
                  if (Cesium.defined(pickedObject)) {                    
                    const entity = pickedObject.id;
                    if (entity && entity.isOriginal !== false && entity?.type === 'clyde') {
                      if (previousEntity) {
                        this.resetEntity(previousEntity);
                      }
                      this.previousIndex = -1;
                      this.handleClydeClick(entity,isHistorical,taskId,sensor);
                      this.highlightEntity(entity);
                      this.clickedEntity = entity;
                      previousEntity = entity;
                    }
                  }
                }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  
                this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
  
               if (scene?.operatorKey === this.OPERATOR.CLYDE) {
                  USLcoverage = scene?.footprint?.coordinates[0]
                  BBpoints = USLcoverage.toString().split(',').map(Number);
            
                  this.uslBB = this.viewer.entities.add({
                    sensorId: sensor?.id,
                    polyline: {
                      positions: Cesium.Cartesian3.fromDegreesArray(BBpoints),
                      clampToGround: true,
                      material: new Cesium.PolylineOutlineMaterialProperty({
                        outlineWidth: 3,
                        outlineColor: Cesium.Color.fromRandom({
                          alpha: 1.0,
                        }),
                      }),
                    },
                  });
                  this.uslBB.index = scene?.sceneIdx;
                  this.SpirescnLyr.push(this.uslBB);
                  this.setJsonData(scene,taskId,sensor?.id);
                }
            
                if (this.uslBB) {
                  this.viewer.zoomTo(this.uslBB);
                }
              } else if(type === 'download') {
                const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
                this.downloadService.setProgress(sensorObj);
                const blob = new Blob([JSON.stringify(updatedAis)], {type: 'application/json'});
                const url = window.URL.createObjectURL(blob);
            
                const link = document.createElement('a');
                link.href = url;
                link.download = 'clyde.geojson'; 
                link.click();
            
                // Clean up
                window.URL.revokeObjectURL(url);
                this.progress = 0;
                this.spinnerService.hide();
                this.freeze = false;
                this.disable = false;
              }
            }
          }
          });  
    }
  }

  displayImage(scene) {
    let selectData: any, USLcoverage: any, BBpoints: any;
    let geoJsonFiles: any, crossImages: any;
    //let footprint = scene?.usl_footprint ? scene.usl_footprint : scene.uslFootprint;
    let footprint = scene?.usl_footprint ?? scene?.uslFootprint ?? scene?.footprint;
    this.leftBand = false;
    this.rightBand = false;
    
    if (scene?.x_band && scene?.operatorKey === this.OPERATOR.USL) {
      if (this.bandSelected === 'xband') {
        geoJsonFiles = [scene.x_band];
        crossImages = ['assets/images/cross.png'];
      }
      else if (this.bandSelected === 'sband') {
        geoJsonFiles = [scene.s_band];
        crossImages = ['assets/images/cross-S.png'];
      } else {
        this.leftBand = true;
        this.rightBand = false;
        geoJsonFiles = [scene.x_band, scene.s_band];
        crossImages = ['assets/images/cross.png', 'assets/images/cross-S.png'];
      }
      for (let i = 0; i < geoJsonFiles.length; i++) {
        const currentGeoJsonFile = geoJsonFiles[i];
        const currentCrossImage = crossImages[i];
        const selectData = Cesium.GeoJsonDataSource.load(currentGeoJsonFile);

        selectData.then((dataSource: CustomGeoJsonDataSource) => {
          dataSource.sceneId = scene?.id;
          dataSource.sensorId = this.bandSensorId;
           const entities = dataSource.entities.values;
          for (let j = 0; j < entities.length; j++) {
            let formattedProperties = this.setProperties(entities[j].properties)            
            const entity = entities[j];
            entity.name = 'broRf';
            entity.billboard = new Cesium.BillboardGraphics({
              image: currentCrossImage,
              show: true,
              eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              alignedAxis: Cesium.Cartesian3.ZERO,
              width: 20,
              height: 20,
            });
            entity.properties = new Cesium.PropertyBag(formattedProperties);
          }

          this.viewer.dataSources.add(dataSource);
          this.viewer.scene.globe.depthTestAgainstTerrain = false;
          if (i === geoJsonFiles.length - 1) {
            // Fly to the last loaded data source
            this.viewer.flyTo(dataSource, { duration: 3 });
          }
        });

      }
    } else if (scene?.operatorKey != this.OPERATOR.LBAND) {
      selectData = Cesium.GeoJsonDataSource.load(footprint);
      selectData.then((dataSource: CustomGeoJsonDataSource) => {
        dataSource.sceneId = scene?.id;
        dataSource.sensorId = this.bandSensorId;
        const entities = dataSource.entities.values;
        for (let i = 0; i < entities.length; i++) {
          let formattedProperties = this.setProperties(entities[i].properties)            
          const entity = entities[i];
          entity.name = 'broRf';
          entity.billboard = new Cesium.BillboardGraphics({
            image: 'assets/images/cross.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 20,
            height: 20,
          });
          entity.properties = new Cesium.PropertyBag(formattedProperties);
        }

        this.viewer.flyTo(dataSource, { duration: 3 });
        this.viewer.dataSources.add(dataSource);
        this.viewer.scene.globe.depthTestAgainstTerrain = false;
      });
    }

    if (scene?.metadata?.features && (scene?.operatorKey === this.OPERATOR.USL)) {
      USLcoverage = scene.metadata.features[0].geometry.coordinates[0];
      BBpoints = USLcoverage.toString().split(',').map(Number);

      this.uslBB = this.viewer.entities.add({
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArray(BBpoints),
          clampToGround: true,
          material: new Cesium.PolylineOutlineMaterialProperty({
            outlineWidth: 3,
            outlineColor: Cesium.Color.fromRandom({
              alpha: 1.0,
            }),
          }),
        },
      });
      this.uslBB.index = scene?.sceneIdx;
      this.uslBBList.push(scene?.sceneIdx);
      this.USLscnLyr.push(this.uslBB);      
      this.setJsonData(scene,this.bandTaskId,this.bandSensorId);
    }
    this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    this.displayProperties(this.currentSignal);

    if (this.uslBB) {
      this.viewer.zoomTo(this.uslBB);
    }

  }

  setProperties(data) {
    let properties = {
      ID: data?.ID.getValue(),
      'Timestamp UTC': data?.timestamp_utc.getValue(),
      'RF Frequency MHz': data?.RF_Frequency_MHz.getValue(),
      Lng: data?.longitude_deg.getValue(),
      Lat: data?.latitude_deg.getValue(),
      'Accuracy Level': data?.accuracy_level.getValue(),
      'Pulses Duration ns': data?.pulses_duration_ns.getValue(),
      'Pulses Repetition Frequency Hz': data?.pulses_repetition_frequency_Hz.getValue()
    }
    const waveform = data?.wave_form?.getValue();
    if (waveform && waveform.trim() !== '') {
      properties['Waveform'] = waveform;
    }

    const aisData = data?.ais_correlation?.getValue();
    if (aisData) {
    [1, 2, 3].forEach(num => {
      const confidence = aisData[`cand_${num}_confidence`];
      const mmsi = aisData[`cand_${num}_mmsi`];
      const name = aisData[`cand_${num}_name`];

      const colorClass = `candidate-${num}`;

      if (confidence && confidence.trim() !== '') {
        properties[`<span class="${colorClass}">Candidate ${num} Confidence</span>`] = `<span class="${colorClass}">${confidence}</span>`;
      }
      if (mmsi && mmsi.trim() !== '') {
        properties[`<span class="${colorClass}">Candidate ${num} MMSI</span>`] = `<span class="${colorClass}">${mmsi}</span>`;
      }

      if (name && name.trim() !== '') {
        properties[`<span class="${colorClass}">Candidate ${num} Name</span>`] = `<span class="${colorClass}">${name}</span>`;
      }
    });
  }
  return properties;
  }

  convertToGeoJSON(vesselsData,type: any) {
    // Assuming vesselsData is the JSON object from the API response
    let AISdata: any; 
    if(type === 'overlay' || type === 'CLYDE') AISdata = vesselsData;
    else AISdata = vesselsData.vessels.nodes
    
    if(type == 'CLYDE') {
      const features = AISdata.map(vessel => ({
        type: 'Feature',
        id: vessel.id,
        geometry: {
            type: 'Point',
            coordinates: [vessel.location.longitude, vessel.location.latitude]
        },
        properties: {
            ID: vessel.id,
            MMSI: vessel.mmsi,
            'Timestamp UTC': vessel.timestamp,
            Lng: vessel.location.longitude.toString(),
            Lat: vessel.location.latitude.toString(),
        }
    }));

    return {
        type: 'FeatureCollection',
        features: features
    };
    }
    else {
    const features = AISdata.map(vessel => ({
        type: 'Feature',
        id: vessel.id,
        geometry: {
            type: 'Point',
            coordinates: [vessel.lastPositionUpdate.longitude, vessel.lastPositionUpdate.latitude]
        },
        properties: {
            ID: vessel.id,
            MMSI: vessel.staticData.mmsi,
            Name: vessel.staticData.name,
            'Timestamp UTC': vessel.lastPositionUpdate.timestamp,
            Lng: vessel.lastPositionUpdate.longitude.toString(),
            Lat: vessel.lastPositionUpdate.latitude.toString(),
            Course: vessel.lastPositionUpdate?.course,
            Flag: vessel.staticData.flag,
            'Ship Type': vessel.staticData?.shipType,
            IMO: vessel.staticData?.imo,
            'ETA UTC': vessel?.currentVoyage?.eta,
            'Port Name': vessel?.currentVoyage?.matchedPort?.port?.name,
            Destination: vessel?.currentVoyage?.destination ? vessel?.currentVoyage?.destination : 'N/A',
            Speed: vessel.lastPositionUpdate?.speed ? vessel.lastPositionUpdate.speed : 'N/A',
            'Vessel Length': vessel?.staticData?.dimensions?.length ? vessel?.staticData?.dimensions?.length : 'N/A',
            'Vessel Width': vessel?.staticData?.dimensions?.width ? vessel?.staticData?.dimensions?.width : 'N/A'
        }
    }));

    return {
        type: 'FeatureCollection',
        features: features
    };
  }
}
  

  displayRFImage(scene, sensorIndex, sensorId, taskId) {
    let selectData: any, USLcoverage: any, BBpoints: any;
    let image: string;
    let geoJsonFiles: any, crossImages: any;    
    //let footprint = scene?.usl_footprint ? scene.usl_footprint : scene.uslFootprint;
    let footprint = scene?.usl_footprint ?? scene?.uslFootprint ?? scene?.footprint;
    selectData = Cesium.GeoJsonDataSource.load(footprint);

    if (scene?.x_band && scene?.operatorKey === this.OPERATOR.USL) {
      if (this.bandSelected === 'xband') {
        geoJsonFiles = [scene?.x_band];
        if (sensorIndex === 0) {
          crossImages = ['assets/images/cross.png'];
        } else {
          crossImages = ['assets/images/green-cross.png'];
        }

        this.leftBand = false;
        this.rightBand = false;
      } else if (this.bandSelected === 'sband') {
        geoJsonFiles = [scene?.s_band];
        if (sensorIndex === 0) {
          crossImages = ['assets/images/cross-S.png'];
        } else {
          crossImages = ['assets/images/green-cross-S.png'];
        }

        this.leftBand = false;
        this.rightBand = false;
      } else {
        geoJsonFiles = [scene?.x_band, scene?.s_band];
        if (sensorIndex === 0) {
          this.leftBand = true;
          this.rightBand = false;
          crossImages = ['assets/images/cross.png', 'assets/images/cross-S.png'];
        } else {
          this.rightBand = true;
          crossImages = ['assets/images/green-cross.png', 'assets/images/green-cross-S.png'];
        }
      }

      if (geoJsonFiles.length > 0) {
        for (let i = 0; i < geoJsonFiles.length; i++) {
          const currentGeoJsonFile = geoJsonFiles[i];
          const currentCrossImage = crossImages[i];
          const selectData = Cesium.GeoJsonDataSource.load(currentGeoJsonFile);

          selectData.then((dataSource) => {
            const entities = dataSource.entities.values;
            for (let j = 0; j < entities.length; j++) {
              let formattedProperties = this.setProperties(entities[j].properties)            
              const entity = entities[j];
              entity.name = 'broRf';
              entity.billboard = new Cesium.BillboardGraphics({
                image: currentCrossImage,
                show: true,
                eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                alignedAxis: Cesium.Cartesian3.ZERO,
                width: 20,
                height: 20,
              });
              entity.properties = new Cesium.PropertyBag(formattedProperties);
            }

            this.viewer.dataSources.add(dataSource);
            this.viewer.scene.globe.depthTestAgainstTerrain = false;
            if (i === geoJsonFiles.length - 1) {
              // Fly to the last loaded data source
              this.viewer.flyTo(dataSource, { duration: 3 });
            }
          });
        }
      }
    } else if (scene?.operatorKey != this.OPERATOR.LBAND) {
      selectData.then((dataSource) => {
        const entities = dataSource.entities.values;
        for (let i = 0; i < entities.length; i++) {
          const entity = entities[i];
          let formattedProperties = this.setProperties(entities[i].properties)            
          if (sensorIndex === 0) {
            image = 'assets/images/cross.png';
          } else {
            image = 'assets/images/green-cross.png';
          }
          entity.name = 'broRf';
          entity.billboard = new Cesium.BillboardGraphics({
            image: image,
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 20,
            height: 20,
          });
          entity.properties = new Cesium.PropertyBag(formattedProperties);
        }
  
        this.viewer.flyTo(dataSource, { duration: 3 });
        this.viewer.dataSources.add(dataSource);
        this.viewer.scene.globe.depthTestAgainstTerrain = false;
      });
    }

    this.handleAnnotation();

    if (scene?.metadata?.features && scene?.operatorKey === this.OPERATOR.USL) {
      let bbColor: any;
      if (sensorIndex === 0) {
        bbColor = Cesium.Color.RED;
      } else {
        bbColor = Cesium.Color.GREEN;
      }
      USLcoverage = scene.metadata.features[0].geometry.coordinates[0];
      BBpoints = USLcoverage.toString().split(',').map(Number);
      this.uslBB = this.viewer.entities.add({
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArray(BBpoints),
          clampToGround: true,
          material: new Cesium.PolylineOutlineMaterialProperty({
            outlineWidth: 10,
            outlineColor: bbColor,
          }),
        },
      });
      this.uslBB.index = scene?.sceneIdx;
      this.USLscnLyr.push(this.uslBB);
    }
    this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    this.displayProperties(this.currentSignal);

    if (this.uslBB) {
      this.viewer.zoomTo(this.uslBB);
    }

  }
  RFOverlay(i: any, j: any, k: any, e: any, type: any, task: any,operatorKey) {
    const taskId = this.collections[i]?.taskId;
    if (e?.checked) {
      this.showSubDailyList = false;
      this.selectedSubDailyItems = [];
      this.selectOption(task?.recurrencyArray[j], 'split');
      this.overlay[j] = 100;

      if (this.selectedCheckboxes.length < 2) {
        this.collection.recurrencyArray[j].index = j;
        this.collection.recurrencyArray[j].scenes.forEach((scene, index) => {
          if (scene.status !== "failed")
            scene.checked = true
        });
        this.collection.recurrencyArray[j].name = (this.collection.sensors[0].name);
        this.collection.recurrencyArray[j].resolution_tooltip = (this.collection.sensors[0]?.resolution_tooltip);
        this.collection.recurrencyArray[j].isAdditionalProducts = (this.collection.sensors[0]?.isAdditionalProducts);
        this.collection.recurrencyArray[j].isAdditionalCSIProducts = (this.collection.sensors[0]?.isAdditionalCSIProducts);
        this.collection.recurrencyArray[j].downloaded = (this.collection.sensors[0]?.downloaded);
        this.collection.recurrencyArray[j].status = (this.collection.sensors[0]?.status);
        this.collection.recurrencyArray[j].restoreStatus = (this.collection.sensors[0]?.restoreStatus);
        this.collection.recurrencyArray[j].restoreOption = (this.collection.sensors[0]?.restoreOption);
        // Only allow selection if less than 2 checkboxes are already selected
        this.selectedCheckboxes.push(this.collection.recurrencyArray[j]);
        this.setPreviousSelectiontext();
        this.selectionChange.next(this.collection.recurrencyArray[j])
      } else {
        if (this.selectedCheckboxes.length >= 2) {
          this.selectedCheckboxes.shift();
          this.collection.recurrencyArray[j].index = j;
          this.collection.recurrencyArray[j].name = (this.collection.sensors[0].name);
          this.collection.recurrencyArray[j].resolution_tooltip = (this.collection.sensors[0]?.resolution_tooltip);
          this.collection.recurrencyArray[j].isAdditionalProducts = (this.collection.sensors[0]?.isAdditionalProducts);
          this.collection.recurrencyArray[j].isAdditionalCSIProducts = (this.collection.sensors[0]?.isAdditionalCSIProducts);
          this.collection.recurrencyArray[j].downloaded = (this.collection.sensors[0]?.downloaded);
          this.collection.recurrencyArray[j].status = (this.collection.sensors[0]?.status);
          this.collection.recurrencyArray[j].restoreStatus = (this.collection.sensors[0]?.restoreStatus);
          this.collection.recurrencyArray[j].restoreOption = (this.collection.sensors[0]?.restoreOption);
          // Only allow selection if less than 2 checkboxes are already selected
          this.selectedCheckboxes.push(this.collection.recurrencyArray[j]);
          this.setPreviousSelectiontext();
          this.selectionChange.next(this.collection.recurrencyArray[j])
          this.collection.recurrencyArray.forEach((sensor, index) => {
            const indexToRemove = this.selectedCheckboxes.findIndex((item) => item.index === sensor.index);
            if (indexToRemove === -1) {
              sensor.checked = false
            }
          });

        }
        //  If already 2 checkboxes are selected, prevent this selection
      }
      if (this.selectedSensors.length === 0) {
        this.collection.sensors[0].index = j;
        this.collection.sensors[0].start = e.start;
        this.selectedSensors.push(this.collection.sensors[0])
        if (j === 0) {
          this.sensorList[j] = this.collection.sensors[0]
        }
      } else {
        const findIndex = this.selectedSensors
          .filter(function (el) {
            return el.index === j;
          })
        if (findIndex.length === 0) {
          this.collection.sensors[0].index = j;
          this.collection.sensors[0].start = e.start;
          this.selectedSensors.push(this.collection.sensors[0])
          this.sensorList.push(this.collection.sensors[0])
        } else {
          this.collection.sensors[0].index = j;
          this.collection.sensors[0].start = e.start;
          this.selectedSensors.push(this.collection.sensors[0])
        }

      }
      if (k === undefined) {
        this.viewer.entities.removeAll();
        this.clearBandLegends();
        for (const [sensorIndex, sensors] of this.selectedCheckboxes.entries()) {
          sensors.checked = true
          if (operatorKey === OPERATORS.LBAND) {
            this.selectSignals(sensors, this.signalSelected)
          } else {
            for (const [index, scn] of sensors?.scenes.entries()) {
              if (scn?.id && scn?.status !== 'failed') {
                scn.checked = true;
                this.displayRFImage(scn, sensorIndex, sensors.id, taskId);
              }
            }
          }
        }

        if (this.selectedSensors.length === 0)
          this.collection.recurrencyArray[j].checked = e?.checked;
      } else {
        this.selectedCheckboxes[j].scenes[k].checked = e?.checked;
        const scn = this.selectedCheckboxes[j].scenes[j]?.scenes[k];
      }
    } else {

      if (k === undefined) {
        this.overlay[j] = 100
        const indexToRemove = type === "dropdown" ? this.selectedCheckboxes.findIndex((item) => item.start === this.collection.recurrencyArray[j].start) : j;
        const indexToRemoveSelectedSensor = this.selectedCheckboxes.findIndex((item) => item.index === j);
        if (indexToRemove !== -1) {

          this.selectedCheckboxes.splice(indexToRemove, 1);

          this.selectionChange.next(this.selectedCheckboxes[0])
          this.subSelectionSelectionChange.next(1)
          if (this.collection.recurrencyArray.filter(item => item.checked).length > 0) {

            this.collection.recurrencyArray.forEach((sensor, index) => {
              const indexTouncheck = this.selectedCheckboxes.findIndex((item) => item.start === sensor.start);
              if (indexTouncheck === -1) {
                sensor.checked = false
                sensor.scenes.forEach((scene) => {
                  scene.checked = false

                });
              }
            });
          }
        }

        if (indexToRemoveSelectedSensor !== -1) {
          this.selectedSensors.splice(indexToRemoveSelectedSensor, 1);
        }

        if (this.selectedCheckboxes?.length === 0) {
          this.viewer.entities.removeAll();
          this.clearBandLegends();
          this.toggleDailyRecurrency(e)
        } else {

          this.viewer.entities.removeAll();
          this.clearBandLegends();
          for (const [sensorIndex, sensors] of this.selectedCheckboxes.entries()) {
            sensors.checked = true
            if (operatorKey === OPERATORS.LBAND) {
              this.selectSignals(sensors, this.signalSelected)
            } else {
            for (const [index, scn] of sensors?.scenes.entries()) {
              if (scn?.id && scn?.status !== 'failed') {
                if (scn.checked) {
                  this.displayRFImage(scn, sensorIndex, sensors.id, taskId);
                }
              }
            }
          }
          }
        }

      } else {
        if (this.selectedCheckboxes?.length === 0) {
          this.toggleDailyRecurrency(e)
        } else {
          this.viewer.entities.removeAll();
          this.clearBandLegends();
          if (operatorKey === OPERATORS.LBAND) {
            this.selectSignals(this.selectedCheckboxes, this.signalSelected)
          }
          this.selectedCheckboxes[0].scenes.forEach(scene => {
            if (scene.checked) {
              if (operatorKey === OPERATORS.USL) {
                this.displayRFImage(scene, this.selectedCheckboxes?.length, 'none', taskId);
              }
            }
          });
        }       
      }
    }
  }

  async toggleRecurrentSensor(i: any, j: any, k: any, e: any, type: any, task: any) {

    let unShowSensor = this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.USL && 
    this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.LBAND;

    if (task?.recurrencyArray && (task?.recurrencyArray[j]?.scenes[0]?.operatorKey === this.OPERATOR.USL ||
      task?.recurrencyArray[j]?.scenes[0]?.operatorKey === this.OPERATOR.LBAND) && k === undefined) {
      let operatorKey = task?.recurrencyArray[j]?.scenes[0]?.operatorKey;
      this.RFOverlay(i, j, k, e, type, task, operatorKey);
      this.RF = true;
    } else if ((task?.operatorKey === this.OPERATOR.USL || task?.operatorKey === this.OPERATOR.LBAND) && k === undefined) {
      let operatorKey = task?.operatorKey;
      this.RFOverlay(i, j, k, e, type, task, operatorKey);
      this.RF = true;
    } else {

    this.RF = false;
    let sceneId: any;
    let sensorId: any;
    let action: any;
    const taskId = this.collections[i]?.taskId;
    this.fail = 0;
    let selectedDropdown: any
    if (type === "dropdown" && this.collection.recurrencyArray[j]) {

      this.collection.recurrencyArray[j].checked = e?.checked;
      selectedDropdown = this.collection.recurrencyArray[j]
    }

    if (this.collection.recurrencyArray.filter(item => item.checked).length > 0) {
      this.collection.sensors.forEach((sensor, index) => {
        sensor.checked = true
        sensor.scenes.forEach((scene) => {
          if (scene?.status != "failed")
            scene.checked = true

        });
      });
    }

    if (e?.checked && k === undefined) {
    const hasSkipPreview = this.collection.recurrencyArray[j].scenes?.some(scene => (scene.skipPreview === true || !scene.footprint));
    if (hasSkipPreview) {
      let message = `Not all scenes on this project can be visualised. Clicking on scene's
                    checkboxes will identify those that cannot be visualised. All scenes can
                    still be downloaded individually or at the project level.`
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }

      if (this.collection?.recurrencyArray[0]?.repeatFrequency === 'GHG-Monthly') {
        this.selectSite(this.selectedSites[0].value);
      }     
      else if (this.collection?.recurrencyArray?.length > 1) {
        this.selectOption(this.collection?.recurrencyArray[j], 'split');
      } else {
        this.selectOption(this.collection?.recurrencyArray[0], 'split');
      }
      this.overlay[j] = 100;

      if (this.selectedCheckboxes.length < 2) {
        this.collection.recurrencyArray[j].index = j;
        this.collection.recurrencyArray[j].scenes.forEach((scene, index) => {
          if (scene.status !== "failed" && !scene.skipPreview && scene.footprint)
            scene.checked = true
        });
        this.collection.recurrencyArray[j].name = (this.collection.sensors[0].name);
        this.collection.recurrencyArray[j].resolution_tooltip = (this.collection.sensors[0]?.resolution_tooltip);
        this.collection.recurrencyArray[j].isAdditionalProducts = (this.collection.sensors[0]?.isAdditionalProducts);
        this.collection.recurrencyArray[j].isAdditionalCSIProducts = (this.collection.sensors[0]?.isAdditionalCSIProducts);
        this.collection.recurrencyArray[j].downloaded = (this.collection.sensors[0]?.downloaded);
        this.collection.recurrencyArray[j].status = (this.collection.sensors[0]?.status);
        this.collection.recurrencyArray[j].restoreStatus = (this.collection.sensors[0]?.restoreStatus);
        this.collection.recurrencyArray[j].restoreOption = (this.collection.sensors[0]?.restoreOption);
        this.collection.recurrencyArray[j].assetsDelivered = (this.collection.sensors[0]?.assetsDelivered);

        // Only allow selection if less than 2 checkboxes are already selected
        this.selectedCheckboxes.push(this.collection.recurrencyArray[j]);
        this.setPreviousSelectiontext();
        this.selectionChange.next(this.collection.recurrencyArray[j])
      } else {
        if (this.selectedCheckboxes.length >= 2) {
          this.selectedCheckboxes.shift();
          this.collection.recurrencyArray[j].index = j;
          this.collection.recurrencyArray[j].name = (this.collection.sensors[0].name);
          this.collection.recurrencyArray[j].resolution_tooltip = (this.collection.sensors[0]?.resolution_tooltip);
          this.collection.recurrencyArray[j].isAdditionalProducts = (this.collection.sensors[0]?.isAdditionalProducts);
          this.collection.recurrencyArray[j].isAdditionalCSIProducts = (this.collection.sensors[0]?.isAdditionalCSIProducts);
          this.collection.recurrencyArray[j].downloaded = (this.collection.sensors[0]?.downloaded);
          this.collection.recurrencyArray[j].status = (this.collection.sensors[0]?.status);
          this.collection.recurrencyArray[j].restoreStatus = (this.collection.sensors[0]?.restoreStatus);
          this.collection.recurrencyArray[j].restoreOption = (this.collection.sensors[0]?.restoreOption);
          this.collection.recurrencyArray[j].assetsDelivered = (this.collection.sensors[0]?.assetsDelivered);

          // Only allow selection if less than 2 checkboxes are already selected
          this.selectedCheckboxes.push(this.collection.recurrencyArray[j]);
          this.setPreviousSelectiontext();
          this.selectionChange.next(this.collection.recurrencyArray[j])
          this.collection.recurrencyArray.forEach((sensor, index) => {
            const indexToRemove = this.selectedCheckboxes.findIndex((item) => item.index === sensor.index);
            if (indexToRemove === -1) {
              sensor.checked = false
            }
          });

        }
        //  If already 2 checkboxes are selected, prevent this selection
      }

      this.selecetedData = JSON.parse(JSON.stringify(this.selectedCheckboxes));
      
      if (this.datePlace) {  
        this.showSubDailyList = false;
        this.subDailyCount = '';
        this.selectedSubdaily = '';

        if (this.selectedCheckboxes[0].name === undefined && this.subDailyFinalArray?.length > 0) {
          this.selectedCheckboxes[0].name = this.subDailyFinalArray[0].name;
          this.selectedCheckboxes[0].id = this.subDailyFinalArray[0].id;
          this.selectedCheckboxes[0].status = this.subDailyFinalArray[0].status;
        }
       
        if (this.selectedSite || this.selectedSites[0]) {
          let site = this.selectedSite ? this.selectedSite : this.selectedSites[0]          
        this.selectedCheckboxes = this.selectedCheckboxes.map(checkbox => {
          if (checkbox.checked) {
            checkbox.scenes = checkbox.scenes.filter(scene => scene.siteId === site.siteId);
          }
          return checkbox;
        });
        this.subDailyCount = 'Site Name : ' + site?.siteName;
        this.selectedSubdaily = 'Site Name : ' + site?.siteName;        
      }

      } else this.selectedCheckboxes = this.selecetedData;      
      
      if (this.selectedSensors.length === 0) {
        this.collection.sensors[0].index = j;
        this.collection.sensors[0].start = e.start;
        this.selectedSensors.push(this.collection.sensors[0])
        if (j === 0) {
          this.sensorList[j] = this.collection.sensors[0]
        }
      } else {
        const findIndex = this.selectedSensors
          .filter(function (el) {
            return el.index === j;
          })
        if (findIndex.length === 0) {
          this.collection.sensors[0].index = j;
          this.collection.sensors[0].start = e.start;
          this.selectedSensors.push(this.collection.sensors[0])
          this.sensorList.push(this.collection.sensors[0])
        } else {
          this.collection.sensors[0].index = j;
          this.collection.sensors[0].start = e.start;
          this.selectedSensors.push(this.collection.sensors[0])
        }

      }
      if (k === undefined) {


        this.viewer.entities.removeAll();
         this.clearBandLegends();
        this.resetBackgroundWithChangeInBaseLayer();
        this.scnLyr = [];
        this.scnLyr2 = [];
       for (const [sensorIndex, sensors] of this.selectedCheckboxes.entries()) {
          sensors.checked = true

          for (const [index, scn] of sensors?.scenes.entries()) {
            if (scn?.id && scn?.status !== 'failed' && !scn.skipPreview && scn.footprint) {
              scn.checked = true

              if (scn.footprint) {
                const sensorId = sensors?.id;
                const sceneId = scn?.id;
                const action = "sensor"
                const taskId = this.collection?.taskId;
                const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
                this.spinnerService.show();
                this.mapLoad = true;
                this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
                  if (res?.msg === 'Failed') {
                    this.fail = this.fail + 1;
                    if (this.fail === 1) {
                      const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                    }
                    this.spinnerService.hide();
                    this.mapLoad = false;
                  } else if (res?.msg === 'user storage') {
                    this.fail = this.fail + 1;
                    if (this.fail === 1) {
                      const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                    }
                    this.spinnerService.hide();
                    this.mapLoad = false;
                  }
                  scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
                  this.displayFootPrint(scn, sensorIndex, res.result,sensorId,taskId);
                  this.spinnerService.hide();
                  this.mapLoad = false;
                });

              }
            }
          }


        }
        if (this.selectedCheckboxes.length === 2 && unShowSensor) {
          this.isVisible = true
          this.splitRightPostion = true
          this.splitLeftPostion = true
          this.splitPosition = 0.5;
          this.clearAnnotations();
        }
        this.selectedSensors = this.selectedCheckboxes
        if (this.selectedSensors.length === 0)
          this.collection.recurrencyArray[j].checked = e?.checked;
      } else {
        this.selectedCheckboxes[j].scenes[k].checked = e?.checked;
        const scn = this.selectedCheckboxes[j].scenes[j]?.scenes[k];
        if (e?.checked) {
          if (scn.footprint) {
            sensorId = this.selectedSensors[j]?.id;
            action = "scene"
            sceneId = scn?.id;
            this.spinnerService.show();
            this.mapLoad = true;
            const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
            this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
              if (res?.msg === 'Failed') {
                this.spinnerService.hide();
                this.mapLoad = false;
                const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              } else if (res?.msg === 'user storage') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              }
              if (this.selectedSensors[j]?.scenes[k]?.thumbnailUrl) {
                this.selectedSensors[j].scenes[k].thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
              }
              scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
              this.displayFootPrint(scn, j, res.result,sensorId,taskId);
              this.spinnerService.hide();
              this.mapLoad = false;
            });
          }
        }


      }
    } else if (e?.checked && k !== undefined) {
      const scn = this.selectedCheckboxes[j].scenes[k];
      if ((scn.skipPreview || ((!scn.footprint || !scn.scene_id) && !scn.uslFootprint && !scn.usl_footprint && !scn.signalOfInterest)) && k != undefined) {//scene level
      this.showNoPreview(e, scn);
      this.selectedCheckboxes[j].scenes[k].checked = false;
      return;
    }

      if (scn?.operatorKey === this.OPERATOR.USL || scn?.operatorKey === this.OPERATOR.LBAND) {
        this.viewer.entities.removeAll();
        this.clearBandLegends();
        for (const [sensorIndex, sensors] of this.selectedCheckboxes.entries()) {
          if (scn?.operatorKey === OPERATORS.LBAND) {
            this.selectSignals(sensors, this.signalSelected)
          } else {
            for (const item of sensors.scenes) {
              if (item.checked && item.operatorKey === this.OPERATOR.USL) {
                this.displayRFImage(item, sensorIndex, sensors.id,taskId);
              }
            }
          }
        }
      }

      if (e?.checked) {
        if (scn.footprint) {
          sensorId = this.selectedSensors[j]?.id;
          action = "scene"
          sceneId = scn?.id;
          this.spinnerService.show();
          this.mapLoad = true;
          const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
          this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
            if (res?.msg === 'Failed') {
              this.spinnerService.hide();
              this.mapLoad = false;
              const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            } else if (res?.msg === 'user storage') {
              this.fail = this.fail + 1;
              if (this.fail === 1) {
                const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              }
              this.spinnerService.hide();
              this.mapLoad = false;
            }
            scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
            this.displayFootPrint(scn, j, res.result,sensorId,taskId);
            this.spinnerService.hide();
            this.mapLoad = false;
          });
        }
      }
    } else {
      // Checkbox is being deselected


      if (k === undefined) {
        this.overlay[j] = 100
        const indexToRemove = type === "dropdown" ? this.selectedCheckboxes.findIndex((item) => item.start === this.collection.recurrencyArray[j].start) : j;
        const indexToRemoveSelectedSensor = this.selectedCheckboxes.findIndex((item) => item.index === j);
        if (indexToRemove !== -1) {

          this.selectedCheckboxes.splice(indexToRemove, 1);

          this.selectionChange.next(this.selectedCheckboxes[0])
          this.subSelectionSelectionChange.next(1)
          if (this.collection.recurrencyArray.filter(item => item.checked).length > 0) {

            this.collection.recurrencyArray.forEach((sensor, index) => {
              const indexTouncheck = this.selectedCheckboxes.findIndex((item) => item.start === sensor.start);
              if (indexTouncheck === -1) {
                sensor.checked = false
                sensor.scenes.forEach((scene) => {
                  scene.checked = false

                });
              }
            });
          }
        }

        if (indexToRemoveSelectedSensor !== -1) {
          this.selectedSensors.splice(indexToRemoveSelectedSensor, 1);
        }
      }
      if (j === 0) {

        var allImageryLayers = this.viewer.imageryLayers._layers;
        var leftImageryLayers: any = [];
        var rightImageryLayers: any = [];
        for (var index = 0; index < allImageryLayers.length; index++) {
          var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url

          var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
          var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
          if (url !== undefined && isLeft) {
            leftImageryLayers.push(allImageryLayers[index]);
          }
          if (url !== undefined && isRight) {
            rightImageryLayers.push(allImageryLayers[index]);
          }
        }
        if (k === undefined) {

         if (this.selectedCheckboxes.length === 0 && rightImageryLayers.length === 1) {
            for (let rightIndex = 0; rightIndex < rightImageryLayers.length; rightIndex++) {
              this.viewer.imageryLayers.remove(rightImageryLayers[rightIndex]);
            }
            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
             this.scnLyr[indexToRemoveEntity].show = false;
            }
            for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = false;
           }

            this.scnLyr2 = []
            this.scnLyr = []
          }
          else {
            for (var leftIndex = 0; leftIndex < leftImageryLayers.length; leftIndex++) {
              this.viewer.imageryLayers.remove(leftImageryLayers[leftIndex]);
            }

            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr[indexToRemoveEntity].show = false;
             }

          }


        } else {
          const findSensor = this.selectedCheckboxes[j]
          if (leftImageryLayers.length === 1) {
            this.viewer.imageryLayers.remove(leftImageryLayers[0]);

            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              const item = this.scnLyr[indexToRemoveEntity];              
              if (item.index === findSensor.scenes[k].sceneIdx) {
                this.scnLyr[indexToRemoveEntity].show = false;
                this.scnLyr.splice(indexToRemoveEntity, 1);
              }
            }

          } else {

            if (leftImageryLayers.length === 0) {
              for (let rightIndex = 0; rightIndex < rightImageryLayers.length; rightIndex++) {
                this.viewer.imageryLayers.remove(rightImageryLayers[rightIndex]);
              }
              for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                  this.scnLyr2[indexToRemoveEntity].show = false;
                  this.scnLyr2.splice(indexToRemoveEntity, 1);
              }
            }
             else {
              if (allImageryLayers.length === 1 && rightImageryLayers.length === 1) {
                for (let rightIndex = 0; rightIndex < rightImageryLayers.length; rightIndex++) {
                  this.viewer.imageryLayers.remove(rightImageryLayers[rightIndex]);

                }
                for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                  this.scnLyr2[indexToRemoveEntity].show = false;
                  this.scnLyr2.splice(indexToRemoveEntity, 1);
              }
              }
              else {
                for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
                  if (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl)) {
                    this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
                  }
                }
                for (
                  let indexToRemoveEntity = this.scnLyr?.length - 1;
                  indexToRemoveEntity >= 0;
                  indexToRemoveEntity--
                ) {
                  const item = this.scnLyr[indexToRemoveEntity];
                  if (item.index === findSensor.scenes[k].sceneIdx) {
                    this.scnLyr[indexToRemoveEntity].show = false;
                    this.scnLyr.splice(indexToRemoveEntity, 1);
                  }
                }
              }

            }

          }
          if (this.selectedCheckboxes[j].scenes.filter(item => item.checked).length === 0) {
            this.selectedCheckboxes[j].checked = false
            this.selectedCheckboxes.splice(j, 1);
          }

        }


      }
      else {
        var allImageryLayers = this.viewer.imageryLayers._layers;
        var leftImageryLayers: any = [];
        var rightImageryLayers: any = [];
        for (var index = 0; index < allImageryLayers.length; index++) {
          var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url;
          var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
          var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
          if (url !== undefined && isLeft) {
            leftImageryLayers.push(allImageryLayers[index]);
          }
          if (url !== undefined && isRight) {
            rightImageryLayers.push(allImageryLayers[index]);
          }
        }
        if (k === undefined) {

          for (let rightIndex = 0; rightIndex < rightImageryLayers.length; rightIndex++) {
            this.viewer.imageryLayers.remove(rightImageryLayers[rightIndex]);
          }
          if (leftImageryLayers.length > 0) {
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = true;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = false;
          }
        }

        } else {
          const findSensor = this.selectedCheckboxes[j]
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            const item = this.scnLyr2[indexToRemoveEntity];              
            if (item.index === findSensor.scenes[k].sceneIdx) {
              this.scnLyr2[indexToRemoveEntity].show = false;
            }
          }
          if (rightImageryLayers.length === 1) {
            this.viewer.imageryLayers.remove(rightImageryLayers[0]);
          } else {


            if (rightImageryLayers.length === 0) {
              for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
                if (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl)) {
                  this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
                }
              }
             } else {
              for (var index = 0; index < rightImageryLayers.length; index++) {
                if (rightImageryLayers[index]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || (rightImageryLayers[index]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl) ) {
                  this.viewer.imageryLayers.remove(rightImageryLayers[index]);
                }
              }
            }
            if (this.selectedCheckboxes[j].scenes.filter(item => item.checked).length === 0) {
              this.selectedCheckboxes[j].checked = false
              this.selectedCheckboxes.splice(j, 1);
            }

          }
          if (this.selectedCheckboxes[j]?.scenes.filter(item => item.checked).length === 0) {
            this.selectedCheckboxes[j].checked = false
            this.selectedCheckboxes.splice(j, 1);
          }
        }
        if (leftImageryLayers.length === 0) {
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = false;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = true;
          }
          
        }
        if (rightImageryLayers.length === 0) {
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = true;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = false;
          }
        }

        if (leftImageryLayers.length === 0 && rightImageryLayers.length === 0) {
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = false;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = false;
          }
        }


      }
      const uniqueArray: any = [];
      const seenIds = new Set();

      for (const item of this.selectedSensors) {
        if (!seenIds.has(item.index && item.start)) {
          seenIds.add(item.index && item.start);
          uniqueArray.push(item);
        }
      }

      this.selectedSensors = uniqueArray
      if (this.selectedCheckboxes.length < 2) {
        this.isVisible = false
        this.splitRightPostion = false
        this.splitLeftPostion = false
        this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
        this.viewer.scene.imagerySplitPosition = undefined;
        this.splitPosition = 0.0;
      }
      
      if (this.collection.sensors[0]?.scenes[0]?.operatorKey === this.OPERATOR.USL || 
        this.collection.sensors[0]?.scenes[0]?.operatorKey === this.OPERATOR.LBAND
      ) {
        let operatorKey = this.collection.sensors[0]?.scenes[0]?.operatorKey;
        this.viewer.entities.removeAll();
        this.clearBandLegends();
        for (const [sensorIndex, sensors] of this.selectedCheckboxes.entries()) {
          if (operatorKey === OPERATORS.LBAND) {
            this.selectSignals(sensors, this.signalSelected)
          } else {
            for (const item of sensors.scenes) {
              if (item.checked && item.operatorKey === this.OPERATOR.USL) {
                this.displayRFImage(item, sensorIndex, sensors.id,taskId);
              }
            }
          }
        }
      }

      if (this.selectedCheckboxes?.length === 0 && !this.datePlace) {
        this.toggleDailyRecurrency(e)
      }

      if (this.selectedCheckboxes?.length === 0 && this.datePlace) {
        this.currentEvent = {
          checked : true
         };

         let site = this.subDailyCountarray.filter(item => item.checked);
         this.selectedSites = [];
        this.selectSiteRecurrent(this.currentEvent,site[0]);        
      }

    }

    const findIndexImage = this.collection.recurrencyArray[j]?.scenes
      .filter(function (el) {

        return el.checked;
      })

    if (findIndexImage.length === 0) {

    } else {
      var bothSensorSelected: any = []
      this.selectedCheckboxes.forEach((item: any, index: any) => {
        const findIndexsensor = item.scenes
          .filter(function (el) {

            return el.checked;
          })
        if (findIndexsensor.length > 0)
          bothSensorSelected.push(item)

      });



    }

    if (this.selectedCheckboxes.length === 2 && unShowSensor) {
      this.isVisible = true
      this.splitRightPostion = true
      this.splitLeftPostion = true
      this.splitPosition = 0.5;
      this.clearAnnotations();
    } else {
      this.isVisible = false;
      this.splitRightPostion = false
      this.splitLeftPostion = false
      this.splitPosition = 0.0;
    }

    this.collection.sensor = this.selectedSensors;
    if (this.selectedCheckboxes.length > 0) {
      this.collection.sensors.forEach((sensor, index) => {
        sensor.checked = true
        sensor.scenes.forEach((scene) => {
          scene.checked = true

        });
      });
      if (this.selectedCheckboxes.length === 1)
        this.SensorIndex = this.selectedCheckboxes[0].index
    }
    if (this.collection.recurrencyArray.filter(item => item.checked).length > 0) {
      this.collection.sensors.forEach((sensor, index) => {
        sensor.checked = true
        sensor.scenes.forEach((scene) => {
          scene.checked = true

        });
      });
    }
    if (this.selectedCheckboxes.length === 1) {
      this.selectedIndex = this.selectedCheckboxes[0].index
    }

    this.monthSelected = null;
    this.selectedType = null;
    const filteredCheckboxes = this.selectedCheckboxes.filter(item => item.checked);
    if (this.datePlace && filteredCheckboxes[0]) {
      this.monthSelected = filteredCheckboxes[0];
      if (filteredCheckboxes?.length === 1) {
        this.selectedType = 'dateDropdown';
        this.selectRecurrency(filteredCheckboxes[0], 'split');
        if (this.selectedSite) {
          this.subDailyCountarray = this.subDailyCountarray.map(site => {
            if (site.value === this.selectedSite.value) {
              return { ...site, checked: true };
            }
            return site;
          });
        }   
      }

      const filteredCheckbox = this.subDailyCountarray.filter(item => item.checked);      
      if (filteredCheckbox?.length === 1) {
        this.dateDisable = false;
      }

    }
    
  }

  if (this.selectedCheckboxes?.length === 2 && this.datePlace) {
    if (this.selectedSites.length > 0) {
      this.selectedSites[0].checked = true;
    }
  }

  const checkedItemsLength = this.subDailyCountarray.filter(item => item.checked).length;  
  if (checkedItemsLength === 0 && this.datePlace) {        
    for (const count of this.subDailyCountarray) {
      if (count.value === this.selectedSites[0].value) {
        count.checked = true;
        this.siteSelected = count;        
      }
    }
  }

  }

  setPreviousSelectiontext() {
    if (this.selectedCheckboxes[0] && this.selectedCheckboxes[0]?.start) {
      const start = this.formatDate(new Date(this.selectedCheckboxes[0]?.start))
      const end = this.formatDate(new Date(this.selectedCheckboxes[0]?.end));
      const combinedDate = `${start} - ${end}`;
      if (this.dateRange) {
        this.previousSelectionText = new Date(this.selectedCheckboxes[0]?.start);
        this.previousEndText = new Date(this.selectedCheckboxes[0]?.end);
      } else
        this.previousSelectionText = new Date(this.selectedCheckboxes[0]?.start)
    }
  }

  formatDate(date) {
    const day = String(date.getDate() - 1).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Note that months are 0-based.
    const year = String(date.getFullYear()).slice(-4);

    return `${day}/${month}/${year}`;
  }
  async toggleSensor(i: any, j: any, k: any, e: any, scenes: any, taskAll:any = false) {
    // console.log("scens",scenes);

    this.resetAllFeedPanels();
    if (this.getCollectionSub) {
    this.getCollectionSub.unsubscribe();
    }
            this.collections[i].sensors[j]?.indicesDetails?.forEach((detail) => {
          delete detail.disabled;
      });
    this.unSubscribeAPI();
    const hasSkipPreview = this.collections[i].sensors[j]?.scenes?.some(scene => (scene.skipPreview === true || !scene.footprint));
    if ((scenes.skipPreview || ((!scenes.footprint || !scenes.scene_id) && !scenes.uslFootprint && !scenes.signalOfInterest)) && k != undefined) {//scene level
      if(e.checked) {
        this.showNoPreview(e,scenes);
      }
      return;
    } else if (k === undefined && hasSkipPreview && e.checked) { // sensor level
      let message: string | false = false;
      if (!scenes.isNonImagery && scenes.scene_id) {
        message = `Not all scenes on this project can be visualised. Clicking on scene's
            checkboxes will identify those that cannot be visualised. All scenes can
            still be downloaded individually or at the project level.`
      } else if (scenes.scene_id && scenes.isNonImagery &&  !scenes.footprint &&
        ((scenes.operatorKey === 'USL' && !scenes.uslFootprint && (scenes.s_band || scenes.x_band)) ||
        (scenes.operatorKey === 'Spire-RF' && !scenes.signalOfInterest))) {
        message = `Not all collections on this project can be visualised. Clicking on collection's
          checkboxes will identify those that cannot be visualised. All collections can
          still be downloaded individually or at the project level.`;
      } else if (scenes.operatorKey === 'USL'&& !scenes.s_band && !scenes.x_band) {
        message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
      }

      if (message) {
        const dialogRef = this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        dialogRef.afterClosed().subscribe(() => {
          this.displayToggleSensor(i, j, k, e,scenes);
        });
      } else {
         if (e.checked){
          this.observationEnabled = true;
         } else {
          this.observationEnabled = false;
         }
         this.displayToggleSensor(i, j, k, e,scenes);
      }
      return;
    }

    if (e.checked){
      this.observationEnabled = true;
    } else {
      this.observationEnabled = false;
    }
    this.displayToggleSensor(i, j, k, e,scenes,taskAll);
  } 

  async displayToggleSensor(i: any, j: any, k: any, e: any, scenes: any, taskAll: any = false) {
    this.progressing = false;
    this.feedInfo = false;
    if(this.selectedIndices){
      this.collections[i].sensors[j].scenes[k].checked = e.checked; 
      if(this.collections[i].sensors[j]?.operatorKey === OPERATORS.AXELSPACE){
        if(e.checked){
           this.resetIndicesOptions(i, j, e)
           return;   
        } else {
            this.collections[i]?.sensors[j].indicesDetails.forEach((i) => {
             i.checked = false;
             })
             this.selectedIndices = null;      
             this.selectIndices(i,j,'',e);
             return;
        }   
      }else {
       this.resetIndicesOptions(i, j, e);
      }
      
    }  
    if(this.selectedSR !== null) {
      this.resetSROptions(i, j, e);
       this.resetCurrentProductLayer();
    }  
    if(k === undefined) 
      this.selectedOptions = [];    
    let sceneId: any;
    let sensorId: any;
    let action: any;
    const taskId = this.collections[i]?.taskId;
    this.fail = 0;
    let count = 0;
    let previouseSceneId: any;
    this.selectedRecurrencyArray = [];

    if(scenes?.operatorKey === this.OPERATOR.CLYDE && e?.checked && this.collections[i].sensors[j].status === 'canceled') {
      const message = 'The user has cancelled the task, and the data is unavailable';
      this.popupService.openPopup(WarningPopupComponent, message, '', '40%');
    } else {
    if (e?.checked) {
      this.operatorArray.push(scenes?.operatorKey);
    } else {
      const index = this.operatorArray.findIndex(selectedItem => selectedItem === scenes?.operatorKey);
      this.operatorArray.splice(index, 1);
    }

    if (this.timeseries) {
      if (this.slider) this.slider.value = 0;
      this.currentSliderValue = 0;
      this.collections[i].sensors[j].checked = e?.checked
      this.clearBandLegends();
      this.removeImages();
      this.viewer.entities.removeAll();
      this.sliderShow = false;
      this.sourceRateArray = [];
      this.previousIndex = -1;
      this.clearAnnotations();
      this.annotateClicked = false;
      this.newTaskButtonClicked = false;
  
      if (this.collections[i]?.recurrencyArray?.length > 1 && !this.spire) {
        this.selectedRecurrencyArray = this.collections[i]?.recurrencyArray;
        this.groupedScenes = this.groupRecurrencyCollections(this.collections[i]?.recurrencyArray);
      }
      else this.groupedScenes = this.groupCollections();
      if (this.operatorArray?.length === 0) {
        this.sliderDateRangeArray = [];
      } else this.sliderView = true;
      if ((scenes?.operatorKey === this.OPERATOR.SPIRE || scenes?.operatorKey === this.OPERATOR.CLYDE) && !e?.checked) {
        this.sliderShow = false;
        this.currentSliderValue = 0;
      }
    } 
    else {
    if (scenes?.operatorKey === this.OPERATOR.USL) {
      const sceneIdx = (k !== undefined)? this.collections[i].sensors[j].scenes[k]?.sceneIdx: scenes?.sceneIdx;

      const indexToRemoveEntity = this.USLscnLyr.findIndex((item) => {
        return item.index === sceneIdx;
      });
      if(this.uslBBList.length > 0 && indexToRemoveEntity !== -1 && taskAll) {
        this.uslBBList.forEach(targetIndexValue => {
          const indexTo = this.USLscnLyr.findIndex(item => item.index === targetIndexValue);
          
          if (indexTo !== -1) {
            this.USLscnLyr[indexTo].show = false;
            this.USLscnLyr.splice(indexTo, 1);
          }
        });
      }else if (indexToRemoveEntity !== -1 ) {
        if (this.USLscnLyr[indexToRemoveEntity]) {
          this.USLscnLyr[indexToRemoveEntity].show = false;
          this.USLscnLyr.splice(indexToRemoveEntity, 1);
        }
      }

      if (e?.checked) {
        this.sceneBands = scenes;
        this.bandTaskId = taskId;
        this.bandSensorId = this.collections[i].sensors[j].id;        
        
        if (k === undefined) {
        this.collections[i].sensors[j].checked = true
        this.collections[i].sensors[j]?.scenes.forEach(async (scn: any, index: any) => {
          if (scn?.id && scn?.status !== 'failed') {
            scn.checked = e?.checked;
          }
          this.displayImage(scn);
        })
      } else { 
        this.collections[i].sensors[j].scenes[k].checked = true;
        this.displayImage(scenes);
      }
      } else {
        this.sceneBands = '';
        this.bandTaskId = '';
        this.bandSensorId = '';
        if (k === undefined) {
        this.collections[i].sensors[j].checked = false
        this.collections[i].sensors[j]?.scenes.forEach(async (scn: any, index: any) => {
          scn.checked = false
          this.clearAnnotationsByScene(scn.id);
          this.removeDataSourceById("scene", scn.id);
        });
      } else {
        this.collections[i].sensors[j].scenes[k].checked = false;
        let sceneId = this.collections[i].sensors[j].scenes[k]?.id;
        this.clearAnnotationsByScene(scenes.id);
        this.removeDataSourceById("scene", sceneId);
      }
      // Only clear all if no scenes are checked
      const anyChecked = this.collections[i].sensors[j].scenes.some(scn => scn.checked);
      if (!anyChecked) {
        this.USLscnLyr = [];
        this.uslBBList = [];
        this.isVisible = false;
        this.splitPosition = 0.0;
        this.leftBand = false;
        this.rightBand = false;
        this.feedLoaded = false;
      }
      if (this.selectedSensors?.length === 2) {
        this.isVisible = true
        this.splitRightPostion = true
        this.splitLeftPostion = true
        this.splitPosition = 0.5;
        this.clearAnnotations();
      }
      }
    } else if(scenes?.operatorKey === this.OPERATOR.SPIRE || scenes?.operatorKey === this.OPERATOR.CLYDE) {
      let sensor = this.collections[i]?.sensors[j];
      this.clearSilder();
      this.isVisible = false;
      this.splitPosition = 0.0;
      if (e?.checked) {
        if (scenes?.operatorKey === this.OPERATOR.SPIRE) this.displayAIS(scenes, "display",sensor);
        else if (scenes?.operatorKey === this.OPERATOR.CLYDE) this.displayAISClyde(scenes, "display",sensor);

        if (k === undefined) {
          console.log("sensor checked");
        this.collections[i].sensors[j].checked = true;
        this.collections[i].sensors[j]?.scenes.forEach(async (scn: any, index: any) => {
          if (scn?.id && scn?.status !== 'failed') {
            scn.checked = e?.checked;
            this.loadCombinedFeed = true;
          }
        })
      } else {
        console.log("scene checked");
        this.collections[i].sensors[j].scenes[0].checked = true;
      }
      } 
      else {
        this.overlayVessel = [];
        this.overlayClydeVessel = [];
        this.removeDataSourceBySensorId(sensor?.id);
        const indexToRemoveEntity = this.SpirescnLyr.findIndex((item) => item.index === this.uslBB.index);
        if (indexToRemoveEntity !== -1) {
          this.SpirescnLyr[indexToRemoveEntity].show = false
          this.SpirescnLyr.splice(indexToRemoveEntity, 1);
        }
        this.SpirescnLyr = [];

        if (k === undefined) {
        this.collections[i].sensors[j].checked = false;
        this.collections[i].sensors[j]?.scenes.forEach(async (scn: any, index: any) => {
          scn.checked = false
          this.clearAnnotationsByScene(scn.id);
        })
      } else {
        this.collections[i].sensors[j].scenes[0].checked = false;
        this.clearAnnotationsByScene(scenes.id);
      }

      if (this.selectedSensors?.length === 2) {
        this.isVisible = true
        this.splitRightPostion = true
        this.splitLeftPostion = true
        this.splitPosition = 0.5;
        this.clearAnnotations();
      }
      
      this.clearFilterData();
      }
    } else if (scenes?.operatorKey === this.OPERATOR.LBAND) {
      this.isVisible = false;
      this.splitPosition = 0.0;
      if (e?.checked) {
        this.signalBands = scenes;
        this.bandTaskId = taskId;
        this.signalSensorId = this.collections[i].sensors[j].id;        
        
        if (k === undefined) {
        this.collections[i].sensors[j].checked = true
        this.collections[i].sensors[j]?.scenes.forEach(async (scn: any, index: any) => {
          if (scn?.id && scn?.status !== 'failed') {
            scn.checked = e?.checked;
          }
        })
      } else this.collections[i].sensors[j].scenes[k].checked = true;

       this.selectSignals(this.collections[i].sensors[j], this.signalSelected)

      } else {
        this.signalBands = '';
        this.bandTaskId = '';
        this.signalSensorId = '';

        if (k === undefined) {
        this.collections[i].sensors[j].checked = false
        this.collections[i].sensors[j]?.scenes.forEach(async (scn: any, index: any) => {
          scn.checked = false
          this.clearAnnotationsByScene(scn.id);
        })
      } else {
        this.collections[i].sensors[j].scenes[k].checked = false;
        this.clearAnnotationsByScene(scenes.id);
      }

      if (this.selectedSensors?.length === 2) {
        this.isVisible = true
        this.splitRightPostion = true
        this.splitLeftPostion = true
        this.splitPosition = 0.5;
        this.clearAnnotations();
      }

      if (scenes?.operatorKey === this.OPERATOR.LBAND) {
        this.selectSignals(this.collections[i].sensors[j], this.signalSelected)
       }
      }
    } else {
      
      if (e?.checked) {
        this.overlay[j] = 100
        if (this.selectedSensors.length === 0) {
          this.collections[i].sensors[j].index = j;
          this.selectedSensors.push(this.collections[i].sensors[j])
        } else {
          const findIndex = this.selectedSensors
            .filter(function (el) {
              return el.index === j;
            })
          if (findIndex.length === 0) {
            this.collections[i].sensors[j].index = j;
            this.selectedSensors.push(this.collections[i].sensors[j])
          }
        }
        const uniqueArray: any = [];
        const seenIds = new Set();

        for (const item of this.selectedSensors) {
          if (!seenIds.has(item.index)) {
            seenIds.add(item.index);
            uniqueArray.push(item);
          }
        }
        this.selectedSensors = uniqueArray        
      } else {
        if (k === undefined) {
          this.overlay[j] = 100
          this.selectedSensors = this.selectedSensors
            .filter(function (el) {
              return el.index !== j;
            })
        } else {
          if (this.showDailyRecurrencyCheckboxes) {
            this.collection.sensors[0].scenes[k].checked = e?.checked;
            const collectionUnselectedFilter = this.collection.sensors[0].scenes.filter(item => item?.checked);
            if (collectionUnselectedFilter.length === 0) {
              this.collection.sensors[0].checked = e?.checked;
              let filterIndex = 0

              this.collection.recurrencyArray.forEach((sensor, index) => {
                sensor.scenes.forEach((scene) => {
                  if ((new Date(scene.predicted_date)).getTime() === (new Date(this.collection.sensors[0].scenes[k].predictedDate)).getTime()) {
                    sensor.checked = false
                    filterIndex = index;
                  }
                });
              });

              this.toggleDailyRecurrency(e)
              return
            }

          }

        }

        var allImageryLayers = this.viewer.imageryLayers._layers;
        var leftImageryLayers: any = [];
        var rightImageryLayers: any = [];
        var assetImageryLayers: any = [];
        for (var index = 0; index < allImageryLayers.length; index++) {
          var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url
          var ionImageryProvider = allImageryLayers[index]?.imageryProvider;
          var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
          var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
          if (url !== undefined && isLeft) {
            leftImageryLayers.push(allImageryLayers[index]);
          }
          if (url !== undefined && isRight) {
            rightImageryLayers.push(allImageryLayers[index]);
          }
        }

        if (j === 0) {
          if (k === undefined) {
            for (var index = 0; index < leftImageryLayers.length; index++) {
              this.viewer.imageryLayers.remove(leftImageryLayers[index]);
            }

            for (var index = 0; index < assetImageryLayers.length; index++) {
              this.viewer.imageryLayers.remove(assetImageryLayers[index]);
            }

            if (leftImageryLayers.length === 1) {
              const findSensor = this.selectedSensors
                .filter(function (el) {

                  return el.index === j;
                })

              for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                const item = this.scnLyr[indexToRemoveEntity];              
                if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                  this.scnLyr[indexToRemoveEntity].show = false;
                  this.scnLyr.splice(indexToRemoveEntity, 1);
                }
              }
            } else {
              const findSensor = this.selectedSensors
                .filter(function (el) {

                  return el.index === j;
                })

              for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                const item = this.scnLyr[indexToRemoveEntity];              
                if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                  this.scnLyr[indexToRemoveEntity].show = false;
                  this.scnLyr.splice(indexToRemoveEntity, 1);
                }
              }
            }
            
          } else {
            if (leftImageryLayers.length === 1) {
              for (var index = 0; index < leftImageryLayers.length; index++) {
                this.viewer.imageryLayers.remove(leftImageryLayers[index]);
              }
              const findSensor = this.selectedSensors
              .filter(function (el) {

                return el.index === j;
              })

            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              const item = this.scnLyr[indexToRemoveEntity];              
              if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                this.scnLyr[indexToRemoveEntity].show = false;
                this.scnLyr.splice(indexToRemoveEntity, 1);
              }
            }
            } else {
              const findSensor = this.selectedSensors
                .filter(function (el) {

                  return el.index === j;
                })

              for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                const item = this.scnLyr[indexToRemoveEntity];              
                if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                  this.scnLyr[indexToRemoveEntity].show = false;
                  this.scnLyr.splice(indexToRemoveEntity, 1);
                }
              }

              for (var index = 0; index < leftImageryLayers.length; index++) {

                if ((leftImageryLayers[index]?.imageryProvider?._source?.source?.source?.client?.url === findSensor[0].scenes[k].thumbnailUrl) || (leftImageryLayers[index]?.imageryProvider.url === findSensor[0].scenes[k].thumbnailUrl)) {
                  this.viewer.imageryLayers.remove(leftImageryLayers[index]);
                }
              }
              for (var index = 0; index < assetImageryLayers.length; index++) {
                if (assetImageryLayers[index]._imageryProvider._imageryProvider._resource._url.includes(findSensor[0].scenes[k].thumbnailUrl.assetId))
                  this.viewer.imageryLayers.remove(assetImageryLayers[index]);
              }
            }

          }


        } else {
          if (k === undefined) {
            for (var index = 0; index < rightImageryLayers.length; index++) {
              this.viewer.imageryLayers.remove(rightImageryLayers[index]);
            }
            for (var index = 0; index < assetImageryLayers.length; index++) {
              this.viewer.imageryLayers.remove(assetImageryLayers[index]);
            }

            if (rightImageryLayers.length === 1) {
              const findSensor = this.selectedSensors
                .filter(function (el) {

                  return el.index === j;
                })

              for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                const item = this.scnLyr2[indexToRemoveEntity];              
                if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                  this.scnLyr2[indexToRemoveEntity].show = false;
                  this.scnLyr2.splice(indexToRemoveEntity, 1);
                }
              }
            } else {
              const findSensor = this.selectedSensors
                .filter(function (el) {

                  return el.index === j;
                })

              for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                const item = this.scnLyr2[indexToRemoveEntity];              
                if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                  this.scnLyr2[indexToRemoveEntity].show = false;
                  this.scnLyr2.splice(indexToRemoveEntity, 1);
                }
              }
            }
            
          } else {
            if (k === undefined) {
              for (var index = 0; index < rightImageryLayers.length; index++) {
                this.viewer.imageryLayers.remove(rightImageryLayers[index]);
              }
              
            } else {
              if (rightImageryLayers.length === 1) {
                const findSensor = this.selectedSensors
                  .filter(function (el) {

                    return el.index === j;
                  })
                this.viewer.imageryLayers.remove(rightImageryLayers[0]);

                for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                  const item = this.scnLyr2[indexToRemoveEntity];              
                  if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                    this.scnLyr2[indexToRemoveEntity].show = false;
                    this.scnLyr2.splice(indexToRemoveEntity, 1);
                  }
                }
              } else {
                const findSensor = this.selectedSensors
                .filter(function (el) {

                  return el.index === j;
                })

                for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                  const item = this.scnLyr2[indexToRemoveEntity];              
                  if (item.index === findSensor[0]?.scenes[k]?.sceneIdx) {
                    this.scnLyr2[indexToRemoveEntity].show = false;
                    this.scnLyr2.splice(indexToRemoveEntity, 1);
                  }
                }
              for (var index = 0; index < rightImageryLayers.length; index++) {
                if ((rightImageryLayers[index]?.imageryProvider?._source?.source?.source?.client?.url === findSensor[0].scenes[k].thumbnailUrl) || (rightImageryLayers[index]?.imageryProvider.url === findSensor[0].scenes[k].thumbnailUrl)) {                  
                  this.viewer.imageryLayers.remove(rightImageryLayers[index]);
                }
              }
              }

            }
          }
        }

        if (leftImageryLayers.length === 0) {
        for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
          this.scnLyr[indexToRemoveEntity].show = false;
        }
        for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr2[indexToRemoveEntity].show = true;
        }
      }

        if (rightImageryLayers.length === 0) {
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = true;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = false;
          }
        }
        if (leftImageryLayers.length === 0 && rightImageryLayers.length === 0) {
          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = false;
          }
          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr2[indexToRemoveEntity].show = false;
          }

        }
        this.selectedSensors = this.selectedSensors.filter(item => (item?.scenes[0]?.operatorKey !== OPERATORS.USL && item?.scenes[0]?.operatorKey !== OPERATORS.LBAND));

        if (this.selectedSensors.length < 2) {
          this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
          this.viewer.scene.imagerySplitPosition = undefined;
          var imageryLayers = this.viewer.imageryLayers;
          this.splitPosition = 0.0;
          this.isVisible = false
          this.splitRightPostion = false
          this.splitLeftPostion = false
        }

      }

    if (k === undefined) {
      var allImageryLayers = this.viewer.imageryLayers._layers;
      if(j === 0) {
        for (var index = 0; index < allImageryLayers.length; index++) {
          var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url
          var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
          var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
          if (url !== undefined && isLeft) {
            allImageryLayers.forEach(() => {
              this.viewer.imageryLayers.remove(allImageryLayers[index]);
            })
          }
        }

        this.scnLyr.forEach(scn => {
          scn.show = false
        })
      } else {
        for (var index = 0; index < allImageryLayers.length; index++) {
          var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url
          var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
          var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
          
          if (url !== undefined && isRight) {
            allImageryLayers.forEach(() => {
              this.viewer.imageryLayers.remove(allImageryLayers[index]);
            })
          }
        }
        this.scnLyr2.forEach(scn => {
          scn.show = false
        })
      }


      // this.scnLyr = [];
      // this.scnLyr2 = [];
      this.collections[i].sensors[j].scenes.forEach(async (scn: any, index: any) => {

        const checked = this.collections[i].sensors[j].checked;
        if (scn.id && e?.checked === true)
          if (scn?.id && scn?.status !== 'failed' && !scn?.sceneName?.includes('L1D') && !scn.skipPreview && scn.footprint) {
            scn.checked = e?.checked;
            this.loadCombinedFeed = true
          }
        if (e?.checked) {
          if (scn.footprint && (scn.operatorKey !== OPERATORS.SPIRE || scn.operatorKey !== OPERATORS.CLYDE) && !scn?.sceneName?.includes('L1D')
          && !scn.skipPreview && scn.footprint) {
            sensorId = this.collections[i].sensors[j]?.id;
            sceneId = scn?.id;
            action = "sensor";
            this.sceneSelected = sceneId;
            const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
            this.spinnerService.show();
            this.mapLoad = true;
            this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
              if (res?.msg === 'Failed') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                  this.popupService.openPopup(CollectionPopupComponent, message,'', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              } else if (res?.msg === 'user storage') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              }
              if (this.selectedSensors?.length === 1 && this.selectedSensors[0]?.scenes[index]?.thumbnailUrl) {
                  this.selectedSensors[0].scenes[index].thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;  
              } else if (this.selectedSensors[j]?.scenes[index]?.thumbnailUrl){
                this.selectedSensors[j].scenes[index].thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;  
              }
              this.displayFootPrint(scn, j, res.result,sensorId,taskId);
              this.spinnerService.hide();
              this.mapLoad = false;
            });
            const scenes = this.collections[i]?.sensors[j]?.scenes || [];

          } else if (scn?.uslFootprint && !scn?.sceneName?.includes('L1D') && !scn.skipPreview && scn.footprint) {
            this.displayFootPrint(scn, j, scn?.uslFootprint,this.collections[i].sensors[j].id,taskId);
          }
        } else {
          this.collections[i].sensors[j]?.scenes.forEach(async (scn: any, index: any) => {
            scn.checked = false;
            this.clearAnnotationsByScene(scn.id);
            this.loadCombinedFeed = false;
          })
          // this.viewer.entities.removeAll();
          if (scn?.uslFootprint) {
            this.clearBandLegends();
            const indexToRemoveEntity = this.USLscnLyr.findIndex((item) => item.index === this.uslBB.index);
            if (indexToRemoveEntity !== -1) {
              this.USLscnLyr[indexToRemoveEntity].show = false
              this.USLscnLyr.splice(indexToRemoveEntity, 1);
            }
            this.USLscnLyr = [];
          }
        }
      });
      this.collections[i].sensors[j].checked = e?.checked;
    } else {
     

       const scenes = this.collections[i]?.sensors[j]?.scenes || [];

        const checkedScenesLength = scenes.filter(scene => {
          console.log("scene.checked:", scene.checked);
          return scene.checked === true;  
        }).length;



      //  console.group("testing")
      // console.log("single scene toggle");
      // console.log("i value", i);
      // console.log("j value", j);
      // console.log("this.collections[i]", this.collections[i]);
      // console.log("this.collections[i]?.sensors[j]", this.collections[i]?.sensors[j]);
      // console.log("scenes", scenes);
      // console.log("checkedScenesLength", checkedScenesLength);


      // console.groupEnd();


      if(scenes?.length === checkedScenesLength){
        this.loadCombinedFeed = true;
      }else{
        this.loadCombinedFeed = false;
      }

      const checkedScnes = this.collections[i].sensors[j].scenes.filter(scene => scene.checked === true);
      if (checkedScnes?.length > 0) {
      previouseSceneId = checkedScnes[0].id;
      }

      this.collections[i].sensors[j].scenes[k].checked = e?.checked;
      const scn = this.collections[i].sensors[j].scenes[k];
      if (e?.checked) {
        if (scn.footprint && (scn.operatorKey !== OPERATORS.SPIRE || scn.operatorKey !== OPERATORS.CLYDE)) {
          sensorId = this.collections[i].sensors[j]?.id;
          action = "scene"
          sceneId = scn?.id;
          this.sceneSelected = sceneId;
          this.spinnerService.show();
          this.mapLoad = true;
          const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
          
          this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
            if (res?.msg === 'Failed') {
              this.spinnerService.hide();
              this.mapLoad = false;
              const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            } else if (res?.msg === 'user storage') {
              this.fail = this.fail + 1;
              if (this.fail === 1) {
                const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              }
              this.spinnerService.hide();
              this.mapLoad = false;
            }


            
            if (this.selectedSensors?.length === 1 && this.selectedSensors[0]?.scenes[k]?.thumbnailUrl) {
              this.selectedSensors[0].scenes[k].thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;  
            } else if (this.selectedSensors[j]?.scenes[k]?.thumbnailUrl){
              this.selectedSensors[j].scenes[k].thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;  
            }
            
            this.displayFootPrint(scn, j, res.result,sensorId,taskId);
            this.spinnerService.hide();
            this.mapLoad = false;
          });
        } else if (scn?.uslFootprint) {
          this.displayFootPrint(scn, j, scn?.uslFootprint,this.collections[i].sensors[j].id,taskId);
        }
      } else {
        this.clearAnnotationsByScene(scn.id);
        // this.viewer.entities.removeAll();
        if (scn?.uslFootprint) {
          this.clearBandLegends();
          const indexToRemoveEntity = this.USLscnLyr.findIndex((item) => item.index === this.uslBB.index);
          if (indexToRemoveEntity !== -1) {
            this.USLscnLyr[indexToRemoveEntity].show = false
            this.USLscnLyr.splice(indexToRemoveEntity, 1);
          }
          this.USLscnLyr = [];
        }
      }
    }

    const findIndexImage = this.collections[i].sensors[j].scenes
      .filter(function (el) {

        return el.checked;
      })

    if (findIndexImage.length === 0) {
      this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
      this.viewer.scene.imagerySplitPosition = undefined;
      var imageryLayers = this.viewer.imageryLayers;
      this.splitPosition = 0.0;
      // Get the layer you want to remove the split position from
      var layer = imageryLayers.get(0); // Change 0 to the index of your layer
      this.isVisible = false
      // Remove the imagery split position
      // layer.imagerySplitPosition = undefined;
      this.splitRightPostion = false
      this.splitLeftPostion = false

    } else {
      var bothSensorSelected: any = []
      this.selectedSensors.forEach((item: any, index: any) => {
        const findIndexsensor = item.scenes
          .filter(function (el) {

            return el.checked;
          })
        if (findIndexsensor.length > 0)
          bothSensorSelected.push(item)

      });

      if (bothSensorSelected.length === 2) {
        let noSplit = this.operatorArray.includes(OPERATORS.USL) || this.operatorArray.includes(OPERATORS.SPIRE) || this.operatorArray.includes(OPERATORS.LBAND);
        if (noSplit) {
          this.isVisible = false;
          this.splitPosition = 0.0;
        } else {
          this.isVisible = true
          this.splitRightPostion = true
          this.splitLeftPostion = true
          this.splitPosition = 0.5;
          this.clearAnnotations();
        }
      } else {
        this.isVisible = false;
        this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
        this.viewer.scene.imagerySplitPosition = undefined;
        var imageryLayers = this.viewer.imageryLayers;
        // Get the layer you want to remove the split position from
        var layer = imageryLayers.get(0); // Change 0 to the index of your layer
        // Remove the imagery split position
        // layer.imagerySplitPosition = undefined;
        this.splitRightPostion = false
        this.splitLeftPostion = false
        this.splitPosition = 0.0;
      }

    }

    if ((this.collections[i]?.sensors[j]?.InfoServices?.length > 0 || this.collections[i]?.sensors[j]?.Observation?.length > 0) && (this.collections[i]?.sensors[j]?.operatorKey != OPERATORS.AXELSPACE || this.collections[i]?.sensors[j]?.operatorKey != OPERATORS.AZISTA)) {
      const scenesArray = this.collections[i].sensors[j].scenes;
      const checkedScenes = scenesArray.filter(scene => scene.checked === true);
      this.checkedScenes = checkedScenes;
      const checkedInfo = this.collections[i].sensors[j].InfoServices.filter(info => info.checked === true);
      count = checkedScenes.length;
      const checkedSensors = this.collections[i].sensors.filter(scene => scene.checked === true);

      const selectedScenes: any = [], sceneList: any = [];
      for (const sensors of checkedSensors) {
        for (const item of sensors.scenes) { 
          if (item.checked) {
            selectedScenes.push(item);
          }
        }
      }

      if (count != 2) {
        for (const sensors of  this.collections[i].sensors) {
          for (const item of sensors.scenes) {
            if (item.checked) {
              sceneList.push(item);
            }
          }
        }
      }

      if (sceneList?.length > 0) this.sceneSelected = sceneList[0]?.id;
      if (checkedSensors?.length > 1 || sceneList?.length > 1) {
        this.sensorsIS = true;
        this.clearBandLegends();
        for (const [sensorIndex, sensors] of this.collections[i].sensors.entries()) {
          for (const item of sensors.InfoServices) {
            item.checked = false;
          }
        }

      } else {
        if (count === 1 || selectedScenes?.length === 1 || sceneList?.length === 1) {
          this.sensorsIS = false;
          for (const item of checkedInfo) {
          item.checked = false;
        }
        } else if (count === 0 && selectedScenes?.length === 0) {
          
        this.sensorsIS = true;
        this.clearBandLegends();
        for (const item of checkedInfo) {
            item.checked = false;
        }
      } else if ((count > 1 && k === undefined) || (count > 1 && checkedInfo?.length === 0)) {
        this.sensorsIS = true;
        this.clearBandLegends();
        for (const item of checkedInfo) {
          item.checked = false;
        }
      }else if(count === 2 && k === 1){
        this.sensorsIS = true;
        this.clearBandLegends();
        for (const item of checkedInfo) {
          item.checked = false;
        }
      }else if(count > 2 && k > 1){
        this.sensorsIS = true;
        this.clearBandLegends();
        for (const item of checkedInfo) {
          item.checked = false;
        }
      }
      }
          const scenes = this.collections[i]?.sensors[j]?.scenes || [];
          const checkedScenesLength = scenes.filter(scene => scene.checked).length;
       if (checkedInfo?.length > 0   && (checkedScenesLength==1 || checkedScenesLength == scenes.length) ) {
          const selectedSceneIS = checkedInfo[0]?.insightDatas?.filter(scene => scene.sceneId === this.sceneSelected);
          this.clearBandLegends();
           if(checkedScenesLength==1 || checkedScenesLength == scenes.length) {
             let payload:any = {
              "type": "json",
              "sensorId" : this.collections[i].sensors[j].id
            }    
             if (checkedScenesLength == 1) {
                payload.sceneId = sceneId;
                payload.action= "ISDisplay"
              }
              else if(checkedScenesLength == scenes.length){
                payload.action= "sensorFeed"
              }
            this.mapLoad = true;
            
          } else {
            this.clearBandLegends();
          }
          e.checked = false;
          const index = this.collections[i].sensors[j].scenes.findIndex(item => item.id === previouseSceneId);
          this.toggleSensor(i,j,index,e,'');


      }  

    } else if(this.collections[i]?.sensors[j]?.operatorKey === OPERATORS.AXELSPACE || this.collections[i]?.sensors[j]?.operatorKey === OPERATORS.AZISTA) {
      const scenesArray = this.collections[i].sensors[j].scenes;
      const checkedScenes = scenesArray.filter(scene => scene.checked === false);
      if (checkedScenes?.length > 0) {
        this.clearBandLegends();
        for (const [sensorIndex, sensors] of this.collections[i].sensors.entries()) {
          for (const item of sensors.InfoServices) {
            item.checked = false;
          }
        }
      }
    }

    /** Toggle Scenes if Value Added Options Already Selected */
    if(this.selectedOptions.length > 0)
    {
      this.selectedOptions = [];
      if (previouseSceneId) {
        const index = this.collections[i].sensors[j].scenes.findIndex(item => item.id === previouseSceneId);
        this.collections[i].sensors[j].scenes[index].checked = false;
      }
    }

    }
   }
  }
   if(this.selectedIndices) {
    if (k === undefined && !e.checked) this.viewer.entities.removeAll();
    this.resetIndicesOptions(i, j, e);
  }
  }

  toggle(i: number, j: number) {
    const checked = this.collections[i].sensors[j].checked;
    this.collections.forEach((item: any, index: any) => {
      if (index === i) this.collections[index].sensors[j].checked = checked;
    });
    this.showSlider();
  }
  showSlider() {
    this.selectedItems = 0;
    this.LEFTOPTIONS = [];
    this.RIGHTOPTIONS = [];
    const sliderOverlay = this.sliderOverlay;

    this.collections.forEach((item: any, index: any) => {
      if (item.checked) {
        this.selectedItems += 1;
        this.LEFTOPTIONS.push(item);
      }
    });

    this.LEFTOPTIONS.forEach((item: any, index: any) => {
      if (index > 0) this.RIGHTOPTIONS.push(item);
    });

  }
  downloadScn(url: any) {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = url;
    // link.download = path;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  zipDownload(urls: any, taskId: any, sensorId: any, sceneId: any) {
    var zip = new JSZip();
    var count = 0;
    var zipFilename = 'zipFilename.zip';
    urls.forEach((url: any) => {
      const filename = url.split('/')[url.split('/').length - 1].split('?')[0];
      // loading a file and add it in a zip file
      JSZipUtils.getBinaryContent(url, (err: any, data: any) => {
        if (err) {
          this.progress = 0;
          this.spinnerService.hide();
          this.freeze = false;
          this.downloadClick = false;
          const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
          // this.popupService.openPopup(CollectionPopupComponent, message, '40%');
          throw err; // or handle the error
        }
        zip.file(filename, data, { binary: true });
        count++;
        const totalCount = urls.length;
        const percentComplete = Math.round((count / totalCount) * 100);
        this.progress = percentComplete;
        const sensorObj = { progress: this.progress, taskId: taskId, sensorId: sensorId, sceneId: sceneId, download: this.downloadClick };
        this.downloadService.setProgress(sensorObj);

        if (count == urls.length) {
          this.progress = 0;
          this.spinnerService.hide();
          this.freeze = false;
          this.disable = false;
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            const objectUrl: string = URL.createObjectURL(content);
            const link: any = document.createElement('a');

            link.download = `${taskId}.zip`;
            link.href = objectUrl;
            link.click();
          });
        }
      });
    });
  }

  /**
   *
   * @param i
   * @param j
   * @param k
   */
  fullDownload(i: any, j: any, k: any) {
    var urls: any = [];
    this.collections[i]?.taskCollection?.map((item: any, index: any) => {
      if (this.collections[i]?.sensorName.includes('Capella')) {
        [
          { path: 'HH', ext: '.tiff' },
          { path: 'metadata', ext: '.json' },
          { path: 'thumbnail', ext: '.png' },
          { path: 'preview', ext: '.tiff' },
        ]?.map((downlaodItem) => {
          urls.push(environment.eeDownloadUrl +
            `collections/orders/${this.collections[i].taskId}/${downlaodItem?.path}/${item}${downlaodItem?.ext}`
          );
        });
      } else {
        if (this.collections[i]?.sensorName.includes('Satellogic')) {
          urls.push(
            environment.eeDownloadUrl + `collections/orders/${this.collections[i].taskId}/delivery_zip/${item}.zip`
          );
        }
      }
    });
    if (this.collections[i]?.sensorName.includes('21AT')) {
      urls.push(
        environment.eeDownloadUrl + `collections/${this.collections[i].sensors[j].downloadUrl}`
      );
    }
  }

  getDownloadImage(i: any, j: any, k: any) {
    let sensor = this.collections[i].sensors[j];
    let scene = sensor.scenes[k];
    return scene?.rawIQDownloaded ? this.downloadedImage : ((this.checkDownloaded(scene) && scene?.rawIQIncluded)  ? this.downloadImage :'../../../assets/images/cloud.png')
  }

  ecursSensorObject: any;
  download(i: any, j: any, k: any, scene: any, mode:any = false) {
   // return;
    this.ecursSensorObject = null;
    let sceneId: any = [], scenesId: any = [];
    let sensorId: any, infoId: any, sensorObj: any;
    let action: any;
    let urls: any = [];
    let sensorDownloadId: any;
    const taskId = this.collections[i]?.taskId;
    let sceneType = mode == 'rawdataDownload' ? 'raw_iq' : '';
    let refCount;

    const selcetedSensor = this.collection.sensors[j];
    if(selcetedSensor?.operatorKey === this.OPERATOR.CLYDE && selcetedSensor.status === 'canceled') {
      const message = 'The user has cancelled the task, and the data is unavailable';
      this.popupService.openPopup(WarningPopupComponent, message, '', '40%');
      return
    }

    if(this.collection.sensors[j].operatorKey === OPERATORS.SPIRE) {
      refCount = this.collection.sensors[j].updatedRefreshes == 0 ? 0 : this.collection.sensors[j].updatedRefreshes || this.collection.sensors[j].noOfRefreshes
    }
    if( (refCount > 0 && scene.operatorKey === OPERATORS.SPIRE) || scene.operatorKey !== OPERATORS.SPIRE) {
    const endDate = new Date(this.collections[i].closeWindow);
    const currentDate = new Date();
    
      if (this.freeze) {
        const message = 'A download is in progress. Please wait until the current download finishes to continue downloading others.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return
      } else if (((scene?.downloaded || this.checkDownloaded(scene) || this.checkSensorDownloaded(scene)) && !mode) || scene?.rawIQDownloaded) {
        let message = 'download';
        if (mode && scene?.rawIQDownloaded) {
          message = 'rawIQmessage'
        }
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return
      } else if (scene.operatorKey === OPERATORS.CLYDE && (endDate.getTime() < currentDate.getTime())) {    
          const message = 'The time of interest (TOI) has been passed. Download is possible only during the TOI.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          return
      } else
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      const sensor = this.collections[i].sensors[j];
      const totalScenes = this.collections[i]?.sensors[j]?.scenes || [];
      const checkedScenesLength = totalScenes.filter(scene => scene.checked).length;
      if (scene?.insightDatas && !mode) {
        sensorId = scene?.sensorId;
        if(checkedScenesLength == 1){
          action = "ISDownload";
          sceneId = this.sceneSelected;
        }
        else if(totalScenes.length == checkedScenesLength){
          action = "sensorFeed";
        }
        infoId = scene?._id;
        if (this.collections[i]?.sensors[j]?.operatorKey === OPERATORS.AXELSPACE) sceneId = scene?.sensorId;
        sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, feedId: infoId};
      } else if (scene?.refreshId && !mode) {        
        sensorId = scene?.sensorId;
        action = "download";
        sceneId = sensor.scenes[0].id;
        sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, refreshId: scene?.refreshId};
      } else if (k === undefined && !mode) {
        sensor.scenes.forEach(async (scn: any, index: any) => {
          sceneId.push(scn.scene_id);
          scenesId.push(scn.scene_id);
        });
        sensorId = sensor?.id;
        action = "sensorDownload";
        sensorDownloadId = sensor?.id
        sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action};
      } else if (mode) {
        sensorId = this.collections[i].sensors[j].id;
        sensorDownloadId = this.collections[i].sensors[j].id;
        scenesId = scene?.scene_id;
        action = mode;
        sensorObj = {
          "sensorId": this.collections[i].sensors[j].id,
          "sceneId": scene?.scene_id,
          "action": mode,
          "type": "zip"
        }
      } else {
        sceneId = scene?.id;
        scenesId.push(scene?.id);
        action = "sceneDownload";
        sensorId = sensor?.id;
        sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType};
      }

      const downloadObj = { progress: this.progress, taskId: this.collections[i].taskId, sensorId: sensorDownloadId, sceneId: scenesId, download: this.downloadClick, type: sceneType };
      
      if(!(sensor?.sensorType == 'InSAR') || k == undefined) {
        this.downloadService.setProgress(downloadObj);
      } 
  
    }
    if (scene?.refreshId && !mode) {
      const sensor = this.collections[i].sensors[j];
      this.displayRefreshData('$event',sensor.scenes[0],sensor, action, scene);
    } else if(((scene.operatorKey === OPERATORS.SPIRE && scene.aisDownloadable) || (scene.operatorKey === OPERATORS.CLYDE && scene.aisAvailable)) && !mode) {
      const sensors = this.collections[i].sensors[j];
      this.AISDownload(sensors);
    } else {
      if((scene?.operatorKey == OPERATORS.ECURS || scene?.operatorKey == OPERATORS.ECURS_L) && this.collections[i].sensors[j].sensorType === 'InSAR' && k != undefined && !mode) {

        let sceneIds = [scene.id]
        
        let index = this.collections[i].sensors[j]?.scenes.findIndex((scn) => scn.id == scene.id);
        if (index > 0) {
          const scenes = this.collections?.[i]?.sensors?.[j]?.scenes ?? [];
          const downloadedSet = new Set(this.downloadedScene ?? []);
          const prior = scenes.slice(0, Math.max(0, index));
 
          const missingPrevScenes: any[] = prior.filter(
            s => s && !(s.downloaded || downloadedSet.has(s.id))
          );
          if (missingPrevScenes.length > 0) {
            const message = 'downloadWarning';
            const dialog = this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            dialog.afterClosed().subscribe((res) => {
              if(res == 'cancel') {
                this.freeze = false;
                this.fail = 0;
                this.progress = 0;
                this.downloadClick = false;
                return;
              }
              else if(res == 'yes') {
                const dialog = this.popupService.openPopup(CollectionPopupComponent, 'downloadProgress', '', '40%');
                 dialog.afterClosed().subscribe((res) => {
                  missingPrevScenes.forEach((scn) => {
                    sceneIds.push(scn.id)
                  });
                  sensorObj = { sensorId: sensorId, sceneIds: sceneIds, action: action, type: this.imageType};
                  this.ecursSensorObject = sensorObj;
                  this.collectionImageDownload(taskId, sensorObj, i, sensorDownloadId, scenesId);
                });
              }
              else if(res == 'no') {
                sensorObj = { sensorId: sensorId, sceneIds: sceneIds, action: action, type: this.imageType};
                this.ecursSensorObject = sensorObj;
                this.collectionImageDownload(taskId, sensorObj, i, sensorDownloadId, scenesId);
              }
            })
          } else {
            sensorObj = { sensorId: sensorId, sceneIds: sceneIds, action: action, type: this.imageType};
            this.collectionImageDownload(taskId, sensorObj, i, sensorDownloadId, scenesId);
          }
        }
        else {
          sensorObj = { sensorId: sensorId, sceneIds: sceneIds, action: action, type: this.imageType};
          this.ecursSensorObject = sensorObj;
          this.collectionImageDownload(taskId, sensorObj, i, sensorDownloadId, scenesId);
        }
        
      } else {
        this.apiService.getCollectionImage(taskId, sensorObj).subscribe(async (res: any) => {
          if (res?.msg === 'Failed') {
            this.downloadService.unsubscribeProgress();
            this.spinnerService.hide();
            this.freeze = false;
            this.fail = this.fail + 1;
            if (this.fail === 1) {
              const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            }
          } else if (res?.msg === 'user storage') {
            this.downloadService.unsubscribeProgress();
            this.spinnerService.hide();
            this.freeze = false;
            this.fail = this.fail + 1;
            if (this.fail === 1) {
              const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            }
          } else {
            for (const [index, item] of res.result.entries()) {
            let url = item;
    
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.responseType = 'blob';
    
            xhr.onprogress = (event) => {
              if (event.lengthComputable) {
                const percentComplete = ((event.loaded / event.total) * 100);
                this.progress = percentComplete.toFixed(2);
                const sensorObj = { progress: this.progress, taskId: this.collections[i].taskId, sensorId: sensorDownloadId, sceneId: scenesId, download: this.downloadClick, type: sceneType };
                this.downloadService.setProgress(sensorObj);
              }
            };
    
            xhr.onload = () => {
              if (xhr.status === 200) {
                const blob = xhr.response;
                const fileName = this.getFileNameFromS3SignedUrl(url);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
    
                // Reset progress after download
                this.progress = 0;
                this.spinnerService.hide();
                this.freeze = false;
                this.disable = false;
                if( mode == 'rawdataDownload') 
                  scene.rawIQDownloaded = true;      
              } else {
               this.showDownloadError();
              }
            };
    
            xhr.onerror = () => {
              // Handle errors
            this.showDownloadError();
            };
            xhr.send();
          }
        }
        });
      }
    }
    return
  }

  collectionImageDownload(taskId: string,
    sensorObj: any,
    i: number,
    sensorDownloadId: any,
    scenesId: any) {
    
    this.apiService.getCollectionImage(taskId, sensorObj).subscribe(async (res: any) => {
      if (res?.msg === 'Failed') {
        this.downloadService.unsubscribeProgress();
        this.spinnerService.hide();
        this.freeze = false;
        this.fail = this.fail + 1;
        if (this.fail === 1) {
          const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        }
      } else if (res?.msg === 'user storage') {
        this.downloadService.unsubscribeProgress();
        this.spinnerService.hide();
        this.freeze = false;
        this.fail = this.fail + 1;
        if (this.fail === 1) {
          const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        }
      } else {
        const urls = res.result;
        const lastIndex = urls.length - 1;
        let downloadedCount = 0;
        let hasError = false;

        // Initialize progress to 0% immediately when download starts
        this.progress = 0;
        const initialSensorObj = { 
          progress: this.progress, 
          taskId: this.collections[i].taskId, 
          sensorId: sensorDownloadId, 
          sceneId: scenesId, 
          download: this.downloadClick 
        };
        this.downloadService.setProgress(initialSensorObj);

        // Sequential download function
        const downloadFileSequentially = (index: number) => {
          if (index >= urls.length || hasError) {
            // All downloads completed or error occurred
            if (!hasError) {
              this.progress = 0;
              this.spinnerService.hide();
              this.freeze = false;
              this.disable = false;
            }
            return;
          }

          const url = urls[index];
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url);
          xhr.responseType = 'blob';

          // Add timeout
          xhr.timeout = 300000; // 5 minutes timeout

          // Only show progress for the last file
          if (index === lastIndex) {
            xhr.onprogress = (event) => {
              if (event.lengthComputable && !hasError) {
                const percentComplete = ((event.loaded / event.total) * 100);
                this.progress = percentComplete.toFixed(2);
                const sensorObj = { 
                  progress: this.progress, 
                  taskId: this.collections[i].taskId, 
                  sensorId: sensorDownloadId, 
                  sceneId: scenesId, 
                  download: this.downloadClick 
                };
                this.downloadService.setProgress(sensorObj);
              }
            };
          }

          xhr.onload = () => {
            if (xhr.status === 200 && !hasError) {
              try {
                const blob = xhr.response;
                const fileName = this.getFileNameFromS3SignedUrl(url);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                
                // Add small delay to ensure browser processes the download
                setTimeout(() => {
                  link.click();
                  URL.revokeObjectURL(link.href);
                  downloadedCount++;
                  
                  // Continue with next download after a small delay
                  setTimeout(() => {
                    downloadFileSequentially(index + 1);
                  }, 100);
                }, 50);
                
              } catch (error) {
                hasError = true;
                this.showDownloadError();
              }
            } else if (!hasError) {
              hasError = true;
              this.showDownloadError();
            }
          };

          xhr.onerror = () => {
            if (!hasError) {
              hasError = true;
              this.showDownloadError();
            }
          };

          xhr.ontimeout = () => {
            if (!hasError) {
              hasError = true;
              this.showDownloadError();
            }
          };
          
          xhr.send();
        };

        // Start sequential download
        downloadFileSequentially(0);
      }
    }, 
    (error) => {
      // Handle API subscription errors
      this.downloadService.unsubscribeProgress();
      this.spinnerService.hide();
      this.freeze = false;
      this.showDownloadError();
    });
  }
  

  getFileNameFromS3SignedUrl(signedUrl) {
    const filename = signedUrl.split('/')[signedUrl.split('/').length - 1].split('?')[0];
    return `${filename}`;
  }

  async displayFootPrint(scn, index, urlData,sensorId, taskId) {
    let assetId: any, imageUrl: any, COGUrl: any;
    if (urlData?.assetId) {
      assetId = urlData?.assetId;
    } else if (urlData?.imageUrl) {
      imageUrl = urlData?.imageUrl;
    } else if (urlData?.COGUrl) {
      COGUrl = urlData?.COGUrl;
    }
    // else if (scn?.operatorKey != this.OPERATOR.USL) {
    //   this.displayImage(scn);
    //   return
    // }

    this.emissionMessage = '';
    if (scn?.operatorKey === this.OPERATOR.GHG) {
      this.offset = 0.02;
      this.emissionMessage = scn.metadata.emission ? '' : 'No Emission';
    } else {
      this.offset = 0.25;
      this.emissionMessage = '';
      this.selectedMetric = 'ppb';
    }

    if (!scn.footprint) return;
    const scnPreview = urlData?.imageUrl;
    let pt: any, fpPos: any;
    let scnRectangle: any;
    let pngFp: any;
    let legendUnit = '';

    pt = scn.footprint?.coordinates[0];
    fpPos = pt.toString().split(',').map(Number);
    let boundingBox = scn?.tif_footprint;
    let sumLatitude = 0;
    let sumLongitude = 0;

    for (const coordinate of pt) {
      sumLatitude += coordinate[1];
      sumLongitude += coordinate[0];
    }

    const centroidValue = [
      sumLongitude / pt.length,
      sumLatitude / pt.length,
    ];

    const currentMode = this.viewer.scene.mode;
    let centroid: any;

    var bbox = turf.bbox(scn.footprint);
    if (scn?.png_footprint) {
      pngFp = scn?.png_footprint[0];
      scnRectangle = Cesium.Rectangle.fromDegrees(
        pngFp[0],
        pngFp[1],
        pngFp[2],
        pngFp[3]
      );
    } else {
      scnRectangle = Cesium.Rectangle.fromDegrees(
        bbox[0],
        bbox[1],
        bbox[2],
        bbox[3]
      );
    }

    // Calculate the center of the rectangle
    let centerLongitude = (Cesium.Math.toDegrees(scnRectangle.east) + Cesium.Math.toDegrees(scnRectangle.west)) / 2;
    let centerLatitude = (Cesium.Math.toDegrees(scnRectangle.north) + Cesium.Math.toDegrees(scnRectangle.south)) / 2;
    
    if (this.selectedMetric === 'kg') {
      centroid = Cesium.Cartesian3.fromDegrees(centerLongitude, centerLatitude);      
      if (scn.metadata.emission) {
        this.emissionMessage = scn?.ch4srData?.sourceRate;

        const centroidWithId = {
          centroid: centroid,
          sceneId: scn.id
        };

        this.sourceRateArray.push(centroidWithId);
      }
    } else {
      centroid = Cesium.Cartesian3.fromDegrees(centroidValue[0], centroidValue[1]);
    }

    if (scn?.legendScale) {      
      this.legendData = {
        minValue: scn?.legend_min,
        maxValue: scn?.legend_max,
        items: scn?.legendScale
      };

      if (scn?.operatorKey === this.OPERATOR.GHG) {
       legendUnit = 'ppb';
      } else if (scn?.operatorKey === this.OPERATOR.ORORATECH) {
        legendUnit = 'W/sr/m²';
      }

      const minTenthMultiple = Math.floor(this.legendData.minValue / 10) * 10;
      const maxTenthMultiple = Math.ceil(this.legendData.maxValue / 10) * 10;
      const range = maxTenthMultiple - minTenthMultiple;
      const step = range / this.legendData.items.length;
  
      this.scaleArray = [];
      let legendItems: any = [];
  
      for (const [index, item] of this.legendData.items.entries()) {
        const value = minTenthMultiple + step * index;
        item.value = value;
        legendItems.push(item.color);
      }
  
      const groupSize = this.legendData.items.length / 5;
      const numValues = 5;
      const steps = (maxTenthMultiple - minTenthMultiple) / numValues;
      const displayValues: number[] = [];
  
      for (let i = 0; i <= numValues; i++) {
        const value = minTenthMultiple + i * steps;
        displayValues.push(value);
      }
  
      for (let i = 0; i < this.legendData.items.length; i += groupSize) {
        const group = this.legendData.items.slice(i, i + groupSize);
        this.scaleArray.push(group);
      }
  
      this.scaleArray.forEach((group, index) => {
        if (index < displayValues.length) {
          group.displayValue = displayValues[index];
        }
      });
      
      const colors = [{color: 'rgba(0,0,0,0)'}]
      this.scaleArray.push({
        colors, displayValue: maxTenthMultiple
      });

      // this.legendData.items.reverse();
      this.scaleArray.reverse();
      legendItems.reverse();
      const gradientColors = legendItems.join(', ');
      this.legendColor = `linear-gradient(to bottom, ${gradientColors})`;
    }
    

    var layers = this.viewer.scene.imageryLayers;
    const URL = 'https://stafs-cogs.s3.ap-southeast-2.amazonaws.com/Whian_Whian_TCI_4326_cog.tif';
    if (index === 0) {
      let layer1: any;
      if (urlData?.assetId) {
        layer1 = new Cesium.ImageryLayer(
          new Cesium.IonImageryProvider({ assetId: assetId }), {
          splitDirection: Cesium.SplitDirection.LEFT,
          alpha: 1
        });
        this.viewer.imageryLayers.add(layer1);

      } else if (urlData?.COGUrl) {
        const provider = await TIFFImageryProvider.fromUrl(COGUrl);
        layer1 = this.viewer.imageryLayers.addImageryProvider(provider);
        layer1.alpha = 1;
        layer1.splitDirection = Cesium.SplitDirection.LEFT;
      }
      else {
        layer1 = new Cesium.ImageryLayer(
          new Cesium.SingleTileImageryProvider({
            url: scnPreview,
            rectangle: scnRectangle,
          }), {
          splitDirection: Cesium.SplitDirection.LEFT,
          alpha: 1
        });
        this.viewer.imageryLayers.add(layer1);
        this.imageryLayerMap.set(layer1, { sceneId: scn?.id, rectangle: scnRectangle,
          taskId: taskId, sensorId: sensorId
         });
      }

    } else {
      let layer2: any;
      if (urlData?.assetId) {
        layer2 = new Cesium.ImageryLayer(
          new Cesium.IonImageryProvider({ assetId: assetId }), {
          splitDirection: Cesium.SplitDirection.RIGHT,
          alpha: 1
        });
        this.viewer.imageryLayers.add(layer2);
      } else if (urlData?.COGUrl) {
        const provider = await TIFFImageryProvider.fromUrl(COGUrl);
        layer2 = this.viewer.imageryLayers.addImageryProvider(provider);
        layer2.splitDirection = Cesium.SplitDirection.RIGHT;
      } else {
        layer2 = new Cesium.ImageryLayer(
          new Cesium.SingleTileImageryProvider({
            url: scnPreview,
            rectangle: scnRectangle,
          }), {
          splitDirection: Cesium.SplitDirection.RIGHT,
        });
        this.viewer.imageryLayers.add(layer2);
        this.imageryLayerMap.set(layer2, { sceneId: scn?.id, rectangle: scnRectangle,
          taskId: taskId, sensorId: sensorId
         });
      }

    }

    this.selectedSensors = this.selectedSensors.filter(item => (item?.scenes[0]?.operatorKey !== OPERATORS.USL || item?.scenes[0]?.operatorKey !== OPERATORS.LBAND));
    if (this.selectedSensors.length === 2 && !this.operatorArray.includes(OPERATORS.USL) && !this.operatorArray.includes(OPERATORS.LBAND)) {
      this.viewer.scene.splitPosition = this.splitPosition;
      this.viewer.scene.imagerySplitPosition = this.splitPosition;
      const slider = document.getElementById('sliders') as HTMLCanvasElement;
      slider.style.left = `${100.0 * this.splitPosition}%`;
    }
    if (this.selectedSensors.length < 2) {
      this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
      this.viewer.scene.imagerySplitPosition = undefined;
      this.splitPosition = 0.0;
    }
    let entitylLeft: any, entityRight: any, entitylLeftBB: any, entityRightBB: any,legendLeft: any, legendRight: any;
    const localHandlerEvent = new ScreenSpaceEventHandler(this.viewer.scene.canvas);
    const addHoverEventHandler = (entity, scn) => {
    const sceneId = scn.scene_id;
    let tooltip = document.getElementById(`feedTooltip-${sceneId}`);

  // create one tooltip per scene if it doesn’t exist
  if (!tooltip) {
    const container = document.getElementById('cesiumContainer1');
    tooltip = document.createElement('div');
    tooltip.id = `feedTooltip-${sceneId}`;
    Object.assign(tooltip.style, {
      position: 'absolute',
      display: 'none',
      pointerEvents: 'none',
      background: 'black',
      color: '#fff',
      padding: '10px',
      border: "1px solid black",
      fontSize: '15px',
      fontFamily: 'Barlow, sans-serif',
      lineHeight: '1.8',
      maxWidth: '300px',
      whiteSpace: 'normal',
    });
    container?.appendChild(tooltip);
  }

  localHandlerEvent.setInputAction((movement) => {
    const picked = this.viewer.scene.pick(movement.endPosition);
    const pickedEntity =
    picked?.id || picked?.primitive?.id || picked?.collection?.owner || null;

    // show tooltip only for this entity
    if (pickedEntity === entity && scn?.ch4srData) {
      const d = scn.ch4srData;
      if(tooltip){
        tooltip.innerHTML = `
        <b>Acquisition Time :</b> ${d?.acquisitiontTime ?? 'N/A'}<br>
        <b>Lng:</b> ${d?.longitude ?? 'N/A'}<br>
        <b>Lat:</b> ${d?.latitude ?? 'N/A'}<br>
        <b>Wind Speed:</b> ${d?.windSpeed ?? 'N/A'}<br>
        <b>Source Rate:</b> ${d?.sourceRate ?? 'N/A'}
      `;
      tooltip.style.display = 'block';
      }
     
      this.tooltipHandlers(tooltip, movement);
    } else {
      // hide only this scene’s tooltip
      if(tooltip){
         tooltip.style.display = 'none';
      }
     
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
};

    if (index === 0) {
        entitylLeft = this.viewer.entities.add({
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray(fpPos),
            clampToGround: true,
            material: new Cesium.PolylineOutlineMaterialProperty({
              outlineWidth: 10,
              outlineColor: Cesium.Color.GREEN
            }),
          },
          position: centroid,
          label: {
            text: this.emissionMessage,
            font: '17px barlow',
            fontweight: '800',
            lineHeight: '1.8',
            display: 'block',
            show: true,
            showBackground: true,
            backgroundColor: new Cesium.Color(0.165, 0.165, 0.165, 0.8), // Semi-transparent background
            backgroundPadding: new Cesium.Cartesian2(7, 5),
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
          }
        });
       
        if (boundingBox) {
          entitylLeftBB = this.viewer.entities.add({
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArray(boundingBox),
              clampToGround: true,
              material: new Cesium.PolylineOutlineMaterialProperty({
                outlineWidth: 8,
                outlineColor: Cesium.Color.YELLOW
              }),
            }
          });
          entitylLeftBB.index = scn?.sceneIdx;
          entitylLeftBB.sceneId = scn?.id;
          this.scnLyr.push(entitylLeftBB);
        }
        
      if (scn?.legendScale && this.selectedMetric === 'ppb') {
        const longitudes = boundingBox.filter((_, index) => index % 2 === 0);
        const latitudes = boundingBox.filter((_, index) => index % 2 !== 0);
        

        // Calculate the center latitude of the bounding box
        const minLatitude = Math.min(...latitudes);
        const maxLatitude = Math.max(...latitudes);
        const centerLatitude = ((minLatitude + maxLatitude) / 2) - 0.06;


        // Calculate the rightmost longitude of the bounding box
        const maxLongitude = Math.max(...longitudes);

        // Calculate the position for the legend
        const offset = 0.2; // Adjust this value as needed
        const legendLongitude = maxLongitude + this.offset; // Legend will be placed exactly at the right edge of the bounding box
        const legendLatitude = centerLatitude;

        // Create the legend entity
        legendLeft = this.viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(legendLongitude, legendLatitude),
          name: 'legend',
          billboard: {
            image: '',
            show: true,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            horizontalOrigin: Cesium.HorizontalOrigin.RIGHT,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
        });

      //creating legend image
    
        let htmlContent = `
        <style>
        .legend-containers {
          display: flex;
          flex-direction: column;
          height: 280px;
          width: 23px;
          background: linear-gradient(to bottom);
        }
        .color-stop {
          flex-grow: 1;
          display: flex;
          justify-content: center;
          color: white;
          padding-bottom: 28px;
        } 
        
        .scale-value {
          position: absolute;
          font-size: 18px;
          color: white;
          left: 30px;
          font-weight: 600;
        }

        .legend-unit {
          font-size: 13px;
          color: white;
        }

        .unit {
          display: flex;
          flex-direction: column;
        }
      </style>
      <div class="unit">
        <div class="legend-unit">(${legendUnit})</div>
        <div style= "display: flex">
          <div class="legend-containers" style="background: ${this.legendColor};"></div>
          <div class="legend-containers">
            ${this.scaleArray.map(item => `
              <div class="color-stop" style="background-color: transparent">
                <span class="scales-value">${item.displayValue}</span>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
      `;

      let entitiesToRemove: any = [];
      this.viewer.entities.values.forEach((entity) => {
        if (entity.name === 'legend') {
          entitiesToRemove.push(entity);
        }
      });
      
      if (this.timeseries || this.showDailyRecurrencyCheckboxes) {
        this.legendContainer = document.getElementById('legend-container');

        if(this.legendContainer) {              
          this.legendContainer.style.display = 'block';
          this.legendContainer.innerHTML = htmlContent;
        }
      } else {
    
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = htmlContent;
        tempContainer.style.position = 'absolute';
        document.body.appendChild(tempContainer);
              
        html2canvas(tempContainer,{backgroundColor: null}).then((canvas) => {
          const imageDataUrl = canvas.toDataURL('image/png');
          legendLeft.billboard.image = imageDataUrl;
          document.body.removeChild(tempContainer);
        });

        if (currentMode != 2) {
          legendLeft.billboard.verticalOrigin = Cesium.VerticalOrigin.BOTTOM;
          legendLeft.billboard.horizontalOrigin = Cesium.HorizontalOrigin.LEFT;
          legendLeft.billboard.disableDepthTestDistance = Number.POSITIVE_INFINITY;
        }
      }

        legendLeft.index = scn?.sceneIdx;
        legendLeft.sceneId = scn?.id;
        this.scnLyr.push(legendLeft);    
      }
        
      entitylLeft.index = scn?.sceneIdx;
      entitylLeft.sceneId = scn?.id;
      this.scnLyr.push(entitylLeft)
      this.viewer.zoomTo(entitylLeft);
      
      this.handleAnnotation();
      addHoverEventHandler(entitylLeft, scn);
    }
    else {
        entityRight = this.viewer.entities.add({
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray(fpPos),
            clampToGround: true,
            material: new Cesium.PolylineOutlineMaterialProperty({
              outlineWidth: 10,
              outlineColor: Cesium.Color.RED
            }),
          },
          position: centroid,
          label: {
            text: this.emissionMessage,
            font: '17px barlow',
            fontweight: '800',
            lineHeight: '1.8',
            display: 'block',
            show: true,
            showBackground: true,
            backgroundColor: new Cesium.Color(0.165, 0.165, 0.165, 0.8), // Semi-transparent background
            backgroundPadding: new Cesium.Cartesian2(7, 5),
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
          }
        });

        if (boundingBox) {
          entityRightBB = this.viewer.entities.add({
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArray(boundingBox),
              clampToGround: true,
              material: new Cesium.PolylineOutlineMaterialProperty({
                outlineWidth: 8,
                outlineColor: Cesium.Color.WHITE
              }),
            }
          });
          entityRightBB.index = scn?.sceneIdx;
          entityRightBB.sceneId = scn?.id;
          this.scnLyr2.push(entityRightBB);
        }

        if (scn?.legendScale && this.selectedMetric === 'ppb') {      
          const longitudes = boundingBox.filter((_, index) => index % 2 === 0);
        const latitudes = boundingBox.filter((_, index) => index % 2 !== 0);

        // Calculate the center latitude of the bounding box
        const minLatitude = Math.min(...latitudes);
        const maxLatitude = Math.max(...latitudes);
        const centerLatitude = ((minLatitude + maxLatitude) / 2) - 0.06;


        // Calculate the rightmost longitude of the bounding box
        const maxLongitude = Math.max(...longitudes);

        // Calculate the position for the legend
        const offset = 0.2; // Adjust this value as needed
        const legendLongitude = maxLongitude + this.offset; // Legend will be placed exactly at the right edge of the bounding box
        const legendLatitude = centerLatitude;


        legendRight = this.viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(legendLongitude, legendLatitude),
          name: 'legend',
          billboard: {
            image: '',
            show: true,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            horizontalOrigin: Cesium.HorizontalOrigin.RIGHT,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
        });
    
        //creating legend image
      
          let htmlContent = `
          <style>
          .legend-containers {
            display: flex;
            flex-direction: column;
            height: 280px;
            width: 23px;
            background: linear-gradient(to bottom);
          }
          .color-stop {
            flex-grow: 1;
            display: flex;
            justify-content: center;
            color: white;
            padding-bottom: 28px;
          } 
          
          .scale-value {
            position: absolute;
            font-size: 18px;
            color: white;
            left: 30px;
            font-weight: 600;
          }
          .legend-unit {
            font-size: 13px;
            color: white;
          }
  
          .unit {
            display: flex;
            flex-direction: column;
          }
        </style>
        <div class="unit">
          <div class="legend-unit">(${legendUnit})</div>
          <div style= "display: flex">
            <div class="legend-containers" style="background: ${this.legendColor};"></div>
            <div class="legend-containers">
              ${this.scaleArray.map(item => `
                <div class="color-stop" style="background-color: transparent">
                  <span class="scales-value">${item.displayValue}</span>
                </div>
              `).join('')}
            </div>
          </div>
        </div>
        `;

        let entitiesToRemove: any = [];
        this.viewer.entities.values.forEach((entity) => {
          if (entity.name === 'legend') {
            entitiesToRemove.push(entity);
          }
        });
        
        if (this.timeseries || this.showDailyRecurrencyCheckboxes) {
          this.legendContainer = document.getElementById('legend-container');
  
          if(this.legendContainer) {              
            this.legendContainer.style.display = 'block';
            this.legendContainer.innerHTML = htmlContent;
          }
        } else {
      
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = htmlContent;
          tempContainer.style.position = 'absolute';
          document.body.appendChild(tempContainer);
      
          html2canvas(tempContainer,{backgroundColor: null}).then((canvas) => {
            const imageDataUrl = canvas.toDataURL('image/png');
            legendRight.billboard.image = imageDataUrl;
            document.body.removeChild(tempContainer);
          });

          if (currentMode != 2) {
            legendRight.billboard.verticalOrigin = Cesium.VerticalOrigin.BOTTOM;
            legendRight.billboard.horizontalOrigin = Cesium.HorizontalOrigin.LEFT;
            legendRight.billboard.disableDepthTestDistance = Number.POSITIVE_INFINITY;
          }
        }
    
          legendRight.index = scn?.sceneIdx;
          legendRight.sceneId = scn?.id;
          this.scnLyr2.push(legendRight);    
        }

      entityRight.index = scn?.sceneIdx;
      entityRight.sceneId = scn?.id;
      this.scnLyr2.push(entityRight)
      this.viewer.zoomTo(entityRight);

      this.handleAnnotation();
 
      addHoverEventHandler(entityRight, scn);
    }

    var allImageryLayers = this.viewer.imageryLayers._layers;
    var leftImageryLayers: any = [];
    var rightImageryLayers: any = [];
    // Adjust the alpha (opacity) of the layers based on the camera position
    for (var layerIndex = 0; layerIndex < allImageryLayers.length; layerIndex++) {
      var url = allImageryLayers[layerIndex].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[layerIndex].imageryProvider?._source.source.source.client.url : allImageryLayers[layerIndex]?.imageryProvider?.url

      var isLeft = allImageryLayers[layerIndex]?.splitDirection === Cesium.SplitDirection.LEFT;
      var isRight = allImageryLayers[layerIndex]?.splitDirection === Cesium.SplitDirection.RIGHT;
      if (url !== undefined && isLeft) {
        leftImageryLayers.push(allImageryLayers[layerIndex]);
      }
      if (url !== undefined && isRight) {
        rightImageryLayers.push(allImageryLayers[layerIndex]);
      }
    }

    var leftLayerExtent = leftImageryLayers[0]?.imageryProvider.rectangle;
    var rightLayerExtent = rightImageryLayers[0]?.imageryProvider.rectangle;

    if (leftLayerExtent && rightLayerExtent) {
      // Combine the extents of both layers
      var combinedExtent = Cesium.Rectangle.union(leftLayerExtent, rightLayerExtent);
    }
    this.viewer.render();
  }

  onLeftOptChange(option: string) {
    this.RIGHTOPTIONS = [];
    this.LEFTOPTIONS.forEach((item: any, index: any) => {
      if (item.name !== option) {
        this.RIGHTOPTIONS.push(item);
      }
    });
    this.selectedLeft = option;
    this.selectedRight = this.RIGHTOPTIONS[0].name;
    this.rightLayer.splitDirection =
      this.rightLayer.splitDirection === Cesium.SplitDirection.LEFT
        ? Cesium.SplitDirection.RIGHT
        : Cesium.SplitDirection.LEFT;
  }
  onRightOptChange(option: string) {
  }

  clickMenuItem(menuItem, index) {
    this.selectedOptions = [];
    this.taskSelected = false;
    this.selectedSubDailyItems = [];
    this.subDailyFinalArray = [];
    this.selectedCheckboxes = [];
    this.subDailyArray = [];
    this.showDailyRecurrencyCheckboxes = false
    this.spinnerService.hide();
    this.operatorArray = [];
    this.defaultSubdailyCount = 1;
    this.showDailyRecurrencyCheckboxes = false;
    this.subDailyCount = '';
    this.selectedSubdaily = '';
    this.scnLyr = []
    this.scnLyr2 = [];
    this.taskCollection = '';
    this.resetSelect();
    // Clear the emissionMessage when the project name changes
    this.emissionMessage = '';
    this.clearAnnotations();
    this.resetCurrentProductLayer();
    this.selectedIndices = null;
    this.observationEnabled = false;
    this.resetAllFeedPanels();
    if (this.getCollectionSub) {
    this.getCollectionSub.unsubscribe();
    }
    this.unSubscribeAPI();

    if ((this.previousSelectedProject !== null && JSON.stringify(this.previousSelectedProject) !== JSON.stringify(menuItem)) || this.previousSelectedProject === null) {
      this.previousSelectedProject = menuItem;
      this.getCollections(menuItem?.projectid,0);
      this.projectName = menuItem?.project;
      this.collectionIndex = 0;
      this.overlay = [100, 100];
      this.baseOverlay = 100
      this.baseAlpha = 1
      this.selectedSensors = [];
      this.isVisible = false
      this.splitRightPostion = false
      this.splitLeftPostion = false
      this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
      this.viewer.scene.imagerySplitPosition = undefined;
      this.splitPosition = 0.0;
      this.viewer.entities.removeAll();
      this.clearBandLegends();
      this.USLscnLyr = [];
      this.SpirescnLyr = [];
      this.resetBackgroundWithChangeInBaseLayer();
      this.isVisible = false;
      this.splitPosition = 0.0;
      this.splitRightPostion = false
      this.splitLeftPostion = false
      this.collection.sensors.forEach((sensor, index) => {
        sensor.checked = false
        sensor.scenes.forEach((scene) => {
          scene.checked = false

        });
      });
    }
  }

  getCollections(item,idx) {
    this.sensorsIS = true;
    this.taskCollection = '';
    this.clearSilder();
    this.sliderView = false;
    this.timeseries = false;
    this.jump = false;
    this.imageLoaded = false;
    this.annotateClicked = false;
    this.clearAnnotations();
    this.imageryLayerMap.clear();
    this.boundingBoxMap.clear();
    this.datePlace = false;
    this.selectedType = null;
    this.dateDisable = false;
    this.signalSelected = 'All';
    this.newTaskButtonClicked = false;
    this.audioAvailable = false;
    this.currentRfSignals = [];
    this.selectedRecurrencyArray = [];
    this.feedInfo = false;
    this.oilSpil = false;
    this.lastVisibleEntities = [];
    if(this.legendContainer) this.legendContainer.style.display = 'none';

    this.resetBackgroundWithChangeInBaseLayer();
    this.currentSliderValue = 0;
    if (!this.showDailyRecurrencyCheckboxes) {
      this.selectedMetric = 'kg';
      this.sourceRateArray = [];
      this.currentSites = null;
    }
    this.selectedOptions = [];
    this.resetBackgroundWithChangeInBaseLayer();
    this.apiService.getCollections(item).subscribe((res: any) => {
      this.dataSource = res.result;
      if (res.result?.length > 0) {
        this.collectionsData = res.result;
        this.collections = [];
        this.fullCollection = [];
        let count: any;
        res.result.forEach((item, index) => {
          const project = item.project;
          const taskname = item.taskname;
          const createdDate = item?.createdAt;
          const taskId = item.id;
          let sensorName = item?.sensors?.[0]?.sensor;
          const target = JSON.parse(item.target);
          const sensors: any = [];
          const start: Date = new Date(item?.openWindow);
          const end: Date = new Date(item?.closeWindow);
          let datesArray: any[] = [];

          if (item?.repeatFrequency === 'Daily' || item?.repeatFrequency === 'Sub-daily') { count = 1; this.dateRange = false; }
          else if (item?.repeatFrequency === 'Weekly') { count = 7; this.dateRange = true; }
          else if (item?.repeatFrequency === 'Monthly') { count = 30; this.dateRange = true; }


          function generateDateRangeArray(startDate, endDate, daysInterval) {
            const dateRangeArray: any = [];
            let currentDate = new Date(startDate);
            while (currentDate <= endDate) {
              let isDisabled = true;
              let scenesFilterarray: any = [], scenesList: any = [];
              const endDateCopy = new Date(currentDate);
              endDateCopy.setDate(endDateCopy.getDate() + daysInterval - 1);
          
              if (endDateCopy > endDate) {
                endDateCopy.setTime(endDate.getTime());
              }
              endDateCopy.setUTCHours(23, 59, 59, 0);
          
              const convertedStart = new Date(currentDate).toISOString();
              const convertedEnd = endDateCopy.toISOString();
              const startDateOnly = new Date(currentDate).toISOString().split('T')[0];
              
              for (const [sceneIndex, scenes] of item?.sensors?.[0].scenes.entries()) {
                scenes.operatorKey = item?.sensors[0]?.operatorKey;
                const datePredicted = scenes.predicted_date;
                let PredictedDateOnly;
                if (scenes.predicted_date != undefined) {
                  PredictedDateOnly = new Date(scenes.predicted_date).toISOString().split('T')[0];
                }
                
                if ((item?.repeatFrequency === 'Sub-daily' || item?.repeatFrequency === 'Daily') && PredictedDateOnly == startDateOnly && scenes.status !== 'error') {                  
                  const indexToRemove = scenesFilterarray.findIndex((item) => item.predicted_date === scenes.predicted_date);
                  if (indexToRemove === -1) {
                    scenesFilterarray.push(scenes)
                    isDisabled = false;
                  }
                } else if (datePredicted >= convertedStart && datePredicted <= convertedEnd && scenes.status !== 'error') {
                  const indexToRemove = scenesFilterarray.findIndex((item) => item.predicted_date === scenes.predicted_date);
                  if (indexToRemove === -1) {
                    scenesFilterarray.push(scenes)
                    isDisabled = false;
                  }
                }               
               }

              scenesFilterarray.forEach((element, index) => {
                element.sceneIdx = index + 1;
                if (element?.id != null && element?.status != 'failed') {
                  scenesList.push({ id: element.id });
  
                }
              });
  
              const unfailedScenes = scenesFilterarray.filter(scene => scene.status != 'failed');
              if (unfailedScenes.length === 0)
                isDisabled = true;

              dateRangeArray.push({
                start: convertedStart,
                end: convertedEnd,
                repeatFrequency: item?.repeatFrequency,
                checked: false,
                disabled: isDisabled,
                scenes: scenesFilterarray,
                scenesList: scenesList
              });
              currentDate.setDate(currentDate.getDate() + daysInterval);
            }
            return dateRangeArray;
          }

          function hasTimeReached(openWindow) {
            const targetTime = new Date(openWindow);
            const currentTime = new Date();
        
            return currentTime >= targetTime;
        }

        function hasCloseWindowPassed(closeWindow) {
          const closeTime = new Date(closeWindow);
          const currentTime = new Date();
      
          return currentTime > closeTime;
      }
      

          if (item?.frequency === 1) {
            const dateRange = generateDateRangeArray(start, end, count);
            datesArray = dateRange;            
          }

          item.sensors.forEach((sensor, i) => {
            const scenes: any = [];
            const scenesList: any = [];
            const startDate = new Date(item?.openWindow);
            const endDate = new Date(item?.closeWindow);
            let valueAddedOption:any;
            let superResolutions:any;
            let indicesDetails:any;
            let gropVessel: any;

            if (sensor?.operatorKey === this.OPERATOR.GHG) {
              const daysInterval = 30;
              datesArray = [];
              item.repeatFrequency = 'GHG-Monthly';
              this.dateRange = true;
              this.datePlace = true;

              const dateRange = generateDateRangeArray(startDate, endDate, daysInterval);
              datesArray = dateRange; 

              function generateDateRangeArray(startDate, endDate, daysInterval) {
                const dateRangeArray: any = [];
                let currentDate = new Date(startDate);
                while (currentDate <= endDate) {
                  let isDisabled = true;
                  let scenesFilterarray: any = [], scenesList: any = [];
                  const endDateCopy = new Date(currentDate);
                  endDateCopy.setDate(endDateCopy.getDate() + daysInterval - 1);
              
                  if (endDateCopy > endDate) {
                    endDateCopy.setTime(endDate.getTime());
                  }
                  endDateCopy.setUTCHours(23, 59, 59, 0);
              
                  const convertedStart = new Date(currentDate).toISOString();
                  const convertedEnd = endDateCopy.toISOString();              
                  
                  for (const [sceneIndex, scenes] of item?.sensors?.[0].scenes.entries()) {
                    scenes.operatorKey = item?.sensors[0]?.operatorKey;
                    const datePredicted = scenes.predicted_date;
                    if (datePredicted >= convertedStart && datePredicted <= convertedEnd && scenes.status !== 'error') {
                      const indexToRemove = scenesFilterarray.findIndex((item) => item.predicted_date === scenes.predicted_date);
                      if (indexToRemove === -1) {
                        scenesFilterarray.push(scenes)
                        isDisabled = false;
                      }
                    }
                   }
    
                  scenesFilterarray.forEach((element, index) => {
                    element.sceneIdx = index + 1;
                    if (element?.id != null && element?.status != 'failed') {
                      scenesList.push({ id: element.id });
      
                    }
                  });
      
                  const unfailedScenes = scenesFilterarray.filter(scene => scene.status != 'failed');
                  if (unfailedScenes.length === 0)
                    isDisabled = true;
    
                  dateRangeArray.push({
                    start: convertedStart,
                    end: convertedEnd,
                    repeatFrequency: 'GHG-Monthly',
                    checked: false,
                    disabled: isDisabled,
                    scenes: scenesFilterarray,
                    scenesList: scenesList
                  });
                  currentDate.setDate(currentDate.getDate() + daysInterval);
                }
            
                return dateRangeArray;
              }
            }
            if (sensor?.valueAddedOption) {
              valueAddedOption = this.getValueAddedOption(sensor?.valueAddedOption);
            }
            if (sensor?.super_resolution) {
              superResolutions = sensor?.super_resolution;
            }
            if (sensor?.indices) {
              indicesDetails = sensor?.indices;
            }
            if (sensor?.pastPredictions ) {
                gropVessel = sensor?.pastPredictions.reduce((acc, item) => {
                if (!acc[item.mmsi]) acc[item.mmsi] = [];
                acc[item.mmsi].push(item);
                return acc;
              }, {} as { [key: string]: any[] });
            }
            const isNonImagery = this.nonImageryKey.includes(sensor?.operatorKey ?? false);
            if (sensor?.scenes?.length > 0 && ((sensor?.status != 'canceled' && sensor?.operatorKey != OPERATORS.CLYDE) || (sensor?.operatorKey === OPERATORS.CLYDE)) && sensor?.status != 'rejected' && sensor?.status != 'approved' && sensor?.status != 'review' && sensor?.status != 'pending' 
            && sensor?.status != 'failed') {
              sensor?.scenes?.forEach((scene, index) => {
                const predictedDate = new Date(scene?.predicted_date).getUTCDate();
                scene.checked = false;
                let thumbnailUrl;
                let aisAvailable = hasTimeReached(item?.openWindow)
                let aisDownloadable = hasCloseWindowPassed(item?.closeWindow);

                sensor.scenes[index] = scene;
                thumbnailUrl =
                  environment.eeTaskServer +
                  '/' +
                  scene.thumbnailUrl || '';
                if (scene.status != 'error') {
                  scenes.push({
                    id: scene.id,
                    name: `Scene ${index + 1}`,
                    sceneIdx: index + 1,
                    footprint: scene.footprint,
                    aisAvailable,
                    aisDownloadable,
                    openWindow: item?.openWindow,
                    closeWindow: item?.closeWindow,
                    metadata: scene.metadata,
                    metadata_tooltip: scene?.metadata_tooltip,
                    thumbnailUrl: thumbnailUrl,
                    previewUrl: scene.previewUrl,
                    downloadUrl: scene.downloadUrl,
                    checked: false,
                    color: 'primary',
                    scene_id: scene?.scene_id,
                    predictedDate: scene?.predicted_date,
                    status: scene?.status,
                    RRdeliveryDate: scene?.RRdeliveryDate,
                    sequenceNumber: scene?.sequence,
                    uslFootprint: scene?.usl_footprint,
                    s_band: scene?.s_band,
                    x_band: scene?.x_band,
                    operatorKey: sensor?.operatorKey,
                    downloaded: scene?.downloaded,
                    refundRequest: scene?.refundRequest,
                    returnRefundAccept: scene?.returnRefundAccept,
                    returnRefundReject: scene?.returnRefundReject,
                    siteId: scene?.siteId,
                    target: scene?.target,
                    isName: scene?.isName,
                    png_footprint: scene?.png_footprint,
                    tif_footprint: scene?.tif_footprint,
                    legendScale: scene?.legendScale,
                    legend_min: scene?.legend_min,
                    legend_max: scene?.legend_max,
                    legend_long: scene?.legend_long,
                    legend_lat: scene?.legend_lat,
                    ch4srData: scene?.ch4srData,
                    signals: this.getSignals(scene?.signalOfInterest),
                    signalOfInterest: scene?.signalOfInterest,
                    sceneName: scene.name ? scene.name : `Scene ${index + 1}`,
                    skipPreview: scene?.skipPreview,
                    isNonImagery : isNonImagery,
                    rawIQDownloaded : scene?.raw_iq_downloaded,
                    rawIQIncluded : scene?.raw_iq_included
                  });
                }

                for (const [idx, scene] of scenes.entries()) {
                  scene.name = `Scene ${idx + 1}`;
                  scene.sceneIdx = idx + 1;
                }

                if (scene?.id != null && scene?.status != 'failed') {
                  sensor.scenes[index] = scene;
                  scenesList.push({
                    id: scene.id
                  });
                }
              });

              if (scenes.length > 0) {
                sensors.push({
                  name: sensor.sensor, scenes, checked: false, id: sensor?.sensor_uuid, downloadUrl: sensor?.downloadUrl, scenesList, latency: sensor?.latency, downloaded: sensor?.downloaded, resolution_tooltip: sensor.resolution_tooltip, isAdditionalProducts: sensor.isAdditionalProducts, feed_results: sensor.feed_results,
                  isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
                  siteData: sensor?.siteData, InfoServices: sensor.informationServices || [], Observation: sensor.observation || [],
                  intervals: sensor?.intervals, status: sensor?.status, restoreStatus: sensor?.restoreStatus, restoreOption: sensor?.restoreOption, operatorKey : sensor?.operatorKey, noOfRefreshes: sensor?.noOfRefreshes, updatedRefreshes: sensor?.updatedRefreshes, timeExpired: sensor?.timeExpired,
                  isHistorical: sensor?.isHistorical, noOfHistoricalData: sensor?.noOfHistoricalData, updatedFetches: sensor?.updatedFetches, valueAddedOption : valueAddedOption, superResolutions: superResolutions, indicesDetails: indicesDetails,
                  refreshHistory: sensor?.refreshHistory,
                  unUsedRefreshes: sensor.updatedRefreshes == 0 ? 0 : sensor.updatedRefreshes || sensor.noOfRefreshes,
                  unUsedFetches: sensor.updatedFetches == 0 ? 0 : sensor.updatedFetches || sensor.noOfHistoricalData,
                  obfuscateName: sensor?.obfuscateName, assetsDelivered: sensor?.assetsDelivered, sensorType: sensor?.sensorType,
                  tnqSensorType: sensor?.tnqSensorType, pastPrediction: gropVessel
                });
              }
            }
          });

          let taskCollection = item?.taskcollection;
          let captures = item?.captures;
          let sensorsName = item?.sensorsName;
          let info = item?.info;
          if (sensors.length > 0) {
            this.collections.push({
              project,
              taskname,
              target,
              sensors,
              taskId,
              sensorName,
              taskCollection,
              captures,
              sensorsName,
              info,
              frequency: item?.frequency,
              repeatFrequency: item?.repeatFrequency,
              noOfRepeats: item?.noOfRepeats,
              recurrencyArray: datesArray,
              subDailyCount: item?.subDailyCount,
              feasibilityTask: item?.feasibilityTask,
              opportunityList: item?.opportunityList,
              projectId: item?.projectid,
              returnRefund: item?.returnRefund,
              createdDate,
              openWindow: item?.openWindow,
              closeWindow: item?.closeWindow,
            });
          }
        });
        const sensorWithData = this.collections[0].sensors.find(
          (sensor) => sensor.InfoServices
        );
        if (sensorWithData) {
          const infoServicesLength = sensorWithData.InfoServices.length;
          this.selectedIS = Array(infoServicesLength).fill(false);
        }

        this.collection = this.collections[idx];
        this.taskName = this.collections[idx].taskname;
        this.taskid = this.collections[idx].taskId;
        this.sensorList = this.collections[idx].sensors;
        this.fullCollection = JSON.parse(JSON.stringify(this.collections[idx]));
        this.recurrencyArray = this.collections[idx].recurrencyArray;

        if ((this.collection?.frequency === 1  && this.collection?.recurrencyArray?.length > 0)
          || (this.collection?.recurrencyArray[0]?.repeatFrequency === 'GHG-Monthly') ||
          (this.collection?.feasibilityTask && this.collection?.opportunityList?.length > 0)) {
         this.recurrentTask = true;
        } else this.recurrentTask = false;

        this.taskCreatedDate = this.collections[idx].createdDate;
        for (const [sensorIndex, opprDates] of this.collection.opportunityList.entries()) {
          const givenDateObj = new Date(opprDates.date);
          givenDateObj.setHours(0, 0, 0, 0);
          opprDates.checked = false;
          opprDates.name = this.collections[idx].sensors[0].name;
          opprDates.id = this.collections[idx].sensors[0]?.id;
          opprDates.scenes = this.collections[idx].sensors[0].scenes.filter((scene) => {
            const dateObj = new Date(scene.predictedDate);
            dateObj.setHours(0, 0, 0, 0);
            return givenDateObj.getTime() === dateObj.getTime();
          });
        }
        if ((this.collections[idx]?.frequency === 1 && this.collections[idx]?.recurrencyArray?.length > 0)) {
          this.selectOption(this.collections[idx]?.recurrencyArray[0], 'normal');
        } else if (this.collections[idx]?.feasibilityTask && this.collections[idx]?.opportunityList?.length > 0) {
          this.selectOpportunity(this.collections[idx]?.opportunityList[0], 'normal');
        } else if (this.collections[idx]?.repeatFrequency === 'GHG-Monthly') {
          this.selectSite(1)
        }
        
      } else {
        this.collectionsData = [];
      }
      this.spire = false;
      this.usl = false;

      this.spire = this.collections[idx].sensors.some(sensor => 
        sensor?.operatorKey === OPERATORS.SPIRE || sensor?.operatorKey === OPERATORS.CLYDE
      );
      
      this.usl = this.collections[idx].sensors.some(sensor => 
        sensor?.operatorKey === OPERATORS.USL || sensor?.operatorKey === OPERATORS.LBAND
      );

      this.sensorLength = this.collections[idx].sensors.length;

    });
  }

  restTask() {
    this.selectedCheckboxes = [];
    this.showDailyRecurrencyCheckboxes = false;
  }

  clickTask(taskItem, index) {
    this.datePlace = false;
    this.taskSelected = true;
    this.taskCollection = JSON.parse(JSON.stringify(taskItem));
    this.collectionIndex = JSON.parse(JSON.stringify(index));
    this.toggleDailyRecurrency(index);
    this.clearAnnotations();
    this.resetCurrentProductLayer();
    this.selectedOptions = [];
    this.selectedIndices = null;
    this.observationEnabled = false;
    this.resetAllFeedPanels();
    if (this.getCollectionSub) {
    this.getCollectionSub.unsubscribe();
    }
    this.unSubscribeAPI();
  
  }

  clickTaskId(item, event) {
    return
    this.selectedSubDailyItems = [];
    this.subDailyFinalArray = [];
    this.selectedCheckboxes = [];
    this.feasibilityArray = [];
    this.subDailyArray = [];
    this.showDailyRecurrencyCheckboxes = false;
    this.subDailyCount = '';
    this.selectedSubdaily = '';
    this.taskid = item.taskId;
    event.checked = false;
    this.scnLyr = []
    this.scnLyr2 = []
    var allImageryLayers = this.viewer.imageryLayers._layers;
    for (var layerIndex = 0; layerIndex < allImageryLayers.length; layerIndex++) {
      this.viewer.imageryLayers.remove(allImageryLayers);
    }
    this.viewer.imageryLayers.addImageryProvider(
      new Cesium.IonImageryProvider({ assetId: 3954 })
    );
    this.collection.sensors.forEach((sensor, index) => {
      sensor.checked = false
      sensor.scenes.forEach((scene) => {
        scene.checked = false

      });
    });
  }

  selectOpportunity(event, type: any) {
    this.opportunityId = event.oppid[0];
    this.filteredCollection = [];
    let scenesList: any = [];
    const collection = this.fullCollection;
    let opportunityDate = new Date(event.date);
    opportunityDate.setHours(0, 0, 0, 0);
    this.selectedStartDate = event.date;
    this.imageryLayerMap.clear();
    this.boundingBoxMap.clear();
    this.clearAnnotations();
    this.annotateClicked = false;
    this.imageLoaded = false; 
    this.newTaskButtonClicked = false;

      for (const [sensorIndex, sensors] of collection.sensors.entries()) {
        let sceneArray: any = [];
        for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
          let predictedDate = new Date(scenes.predictedDate);
          predictedDate.setHours(0, 0, 0, 0);
          scenes.checked = false;
          if ((predictedDate.getTime() === opportunityDate.getTime())) {
            sceneArray.push(scenes);
          }
        }

        sceneArray.forEach((element, index) => {
          element.sceneIdx = index + 1;
          if (element?.id != null && element?.status != 'failed') {
            scenesList.push({ id: element.id });
          }
        });

        this.collection.sensors[sensorIndex].scenesList = scenesList;
        this.collection.sensors[sensorIndex].scenes = sceneArray;
      }

    this.collection.sensors.forEach((element, index) => {
      element.checked = false
    });
    this.splitPosition = 1;
    this.viewer.entities.removeAll();
    this.clearBandLegends();
    this.USLscnLyr = [];
    this.SpirescnLyr = [];
   
    this.resetBackgroundWithChangeInBaseLayer();
  }

  selectOption(event, type: any) {
    this.subSelectionSelectionChange.next(1)
    this.filteredCollection = [];
    let scenesList: any = [];
    const collection = this.fullCollection;
    this.sceneBands = '';
    this.signalBands = '';
    this.bandTaskId = '';
    this.bandSensorId = '';
    this.signalSensorId = '';
    this.selectedStartDate = '';
    this.selectedEndDate = '';
    this.imageryLayerMap.clear();
    this.boundingBoxMap.clear();
    
    const startDate = new Date(event.start);
    const endDate = new Date(event.end);
    this.selectionChange.next(event);

    this.selectedStartDate = event.start;
    this.selectedEndDate = event.end;

    this.clearAnnotations();
    this.annotateClicked = false;
    this.imageLoaded = false;
    this.newTaskButtonClicked = false;

      for (const [sensorIndex, sensors] of collection.sensors.entries()) {
        let sceneArray: any = [];

        for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
          let datePredicted = new Date(scenes.predictedDate);
          const predictedDate = scenes.predictedDate;

          scenes.checked = false;
          if (event?.repeatFrequency === 'Daily' && (datePredicted >= startDate && datePredicted <= endDate)) {
            sceneArray.push(scenes);
          } else if (event?.repeatFrequency === 'Sub-daily' && predictedDate !== undefined) {
            const PredictedDateOnly = new Date(scenes.predictedDate).toISOString().split('T')[0];
            const startDateOnly = new Date(startDate).toISOString().split('T')[0];
            const endDateOnly = new Date(endDate).toISOString().split('T')[0];
            if (PredictedDateOnly == startDateOnly && PredictedDateOnly == endDateOnly) {
              sceneArray.push(scenes);
            } else{
            this.collection.sensors[sensorIndex].scenes = event?.scenes?? [];
            sceneArray.push(event?.scenes[0]?? []);
            }
          } else if (datePredicted >= startDate && datePredicted <= endDate) {
            sceneArray.push(scenes);
          } else if(event?.scenes?.length > 0){ 
          this.collection.sensors[sensorIndex].scenes = event?.scenes?? [];
          const sceneToAdd = event?.scenes?.[0];
          if (sceneToAdd && !sceneArray.some(s => s?.id === sceneToAdd?.id)) {
          sceneArray.push(sceneToAdd);
          }
         }
        }

        sceneArray.forEach((element, index) => {
          element.sceneIdx = index + 1;
          if (element?.id != null && element?.status != 'failed') {
            scenesList.push({ id: element.id });
          }
        });

        this.collection.sensors[sensorIndex].scenesList = scenesList;
        this.collection.sensors[sensorIndex].scenes = sceneArray;
      }

    if ((type !== 'split' && ((this.previousSelection !== null && JSON.stringify(this.previousSelection) !== JSON.stringify(event)) || this.previousSelection === null)) || type === 'split') {
      this.previousSelection = event;
      this.collection.sensors.forEach((element, index) => {
        element.checked = false
      });

      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      if (event?.repeatFrequency === 'Sub-daily') {
        this.selectSubdaily(this.defaultSubdailyCount);
      } else if (event?.repeatFrequency === 'GHG-Monthly') {
        this.selectSite(this.defaultSubdailyCount);
      } else if (type != 'split') {
        this.splitPosition = 1;
        this.viewer.entities.removeAll();
        this.clearBandLegends();
        this.USLscnLyr = [];
        this.SpirescnLyr = [];
      
        this.resetBackgroundWithChangeInBaseLayer();
      }
    } else {
      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      if (event?.repeatFrequency === 'Sub-daily') {
        this.selectSubdaily(this.defaultSubdailyCount);
      } else if (event?.repeatFrequency === 'GHG-Monthly') {
        this.selectSites(this.defaultSubdailyCount);
      } else if (type != 'split') {
        this.splitPosition = 1;
        this.viewer.entities.removeAll();
        this.clearBandLegends();
        this.USLscnLyr = [];
        this.SpirescnLyr = [];
        this.collection.sensors.forEach((element, index) => {
          element.checked = false
        });
        this.resetBackgroundWithChangeInBaseLayer();
      }
    }
  }

  selectSubdaily(count: number) {
    this.imageryLayerMap.clear();
    this.boundingBoxMap.clear();

    if (this.selectedCheckboxes?.length > 1) return
    
    this.subDailyCountarray = []
    this.defaultSubdailyCount = count;
    let scenesList: any = [];
    for (const [sensorIndex, sensors] of this.filteredCollection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        if (scenes?.sequenceNumber == count) {
          sceneArray.push(scenes);
        }
      }

      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });

      this.collection.sensors[sensorIndex].checked = false;
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;

    }
    for (let i = 0; i < this.collection?.subDailyCount; i++) {
      const countObject = { checked: false, value: i + 1, disabled: this.disabledCheck(i + 1) }
      this.subDailyCountarray.push(countObject)
    }
    this.splitPosition = 1;

    if (!this.showDailyRecurrencyCheckboxes && !this.RF) {
      this.viewer.entities.removeAll();
      this.clearBandLegends();
      this.USLscnLyr = [];
      this.SpirescnLyr = [];
      this.resetBackgroundWithChangeInBaseLayer();
    }
    this.clearAnnotations();
    this.annotateClicked = false;
    this.imageLoaded = false;
    this.newTaskButtonClicked = false;
  }

  selectSites(item: number) {
    this.subDailyCountarray = []
    this.defaultSubdailyCount = item;
    let scenesList: any = [];
    this.collection.siteData = [];
    this.clearAnnotations();
    this.annotateClicked = false;
    this.imageLoaded = false;
    this.imageryLayerMap.clear();
    this.boundingBoxMap.clear();
    this.newTaskButtonClicked = false;
    
    for (const [sensorIndex, sensors] of this.filteredCollection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        if (scenes?.siteId == item) {
          sceneArray.push(scenes);
        }
      }

      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });

      if (!this.timeseries) this.collection.sensors[sensorIndex].checked = false;
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;

      if (sensors.siteData) {
        this.collection.siteData = sensors.siteData;
      }
    }

    for (const [siteIndex, site] of this.collection?.siteData.entries()) {
      site.checked = false;
      site.value = siteIndex + 1;
      site.siteId = siteIndex + 1;
      site.disabled = this.disabledSiteCheck(site.siteId)
    }
    this.subDailyCountarray = this.collection?.siteData
    this.splitPosition = 1;
    this.clearBandLegends();
    this.USLscnLyr = [];
    this.SpirescnLyr = [];
    if (this.selectedType != 'dateDropdown') {
    this.viewer.entities.removeAll();
    this.resetBackgroundWithChangeInBaseLayer();
    }
  }

  disabledCheck(count: number) {
    let sceneArray: any = [];
    for (const [sensorIndex, sensors] of this.filteredCollection.sensors.entries()) {
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;

        if (scenes?.sequenceNumber == count) {
          sceneArray.push(scenes);
        }
      }
    }
    if (sceneArray.length === 0)
      return true
    else
      return false
  }

  disabledSiteCheck(count: number) {
    let sceneArray: any = [];
    for (const [sensorIndex, sensors] of this.filteredCollection.sensors.entries()) {
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;

        if (scenes?.siteId == count) {
          sceneArray.push(scenes);
        }
      }
    }
    if (sceneArray.length === 0)
      return true
    else
      return false
  }

  selectSubdailyRecurrent(event, data) {

    this.showSubDailyList = true
    this.subDailyArray = []
    if (event.checked) {
      this.selectedSubDailyItems.push(data.value)
      this.subSelectionSelectionChange.next(data.value);
      this.selectedSites.push(data.siteName);
    }
    else {
      let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(data.value));
      this.selectedSubDailyItems.splice(countIndex, 1)
      this.subSelectionSelectionChange.next(this.selectedSubDailyItems[this.selectedSubDailyItems.length - 1]);
      let siteNameIndex = this.selectedSubDailyItems.findIndex(item => (item) === (data.siteName));
      this.selectedSites.splice(siteNameIndex, 1)
    }
    if (this.selectedSubDailyItems.length > 2) {
      // If more than 2 items are selected, remove the first selected item
      this.selectedSubDailyItems.shift();
    }

    if (!data.siteName) {
      this.subDailyCount = 'Sub-daily Count : ' + this.selectedSubDailyItems[0];
      this.selectedSubdaily = 'Sub-daily Count : ' + this.selectedSubDailyItems[1];
    } else {
      this.subDailyCount = 'Site Name : ' + this.selectedSites[0];
      this.selectedSubdaily = 'Site Name : ' + this.selectedSites[1];
    }


    for (const count of this.subDailyCountarray) {
      if (count.value === data.value)
        count.checked = event.checked
      let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(count.value));
      if (countIndex === -1)
        count.checked = false
    }
    let scenesList: any = [];
    const filterSubDailyArray = this.filteredCollection.sensors
    let filterArray: any = [];

    for (const [sensorIndex, sensors] of filterSubDailyArray.entries()) {

      for (const count of this.selectedSubDailyItems) {
        let sceneArray: any;
        if (sensors.siteData?.length > 0 && sensors?.operatorKey != OPERATORS.LBAND) {
          sceneArray = this.filteredCollection.sensors[sensorIndex].scenes.filter(scene => parseInt(scene?.siteId) === parseInt(count));
        } else {
          sceneArray = this.filteredCollection.sensors[sensorIndex].scenes.filter(scene => parseInt(scene?.sequenceNumber) === parseInt(count));
        }

        if (sceneArray.length > 0) {
          sceneArray.forEach((element, index) => {
            element.sceneIdx = index + 1;
            if (element?.id != null && element?.status != 'failed') {
              scenesList.push({ id: element.id });
            } else
              element.checked = false

          });
          filterArray.push({
            scenes: sceneArray, scenesList: scenesList, checked: sensors.checked,
            downloaded: sensors.downloaded, id: sensors.id, name: sensors.name, sequenceNumber: count,
            resolution_tooltip: sensors?.resolution_tooltip, downloadUrl: sensors?.downloadUrl,latency: sensors?.latency,
            status: sensors?.status, restoreStatus: sensors?.restoreStatus, restoreOption: sensors?.restoreOption, isAdditionalProducts: sensors?.isAdditionalProducts,
            isAdditionalCSIProducts: sensors?.isAdditionalCSIProducts,obfuscateName: sensors?.obfuscateName,
            assetsDelivered: sensors?.assetsDelivered,
          })
        }


      }

    }

    const uniqueArray: any = [];
    const seenIds = new Set();

    for (const item of filterArray) {
      if (!seenIds.has(item.sequenceNumber)) {
        seenIds.add(item.sequenceNumber);
        uniqueArray.push(item);
      }
    }
    filterArray = uniqueArray
    this.subDailyFinalArray = uniqueArray
    this.scnLyr = []
    this.scnLyr2 = []
    this.viewer.entities.removeAll();
    this.clearBandLegends();
    this.USLscnLyr = [];
    this.SpirescnLyr = [];
    this.resetBackgroundWithChangeInBaseLayer();
    for (const [sensorIndex, subDailyData] of this.subDailyFinalArray.entries()) {
      subDailyData.checked = true
      for (const [index, scn] of subDailyData?.scenes.entries()) {
        if (scn?.id && scn?.status !== 'failed') {
          scn.checked = true
          if (scn?.operatorKey === this.OPERATOR.USL) {
            this.displayRFImage(scn,sensorIndex,'none','none');
          } else if (scn?.operatorKey === OPERATORS.LBAND) {
            this.selectSignals(subDailyData, this.signalSelected)
          } else if (scn.footprint) {
            const sensorId = subDailyData?.id;
            const sceneId = scn?.id;
            const action = "sensor"
            const taskId = this.collection?.taskId;
            const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
            this.spinnerService.show();
            this.mapLoad = true;
            this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
              if (res?.msg === 'Failed') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              } else if (res?.msg === 'user storage') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              }
              scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
              this.displayFootPrint(scn, sensorIndex, res.result, sensorId, taskId);
              this.spinnerService.hide();
              this.mapLoad = false;
            });

          }
        }
      }


    }
    let unShowSensor = this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.USL && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.SPIRE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.CLYDE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.LBAND;
    if (this.selectedSubDailyItems.length === 2 && unShowSensor) {
      this.isVisible = true
      this.splitRightPostion = true
      this.splitLeftPostion = true
      this.splitPosition = 0.5;
      this.clearAnnotations();
    } else {
      this.isVisible = false
      this.splitRightPostion = false
      this.splitLeftPostion = false
      this.splitPosition = 0.0;
    }

    const countCheckbox = this.subDailyCountarray.filter(item => item.checked === true).length;

    if (countCheckbox === 0) {
     this.toggleDailyRecurrency(event);
    }
    
    
    // Force a redraw of the viewer's scene to apply the changes
    this.viewer.scene.requestRender();

  }
  selectSiteRecurrent(event, data) {
    this.showSubDailyList = true;
    this.selectedCheckboxes = [];
    if (event.checked) {

      if (this.selectedSites.length >= 2) {
        // If more than 2 items are selected, remove the first selected item
        this.selectedSites.shift();
        this.selectedSubDailyItems.shift();

      }

      this.selectedSubDailyItems.push(data)
      this.subSelectionSelectionChange.next(data.value);
      this.selectedSites.push(data)

      for (const count of this.subDailyCountarray) {
        let countIndex = this.selectedSites.findIndex(item => parseInt(item?.value) === parseInt(count.value));
        if (countIndex === -1)
          count.checked = false
        else
          count.checked = true
      }
    }
    else {
      let countIndex = this.selectedSites.findIndex(item => parseInt(item?.value) === parseInt(data.value));
      if (countIndex != -1) {
        this.selectedSubDailyItems.splice(countIndex, 1);
        this.selectedSites.splice(countIndex, 1);
      }

      this.subSelectionSelectionChange.next(this.selectedSites[this.selectedSites.length - 1]);
      
      this.subDailyCountarray = this.subDailyCountarray.map(site => {
        if (site.value === data.value) {
          return { ...site, checked: false };
        }
        return site;
      });
    }

    this.subDailyCount = 'Site Name : ' + this.selectedSites[0]?.siteName;
    this.selectedSubdaily = 'Site Name : ' + this.selectedSites[1]?.siteName;

    let scenesList: any = [];
    const filterSubDailyArray = this.fullCollection.sensors
    let filterArray: any = [];
    let startDate, endDate;
    if(this.dateSelected) {
      startDate = new Date(this.collection.recurrencyArray[this.currentSensorIndex].start);
      endDate = new Date(this.collection.recurrencyArray[this.currentSensorIndex].end);
    }


    for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
      for (const [countIndex, count] of this.selectedSites.entries()) {
        let sceneArray: any;
        sceneArray = this.fullCollection.sensors[sensorIndex].scenes.filter(scene => parseInt(scene?.siteId) === parseInt(count.value));
        if (this.dateSelected) {
          sceneArray = sceneArray.filter(scene => (new Date(scene.predictedDate) >= startDate &&
          new Date(scene.predictedDate) <= endDate));
        }
        
        if (sceneArray.length > 0) {
          sceneArray.forEach((element, index) => {
            element.sceneIdx = index + 1;
            if (element?.id != null && element?.status != 'failed'
            ) {
              scenesList.push({ id: element.id });
            } else
              element.checked = false

          });
          
          const filteredCheckboxes = this.collection?.recurrencyArray;
          
          if (countIndex === 0) {
            this.previousSelectionText = sceneArray[0].predictedDate;
            this.previousEndText = filteredCheckboxes[0].end;
          }

          else {
            this.selectionLabel = sceneArray[0].predictedDate;
            this.selectionLabelEnd = filteredCheckboxes[0].end;
          }
          filterArray.push({
            scenes: sceneArray, scenesList: scenesList, checked: sensor.checked,
            downloaded: sensor.downloaded, id: sensor.id, name: sensor.name, sequenceNumber: count,
            resolution_tooltip: sensor?.resolution_tooltip, downloadUrl: sensor?.downloadUrl,latency: sensor?.latency,
            status: sensor?.status, restoreStatus: sensor?.restoreStatus, restoreOption: sensor?.restoreOption, isAdditionalProducts: sensor.isAdditionalProducts,
            isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,obfuscateName: sensor?.obfuscateName,
            assetsDelivered: sensor?.assetsDelivered,
            tnqSensorType: sensor?.tnqSensorType
          })
        }


      }

    }

    const uniqueArray: any = [];
    const seenIds = new Set();

    for (const item of filterArray) {
      if (!seenIds.has(item.sequenceNumber)) {
        seenIds.add(item.sequenceNumber);
        uniqueArray.push(item);
      }
    }
    filterArray = uniqueArray
    this.subDailyFinalArray = uniqueArray
    this.scnLyr = []
    this.scnLyr2 = []
    this.viewer.entities.removeAll();
  
    this.resetBackgroundWithChangeInBaseLayer();
    for (const [sensorIndex, subDailyData] of this.subDailyFinalArray.entries()) {
      subDailyData.checked = true
      for (const [index, scn] of subDailyData?.scenes.entries()) {

        if (scn?.id && scn?.status !== 'failed') {
          scn.checked = true

          if (scn.footprint) {
            const sensorId = subDailyData?.id;
            const sceneId = scn?.id;
            const action = "sensor"
            const taskId = this.collection?.taskId;
            const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
            this.spinnerService.show();
            this.mapLoad = true;
            this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
              if (res?.msg === 'Failed') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              } else if (res?.msg === 'user storage') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              }
              scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
              this.displayFootPrint(scn, sensorIndex, res.result, sensorId, taskId);
              this.spinnerService.hide();
              this.mapLoad = false;
            });

          }

        }
      }


    }
    let unShowSensor = this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.USL && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.SPIRE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.CLYDE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.LBAND;
    if (this.selectedSubDailyItems.length === 2 && unShowSensor ) {
      this.isVisible = true
      this.splitRightPostion = true
      this.splitLeftPostion = true
      this.splitPosition = 0.5;
      this.clearAnnotations();
    } else {
      this.isVisible = false
      this.splitRightPostion = false
      this.splitLeftPostion = false
      this.splitPosition = 0.0;
    }

    this.siteSelected = null;
    this.selectedSite = null;
    
    const filteredCheckboxes = this.subDailyCountarray.filter(item => item.checked);
    if (this.datePlace && filteredCheckboxes[0]) {
      this.siteSelected = filteredCheckboxes[0];
      if (filteredCheckboxes?.length === 1) {
        this.selectedSite = filteredCheckboxes[0];
      }    
    }
    
    if (filteredCheckboxes?.length === 0) {
      this.selectedCheckboxes = [];
      const checkedData = this.collection.recurrencyArray.filter(item => item.checked);
     const index = checkedData[0].index ? checkedData[0].index : 0;

      this.currentEvent = {
        checked : true
       };
      this.toggleRecurrentSensor(0,index,undefined,this.currentEvent,'dropdown','Month');
      this.subDailyCount = '';
      this.selectedSubdaily = '';
    }

    if (filteredCheckboxes?.length > 1) {
      this.dateDisable = true;
    } else this.dateDisable = false;

    // Force a redraw of the viewer's scene to apply the changes
    this.viewer.scene.requestRender();

    if (this.subDailyFinalArray?.length === 0) {
      this.toggleDailyRecurrency(event)
    }

    this.collection.recurrencyArray.forEach(item => {
      item.checked = false;
    });
    this.monthSelected = null;
    
    if (this.selectedSites?.length === 1) {
      this.fullCollection.recurrencyArray.forEach(item => {
        // Set `disabled` to `true` if none of the scenes match the `siteIdToCheck`
        item.disabled = !item.scenes.some(scene => scene.siteId === this.selectedSites[0].value);
      });
      this.collection.recurrencyArray = JSON.parse(JSON.stringify(this.fullCollection.recurrencyArray));
    }
    
  }

  compareOpportunity(i: any, j: any, k: any, event: any, type: any) {
    let unShowSensor =this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.USL && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.SPIRE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.CLYDE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.LBAND;

    if (type === "dropdown") {

      if (event.checked) {
        this.collection.opportunityList[j].checked = event.checked;
        this.feasibilityArray.push(this.collection.opportunityList[j]);
      }
      else {
        const indexToRemove = this.feasibilityArray.findIndex((item) => item.date === this.collection.opportunityList[j].date)
        this.feasibilityArray.splice(indexToRemove, 1);


      }
      this.viewer.entities.removeAll();
      this.clearBandLegends();
      this.USLscnLyr = [];
     
      this.resetBackgroundWithChangeInBaseLayer();
      for (var feasibilityIndex = 0; feasibilityIndex < this.feasibilityArray?.length; feasibilityIndex++) {

        this.feasibilityArray[feasibilityIndex].checked = true;
        this.showOpprtunityImage(feasibilityIndex)
      }

    }
    else
      if (event.checked) {

        if (j === 0) {
          if (k === undefined) {
            this.feasibilityArray.push(this.collection.opportunityList[j]);

            this.viewer.entities.removeAll();
            this.clearBandLegends();
            this.USLscnLyr = [];
            var allImageryLayers = this.viewer.imageryLayers._layers;


            this.showOpprtunityImage(j)
          } else {
            this.showOpprtunityScene(j, k)
          }
        } else {
          if (k === undefined) {
            this.feasibilityArray.push(this.collection.opportunityList[j]);

            var allImageryLayers = this.viewer.imageryLayers._layers;


            this.showOpprtunityImage(j)
          } else {
            this.showOpprtunityScene(j, k)
          }
        }
      }
      else {
        if (j === 0) {
          var allImageryLayers = this.viewer.imageryLayers._layers;
          var leftImageryLayers: any = [];
          var rightImageryLayers: any = [];
          for (var index = 0; index < allImageryLayers.length; index++) {
            var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url
            var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
            var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
            if (url !== undefined && isLeft) {
              leftImageryLayers.push(allImageryLayers[index]);
            }
            if (url !== undefined && isRight) {
              rightImageryLayers.push(allImageryLayers[index]);
            }
          }
          if (k === undefined) {
            if (leftImageryLayers.length === 1) {
              this.viewer.imageryLayers.remove(leftImageryLayers[0]);
            } else
              for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
                this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
              }
            this.feasibilityArray[j]?.scenes.forEach(async (scn: any, index: any) => {
              scn.checked = false
            });
            this.feasibilityArray.splice(j, 1);
            for (const opportunity of this.collection.opportunityList) {
              let countIndex = this.feasibilityArray.findIndex(item => new Date(item.date).getTime() === new Date(opportunity.date).getTime());
              if (countIndex !== -1)
                opportunity.checked = true
              else
                opportunity.checked = false
            }
            if (this.feasibilityArray.length === 0) {
              this.subSelectionSelectionChange.next(1)
              for (var rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {
                this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);
              }
              this.feasibilityArray[j]?.scenes.forEach(async (scn: any, index: any) => {
                scn.checked = false
              })

            }

            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr[indexToRemoveEntity].show = false;
            }

            if (rightImageryLayers.length > 0)
              for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                  this.scnLyr2[indexToRemoveEntity].show = true;
              }

          } else {
            if (leftImageryLayers.length === 1) {
              this.viewer.imageryLayers.remove(leftImageryLayers[0]);
            } else {
              const findSensor = this.feasibilityArray[j]
              for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
                if (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl)) {
                  this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
                }

              }

            }
            this.feasibilityArray[j].scenes[k].checked = false
            if (this.feasibilityArray[j].scenes.filter(item => item.checked).length === 0) {
              this.feasibilityArray[j].checked = false
              this.feasibilityArray.splice(j, 1);
            }
            this.feasibilityArray = this.feasibilityArray.filter(item => item.checked)

            for (const count of this.subDailyCountarray) {
              let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(count.value));
              if (countIndex !== -1)
                count.checked = true
              else
                count.checked = false
            }
            if (this.feasibilityArray.length === 0) {
              this.subSelectionSelectionChange.next(1)
              for (var rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {
                this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);
              }
              this.feasibilityArray[j]?.scenes.forEach(async (scn: any, index: any) => {
                scn.checked = false
              })
              this.viewer.entities.removeAll();
            }

          }

        }
        else {
          var allImageryLayers = this.viewer.imageryLayers._layers;
          var leftImageryLayers: any = [];
          var rightImageryLayers: any = [];
          for (var index = 0; index < allImageryLayers.length; index++) {
            var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url

            var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
            var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
            if (url !== undefined && isLeft) {
              leftImageryLayers.push(allImageryLayers[index]);
            }
            if (url !== undefined && isRight) {
              rightImageryLayers.push(allImageryLayers[index]);
            }
          }
          if (k === undefined) {
            if (rightImageryLayers.length === 1) {
              this.viewer.imageryLayers.remove(rightImageryLayers[0]);
            } else
              for (var rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {
                this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);
              }

            this.feasibilityArray.splice(this.feasibilityArray.length > 1 ? j : 0, 1);
            for (const opportunity of this.collection.opportunityList) {
              let countIndex = this.feasibilityArray.findIndex(item => new Date(item.date).getTime() === new Date(opportunity.date).getTime());
              if (countIndex !== -1)
                opportunity.checked = true
              else
                opportunity.checked = false
            }
            if (this.feasibilityArray.length === 0) {
              this.subSelectionSelectionChange.next(1)
              for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
                this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
              }
              this.feasibilityArray[j]?.scenes.forEach(async (scn: any, index: any) => {
                scn.checked = false
              })
              this.viewer.entities.removeAll();
            }
            if (leftImageryLayers.length > 0)
            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              this.scnLyr[indexToRemoveEntity].show = true;
            }
            for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                this.scnLyr2[indexToRemoveEntity].show = true;
            }


          } else {
            if (rightImageryLayers.length === 1) {
              this.viewer.imageryLayers.remove(rightImageryLayers[0]);
            } else {

              const findSensor = this.feasibilityArray[j]


              for (let rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {

                if (rightImageryLayers[rightImageryLayersIndex]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || (rightImageryLayers[rightImageryLayersIndex]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl) ) {
                  this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);
                }

              }
            }
            this.feasibilityArray[j].scenes[k].checked = false
            if (this.feasibilityArray[j].scenes.filter(item => item.checked).length === 0) {
              this.feasibilityArray[j].checked = false

            }
            this.feasibilityArray = this.feasibilityArray.filter(item => item.checked)
            if (this.feasibilityArray.length === 0) {
              this.subSelectionSelectionChange.next(1)
              for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
                this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
              }
              this.feasibilityArray[j]?.scenes.forEach(async (scn: any, index: any) => {
                scn.checked = false
              })
              this.viewer.entities.removeAll();
            }
          }


        }
        if (this.feasibilityArray.length === 2 && unShowSensor) {
          this.isVisible = true
          this.splitRightPostion = true
          this.splitLeftPostion = true
          this.splitPosition = 0.5;
          this.clearAnnotations();
        } else if (this.feasibilityArray.length === 0) {
          this.subSelectionSelectionChange.next(1)
        } else {
          this.subSelectionSelectionChange.next(this.selectedSubDailyItems[this.selectedSubDailyItems.length - 1])
          this.isVisible = false
          this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
          this.viewer.scene.imagerySplitPosition = undefined;
          this.splitPosition = 0.0;
          this.splitRightPostion = false
          this.splitLeftPostion = false
        }

      }
    if (this.feasibilityArray.length === 2 && unShowSensor) {
      this.isVisible = true
      this.splitRightPostion = true
      this.splitLeftPostion = true
      this.splitPosition = 0.5;
      this.clearAnnotations();
    } else {
      this.splitRightPostion = false
      this.splitLeftPostion = false
      this.isVisible = false
      this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
      this.viewer.scene.imagerySplitPosition = undefined;
      this.splitPosition = 0.0;
      this.splitRightPostion = false
      this.splitLeftPostion = false
    }
    this.viewer.render();

  }

  toggleSubDailyRecurrentSensor(j: any, k: any, event: any) {
    let unShowSensor = this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.USL && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.SPIRE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.CLYDE && this.collection.sensors[0]?.scenes[0]?.operatorKey != this.OPERATOR.LBAND;

    if (event.checked) {

      if (j === 0) {

        if (k === undefined) {
          this.viewer.entities.removeAll();
          this.clearBandLegends();
          this.USLscnLyr = [];
       
          this.resetBackgroundWithChangeInBaseLayer();
          this.showImageInMap(j)
        } else {
          this.showImageInMapScene(j, k)
        }

      } else {

        if (k === undefined) {

         
          this.resetBackgroundWithChangeInBaseLayer();
          this.showImageInMap(j)
        } else {
          this.showImageInMapScene(j, k)

        }

      }

    } else {
      if (j === 0) {

        var allImageryLayers = this.viewer.imageryLayers._layers;
        var leftImageryLayers: any = [];
        var rightImageryLayers: any = [];
        for (var index = 0; index < allImageryLayers.length; index++) {
          var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url

          var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
          var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
          if (url !== undefined && isLeft) {
            leftImageryLayers.push(allImageryLayers[index]);
          }
          if (url !== undefined && isRight) {
            rightImageryLayers.push(allImageryLayers[index]);
          }
        }
         if (k === undefined) {
          if (leftImageryLayers.length === 1) {
            this.viewer.imageryLayers.remove(leftImageryLayers[0]);

            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                this.scnLyr[indexToRemoveEntity].show = false;
                this.scnLyr.splice(indexToRemoveEntity, 1);
            }
          } else

            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                this.scnLyr[indexToRemoveEntity].show = false;
                this.scnLyr.splice(indexToRemoveEntity, 1);
            }
          for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
            this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
          }
          this.subDailyFinalArray[j]?.scenes.forEach(async (scn: any, index: any) => {
            scn.checked = false
          });
          this.subDailyFinalArray = this.subDailyFinalArray.filter(item => item.checked)
          this.selectedSubDailyItems.splice(j, 1);
          this.selectedSites.splice(j, 1);
          this.subDailyCount = 'Sub-daily Count : ' + this.selectedSubDailyItems[0];
          this.selectedSubdaily = 'Sub-daily Count : ' + this.selectedSubDailyItems[1];

          for (const count of this.subDailyCountarray) {
            let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(count.value));
            if (countIndex !== -1)
              count.checked = true
            else
              count.checked = false
          }

          if (this.selectedSites[0] != undefined) {
            for (const count of this.subDailyCountarray) {
              let countIndex = this.selectedSites.findIndex(item => parseInt(item.value) === parseInt(count.value));
              if (countIndex === -1)
                count.checked = false
              else
                count.checked = true
            }
          }
          if (this.subDailyFinalArray.length === 0) {
            this.subSelectionSelectionChange.next(1);

            for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                this.scnLyr2[indexToRemoveEntity].show = false;
            }

            for (var rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {
              this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);

            }
            this.subDailyFinalArray[j]?.scenes.forEach(async (scn: any, index: any) => {
              scn.checked = false
            })
            this.scnLyr2 = []
          }

          for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr[indexToRemoveEntity].show = false;
          }
          this.scnLyr = []


        } else {
          if (leftImageryLayers.length === 1) {
            this.viewer.imageryLayers.remove(leftImageryLayers[0]);

            for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                this.scnLyr[indexToRemoveEntity].show = false;
                this.scnLyr.splice(indexToRemoveEntity, 1);
            }

          } else {
            const findSensor = this.subDailyFinalArray[j]
            if (leftImageryLayers.length === 0) {
              for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < rightImageryLayers.length; leftImageryLayersIndex++) {
                if (rightImageryLayers[leftImageryLayersIndex]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || (rightImageryLayers[leftImageryLayersIndex]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl)) {
                  this.viewer.imageryLayers.remove(rightImageryLayers[leftImageryLayersIndex]);
                }

              }

              for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                const item = this.scnLyr2[indexToRemoveEntity];              
                if (item.index === findSensor.scenes[k].sceneIdx) {
                  this.scnLyr2[indexToRemoveEntity].show = false;
                  this.scnLyr2.splice(indexToRemoveEntity, 1);
                }
              }
            } else {
              for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
                if (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || (leftImageryLayers[leftImageryLayersIndex]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl)) {
                  this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
                }

              }

              for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                const item = this.scnLyr[indexToRemoveEntity];              
                if (item.index === findSensor.scenes[k].sceneIdx) {
                  this.scnLyr[indexToRemoveEntity].show = false;
                  this.scnLyr.splice(indexToRemoveEntity, 1);
                }
              }
            }


          }
          this.subDailyFinalArray[j].scenes[k].checked = false
          if (this.subDailyFinalArray[j].scenes.filter(item => item.checked).length === 0) {
            this.subDailyFinalArray[j].checked = false
            this.selectedSubDailyItems.splice(j, 1);
            this.selectedSites.splice(j, 1);
          }
          this.subDailyFinalArray = this.subDailyFinalArray.filter(item => item.checked)

          this.subDailyCount = 'Sub-daily Count : ' + this.selectedSubDailyItems[0];
          this.selectedSubdaily = 'Sub-daily Count : ' + this.selectedSubDailyItems[1];

          for (const count of this.subDailyCountarray) {
            let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(count.value));
            if (countIndex !== -1)
              count.checked = true
            else
              count.checked = false
          }

          if (this.selectedSites[0] != undefined) {
            for (const count of this.subDailyCountarray) {
              let countIndex = this.selectedSites.findIndex(item => parseInt(item.value) === parseInt(count.value));
              if (countIndex === -1)
                count.checked = false
              else
                count.checked = true
            }
          }
          if (this.subDailyFinalArray.length === 0) {
            this.subSelectionSelectionChange.next(1)
            for (var rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {
              this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);
            }
            this.subDailyFinalArray[j]?.scenes.forEach(async (scn: any, index: any) => {
              scn.checked = false
            })
            this.viewer.entities.removeAll();
          }


        }

        if (this.collection?.sensors[0]?.scenes[0]?.operatorKey === this.OPERATOR.USL) {
          this.viewer.entities.removeAll();
          this.clearBandLegends();
          if (this.subDailyFinalArray[0]?.scenes[0]) {
            this.displayRFImage(this.subDailyFinalArray[0]?.scenes[0], 0, 'none','none');
          }
        } else if (this.collection?.sensors[0]?.scenes[0]?.operatorKey === OPERATORS.LBAND) {          
          for (const [sensorIndex, sensors] of this.subDailyFinalArray.entries()) {
            this.selectSignals(sensors, this.signalSelected)
          }
        }

        if (this.subDailyFinalArray?.length === 0) {
          this.toggleDailyRecurrency(event);
        }

      }
      else {


        var allImageryLayers = this.viewer.imageryLayers._layers;
        var leftImageryLayers: any = [];
        var rightImageryLayers: any = [];
        for (var index = 0; index < allImageryLayers.length; index++) {
          var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url

          var isLeft = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.LEFT;
          var isRight = allImageryLayers[index]?.splitDirection === Cesium.SplitDirection.RIGHT;
          if (url !== undefined && isLeft) {
            leftImageryLayers.push(allImageryLayers[index]);
          }
          if (url !== undefined && isRight) {
            rightImageryLayers.push(allImageryLayers[index]);
          }
        }
        if (k === undefined) {
          for (var rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {
            this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);

          }

          for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
            this.scnLyr2[indexToRemoveEntity].show = false;
          }

          this.subDailyFinalArray[j]?.scenes.forEach(async (scn: any, index: any) => {
            scn.checked = false
          })
          this.scnLyr2 = []
          this.subDailyFinalArray = this.subDailyFinalArray.filter(item => item.checked)
          this.subDailyCountarray[j].checked = false;
          this.selectedSubDailyItems.splice(j, 1)
          this.selectedSites.splice(j, 1)
          this.subDailyCount = 'Sub-daily Count : ' + this.selectedSubDailyItems[0];
          this.selectedSubdaily = 'Sub-daily Count : ' + this.selectedSubDailyItems[1];

          for (const count of this.subDailyCountarray) {
            let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(count.value));
            if (countIndex !== -1)
              count.checked = true
            else
              count.checked = false
          }
          if (this.selectedSites[0] != undefined) {
            for (const count of this.subDailyCountarray) {
              let countIndex = this.selectedSites.findIndex(item => parseInt(item.value) === parseInt(count.value));
              if (countIndex === -1)
                count.checked = false
              else
                count.checked = true
            }
          }



        } else {
          if (rightImageryLayers.length === 1) {
            this.viewer.imageryLayers.remove(rightImageryLayers[0]);
          } else {

            const findSensor = this.subDailyFinalArray[j]


            for (let rightImageryLayersIndex = 0; rightImageryLayersIndex < rightImageryLayers.length; rightImageryLayersIndex++) {

              if (rightImageryLayers[rightImageryLayersIndex]?.imageryProvider?._source?.source?.source?.client?.url === findSensor.scenes[k].thumbnailUrl || rightImageryLayers[rightImageryLayersIndex]?.imageryProvider.url === findSensor.scenes[k].thumbnailUrl) {
                this.viewer.imageryLayers.remove(rightImageryLayers[rightImageryLayersIndex]);
              }

            }
            this.subDailyFinalArray[j].scenes[k].checked = false
            for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
              const item = this.scnLyr2[indexToRemoveEntity];              
              if (item.index === findSensor.scenes[k].sceneIdx) {
                this.scnLyr2[indexToRemoveEntity].show = false;
                this.scnLyr2.splice(indexToRemoveEntity, 1);
              }
            }
          }

          if (this.subDailyFinalArray[j].scenes.filter(item => item.checked).length === 0) {
            this.subDailyFinalArray[j].checked = false
            this.selectedSubDailyItems.splice(j, 1);
            this.selectedSites.splice(j, 1);
            for (let indexToRemoveEntity = this.scnLyr2?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
                this.scnLyr2[indexToRemoveEntity].show = false;
                this.scnLyr2.splice(indexToRemoveEntity, 1);
            }

          }
          this.subDailyFinalArray = this.subDailyFinalArray.filter(item => item.checked)

          this.subDailyCount = 'Sub-daily Count : ' + this.selectedSubDailyItems[0];
          this.selectedSubdaily = 'Sub-daily Count : ' + this.selectedSubDailyItems[1];

          for (const count of this.subDailyCountarray) {
            let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(count.value));
            if (countIndex !== -1)
              count.checked = true
            else
              count.checked = false
          }
          if (this.selectedSites[0] != undefined) {
            for (const count of this.subDailyCountarray) {
              let countIndex = this.selectedSites.findIndex(item => parseInt(item.value) === parseInt(count.value));
              if (countIndex === -1)
                count.checked = false
              else
                count.checked = true
            }
          }
          if (this.subDailyFinalArray.length === 0) {
            this.subSelectionSelectionChange.next(1)
            for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
              this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
            }
            this.subDailyFinalArray[j]?.scenes.forEach(async (scn: any, index: any) => {
              scn.checked = false
            })
            this.viewer.entities.removeAll();
          }
        }

        if (this.collection?.sensors[0]?.scenes[0]?.operatorKey === this.OPERATOR.USL) {
          this.viewer.entities.removeAll();
          this.clearBandLegends();
          if (this.subDailyFinalArray[0]?.scenes[0]) {
            this.displayRFImage(this.subDailyFinalArray[0]?.scenes[0], 0, 'none','none');
          }
        } else if (this.collection?.sensors[0]?.scenes[0]?.operatorKey === OPERATORS.LBAND) {          
          for (const [sensorIndex, sensors] of this.subDailyFinalArray.entries()) {
            this.selectSignals(sensors, this.signalSelected)
          }
        }

        if (this.subDailyFinalArray?.length === 0) {
          this.toggleDailyRecurrency(event);
        }

      }
      if (this.subDailyFinalArray.length === 2 && unShowSensor) {
        this.isVisible = true
        this.splitRightPostion = true
        this.splitLeftPostion = true
        this.splitPosition = 0.5;
        this.clearAnnotations();
      } else if (this.subDailyFinalArray.length === 0) {
        this.subSelectionSelectionChange.next(1)
      } else {
        this.subSelectionSelectionChange.next(this.selectedSubDailyItems[this.selectedSubDailyItems.length - 1])
        this.isVisible = false
        this.splitRightPostion = false
        this.splitLeftPostion = false
        this.viewer.scene.splitPosition = undefined; // or any value between 0 and 1 to position the split
        this.viewer.scene.imagerySplitPosition = undefined;
        this.splitPosition = 0.0;
      }

    }

    const filteredCheckbox = this.subDailyCountarray.filter(item => item.checked);
       
    if (filteredCheckbox[0] && this.datePlace) {
      this.dateDisable = false;
      this.siteSelected = filteredCheckbox[0];      
    }

    if (this.selectedSites?.length === 1 && this.datePlace) { 
      this.fullCollection.recurrencyArray.forEach(item => {
        // Set `disabled` to `true` if none of the scenes match the `siteIdToCheck`
        item.disabled = !item.scenes.some(scene => scene.siteId === this.selectedSites[0].value);
      });
      this.collection.recurrencyArray = JSON.parse(JSON.stringify(this.fullCollection.recurrencyArray));
    }

    if (this.datePlace && this.selectedSites?.length === 2) {
      this.subDailyCount = 'Site Name : ' + this.selectedSites[0]?.siteName;
      this.selectedSubdaily = 'Site Name : ' + this.selectedSites[1]?.siteName;
    }

    if(this.datePlace) this.selectedCheckboxes = [];

    // Force a redraw of the viewer's scene to apply the changes
    this.viewer.scene.requestRender();
  }

  showOpprtunityImage(j) {
    this.feasibilityArray[j]?.scenes.forEach(async (scn: any, index: any) => {
      if (scn?.id && scn?.status !== 'failed') {
        scn.checked = true
        if (scn.footprint) {
          const sensorId = this.feasibilityArray[j]?.id;
          const sceneId = scn?.id;
          const action = "sensor"
          const taskId = this.collection?.taskId;
          const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
          this.spinnerService.show();
          this.mapLoad = true;
          this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
            if (res?.msg === 'Failed') {
              this.fail = this.fail + 1;
              if (this.fail === 1) {
                const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              }
              this.spinnerService.hide();
              this.mapLoad = false;
            } else if (res?.msg === 'user storage') {
              this.fail = this.fail + 1;
              if (this.fail === 1) {
                const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              }
              this.spinnerService.hide();
              this.mapLoad = false;
            }
            if (this.selectedSensors[0]?.scenes) {
              this.selectedSensors[0].scenes[index].thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
            }
            scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
            this.displayFootPrint(scn, j, res.result, sensorId,taskId);
            this.spinnerService.hide();
            this.mapLoad = false;
          });

        }
      }
    });
  }

  showOpprtunityScene(j, k) {
    const scn = this.feasibilityArray[j]?.scenes[k]

    if (scn.footprint) {
      const sensorId = this.feasibilityArray[j]?.id;
      const sceneId = scn?.id;
      const action = "sensor"
      const taskId = this.collection?.taskId;
      const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
      this.spinnerService.show();
      this.mapLoad = true;
      this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
        if (res?.msg === 'Failed') {
          this.fail = this.fail + 1;
          if (this.fail === 1) {
            const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          }
          this.spinnerService.hide();
          this.mapLoad = false;
        } else if (res?.msg === 'user storage') {
          this.fail = this.fail + 1;
          if (this.fail === 1) {
            const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          }
          this.spinnerService.hide();
          this.mapLoad = false;
        }
        scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
        this.displayFootPrint(scn, j, res.result,sensorId,taskId);
        this.spinnerService.hide();
        this.mapLoad = false;
      });

    }

  }

  showImageInMap(j) {
    this.subDailyFinalArray[j]?.scenes.forEach(async (scn: any, index: any) => {
      if (scn?.id && scn?.status !== 'failed') {
        scn.checked = true

        if (scn.footprint) {
          const sensorId = this.subDailyFinalArray[j]?.id;
          const sceneId = scn?.id;
          const action = "sensor"
          const taskId = this.collection?.taskId;
          const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
          this.spinnerService.show();
          this.mapLoad = true;
          this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
            if (res?.msg === 'Failed') {
              this.fail = this.fail + 1;
              if (this.fail === 1) {
                const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              }
              this.spinnerService.hide();
              this.mapLoad = false;
            } else if (res?.msg === 'user storage') {
              this.fail = this.fail + 1;
              if (this.fail === 1) {
                const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              }
              this.spinnerService.hide();
              this.mapLoad = false;
            }
            if (this.selectedSensors[0]?.scenes) {
              this.selectedSensors[0].scenes[index].thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
            }
            this.displayFootPrint(scn, j, res.result,sensorId,taskId);
            this.spinnerService.hide();
            this.mapLoad = false;
          });

        }
      }
    });
  }
  showImageInMapScene(j, k) {
    const scn = this.subDailyFinalArray[j]?.scenes[k]

    if (scn.footprint) {
      const sensorId = this.subDailyFinalArray[j]?.id;
      const sceneId = scn?.id;
      const action = "sensor"
      const taskId = this.collection?.taskId;
      const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
      this.spinnerService.show();
      this.mapLoad = true;
      this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
        if (res?.msg === 'Failed') {
          this.fail = this.fail + 1;
          if (this.fail === 1) {
            const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(CollectionPopupComponent, message,'', '40%');
          }
          this.spinnerService.hide();
          this.mapLoad = false;
        } else if (res?.msg === 'user storage') {
          this.fail = this.fail + 1;
          if (this.fail === 1) {
            const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          }
          this.spinnerService.hide();
          this.mapLoad = false;
        }
        scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
        this.displayFootPrint(scn, j, res.result,sensorId,taskId);
        this.spinnerService.hide();
        this.mapLoad = false;
      });

    }
  }

  downloadProgress(progress: any) {
    
    if (progress?.sensorId != undefined && !progress?.product && !progress?.type) {
      const sensor = this.fullCollection.sensors.find(sensor => sensor.id === progress?.sensorId);
      const nonEmptyIds = sensor.scenes
        .filter(scene => scene.id !== '')
        .map(scene => scene.id);
          progress.sceneId = nonEmptyIds;
        
    }

    let sensorObj = { taskId: progress.taskId, sensorId: progress?.sensorId, sceneId: progress?.sceneId, product: progress?.product, type: progress?.type };
    if (progress?.type) {
      sensorObj.sceneId = [progress?.sceneId];
    }

    if (progress?.downloadClick && progress.progress > 0 && progress.progress < 100) {
      this.freeze = true;
      this.spinnerService.show();
    } else if (progress?.downloadClick && progress.progress >= 100 && progress.progress < 200 && progress?.action != 'aisDownload') {
      localStorage.setItem('scene-downloaded', progress?.sceneId);
      if (progress?.sensorId != undefined && !progress?.product) {
        localStorage.setItem('sensor-downloaded', progress?.sensorId);
      }
      if(!progress?.product) {
        if(this.ecursSensorObject) {
          this.downloadedScene = this.downloadedScene.concat(this.ecursSensorObject?.sceneIds);
        } else {
          this.downloadedScene = this.downloadedScene.concat(progress?.sceneId);
        }
        this.downloadedSensor.push(localStorage.getItem('sensor-downloaded'));
      }

      this.freeze = false;
      this.downloadClick = false;
      this.spinnerService.hide()
      
      if (progress?.action === 'aisDownload') return

      if(this.ecursSensorObject) {
        sensorObj = { taskId: progress.taskId, sensorId: progress?.sensorId, sceneId: this.ecursSensorObject?.sceneIds, product: progress?.product, type : '' };
      }


      this.apiService.updateCollectionDownload(sensorObj).subscribe(async (res: any) => {
        if(res.msg === 'Success' && progress?.product)
        {
          switch(progress?.product)
          {
            case 'Super Resolution':
              this.setDownloadedSR();
              break;
            case 'NDVI':
              this.setDownloadedIndices();
              break;
            default:
              this.setDownloadedVADP();
              break;    
          }
        }
       });
    }
  }

  toggleDailyRecurrency(event: any) {
    this.showDailyRecurrencyCheckboxes = !this.showDailyRecurrencyCheckboxes;
    this.feasibilityArray = []
    for (const opportunity of this.collection.opportunityList) {
      opportunity.checked = false
    }
    this.selectedSensors = [];
    this.recurrencyArray = [];
    this.selectedCheckboxes = [];
    this.subDailyFinalArray = [];
    this.subDailyArray = [];
    this.selectedSubDailyItems = [];
    this.selectedSites = [];
    this.splitPosition = 0.0;
    this.isVisible = false;
    this.splitRightPostion = false
    this.splitLeftPostion = false
    this.showSubDailyList = false
    this.viewer.entities.removeAll();
    this.clearBandLegends();
    this.USLscnLyr = [];
    this.SpirescnLyr = [];
    this.scnLyr = []
    this.scnLyr2 = []
    this.resetSelect();
    this.defaultSubdailyCount = 1;
    this.clearAnnotations();
    this.imageLoaded = false;
    this.selectedSite = null;
    this.monthSelected = null;
    this.selectedType = null;
    this.dateDisable = false;
    this.feedInfo = false;
    if(this.legendContainer) this.legendContainer.style.display = 'none';
    this.RF = false;
    this.filterStart = null;
    this.filterEnd = null;
    this.clearFilterData();
    this.lastVisibleEntities = [];

    if (!this.showDailyRecurrencyCheckboxes) {
      this.selectedDropdownType = '';
      this.dateSelected = false;
      this.collections[0]?.recurrencyArray.forEach(item => {
        item.checked = false;
      });
      this.currentSensorIndex = null;
      this.currentCollectionIndex = null;
      this.currentSensorIndex = null;
      this.currentSceneIndex = null;
      this.currentSites = null;
    }
    
    this.resetBackgroundWithChangeInBaseLayer();
    this.collection.sensors.forEach((sensor, index) => {
      sensor.checked = false
      sensor.scenes.forEach((scene) => {
        scene.checked = false

      });
    });

    if (this.datePlace && this.showDailyRecurrencyCheckboxes) { 
      if (this.selectedDropdownType === 'sites') {
        if (this.dateSelected) {
          this.selectedCheckboxes.push(this.collection.recurrencyArray[this.currentSensorIndex]);
          this.collection.recurrencyArray[this.currentSensorIndex].checked = true;
          this.monthSelected = this.collection.recurrencyArray[this.currentSensorIndex];
        }        
        this.selectSiteRecurrent(this.currentEvent,this.currentSites);
      } else if (this.selectedDropdownType === 'dateSelection') {
        this.toggleRecurrentSensor(this.currentCollectionIndex,this.currentSensorIndex,undefined,this.currentEvent,'dropdown','Month');
        this.subDailyCount = '';
        this.selectedSubdaily = '';
      }
    }
    else if (this.taskSelected) {
      this.collections = [];
      this.getCollections(this.previousSelectedProject?.projectid ? this.previousSelectedProject?.projectid : this.projectSelected,this.collectionIndex);
      this.selectionChange.next(this.collection.recurrencyArray[0])
    } else {
      this.collections = []
      this.getCollections(this.previousSelectedProject?.projectid ? this.previousSelectedProject?.projectid : this.projectSelected,0);
      this.selectionChange.next(this.collection.recurrencyArray[0])
    }
  }

  countSelectedOptions(): number {
    return this.collection.recurrencyArray.filter(item => item.checked).length;
  }

  exceedsSelectionLimit(): boolean {
    return this.countSelectedOptions() >= this.maxSelections;
  }
  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.initialX = event.clientX - this.left;
  }

  onObservationToggle(event: MatCheckboxChange, info: any): void {
    if (event.checked) {
      this.renderObservation(info);
    } else {
      this.removeObservationMarker();
    }
  }

  removeObservationMarker(): void {
    for (const entity of this.observationMarkerEntities) {
      this.viewer.entities.remove(entity);
    }
    this.observationMarkerEntities = [];
  }

  async renderObservation(info: any) {
    this.hasZoomedToObservation = false; 
    this.ObservationValue = info;
    const raw = (info?.observationValue ?? "").trim();
    const parts = raw.split(",").map(s => parseFloat(s));
    const addCrossMarker = (lon: number, lat: number) => {
    const entity = this.viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(lon, lat),
      billboard: {
        image: 'assets/images/marker-icon.png',
        width: 20,
        height: 30,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      },
    });
    // Only zoom once
    if (!this.hasZoomedToObservation) {
      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(lon, lat, 1500),
        duration: 2.5,
      });
      this.hasZoomedToObservation = true;
    }

    this.observationMarkerEntities.push(entity);
    };

    if (parts.length === 2 && Number.isFinite(parts[0]) && Number.isFinite(parts[1])) {
      const [lon, lat] = parts;
      const destination = Cesium.Cartesian3.fromDegrees(lon, lat, 1500);

      addCrossMarker(lon, lat);

      this.viewer.camera.flyTo({ destination, duration: 2.5 });
      return;
    } else if (parts.length > 2 && parts.every(p => Number.isFinite(p))) {
      const coordPairs = raw.split(";").map(pair => pair.trim().split(",").map(val => parseFloat(val)));

      const positions: Cesium.Cartesian3[] = coordPairs.map(([lon, lat]) =>
        Cesium.Cartesian3.fromDegrees(lon, lat)
      );

      const polygon = this.viewer.entities.add({
        polygon: {
          hierarchy: new Cesium.PolygonHierarchy(positions),
          material: Cesium.Color.TRANSPARENT, // No fill
          outline: true,
          outlineColor: Cesium.Color.ORANGE, // Fluorescent orange
          height: 0,
        },
      });

      this.observationMarkerEntities.push(polygon);

      // Zoom to polygon once
      if (!this.hasZoomedToObservation && positions.length > 0) {
        const boundingSphere = Cesium.BoundingSphere.fromPoints(positions);
        this.viewer.camera.flyToBoundingSphere(boundingSphere, {
          duration: 2.5
        });
        this.hasZoomedToObservation = true;
      }
      return;
    }

    try {
      const coordinates = this.getAllMatchingCoordinates(this.selectedHistory, raw);
      if (coordinates.length) {
        this.removeObservationMarker();
        coordinates.forEach(coord => {
        const [lon, lat] = coord;
        addCrossMarker(lon, lat);
      });
        return;
      } else {
        let message = 'The observation of interest is not present in the area of interest.';
        const dialog = this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        dialog.afterClosed().subscribe((res) => {
          this.resetObservationSelection();
          return;
        });
      }

    } catch (err) {
      const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
       const dialog = this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
       dialog.afterClosed().subscribe((res) => {
         this.resetObservationSelection();
       });
      }
  }

  resetObservationSelection(): void {
    this.checkedObservation = false;  
    this.removeObservationMarker();
  }

  getAllMatchingCoordinates(historyMap: any, searchValue: any): number[][] {
    const allFeatures: any[] = [];

    for (const key in historyMap) {
      if (historyMap[key]?.features) {
        allFeatures.push(...historyMap[key].features);
      }
    }
    const matches = allFeatures.filter(feature => {
      const props = feature.properties ?? {};
      return Object.values(props).some(val => val == searchValue);
    });
    return matches.map(m => m.geometry?.coordinates).filter(Boolean);
  }

  selectIS(
  collectionIndex: number,
  sensorIndex: number,
  infoServiceIndex: number,
  event: { checked: boolean },
  info: any,
  taskId: string,
  sensors: any
): void {
  this.setFeedActive(info, true);
  this.feedInfo = false;
  this.currentTaskId = taskId;
  const row = this.collections[collectionIndex]
                .sensors[sensorIndex]
                .InfoServices[infoServiceIndex];
  // Toggle only this checkbox
  row.checked = !!event.checked;
  // Keep your existing Observation fallback untouched
  const sensor = this.collections[collectionIndex].sensors[sensorIndex];
  const hasObservation = sensor.Observation.length > 0;
  const infy = hasObservation ? sensor.Observation[0] : row;
  const scenes = this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes || [];
  const checkedScenesLength = scenes.filter(scene => scene.checked).length;
  if (event.checked) {
    if (infy?.modelType === this.infoserviceModelType) {
      this.spinnerService.show();
      this.mapLoad = true;

      if (infy?.operatorKey === OPERATORS.AXELSPACE) {
        const payload :any = {
          type: 'json',
          sensorId: sensor.id,
          feedId: info._id
        };
       if (checkedScenesLength ==1) {
          payload.sceneId = sensor.id;
          payload.action= "ISDisplay"
        }
        else if(checkedScenesLength == scenes.length){
           payload.action= "sensorFeed"
        }
 
        this.getCollectionSub = this.apiService.getCollectionImage(this.collection.taskId, payload).subscribe(
          (res: any) => this.fetchAndCombineGeoJson(res?.result?.feedData, info, sensors),
          () => { this.spinnerService.hide(); this.mapLoad = false; }
        );

      } else {
        const payload: any = {
          type: 'json',
          sensorId: sensor.id,
          feedId: info._id
        };
        if (checkedScenesLength == 1) {
          payload.sceneId = this.sceneSelected;
            payload.action= "ISDisplay"
        }
        else if (checkedScenesLength == scenes.length) {
         payload.action= "sensorFeed"
        }
        this.getCollectionSub = this.apiService.getCollectionImage(this.collection.taskId, payload).subscribe(
          (res: any) => this.fetchAndCombineGeoJson(res?.result?.feedData, info, sensors),
          () => { this.spinnerService.hide(); this.mapLoad = false; }
        );
      }

    } else {
      // cached path (unchanged)
      const cached = info?.insightDatas ?? [];
      if (cached.length > 0) {
        if (sensor?.operatorKey === OPERATORS.AXELSPACE) {
          this.displayIS(cached[0], info, sensors);
          this.displayedIS = JSON.parse(JSON.stringify(cached[0]));
        } else {
          const s = info.insightDatas.find((sc: any) => sc.sceneId === this.sceneSelected);
          if (s && info) s._id = info._id;
          this.displayIS(s, info, sensors);
          this.displayedIS = JSON.parse(JSON.stringify(s));
        }
      } else {
        this.spinnerService.hide();
        this.mapLoad = false;
      }
    }

  } else {
    const feedId = String(info?._id);
    const config = this.getFeedConfig(feedId);
    const anyOn = sensor.InfoServices.some((i: any) => i.checked);
    if (!anyOn) {
      this.mapLoad = false;
       this.clearBandLegends(); // optional: clear only when none are selected
    }
    this.removeISOverlay(info)
    const key = String(info?._id ?? this.collections[collectionIndex]
                                  ?.sensors[sensorIndex]
                                  ?.InfoServices[infoServiceIndex]
                                  ?.name ?? 'fallback');

    this.removeFeedPanel(key);
    this.setFeedActive(info, false);
    if (config?.type === 'Soil Moisture - SAR') {
    this.hideLegend();
    }
  }
}
  fetchAndCombineGeoJson(urls: string[], info, sensors): void {
    const geoJsonRequests = urls.map((url) => this.httpClient.get(url));

    this.getCollectionSub = forkJoin(geoJsonRequests).subscribe({
      next: (geoJsonDataArray: any[]) => {
        const combinedGeoJson = this.combineGeoJsonFeatures(geoJsonDataArray);
        this.displayedIS = JSON.parse(JSON.stringify(combinedGeoJson))
        this.displayIS(combinedGeoJson, info, sensors);
      },
      error: (error) => {
            this.spinnerService.hide();
            this.mapLoad = false;
      },
    });
  }

  combineGeoJsonFeatures(geoJsonDataArray: any[]): any {
    const allFeatures = geoJsonDataArray.flatMap((geoJson) => geoJson.features);
    return {
      type: 'FeatureCollection',
      features: allFeatures,
      metadata: geoJsonDataArray[0]?.metadata,
      feed_results: geoJsonDataArray[0]?.feed_results
    };
  }


  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    this.left = event.clientX - this.initialX;
    if (this.left < 63) {
      this.entitywidth1 -= this.left;
    } else {
      this.entitywidth1 += this.left;
    }
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
  }

  flattenObject(obj: any): { key: string; value: any }[] {
    const result: { key: string; value: any }[] = [];

    function recurse(curr: any, prop?: string) {
      if (Object(curr) !== curr) {
        result.push({ key: prop || '', value: curr });
      } else if (Array.isArray(curr)) {
        for (let i = 0; i < curr.length; i++) {
          recurse(curr[i], prop ? prop + '[' + i + ']' : '[' + i + ']');
        }
        if (curr.length === 0) {
          result.push({ key: prop || '', value: [] });
        }
      } else {
        let isEmpty = true;
        for (const p in curr) {
          isEmpty = false;
          recurse(curr[p], prop ? prop + '.' + p : p);
        }
        if (isEmpty && prop) {
          result.push({ key: prop, value: {} });
        }
      }
    }

    recurse(obj);
    return result;
  }


  getMetadata(metadata: any) {
    this.metaDataTooltip = metadata;
  }

  transformDate(dates: string) {
    return this.datePipe.transform(dates, 'yyyy-MM-dd','UTC');
}

selectBands(bands: any) {
  this.bandSelected = bands;

  if (!this.showDailyRecurrencyCheckboxes && this.sceneBands) {
    this.removeDataSourceById("sensor",this.bandSensorId);
    const indexToRemoveEntity = this.USLscnLyr.findIndex((item) => item.index === this.uslBB.index);

    if (indexToRemoveEntity !== -1) {
      this.USLscnLyr[indexToRemoveEntity].show = false
      this.USLscnLyr.splice(indexToRemoveEntity, 1);
    }
    this.USLscnLyr = [];
    this.displayImage(this.sceneBands);
    this.setJsonData(this.sceneBands,this.bandTaskId,this.bandSensorId);

    if(this.annotateClicked) this.getAnnotations();

  } else if (this.showDailyRecurrencyCheckboxes && !this.showSubDailyList) {
    this.viewer.entities.removeAll();
    this.clearBandLegends();
    this.USLscnLyr = [];
    for (const [sensorIndex, sensors] of this.selectedCheckboxes.entries()) {
      for (const item of sensors.scenes) {
        if (item.checked && item.operatorKey === this.OPERATOR.USL) {
          this.displayRFImage(item, sensorIndex, sensors.id,'none');
        }
      }
    }
  } else if (this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
    this.viewer.entities.removeAll();
    this.clearBandLegends();
    this.USLscnLyr = [];
    for (const [sensorIndex, subDailyData] of this.subDailyFinalArray.entries()) {
      subDailyData.checked = true
      for (const [index, scn] of subDailyData?.scenes.entries()) {
        if (scn?.id && scn?.status !== 'failed') {
          scn.checked = true
          this.displayRFImage(scn, sensorIndex, 'none','none');
        }
      }
    }
  }
}

resetSelect() {
  if (this.bandSelect) {
    this.bandSelect.value = 'both';
    this.sceneBands = '';
    this.bandSelected = 'both';
    this.bandTaskId = '';
    this.bandSensorId = '';
  }
}

  isPartialDelivery(res: any){
    if (res?.isPartialApproved === false && res?.partialPayment === true) {
      this.popupService.openPopup(CollectionPopupComponent, 'partial-delivery', '', '40%');
      return true
    }
    return false;
  }

  OpenReturnRequest(i: any, j: any, info: any, scene: any, action: any) {
    const sensor = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sceneId: any = scene?.id;
    let sensorId: any = sensor?.id;
    let product = 'scene';
    let products = 'scene';
    let feedId: any;

    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';
    else if (sensor?.operatorKey === OPERATORS.SPIRE) {
      product = 'AIS';
      products = 'AIS';
    }
    else if (info?.insightDatas && action === 'feed') {
      product = "IS";
      feedId = info?._id;
      products = 'IS';
      sceneId = this.sceneSelected;
    }
    else if (sensor?.operatorKey === OPERATORS.AZISTA) {
      product = OPERATORS.AZISTA;
      products = OPERATORS.AZISTA;
    }

    if (action === 'indices') {
      product = scene.product;
      products = scene.product;
      const currentScene = sensor.scenes.find(scene => scene.checked === true);
      sceneId = currentScene.id;
    }
    
    let sensorObj = {
      taskId, sensorId, sceneId, product: products, feedId
    }

    let sensorInfo = {
      scene, taskId, sensorId, sceneId, product,sensor,feedId, action
    }
  
    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if(this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        let message =  'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }
  
        if (res?.returnRefundReject || (res?.returnRefundAccept)) {
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          return
        } else if (res?.refundRequest && product != 'IS') {
          const message = 'return-refund';
          let type = {msg: product}
          if (action === 'indices') type = {msg: 'indices'}
          this.popupService.openPopup(CollectionPopupComponent, message, type, '40%');
          return
        } else {
          this.handleRefundRequest(sensorInfo);
        }
      } else if (res?.refundRequest && product === 'IS') {
        const message = 'return-refund';
        let type = {msg: product}
        if (action === 'indices') type = {msg: 'indices'}
        this.popupService.openPopup(CollectionPopupComponent, message, type, '40%');
        return
      } else {
        this.handleRefundRequest(sensorInfo);
      }
    });
  }
  
  handleRefundRequest(sensorInfo: any) {
    let scene = sensorInfo.scene;
    let taskId = sensorInfo.taskId;
    let sensorId = sensorInfo.sensorId;
    let sceneId = sensorInfo.sceneId;
    let product = sensorInfo.product;
    let sensor = sensorInfo.sensor;

    if (scene?.refundRequest && product != 'IS' && sensor?.operatorKey !== OPERATORS.AZISTA) {
      const message = 'return-refund';
      const type = {msg: product}
      this.popupService.openPopup(CollectionPopupComponent, message, type, '40%');
      return
    } else {
      const dialog = this.matdialog.open(ReturnRefundComponent, {
        minWidth: '50%',
        data: {type: 'return', taskId: taskId, sensorId: sensorId, sceneId: sceneId,
          product: product, action: sensorInfo?.action, feedId: sensorInfo?.feedId
        },
        backdropClass: 'blurred',
        disableClose: true
      });
  
      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          const message = 'return-refund-success';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          this.refundRequestScenes.push(localStorage.getItem('refund-request'));
        }
      });
    }
  }
  

  refundStatus(scene: any) {
    if (scene?.refundRequest && (scene?.returnRefundAccept || scene?.returnRefundReject)) {
      let message = 'return-refund-accepted';
      if (scene?.returnRefundReject) {
        message = 'return-refund-rejected';
      }
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    }
  }

  shouldDisplayScene(scene: any, collection: any, downloadedScene: any[], sensor: any): boolean {
    const isSceneValid = scene.id && scene.status !== 'failed';
    const isDownloaded = downloadedScene.includes(scene.id) || scene.downloaded;
    const isReturnRefund = collection?.returnRefund;
    const isNotArchive = sensor?.status != 'archived'
    return isSceneValid && isDownloaded && isReturnRefund && isNotArchive;
  }

  shouldNotDisplayScene(scene: any, collection: any, downloadedScene: any[], sensor: any): boolean {
    const hasValidIdAndStatus = scene.id && scene.status !== 'failed';
    const isNotDownloadedAndNotInDownloadedScenes = !scene.downloaded && !downloadedScene.includes(scene.id);
    const isArchived = sensor?.status === 'archived' && collection?.returnRefund;
  
    return (hasValidIdAndStatus && isNotDownloadedAndNotInDownloadedScenes) 
            || isArchived ||  sensor?.status !== 'completed';
  }

  openRestoreRequest(i,j,sensor) {
    const sensors = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sensorId: any;
    sensorId = sensors?.id;
    let statusObj = {taskId: taskId, sensorId: sensorId};

    this.apiService.restoreStatus(statusObj).subscribe(async (res: any) => {      
      if (res?.restoreStatus === 'Submit') {
        const message = 'restore';
        const type = {msg: 'restore-prerequested'}
        this.popupService.openPopup(CollectionPopupComponent, message, type, '40%');
        return
      } else if (res?.restoreStatus === 'Rejected') {
        const message = 'restore';
        const type = {msg: 'rejected', taskname: res?.taskname, reason: res?.reason}
        this.popupService.openPopup(CollectionPopupComponent, message, type, '40%');
      } else {
        const dialog = this.matdialog.open(ReturnRefundComponent, {
          minWidth: '50%',
          data: {type: 'restore'},
          backdropClass: 'blurred',
          disableClose: true 
        });
        dialog.afterClosed().subscribe((result) => {
          if (result != 'close') {
            const message = 'restore';
            const type = {msg: 'restore-success'}
            this.popupService.openPopup(CollectionPopupComponent, message, type, '40%');
            const restoreRequestReason = result.restoreReason;
            const restoreOption = result.restoreOption;
    
            const sensorObj = { taskId: taskId, sensorId: sensorId, restoreOption: restoreOption, restoreRequestReason: restoreRequestReason };
            this.apiService.restoreRequest(sensorObj).subscribe(async (res: any) => { });
            localStorage.setItem('restore-request', sensorId);
            this.restoreRequestedSensors.push(localStorage.getItem('restore-request'));
          }
          else {
            return
          }
        });
      }
    });
  }

private _downloadStatesCache: Map<string, boolean> = new Map();
private _lastInfoServiceData: any;

  shouldDownload(collectionIndex, sensorIndex, scene: any, InfoService) {
    if (!this.sceneSelected) {
      return false;
    }

    scene = this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes.find(scn => scn.id === this.sceneSelected);

    if ( scene && scene.checked === false) {  
      return false;
    }
    

    // Clear cache if InfoService data changed
    if (this._lastInfoServiceData !== InfoService?.insightDatas) {
      this._downloadStatesCache.clear();
      this._lastInfoServiceData = InfoService?.insightDatas;
    }

    // Create unique key for this combination
    const cacheKey = `${collectionIndex}-${sensorIndex}-${scene?.id}`;

    // Return cached value if exists
    if (this._downloadStatesCache.has(cacheKey)) {
      return this._downloadStatesCache.get(cacheKey)!;
    }
    const selectedSceneIS = InfoService?.insightDatas?.filter(scene => scene.sceneId === this.sceneSelected);
    const isData = selectedSceneIS?.length > 0;
    const isSameSensor = this.collections[collectionIndex]?.sensors[sensorIndex]?.id === InfoService.sensorId;
    const isLength = isData;
    const selectedSensorIS = InfoService?.insightDatas?.length > 0;
    let isDownload: boolean = true;

     const isChecked = this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
    const scenes = this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes || [];
    const checkedScenesLength = scenes.filter(scene => scene.checked).length;
    const totalScenes = scenes.length;   
    const isOneOrAllChecked = checkedScenesLength === 1 || checkedScenesLength === totalScenes;
    isDownload = checkedScenesLength != 0 && isOneOrAllChecked;
    if(this.collections[collectionIndex]?.sensors[sensorIndex].InfoServices.length>1 && checkedScenesLength >1){
      return false
    }
    if (isDownload) {
      if (this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey != OPERATORS.AXELSPACE) {
        for (let scene of scenes) {
        const hasScene = scene && scene.id;
        const isSceneValid = scene && scene.status !== 'failed';
          isDownload =   hasScene &&  isSceneValid  && isSameSensor && isData && !this.isVisible && isLength;
          break
        }
      } else {
        const isChecked = this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
        const allSceneChecked = this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes.every(scene => scene.checked);
        isDownload = isChecked && allSceneChecked && selectedSensorIS;
      }
    }
    // Cache the result
    this._downloadStatesCache.set(cacheKey, isDownload);

    return isDownload;
  }

  shouldNotDownload(collectionIndex, sensorIndex, scene: any, InfoService) {
    return !this.shouldDownload(collectionIndex, sensorIndex, scene, InfoService);
  }

   zoomToLocation() {
    const mode = this.viewer.scene.mode;
    var entities = this.viewer.entities;
    var entityArray = entities.values;
    var myEntity = entityArray[0];      

    if (myEntity) {        
      for (var i = 0; i < entityArray.length; i++) {
        var entity = entityArray[i];
        if (entity.name === 'legend' && entity.billboard && mode != 2) {
          entity.billboard.verticalOrigin = new Cesium.ConstantProperty(Cesium.VerticalOrigin.BOTTOM);
          entity.billboard.horizontalOrigin = new Cesium.ConstantProperty(Cesium.HorizontalOrigin.LEFT);
          entity.billboard.disableDepthTestDistance = new Cesium.ConstantProperty(Number.POSITIVE_INFINITY);
      }
       if (entity.show && entity.name != 'legend') {
        this.viewer.flyTo(entity);
      }
      }
    } else {
      var dataSourceCollection = this.viewer.dataSources;
      var dataSource = dataSourceCollection.get(0);

      if (dataSource) {
        this.viewer.flyTo(dataSource);
      }
    }
  }
  
   clearBandLegends () {
    this.viewer.dataSources.removeAll(true);
    this.leftBand = false;
    this.rightBand = false;
    this.feedLoaded = false;
    if(this.legendContainer) this.legendContainer.style.display = 'none';
   }

   shouldDisableIS(collectionIndex,sensorIndex,scene: any,InfoService: any, infoServiceIndex: number = 0) {
    const selectedSceneIS = InfoService?.insightDatas?.filter(scene => scene.sceneId === this.sceneSelected);
    const isData = selectedSceneIS?.length > 0;
    const isSameSensor =  this.collections[collectionIndex]?.sensors[sensorIndex]?.id === InfoService.sensorId;
    const checkedSensors = this.collections[collectionIndex]?.sensors.filter(scene => scene.checked === true);
    let checkedInfo: boolean = true;

    if (checkedSensors?.length > 0) {
      checkedInfo = checkedSensors[0].id === InfoService.sensorId;
    }
    

    let isDisable: boolean = true;

    const isChecked = this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
    const scenes = this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes || [];
    const checkedScenesLength = scenes.filter(scene => scene.checked).length;
    const totalScenes = scenes.length;  
    isDisable = checkedScenesLength === 0 || (checkedScenesLength > 1 && checkedScenesLength < totalScenes);
    if(this.collections[collectionIndex]?.sensors[sensorIndex].InfoServices.length>1 && checkedScenesLength >1){
      return true
    }
    if (!isDisable) {
      if (this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey != OPERATORS.AXELSPACE) {
        for (let scene of scenes) {
          isDisable = !isSameSensor || !scene.id || scene?.status === 'failed' || !isData || !checkedInfo;
          break
        } 
       // isDisable = this.sensorsIS || !isSameSensor || !scene.id || scene?.status === 'failed' || !isData || !checkedInfo;
      } else {
        const isChecked = this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
        //const allSceneChecked = this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes.every(scene => scene.checked);
        isDisable = !isChecked;
      }
    }
    return isDisable;
   }

   shouldDisableObservation(collectionIndex,sensorIndex,scene: any,InfoService: any, infoServiceIndex: number = 0) {
    let isDisable: boolean = true;
    if (this.isObservation(this.collections[collectionIndex]?.sensors[sensorIndex]) && Object.keys(this.selectedHistory).length > 0) {
      isDisable = false;
    } else if (this.observationEnabled) {
      isDisable = false;
    } else {
      isDisable = true;
     this.resetObservationSelection();
    }
    return isDisable;
   }

  //  getFeedInfo(info: any) {
  //   return info.some(item =>
  //   item.checked === true &&
  //   feedsConfig[item._id] !== undefined
  //   );
  //  }

  getFeedInfo(info: any) {
  if (!Array.isArray(info)) return false;

  return info.some(item => {
    const cfg = feedsConfig[item._id];
    return (
      item.checked === true &&
      cfg &&
      ['ship', 'transhipment'].includes(cfg.type?.toLowerCase())
    );
  });
} 

 showFilterIcon(info: any) {
  if (!Array.isArray(info)) return false;

  return info.some(item => {
    const cfg = feedsConfig[item._id];
    return (
      item.checked === true &&
      cfg &&
      ['ship'].includes(cfg.type?.toLowerCase())
    );
  });
 }


  private colorForType(type?: string): Cesium.Color {
  if (!type) return Cesium.Color.fromCssColorString('#ffd166');
  const any = Object.values(feedsConfig).find((c: any) => c?.type === type && c?.color);
  const c = (any as any)?.color as string | undefined;
  if (!c) return Cesium.Color.fromCssColorString('#ffd166');
  if (c.startsWith?.('#')) return Cesium.Color.fromCssColorString(c);
  const named = (Cesium.Color as any)[c];
  return named instanceof Cesium.Color ? named : Cesium.Color.fromCssColorString('#ffd166');
}

// (safe) length predicate
private matchByLength(f: any, len: number, keepGreater: boolean): boolean {
  const v = parseFloat(f?.properties?.vessel_length);
  if (Number.isNaN(v)) return false;
  return keepGreater ? v > len : v < len;
}

private styleFilteredOverlay(ds: Cesium.DataSource) {
  ds.entities.values.forEach((e: any) => {
    const cStr = e?.properties?._color?.getValue?.() ?? e?.properties?._color ?? '#ffd166';
    const base = cStr?.startsWith?.('#')
      ? Cesium.Color.fromCssColorString(cStr)
      : ((Cesium.Color as any)[cStr] as Cesium.Color) || Cesium.Color.fromCssColorString('#ffd166');

    if (e.position) {
      e.billboard = undefined;
      e.point = new Cesium.PointGraphics({
        pixelSize: 10,
        color: base,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 1,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      });
    }
    if (e.polyline) {
      e.polyline.material = new Cesium.ColorMaterialProperty(base);
      e.polyline.width = new Cesium.ConstantProperty(3);
      e.polyline.clampToGround = new Cesium.ConstantProperty(true);
    }
    if (e.polygon) {
      e.polygon.material = new Cesium.ColorMaterialProperty(base.withAlpha(0.4));
      e.polygon.outline = new Cesium.ConstantProperty(false);
      e.polygon.outlineColor = new Cesium.ConstantProperty(base);
      e.polygon.height = new Cesium.ConstantProperty(0);
      e.polygon.perPositionHeight = new Cesium.ConstantProperty(false);
      e.polygon.classificationType = new Cesium.ConstantProperty(Cesium.ClassificationType.TERRAIN);
    }
  });
}

// counts per properties.class for panel
  private countsByClass(features: Feature<Geometry, FeatureProps>[]): Record<string, number> {
    return features.reduce((acc, ft: any) => {
      const cls = String(ft?.properties?.class ?? 'Unknown');
      acc[cls] = (acc[cls] || 0) + 1;
      return acc;
    }, {} as Record<string, number>);
  }

  private getFeedResultKeyForClass(feedType?: string): 'vessel_count' | 'transhipment_count' {
  const s = String(feedType ?? '').trim().toLowerCase();
  return s.includes('trans') ? 'transhipment_count' : 'vessel_count';
}

private setFeedActive(feed: any, checked: boolean) {
  const key = this.getFeedKey(feed, feedsConfig[feed?._id]);
  if (!key) return;
  
  if (checked) {
    this.activeFeedKeys.add(key);
  } else {
    this.activeFeedKeys.delete(key);
    const config = feedsConfig[key];
    const dss = this.currentFilterDs;
    const entities = dss?.entities.values.slice();
    const t = this.viewer.clock.currentTime;
    const norm = (s: any) =>
      String(s ?? '')
        .toLowerCase()
        .replace(/[^a-z]/g, '')           // drop spaces/dashes/etc
        .replace('transhipment', 'transshipment') // alias fix
        .replace(/s$/, '');   
    const want = norm(config?.type);
    if(entities){
      for (const entity of entities) {
        const t = this.viewer.clock.currentTime;
        const cls = entity?.properties?.['_class']?.getValue?.(t) ??
          entity?.properties?.['_class'] ?? undefined;
          if (norm(cls) === want) dss?.entities.remove(entity);
    }
  }
    this.removeFeedPanel(key);
    this.removeFromFiltered(key);
    const ds = this.isLayers.get(key);
    if (ds) (ds as any).show = false; 
  }
}
openFilter() {
  const dialogRef = this.matdialog.open(FilterPopupComponent, {
    width: '35%',
    backdropClass: 'blurr',
    disableClose: true,
    data: { type: 'vessel', currentUser: this.currentUser },
  });

  dialogRef.afterClosed().subscribe(async (result) => {
    if (!result) return;
    if (this.currentFilterDs) {
      this.viewer.dataSources.remove(this.currentFilterDs, true);
      this.currentFilterDs = undefined;
    }

    const lenLimit = Number(result.length);
    const keepGreater = !!result.isGreater;

    const activeEntries: Array<[string, { fc: FeatureCollection; type?: string; color?: string; title: string }]> = [];
    for (const key of this.activeFeedKeys) {
      const entry = this.geoByFeed.get(key);
      if (entry) activeEntries.push([key, entry]);
    }

    if (activeEntries.length === 0) {
      this.popupService.openPopup(CollectionPopupComponent, 'No checked feeds to filter.', '', '40%');
      this.resetAllFeedPanels();
      return;
    }

    // rebuild right-panel for filtered view
    this.feedPanels.clear();

    // ===== helpers =====
    const norm = (s?: string) => (s || '').toLowerCase();
    const isVesselType = (t?: string) =>
      ['ship', 'vessel'].includes(norm(t));
    const colorForType = (t?: string, fallback?: string) => {
      const hit = Object.values(feedsConfig).find((c: any) => norm(c?.type) === norm(t));
      return (hit as any)?.color ?? fallback ?? '#ffd166';
    };

    // Build ONE combined filtered FC (only from active feeds)
    const combined: GeoJSON.Feature[] = [];
    let vesselMatches = 0; 
    for (const [id, entry] of activeEntries) {
      const { fc, type: entryType, color: entryColor, title } = entry;
      const feats = Array.isArray(fc.features) ? fc.features : [];

      const cfg = feedsConfig[id];
      const effectiveType = cfg?.type ?? entryType;

      // (A) Vessel / Trans(ship)ment -> apply length filter + rebuild panel from filtered
      if (isVesselType(effectiveType)) {
        const filtered = feats.filter(f => this.matchByLength(f, lenLimit, keepGreater));
        vesselMatches += filtered.length;

        // panel: counts by class for THIS feed (after filter)
        const classCounts = this.countsByClass(filtered as any);
        const resultKey   = this.getFeedResultKeyForClass(cfg?.type);
        const totalCount  = Object.values(classCounts).reduce((sum, n) => sum + n, 0);
        const feedResults = { [resultKey]: totalCount };
        const vm = this.helperService.buildFeedSections(cfg, feedResults);
        this.addFeedPanel(id, title, cfg?.color, vm.sections);

        // push filtered features with per-feature color
        const colorStr = colorForType(effectiveType, entryColor);
        for (const f of filtered) {
          const props = { ...(f.properties || {}), _color: colorStr };
          combined.push({ ...f, properties: props } as any);
        }
        continue;
      }

      // (B) Non-vessel types -> pass through unchanged (no length filter)
      // Right panel: use original feed_results (unchanged)
      const vm = this.helperService.buildFeedSections(cfg, (fc as any)?.feed_results);
      this.addFeedPanel(id, title, cfg?.color, vm.sections);
      if(cfg?.type ==="Vessel-classification") {
      for (const f of feats) {
        const classKey = f?.properties?.['class'];
        const classColor = cfg?.color?.[classKey]?.color;
        const props = { ...(f.properties || {}), _color: classColor };
        combined.push({ ...f, properties: props } as any);
      }
      } else{
      const passthroughColor = colorForType(effectiveType, entryColor);
      for (const f of feats) {
        const props = { ...(f.properties || {}), _color: passthroughColor };
        combined.push({ ...f, properties: props } as any);
      }
     }
    }

    // ===== after the loop =====
    // If absolutely nothing to show (no vessel matches and no passthrough), restore + popup
    if (combined.length === 0) {
      this.clearFilteredLayerAndRestore();
      this.popupService.openPopup(
        CollectionPopupComponent,
        'There are no vessels meeting the search criteria.',
        '',
        '40%'
      );
      return;
    }
    if (vesselMatches === 0) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'There are no vessels meeting the search criteria.',
        '',
        '40%'
      );
      
    }

    // Hide originals for the currently checked feeds so ONLY filtered shows
    for (const key of this.activeFeedKeys) {
      // const ds = this.isLayers.get(key);
      // if (ds) (ds as any).show = false;
       const ds = this.isLayers.get(key);
        const cfg = feedsConfig[key];
        const type = cfg?.type?.toLowerCase();
        const isVesselType =
        type === 'ship' || type === 'vessel' ||
        type === 'transshipment' || type === 'transhipment';
        if (isVesselType && ds) {
          (ds as any).show = false;
        }
    }

    // Add the single filtered overlay
    const filteredFC: FeatureCollection = { type: 'FeatureCollection', features: combined as any };
    const ds = await Cesium.GeoJsonDataSource.load(filteredFC, { clampToGround: true });
    this.styleFilteredOverlay(ds);        // uses per-feature _color
    await this.viewer.dataSources.add(ds);
    this.currentFilterDs = ds;

    try { await this.viewer.flyTo(ds, { duration: 2 }); } catch {}
    this.rebuildCombined();               // refresh right panel
    this.feedLoaded = true;
  });
}


resetAllFeedPanels() {
  // 1) Remove all Cesium layers for previous project
  for (const ds of this.isLayers.values()) {
    try { this.viewer.dataSources.remove(ds as any, true); } catch {}
  }
  // 2) Also remove filtered overlay if present
  if (this.currentFilterDs) {
    try { this.viewer.dataSources.remove(this.currentFilterDs, true); } catch {}
    this.currentFilterDs = undefined;
  }
  // 3) Clear tracking structures
  this.isLayers.clear();
  this.geoByFeed.clear();
  this.activeFeedKeys.clear();
  // 4) Reset panels/UI
  this.feedPanels.clear();
  this.feedSections = [];
  this.feedLoaded = false;
  this.combinedFeedSections = [];
  this.feedInfo = false;

  // 5) Optional: reset map view
  try { this.viewer.scene.requestRender(); } catch {}
}

private clearFilteredLayerAndRestore() {
  if (this.currentFilterDs) {
    this.viewer.dataSources.remove(this.currentFilterDs, true);
    this.currentFilterDs = undefined;
  }
  for (const key of this.activeFeedKeys) {
    const ds = this.isLayers.get(key);
    if (ds) (ds as any).show = false;
  }
  this.rebuildCombined();
}


   handleClick(entity: any, isHistorical: boolean,taskId: any,sensor: any, resultVessels:any =  false) {
    this.clearSilder();
    this.dateRangeArray = [];
    let historicalFetchCount: any;
    let operator: any;
    let type;
    this.prediction = false;
    
    if(sensor.operatorKey === OPERATORS.SPIRE) {    
      operator = sensor.operatorKey;    
      historicalFetchCount = sensor?.updatedFetches == 0 ? 0 : sensor?.updatedFetches || sensor?.noOfHistoricalData;
      type = 'ais'
    }

    if (isHistorical && entity?.name === 'vessel') {
      if (historicalFetchCount > 0) {
        let courseValue = entity.properties['Course']?.getValue();
        let compassDirection = this.utilsService.getCompassDirection(courseValue);
        
        const dialogRef = this.matdialog.open(FilterPopupComponent, {
          width: '35%',
          backdropClass: 'blurr',
          disableClose: true,
          data: {type: type, historicalDays: historicalFetchCount, currentUser: this.currentUser, isVessel:this.isVesselInfoService(sensor.InfoServices)}
        });
        dialogRef.afterClosed().subscribe((result) => {
          
          let timestamp = entity.properties['Timestamp UTC'].getValue();
          let mmsi = entity.properties['MMSI'].getValue();
          let vesselName = entity.properties['Name'].getValue();
          const shipType = entity.properties['Ship Type'].getValue() || 'OTHER';
          const iconColor = this.utilsService.getShipColor(shipType);
          this.predictedVesselData = {
              color : iconColor,
              lng : entity.properties['Lng'].getValue(),
              lat : entity.properties['Lat'].getValue(),
              timestamp: timestamp
          }
          if (result.type === 'history') {
            this.hideVessels('spireDataSource',entity,false);
            if(operator == OPERATORS.SPIRE) { 
              let vesselObject = {
                mmsi: mmsi,
                endTime: timestamp,
                inputMinutes: result?.duration,
                eeTaskId: taskId,
                compassDirection: compassDirection,
                fetchType: result.type
              }
              this.spinnerService.show();
              this.mapLoad = true;
              let endDate: any = new Date(timestamp)
              const millisecondsBack = result?.duration * 60 * 1000;
              const newDateObj = new Date(endDate - millisecondsBack);
              let startDate = newDateObj.toISOString();          
    
              this.apiService.getHistoricalData(vesselObject).subscribe((response: any) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                if (response?.data?.length > 0) {
                  this.collection.sensors.map((sensor) => {
                    if (sensor.operatorKey === OPERATORS.SPIRE) {
                      if(sensor.updatedFetches) sensor.updatedFetches -= 1
                      else sensor.updatedFetches = sensor.noOfHistoricalData - 1;                    
                    }
                  })
                  this.historicalVesselData = response?.data;
                  let dateRangeArray = this.generateSliderDateRange(timestamp,startDate);
                  this.groupVesselsByDate(dateRangeArray,compassDirection);
                  this.sliderSelected = sensor.operatorKey;
                  this.sliderView = false;
                } else {
                  const message = `There are no vessels in the duration requested. Please change the historical period to try again.`;
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                  if (entity) {
                      this.resetEntity(entity);
                  }
                  this.resetPreviousEntity()
                }
              });
            }
          } else if(result.type === 'prediction') {  
            this.hideVessels('spireDataSource', entity, false);
            this.progressing = true;
            let vesselId = entity.properties['ID'].getValue();
            const selectedVesselJson = resultVessels.find(item => item.id === vesselId);
            let predictedObject = {
              fetchType : result.type,
              feedId: sensor.InfoServices[0]._id,
              sensorId: sensor.InfoServices[0].sensorId,
              timestamp: timestamp,
              mmsi: mmsi,
              eeTaskId: taskId,
              endTime: timestamp,
              vesselName: vesselName,
              selectedVesselJson: selectedVesselJson,
              //predictionCount: result.predictionCount
            }
            this.predictionSubscription = this.apiService.getPredictionData(predictedObject).subscribe((response: any) => {
                this.progressing = false;
                if (response.msg === 'success') {
                  if (response?.data?.vessel_predict?.length > 0) {
                    this.collection.sensors.map((sensor) => {
                      if (sensor.operatorKey === OPERATORS.SPIRE) {
                        if(sensor.updatedFetches) sensor.updatedFetches -= 1
                        else sensor.updatedFetches = sensor.noOfHistoricalData - 1;                    
                      }
                    })

                    /// ****updating past prediction list
                    // const sensorIndex = this.collection.sensors.findIndex(sensor => sensor.id === sensor.InfoServices[0].sensorId);
                    // if (sensorIndex !== -1) {
                    //   if (!this.collection.sensors[sensorIndex].pastPrediction) {
                    //     this.collection.sensors[sensorIndex].pastPrediction = []; // Initialize if not present
                    //   }
                    //   let newPrediction = {
                    //     name : timestamp,
                    //     predictionId: response?.predictionId??'',
                    //     mmsi: mmsi,
                    //     sceneId: sensor.InfoServices[0]._id,
                    //     vesselName: vesselName
                        
                    //   }
                    //   if (this.collection.sensors[sensorIndex].pastPrediction.hasOwnProperty(mmsi)) {
                    //     (this.collection.sensors[sensorIndex].pastPrediction[mmsi] as any[]).push(newPrediction);
                    //   } else {
                    //     this.collection.sensors[sensorIndex].pastPrediction[mmsi] = [newPrediction];
                    //   }
                    //   this.groupedVessels = this.collection.sensors[sensorIndex].pastPrediction;
                    // }
                    const shipType = entity.properties['Ship Type'].getValue() || 'OTHER';
                    const iconColor = this.utilsService.getShipColor(shipType);
                    this.predictedVesselData = {
                        color : iconColor,
                        lng : entity.properties['Lng'].getValue(),
                        lat : entity.properties['Lat'].getValue()
                    }
                    
                  // Main handler for both types (historical or prediction)
                    this.prediction = true;
                    this.historicalVesselData = this.setVesseDataForPrediction(response?.data, 'livePrediction');
                    if(Object.keys(response?.data?.feed_results)?.length > 0){
                    const formattedPrediction = {
                    locations: this.historicalVesselData.length + 2,
                    location_time: response?.data?.feed_results.location_after_one_hour.location_time,
                    location: {
                    LAT: response?.data?.feed_results.location_after_one_hour.location.LAT,
                    LON: response?.data?.feed_results.location_after_one_hour.location.LON
                     }
                    };
                    this.historicalVesselData.push(formattedPrediction);
                   }

                    const startTime = this.historicalVesselData[0].location_time;
                    const endTime = this.historicalVesselData[this.historicalVesselData.length - 1].location_time;
                    let dateRangeArray = this.generateSliderDateRangePredict(endTime, startTime); // Reusable now
                    this.groupVesselsByDatePredict(dateRangeArray);

                    this.sliderSelected = sensor.operatorKey;
                    this.sliderView = false;
                    const feedId = String(sensor.InfoServices[0]?._id);
                    const config = this.getFeedConfig(feedId);
                    const color = 'Yellowgreen';
                    const vm = this.helperService.buildFeedSections(config, response?.data?.feed_results, color);
                    const title = this.feedTitleOf(config, sensor.InfoServices[0]?.feedName || sensor.InfoServices[0]?.name);
                    this.addFeedPanel(sensor.InfoServices[0]?._id, title, color, vm.sections);
                    
                  } else {
                    const message = `There are no vessel location(s) predicted because of a lack of sufficient historical data.`;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                    if (entity) {
                      this.resetEntity(entity);
                    }
                    this.resetPreviousEntity()
                  }
                } else {
                  if (response?.msg) {
                    const message = response?.msg;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                  } else {
                  const message = `An error occurred during processing and ingestion of the request. Please try after sometime.`;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                  }
                  if (entity) {
                    this.resetEntity(entity);
                  }
                  this.resetPreviousEntity()
                }
            });
          } else {

          }
        });
      } else if (sensor.operatorKey === OPERATORS.SPIRE) {
        const message = `Your historical fetches for this task has been exhausted. Please retask.`;
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        if (this.clickedEntity && this.clickedEntity?.name === 'vessel') {
          this.clickedEntity.billboard.width = 20;
          this.clickedEntity.billboard.height = 20;
        }
      }
    }
  }

  handleClydeClick(entity: any, isHistorical: boolean,taskId: any,sensor: any) {
    this.clearSilder();
    this.dateRangeArray = [];
    let historicalFetchCount: any;
    let operator: any;
    let type;
    
   if(sensor.operatorKey === OPERATORS.CLYDE) {   
      operator = sensor.operatorKey;     
      historicalFetchCount = sensor?.noOfHistoricalData;
      type = 'clyde'
    }

    if (isHistorical && entity?.name === 'vessel') {
      if (historicalFetchCount > 0) {
        let compassDirection = "W";

        const dialogRef = this.matdialog.open(FilterPopupComponent, {
          width: '35%',
          backdropClass: 'blurr',
          disableClose: true,
          data: {type: type, historicalDays: historicalFetchCount, currentUser: this.currentUser}
        });
        dialogRef.afterClosed().subscribe((result) => {
          
          let timestamp = entity.properties['Timestamp UTC'].getValue();
          let mmsi = entity.properties['MMSI'].getValue();
          if (result) {
            if(operator == OPERATORS.CLYDE) {  
              let endDate: any = new Date(timestamp);
              let startDate: any ;

              if (result?.type === 'minutes') {
                const millisecondsBack = result?.duration * 60 * 1000;
                const newDateObj = new Date(endDate - millisecondsBack);
                startDate = newDateObj.toISOString();
              } else {
                const previousDate = endDate;
                previousDate.setDate(endDate.getDate() - (result?.duration - 1));
                startDate = previousDate.toDateString();
              }
 
              let vesselObject = {
                mmsi: mmsi,
                endTime: timestamp,
                inputMinutes: result?.duration,
                eeTaskId: taskId,
                startTime: startDate,
                polygon: this.vesselPolygon,
                startTimeType: result?.type,
                duration: result?.duration,
                compassDirection: compassDirection
              }

              const sliderStart = new Date(timestamp);
              const sliderEnd = new Date(startDate);
              const differenceInMilliseconds = sliderStart.getTime() - sliderEnd.getTime();
              const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    
              this.apiService.getClydeHistoricalData(vesselObject).subscribe((response: any) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                if (response?.data?.length > 0) {
                  this.historicalVesselData = response?.data;
                  let dateRangeArray = this.generateSliderDateRange(timestamp, startDate);
                  if (differenceInDays <= 10) this.groupVesselsByDate(dateRangeArray,compassDirection);
                  else this.groupVesselsByDateRange(dateRangeArray);
                  this.sliderView = false;
                  this.sliderSelected = sensor.operatorKey;
                  this.hideVessels('clydeDataSource',entity,false);
                } else {
                  const message = `There are no vessels in the duration requested. Please change the historical period to try again.`;
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                  this.resetPreviousEntity()
                }
              });
            }
          } else {
          }
        });
      }
    }
  }

  generateSliderDateRange(end,start) {
    this.dateRangeArray = [];
    const startDate = new Date(start);
    const endDate = new Date(end);
    const dateArray: string[] = [];
    const differenceInMilliseconds = endDate.getTime() - startDate.getTime();
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    if(differenceInDays <= 10) {
      const normalizedStartDate = new Date(startDate.toISOString().split('T')[0]);
      const normalizedEndDate = new Date(endDate.toISOString().split('T')[0]);

      for (let dt = normalizedStartDate; dt <= normalizedEndDate; dt.setDate(dt.getDate() + 1)) {
        dateArray.push(new Date(dt).toISOString().split('T')[0]);
      }
    } else {
      const step = differenceInDays / 9;
      for (let i = 0; i < 10; i++) {
        const newDate = new Date(startDate.getTime() + step * i * (1000 * 60 * 60 * 24));
        dateArray.push(newDate.toISOString().split('T')[0]);
      }
    }

    return dateArray;
  }

  groupVesselsByDate(dateRangeArray,compassDirection) {
    let vesselDirection = this.utilsService.getVesselDirection(compassDirection);    
    this.vesselData = {};
    if (vesselDirection === 'LR') this.dateRangeArray = dateRangeArray;
    else this.dateRangeArray = dateRangeArray.reverse();

    this.sliderShow = true;
    for (const date of this.dateRangeArray) {
      this.vesselData[date] = this.historicalVesselData.filter(data => {
        const dataDate = new Date(data.timestamp).toISOString().split('T')[0];
        return dataDate === date;
      });
    }
  }

  groupVesselsByDateRange(dateRangeArray: string[]) {
    this.vesselData = {};
    this.sliderShow = true;

    for (let i = 0; i < dateRangeArray.length - 1; i++) {
      const startDate = new Date(dateRangeArray[i]);
      const endDate = new Date(dateRangeArray[i + 1]);

      this.vesselData[dateRangeArray[i]] = this.historicalVesselData.filter(data => {
        const dataDate = new Date(data.timestamp);
        return dataDate >= startDate && dataDate < endDate;
      });
    }

    // Handle the last date separately to include any remaining data
    const lastDate = new Date(dateRangeArray[dateRangeArray.length - 1]);
    this.vesselData[dateRangeArray[dateRangeArray.length - 1]] = this.historicalVesselData.filter(data => {
      const dataDate = new Date(data.timestamp);
      return dataDate >= lastDate;
    });
    
    this.dateRangeArray = dateRangeArray.reverse();

  }

  getSelectedDateVessels(event: MatSliderChange): void {
    const index = event.value;
    if (index !== null && index !== undefined) { 
      let currentIndex = index - 1;
      if (currentIndex > this.previousIndex) {
        // Moving forward
        for (let i = this.previousIndex + 1; i <= currentIndex; i++) {
          const date = this.dateRangeArray[i];
          let convertedVessels:any = '';
          if (this.prediction) {
            convertedVessels = this.vesselData[date];
            this.displayPredictionData(date, convertedVessels);
          } else if(this.pastPrediction){
            convertedVessels = this.vesselData[date];
            this.displayPastPrediction(date, convertedVessels);
          } else {
            convertedVessels = this.convertToGeoJSONData(this.vesselData[date]);
            this.displayHistoricalData(date, convertedVessels);
          }
        }
      } else {
        // Moving backward
        for (let i = this.previousIndex; i > currentIndex; i--) {
          const date = this.dateRangeArray[i];
          this.removeHistoricalData(date);
          this.removePredictionData(date);
        }
      }
      this.previousIndex = currentIndex;
    }
  }

  displayHistoricalData(date,vesselData: any) {
    let iconCanvas,iconUrl;   
    const selectData = Cesium.GeoJsonDataSource.load(vesselData);
    let color = this.predictedVesselData.color?? 'Yellowgreen';
    iconCanvas = this.createNavigationIcon(color, 'dotted');
    iconUrl = iconCanvas.toDataURL();
    selectData.then((dataSource) => {
      const entities = dataSource.entities.values;
      for (let j = 0; j < entities.length; j++) {
        const entity = entities[j] as CustomEntity;
        if (entity.properties) {
          const course = entity.properties['Course']?.getValue(); // Get the course value
          entity.billboard = new Cesium.BillboardGraphics({
            image: iconUrl,
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 22,
            height: 22,
            rotation: course ? Cesium.Math.toRadians(-course) : 0, // Negative because Material Icon 'navigation' points up by default
            pixelOffset: new Cesium.Cartesian2(0, 0),
            verticalOrigin: Cesium.VerticalOrigin.CENTER,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER
          });
          entity.isOriginal = false;
        }
      }

      this.viewer.dataSources.add(dataSource);
      this.viewer.flyTo(dataSource, { duration: 2 });
      this.currentDataSources[date] = dataSource; 
    });
  }

  removeHistoricalData(date: string): void {
    const dataSource = this.currentDataSources[date];
    if (dataSource) {
      this.viewer.dataSources.remove(dataSource);
      delete this.currentDataSources[date];
    }
  }

  convertToGeoJSONData(vesselsData) {
    if(this.sliderSelected == OPERATORS.SPIRE) {
      const features = vesselsData.map((vessel) => ({
        type: 'Feature',
        id: vessel.id,
        geometry: {
          type: 'Point',
          coordinates: [
            vessel.longitude,
            vessel.latitude,
          ],
        },
        properties: {
          ID: vessel.id,
          MMSI: vessel.mmsi,
          Name : vessel?.name ? vessel.name : 'N/A',
          'Timestamp UTC': vessel.timestamp,
          Lng: vessel.longitude.toString(),
          Lat: vessel.latitude.toString(),
          Course: vessel?.course,
          Flag: vessel?.flag,
          'Ship Type': vessel?.shipType ? vessel.shipType : 'N/A',
          IMO: vessel?.staticData?.imo,
          'ETA UTC': vessel?.eta ? vessel.eta : 'N/A',
          'Port Name': vessel?.port?.name ? vessel.port.name : 'N/A',
           Speed: vessel?.speed
        },
      }));
  
      return {
        type: 'FeatureCollection',
        features: features
    };
    } else {
      const features = vesselsData.map((vessel) => ({       
        type: 'Feature',
        id: vessel.id,
        geometry: {
          type: 'Point',
          coordinates: [
            vessel.location.longitude,
            vessel.location.latitude,
          ],
        },
        properties: {
          ID: vessel.id,
          MMSI: vessel.mmsi,
          'Timestamp UTC': vessel.timestamp,
          Lng: vessel.location.longitude.toString(),
          Lat: vessel.location.latitude.toString(),
        },
      }));
  
      return {
        type: 'FeatureCollection',
        features: features
    };
    }

}
resetPredictionData() {
  this.pastVesselData = null;
  this.livePredictedVesselData = null;
  this.previousLat = null;
  this.previousLon = null;
  this.livePreviousLat = null;
  this.livePreviousLon = null;
}
resetPreviousEntity() {
  if (this.clickedEntity && this.clickedEntity?.name === 'vessel') {
    this.clickedEntity.billboard.width = 20;
    this.clickedEntity.billboard.height = 20;
  }

  // Remove any prediction paths
  Object.keys(this.currentDataSources || {}).forEach(key => {
    if (key.includes('_path')) {
      this.viewer.dataSources.remove(this.currentDataSources[key]);
      delete this.currentDataSources[key];
    }
  });
  this.prediction = false;
  this.lastPosition = null;
  this.pastPrediction = false;
  this.resetPredictionData();
  if(this.timeseries) {
    this.sliderView = true;
    this.sliderShow = false;    
    this.removeImages();
    this.clearBandLegends();
    this.viewer.entities.removeAll();
    const slider: any = document.querySelector('#slider');
    if (slider) {
      slider.value = this.currentSliderValue;
    }
    this.overlayData(this.currentIndex + 1, 'reset');
  }
}

clearSilder() {
  this.sliderShow = false;
  this.hideVessels('spireDataSource','',true);
  this.hideVessels('clydeDataSource','',true);
  for (const date in this.currentDataSources) {
    if (this.currentDataSources.hasOwnProperty(date)) {
      this.removeHistoricalData(date);
    }
  }
  this.clearAllFeedPanels();
 }
 
 clearAllFeedPanels() {
  if (!this.feedPanels || this.feedPanels.size === 0) return;

  this.feedPanels = new Map();
  this.rebuildCombined();
 } 


highlightEntity(entity) {
  if (entity?.name === 'vessel') {
  entity.billboard.width = 35;
  entity.billboard.height = 35;
  }
}

resetEntity(entity) {
  if (entity?.name === 'vessel') {
  entity.billboard.width = 20;
  entity.billboard.height = 20;
  this.clearSilder();
}
}

  clickSliderView(event: any) {
    for (const [sensorIndex, sensor] of this.collection.sensors.entries()) {
      sensor.checked = false;
      for (const [sceneIndex, scene] of sensor.scenes.entries()) {
        scene.checked = false;
      }
      
      if (sensor.refreshHistory) {
        for (const [index, history] of sensor.refreshHistory.entries()) {
          history.checked = false;
        }
      }
    }

    this.sliderView = event.checked;
    this.timeseries = event.checked;
    this.sliderShow = false;
    this.sliderDateRangeArray = [];
    this.clearBandLegends();
    this.removeImages();
    this.viewer.entities.removeAll();
    this.isVisible = false;
    this.splitPosition = 0.0;
    this.overlayVessel = [];
    this.operatorArray = [];
    this.overlayClydeVessel = [];
    this.currentSliderValue = 0;
    this.showDailyRecurrencyCheckboxes = false;
    this.sourceRateArray = [];
    this.clearAnnotations();
    this.imageLoaded = false;
    if (!event.checked) {
      this.showDailyRecurrencyCheckboxes = true;
      this.toggleDailyRecurrency(event);
    }
    this.clearFilterData();
    this.refreshFilterObject = undefined;
  }

  getDateArray(start: string, end: string): string[] {
    const dateArray: string[] = [];
    let currentDate = new Date(start);
    const endDate = new Date(end);

    while (currentDate <= endDate) {
      dateArray.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateArray;
  }

  overlayData(event: any, type: any) {
    const index = event;
    let sceneId: any;
    let sensorId: any;
    let action: any;
    const taskId = this.collection?.taskId;
    let isHistorical: any, scene: any;

    if (index !== null && index !== undefined) {
      this.currentIndex = index - 1;
      this.currentSliderValue = index;
      if (this.currentIndex > this.previousIndex) {
        for (const sensor of this.collection.sensors) {
          if (sensor.operatorKey === OPERATORS.SPIRE && sensor.checked) {
            isHistorical = sensor?.isHistorical;
            scene = sensor.scenes[0];
            this.overlayAIS(scene,type,isHistorical,sensor);
          } else if (sensor.operatorKey === OPERATORS.CLYDE && sensor.checked) {
            isHistorical = sensor?.isHistorical;
            scene = sensor.scenes[0];
            this.overlayAIS(scene,type,isHistorical,sensor);
          }
        }


        // Moving forward
        const date = this.sliderDateRangeArray[this.currentIndex];
        const selectedScenes = this.groupedScenes[date];

        if (selectedScenes?.length > 0) {
          for (const [index, scn] of selectedScenes.entries()) {
            if (scn?.id && scn?.status !== 'failed') {
              if (scn.footprint) {
                sensorId = 'this.selectedSensors[j]?.id';
                action = "scene"
                sceneId = scn?.id;
                this.spinnerService.show();
                this.mapLoad = true;
                const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
                this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
                  if (res?.msg === 'Failed') {
                    this.spinnerService.hide();
                    this.mapLoad = false;
                    const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                  } else if (res?.msg === 'user storage') {
                    this.fail = this.fail + 1;
                    if (this.fail === 1) {
                      const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                    }
                    this.spinnerService.hide();
                    this.mapLoad = false;
                  }
                  if (scn?.thumbnailUrl) {
                    scn.thumbnailUrl = res.result?.imageUrl;
                  }
                  scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
                  this.displayFootPrint(scn, 0, res.result,sensorId,taskId);
                  this.spinnerService.hide();
                  this.mapLoad = false;
                });
              }
            }

          }
        }
        
        if (selectedScenes?.length === 0) {
          this.removeImages();
        }
      } else {
        // Moving backward
        for (let i = this.previousIndex; i > this.currentIndex; i--) {
          const date = this.sliderDateRangeArray[i];
          this.removeImages();
          if (this.overlayVessel) {
            const date = this.sliderDateRangeArray[i];
            const overlayData = this.currentVessels[date];
            if (overlayData) {
              this.viewer.dataSources.remove(overlayData);
              delete this.currentVessels[date];
            }
          }

          if (this.overlayClydeVessel) {
            const date = this.sliderDateRangeArray[i];
            const overlayData = this.currentClydeVessels[date];
            if (overlayData) {
              this.viewer.dataSources.remove(overlayData);
              delete this.currentClydeVessels[date];
            }
          }
        }
      }
      this.previousIndex = this.currentIndex;
    }
  }

  overlayAIS(scene: any,type: any, isHistorical: any,sensor: any ) {
    let  USLcoverage: any, BBpoints: any;
    const date = this.sliderDateRangeArray[this.currentIndex];

    if ((sensor.operatorKey === OPERATORS.SPIRE || sensor.operatorKey === OPERATORS.CLYDE) && scene?.footprint) {
      USLcoverage = scene?.footprint?.coordinates[0]
      BBpoints = USLcoverage.toString().split(',').map(Number);

      this.uslBB = this.viewer.entities.add({
        name: 'spireBB',
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArray(BBpoints),
          clampToGround: true,
          material: new Cesium.PolylineOutlineMaterialProperty({
            outlineWidth: 3,
            outlineColor: Cesium.Color.fromRandom({
              alpha: 1.0,
            }),
          }),
        },
      });
      this.uslBB.index = scene?.sceneIdx;
      this.USLscnLyr.push(this.uslBB);
    }
    if (type === 'overlay') {      
      if ((sensor?.operatorKey === OPERATORS.SPIRE) && this.overlayVessel && this.overlay) {            
        for (let i = this.previousIndex + 1; i <= this.currentIndex; i++) {
          const date = this.sliderDateRangeArray[i];
          if (this.overlayVessel[date]?.length > 0) {
            this.displayAISData(date, this.overlayVessel[date], isHistorical,sensor);
          }
        }
      } else if ((sensor?.operatorKey === OPERATORS.CLYDE) && this.overlayClydeVessel) {    
        for (let i = this.previousIndex + 1; i <= this.currentIndex; i++) {
          const date = this.sliderDateRangeArray[i];
          if (this.overlayClydeVessel[date]?.length > 0) {
            this.displayClydeData(date, this.overlayClydeVessel[date], isHistorical,sensor);
          }
        }
      }
    } else {
      if (sensor?.operatorKey === OPERATORS.SPIRE) {
        for (let i = 0; i <= this.currentIndex; i++) {
          const date = this.sliderDateRangeArray[i];
          this.displayAISData(date, this.overlayVessel[date], isHistorical,sensor);
         }
      } else if (sensor?.operatorKey === OPERATORS.CLYDE) {
        for (let i = 0; i <= this.currentIndex; i++) {
          const date = this.sliderDateRangeArray[i];
          this.displayClydeData(date, this.overlayClydeVessel[date], isHistorical,sensor);
         }
      }
    }
  }

  groupCollections() {
    const groupedScenes = {};
    this.groupedScenes = {};
    this.sliderDateRangeArray = [];
    this.AISdata = false;
    this.recurrentSlider = false;
    let startDate = this.collection?.openWindow;
    let endDate = this.collection?.closeWindow;

    if (this.filterStart && this.filterEnd) {
     startDate = this.filterStart;
     endDate = this.filterEnd;
    }

    let dateRangeArray = this.getDateArray(startDate, endDate);
    this.sliderDateRangeArray = dateRangeArray;

    for (const date of this.sliderDateRangeArray) {
      groupedScenes[date] = [];
    }

    for (const sensor of this.collection.sensors) {
      if (sensor.checked) {
        this.sliderView = true;
        if (sensor.scenes[0].operatorKey === OPERATORS.SPIRE || sensor.scenes[0].operatorKey === OPERATORS.CLYDE) {
          this.getAISData(sensor.scenes[0], "display",sensor);
        } else {
        for (const scene of sensor.scenes) {
          const sceneDate = new Date(scene.predictedDate).toISOString().split('T')[0];
          if (groupedScenes.hasOwnProperty(sceneDate)) {
            groupedScenes[sceneDate].push(scene);
            this.AISdata = true;
          }
        }
      }
      }
    }

    return groupedScenes;
  }

  groupRecurrencyCollections(recurrencyArray) {
    let siteId = this.currentSites?.siteId ? this.currentSites?.siteId : 1;
    if (siteId) {
      const filteredRecurrency = recurrencyArray.map(item => {
        return {
          ...item,
          scenes: item.scenes.filter(scene => (!scene.siteId || scene.siteId === siteId) && !scene.skipPreview && scene.footprint)
        };
      });

      recurrencyArray = filteredRecurrency;
    }

    this.recurrentSlider = true;
    let sliderDates: any;
    sliderDates = this.createSliderData(recurrencyArray);
    const groupedScenes = {};
    this.groupedScenes = {};
    this.sliderDateRangeArray = [];
    this.sliderDateRangeArray = sliderDates;    

    for (const range of this.sliderDateRangeArray) {
      const key = `${range.start} to ${range.end}`;
      groupedScenes[key] = [];
    }

    for (const sensor of recurrencyArray) {        
        for (const scene of sensor.scenes) {
          const sceneDate = scene.predicted_date.split('T')[0];

          for (const range of this.sliderDateRangeArray) {
            if (sceneDate >= range.start && sceneDate <= range.end) {
              const key = `${range.start} to ${range.end}`;
              groupedScenes[key].push(scene);
              break;
            }
          }
        }
    }

    return groupedScenes;
  }

  createSliderData(data: any[]): { start: string, end: string }[] {
    return data.map(item => ({
      start: item.start.split('T')[0],
      end: item.end.split('T')[0]
    }));
  }
  
  overlayRecurrentData(event: any, type: any) {
    const index = event;
    let sceneId: any;
    let sensorId: any;
    let action: any;
    const taskId = this.collection?.taskId;

    if(this.legendContainer && index === 0) this.legendContainer.style.display = 'none';
    
    if (index !== null && index !== undefined) {
      this.currentIndex = index - 1;
      this.currentSliderValue = index;
      if (this.currentIndex > this.previousIndex) {
        // Moving forward
        const selectedRange = this.sliderDateRangeArray[this.currentIndex];
        const rangeKey = `${selectedRange.start} to ${selectedRange.end}`;
        const selectedScenes = this.groupedScenes[rangeKey];

        if (selectedScenes?.length > 0) {
          const promises: Promise<void>[] = [];

          for (const [index, scn] of selectedScenes.entries()) {
            if (scn?.id && scn?.status !== 'failed') {
              if (scn.footprint) {
                sensorId = this.selectedSensors[0]?.id;
                action = "scene"
                sceneId = scn?.id;
                this.spinnerService.show();
                this.mapLoad = true;
                const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
                const apiPromise = firstValueFrom(this.apiService.getCollectionImage(taskId, sensorObj))
                .then((res: any) => {
                  if (res?.msg === 'Failed') {
                    this.spinnerService.hide();
                    this.mapLoad = false;
                    const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                  } else if (res?.msg === 'user storage') {
                    this.fail = this.fail + 1;
                    if (this.fail === 1) {
                      const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                    }
                    this.spinnerService.hide();
                    this.mapLoad = false;
                  }
                  if (scn?.thumbnailUrl) {
                    scn.thumbnailUrl = res.result?.imageUrl;
                  }
                  scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
                  this.displayFootPrint(scn, 0, res.result,sensorId,taskId);
                  this.spinnerService.hide();
                  this.mapLoad = false;
                });

                promises.push(apiPromise);
              }
            }

          }

          Promise.all(promises).then(() => {
            if (this.selectedMetric === 'kg') {
              const entities = this.viewer.entities.values;
              for (const entity of entities) {
                if (entity?.name === 'trendline') {
                  this.viewer.entities.remove(entity);
                }
              }
              // Add multiple polyline entities, each connecting two consecutive points
              for (let i = 0; i < this.sourceRateArray.length - 1; i++) {
                const polylineEntity = this.viewer.entities.add({
                  name: 'trendline',
                  polyline: {
                    positions: [this.sourceRateArray[i].centroid, this.sourceRateArray[i + 1].centroid],
                    material: new Cesium.PolylineOutlineMaterialProperty({
                      outlineWidth: 5,
                      outlineColor: Cesium.Color.GREENYELLOW,
                      color: Cesium.Color.GREENYELLOW
                    }),
                    // material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.GREENYELLOW)
                  }
                });
                polylineEntity.sceneId = this.sourceRateArray[i + 1].sceneId;
              }
            }
          });
        }
      } else {
        // Moving backward
        for (let i = this.previousIndex; i > this.currentIndex; i--) {          
          const dateRange = this.sliderDateRangeArray[i];
          const rangeKey = `${dateRange.start} to ${dateRange.end}`;          
          this.removeImagesByDateRange(rangeKey);
        }
      }
      this.previousIndex = this.currentIndex;
    }
  }

  removeImagesByDateRange(rangeKey: string): void {
    const allImageryLayers = this.viewer.imageryLayers._layers;
    const entities = this.groupedScenes[rangeKey];

    for (let i = allImageryLayers.length - 1; i >= 0; i--) {
      const layer = allImageryLayers[i];
      const layerUrl = layer.imageryProvider?._source?.source?.source?.client?.url || layer.imageryProvider?.url;

      if (layerUrl) {
        for (const entity of entities) {
          const thumbnailUrl = entity?.thumbnailUrl;

          if (thumbnailUrl && layerUrl === thumbnailUrl) {
            this.viewer.imageryLayers.remove(layer);
          }
        }
      }
    }

    const entityData = this.groupedScenes[rangeKey];
    const polyLineEntities = this.viewer.entities.values;

    for (let indexToRemoveEntity = this.scnLyr?.length - 1; indexToRemoveEntity >= 0; indexToRemoveEntity--) {
      const item = this.scnLyr[indexToRemoveEntity];

      for (const entity of entityData) {
        if (item.sceneId === entity?.id) {
          this.scnLyr[indexToRemoveEntity].show = false;
          this.scnLyr.splice(indexToRemoveEntity, 1);
        }

        for (let i = polyLineEntities.length - 1; i >= 0; i--) {
          const polyLineEntity = polyLineEntities[i];

          if (polyLineEntity?.sceneId === entity?.id && polyLineEntity?.name === 'trendline') {
            this.viewer.entities.remove(polyLineEntity);
          }
        }

        for (let i = this.sourceRateArray.length - 1; i >= 0; i--) {
          if (this.sourceRateArray[i].sceneId === entity?.id) {
            this.sourceRateArray.splice(i, 1);
          }
        }
      }
    }
  }

  getAISData(scene: any, type: any, sensor: any) {
    let refreshCount;
    let timeExpired;
    let sensorId;
    let taskId;

    if(sensor.operatorKey === OPERATORS.SPIRE) {        
      sensorId = sensor.id;
      timeExpired = sensor.timeExpired;
      refreshCount = sensor.updatedRefreshes == 0 ? 0 : sensor.updatedRefreshes || sensor.noOfRefreshes;
    } else if(sensor.operatorKey === OPERATORS.CLYDE) {  
      sensorId = sensor.id;
      timeExpired = sensor.timeExpired;
    }

    if(!scene.aisAvailable) {
      const message = "AIS data is not available until the start of the time of interest (TOI)";
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
      return
    }

    else if(timeExpired && sensor.operatorKey === OPERATORS.SPIRE) {
      const message = 'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
    }

    else if(refreshCount > 0 && sensor.operatorKey === OPERATORS.SPIRE) {
      const coordinates = scene?.footprint?.coordinates[0]
      taskId = this.collection?.taskId;
  
      let newCoordinates = coordinates.map(coord => {
        return [coord[0], coord[1]];
      });
  
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
  
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow)
      const endTime = encodeURIComponent(scene.closeWindow)
  
  
      const aisReq = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: type
      }

      this.spinnerService.show();
      this.mapLoad = true;
  
      this.apiService.getAISData(aisReq, taskId).subscribe((res: any) => {
        if (res?.msg === 'failed') {
          this.spinnerService.hide();
          this.mapLoad = false;
          this.freeze = false;
          this.disable = false;
          const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
          this.downloadService.setProgress(sensorObj);
          const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          for (const item of this.collection.sensors) {
            if (item.id === sensor.id) {
              item.checked = false;
            }
          }
        } else if (res?.msg === 'success') {
          if(res?.data?.vessels?.nodes?.length === 0) {
            this.spinnerService.hide();
            this.mapLoad = false;
            this.freeze = false;
            this.disable = false;
            const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
            this.downloadService.setProgress(sensorObj);           
            const message = 'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                item.checked = false;
              }
            }
          } else {
            this.groupVessels(res?.data,sensor);
            this.collection.sensors.map((sensor) => {
              if (sensor.operatorKey === OPERATORS.SPIRE) {
                if(sensor.updatedRefreshes) sensor.updatedRefreshes -= 1
                else sensor.updatedRefreshes = sensor.noOfRefreshes - 1

                  if (!sensor.refreshHistory) {
                    sensor.refreshHistory = []; // Initialize if not present
                  }
                  sensor.refreshHistory.push(res.newRefreshHistory);
              }
            });
            this.AISdata = true;
          }
        }
      });
    } else if(sensor.operatorKey === OPERATORS.CLYDE) {
      const coordinates = scene?.footprint?.coordinates[0]
      taskId = this.collection?.taskId;
  
      let newCoordinates = coordinates.map(coord => {
        return [coord[1], coord[0]];
      });
  
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
  
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow)
      const endTime = encodeURIComponent(scene.closeWindow)
  
  
      const aisReq = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: type
      }

      this.spinnerService.show();
      this.mapLoad = true;

      if(timeExpired) {
        const message = 'The time of interest (TOI) has ended. Please re-task if the area of interest (AOI) continues to be the same.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        this.spinnerService.hide();
        this.mapLoad = false;
        this.freeze = false;
        for (const item of this.collection.sensors) {
          if (item.id === sensor.id) {
            item.checked = false;
          }
        }
        return
      }
      
        const input = JSON.parse(decodeURIComponent(aisReq.polygon)); 
        this.vesselPolygon = input[0]
          .map(pair => pair.reverse().join(' '))
          .join(', '); 
        aisReq.polygon = this.vesselPolygon  
  
        this.apiService.getClydeAISData(aisReq, taskId).subscribe((res: any) => {           

        if (res?.msg === 'failed') {
          const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          this.spinnerService.hide();
          this.mapLoad = false;
          this.freeze = false;
          this.disable = false;
          const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
          this.downloadService.setProgress(sensorObj);
          for (const item of this.collection.sensors) {
            if (item.id === sensor.id) {
              item.checked = false;
            }
          }
        } else if (res?.msg === 'Success') {
          if(res?.data?.length === 0) {
            this.spinnerService.hide();
            this.mapLoad = false;
            this.freeze = false;
            this.disable = false;
            const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
            this.downloadService.setProgress(sensorObj);
            const message = 'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                item.checked = false;
              }
            }
          } else {
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                if (!sensor.refreshHistory) {
                  sensor.refreshHistory = []; // Initialize if not present
                }
                sensor.refreshHistory.push(res.newRefreshHistory);
              }
            }
                      
            this.groupVessels(res?.data,sensor);
            this.AISdata = true;
          }
        }
        });  
  } else if(timeExpired) {
      const message = 'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
    } else {
      const message = 'Your refresh count has been exhausted. Please re-task to continue receiving latest AIS information.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
    }
  }

  displayAISData(date:any,convertedData: any,isHistorical: any,sensor: any) {
    let taskId: any, type: any, imgUrl: any;
    taskId = this.collection?.taskId;
    type = 'overlay';
    imgUrl = 'assets/images/yellow-cross.png';  
    const updatedAis = this.convertToGeoJSON(convertedData,type);
      const selectData = Cesium.GeoJsonDataSource.load(updatedAis);
      const currentCrossImage = imgUrl;
      selectData.then((dataSource) => {
        dataSource.name = 'spireDataSource';
        const entities = dataSource.entities.values;
        for (let j = 0; j < entities.length; j++) {
          const entity = entities[j] as CustomEntity;
          entity.name = 'vessel';
          entity.type = 'spire';

          // Get ship type from properties
          if (entity.properties) {
            const shipType = entity.properties['Ship Type'].getValue() || 'OTHER';
            const iconColor = this.utilsService.getShipColor(shipType);
            const course = entity.properties['Course']?.getValue(); // Get the course value

            // Create the icon with the appropriate color
            const iconCanvas = this.createNavigationIcon(iconColor);

            entity.billboard = new Cesium.BillboardGraphics({
              image: iconCanvas.toDataURL(),
              show: true,
              eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
              alignedAxis: Cesium.Cartesian3.ZERO,
              width: 24,
              height: 24,
              rotation: course ? Cesium.Math.toRadians(-course) : 0, // Negative because Material Icon 'navigation' points up by default
              pixelOffset: new Cesium.Cartesian2(0, 0),
              verticalOrigin: Cesium.VerticalOrigin.CENTER,
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER
            });
          }
        }

        this.viewer.dataSources.add(dataSource);
        this.viewer.scene.globe.depthTestAgainstTerrain = false;
        this.viewer.flyTo(dataSource, { duration: 3 });
        this.currentVessels[date] = dataSource; 
      });

      let tooltip = document.getElementById('feedTooltip');
      if (this.handler) {
        this.handler.destroy();
      }
      // Add click event listener
      let previousEntity = null;
      this.handler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);

      this.handler.setInputAction((click) => {
        if (isHistorical && !this.prediction) {
          const pickedObject = this.viewer.scene.pick(click.position);
          if (Cesium.defined(pickedObject)) {
            const entity = pickedObject.id;
            if (entity && entity.isOriginal !== false && entity?.type === 'spire') {
              if (previousEntity) {
                this.resetEntity(previousEntity);
              }
              this.previousIndex = -1;
              this.handleClick(entity,isHistorical,taskId,sensor);
              this.highlightEntity(entity);
              this.clickedEntity = entity;
              previousEntity = entity;
            }
          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

      this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      this.displayProperties('')
  }

  displayClydeData(date:any,convertedData: any,isHistorical: any,sensor: any) {
    let taskId: any, type: any, imgUrl: any;
    let iconCanvas,iconUrl;

    taskId = this.collection?.taskId;
    type = 'CLYDE';
    imgUrl = 'assets/images/orange-cross.png';  
    const updatedAis = this.convertToGeoJSON(convertedData,type);
      const selectData = Cesium.GeoJsonDataSource.load(updatedAis);
      const currentCrossImage = imgUrl;
      iconCanvas = this.createNavigationIcon('orange');
      iconUrl = iconCanvas.toDataURL();
      selectData.then((dataSource) => {
        dataSource.name = 'clydeDataSource';
        const entities = dataSource.entities.values;
        for (let j = 0; j < entities.length; j++) {
          const entity = entities[j] as CustomEntity;
          entity.name = 'vessel';
          entity.type = 'clyde';
          entity.billboard = new Cesium.BillboardGraphics({
            image: iconUrl,
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 24,
            height: 24,
          });
        }

        this.viewer.dataSources.add(dataSource);
        this.viewer.scene.globe.depthTestAgainstTerrain = false;
        this.viewer.flyTo(dataSource, { duration: 3 });
        this.currentClydeVessels[date] = dataSource; 
      });

      let tooltip = document.getElementById('feedTooltip');
      if (this.handlers) {
        this.handlers.destroy();
      }
      // Add click event listener
      let previousEntity = null;
      this.handlers = new ScreenSpaceEventHandler(this.viewer.scene.canvas);

      this.handlers.setInputAction((click) => {        
        if (isHistorical) {
          const pickedObject = this.viewer.scene.pick(click.position);
          if (Cesium.defined(pickedObject)) {
            const entity = pickedObject.id;
            if (entity && entity.isOriginal !== false && entity?.type === 'clyde') {
              if (previousEntity) {
                this.resetEntity(previousEntity);
              }
              this.previousIndex = -1;
              this.handleClydeClick(entity,isHistorical,taskId,sensor);
              this.highlightEntity(entity);
              this.clickedEntity = entity;
              previousEntity = entity;
            }
          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

      this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);

      // Add hover event listener for tooltip
      this.handlers.setInputAction((movement) => {
        const pickedObject = this.viewer.scene.pick(movement.endPosition);
        const entity = pickedObject?.id;
        if (entity && entity.properties && entity?.name != 'annotation' && entity?.name != 'signal') {
          if (tooltip) {                    
          let content = '';
          entity.properties.propertyNames.forEach(propertyName => {                      
            content += `<strong>${propertyName} : </strong> ${entity.properties[propertyName]}<br>`;
          });
          tooltip.innerHTML = content;
          tooltip.style.fontSize = '15px';
          tooltip.style.fontFamily = 'Barlow", sans-serif';
          tooltip.style.lineHeight = '1.8';
          tooltip.style.display = 'block';
          this.tooltipHandlers(tooltip, movement);
        }
      } else if (tooltip) {
        tooltip.style.display = 'none';
      }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  removeImages() {
    let entitiesToRemove: any = [];
    this.sourceRateArray = [];

    this.viewer.entities.values.forEach((entity) => {
      if (entity.name === undefined || entity.name !== 'spireBB') {
        entitiesToRemove.push(entity);
      }
    });

    entitiesToRemove.forEach((entity) => {
      this.viewer.entities.remove(entity);
    });
    
    var allImageryLayers = this.viewer.imageryLayers._layers;
    var leftImageryLayers: any = [];
    for (var index = 1; index < allImageryLayers.length; index++) {
      var url = allImageryLayers[index].imageryProvider?._source?.source?.source?.client?.url ? allImageryLayers[index].imageryProvider?._source.source.source.client.url : allImageryLayers[index]?.imageryProvider?.url
      if (url !== undefined) {
        leftImageryLayers.push(allImageryLayers[index]);
      }
    }

    for (var leftImageryLayersIndex = 0; leftImageryLayersIndex < leftImageryLayers.length; leftImageryLayersIndex++) {
      this.viewer.imageryLayers.remove(leftImageryLayers[leftImageryLayersIndex]);
    }
  }

  groupVessels(responseData: any, sensor: any) {
    let vessels: any;

    if (sensor.operatorKey === OPERATORS.SPIRE) {
      this.overlayVessel = {};
      vessels = responseData?.vessels?.nodes;
      for (const date of this.sliderDateRangeArray) {      
        this.overlayVessel[date] = vessels.filter(data => {
          const dataDate = new Date(data.lastPositionUpdate.timestamp).toISOString().split('T')[0];
          return dataDate === date;
        });      
      }
    } 
    else if (sensor.operatorKey === OPERATORS.CLYDE) {
      this.overlayClydeVessel = {};
      vessels = responseData;
      for (const date of this.sliderDateRangeArray) {      
        this.overlayClydeVessel[date] = vessels.filter(data => {
          const dataDate = new Date(data.timestamp).toISOString().split('T')[0];
          return dataDate === date;
        });      
      }
    }
    this.spinnerService.hide();
    this.mapLoad = false;  
  }

  removeDataSourceBySensorId(sensorId: any) {
    const dataSources = this.viewer.dataSources;
    for (let i = 0; i < dataSources.length; i++) {
      const dataSource = dataSources.get(i) as CustomGeoJsonDataSource;
      if (dataSource.sensorId === sensorId) {
        dataSources.remove(dataSource, true);
        break;
      }
    }

    this.viewer.entities.values.forEach((entity) => {      
      if (entity.sensorId === sensorId) {
        this.viewer.entities.remove(entity);
      }
    });
  }
  resetBackgroundWithChangeInBaseLayer(){
    let imageryLayers = this.viewer.imageryLayers;

    // Get the number of layers
    let numLayers = imageryLayers.length;

    // Remove all layers except the first one (index 0)
    for (let i = numLayers - 1; i > 0; i--) {
        let layer = imageryLayers.get(i);
        imageryLayers.remove(layer);
    }
  }

  selectMetric(unit: string) {
    this.selectedMetric = unit;
    const index = event;
    let sceneId: any;
    let sensorId: any;
    let action: any;
    const taskId = this.collection?.taskId;
    this.removeImages();
    this.viewer.entities.removeAll();
    if (this.slider) this.slider.value = 0;
    this.currentSliderValue = 0;
    this.previousIndex = -1;
    this.clearAnnotations();
    if(this.legendContainer) this.legendContainer.style.display = 'none';

    for (const sensor of this.collection.sensors) {
      for (const [index, scn] of sensor.scenes.entries()) {
        if (scn?.id && scn?.status !== 'failed' && scn.checked) {
          if (scn.footprint) {
            sensorId = this.selectedSensors[0]?.id;
            action = "scene"
            sceneId = scn?.id;
            this.spinnerService.show();
            this.mapLoad = true;
            const sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action, type: this.imageType };
            this.apiService.getCollectionImage(taskId, sensorObj).subscribe((res: any) => {
              if (res?.msg === 'Failed') {
                this.spinnerService.hide();
                this.mapLoad = false;
                const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              } else if (res?.msg === 'user storage') {
                this.fail = this.fail + 1;
                if (this.fail === 1) {
                  const message = 'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
                  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
                }
                this.spinnerService.hide();
                this.mapLoad = false;
              }
              if (scn?.thumbnailUrl) {
                scn.thumbnailUrl = res.result?.imageUrl;
              }
              scn.thumbnailUrl = res.result?.COGUrl ? res.result?.COGUrl : res.result?.imageUrl;
              this.displayFootPrint(scn, 0, res.result,sensorId,taskId);
              this.spinnerService.hide();
              this.mapLoad = false;
            });
          }
        }

      }
    }
  }

  getAdditionalData(taskId: any, sensor: any) {
    if(this.demoView) return;
    let message: any;
    let sensorObj = {
      sensorId: sensor.id,
      taskId: taskId
    }
    this.apiService.addCollectionData(sensorObj).subscribe((res: any) => {
      if (res) {
        if (res.msg === 'success' && res?.refundRequested) {
          message = 'As you requested a refund of the L1B product, L1D is unavailable.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        } else if (res.msg === 'success') {
          const type = 'download'
          message = 'Thank you for submitting additional files for download. You will be notified via email when the files are ready.';
          this.popupService.openPopup(WarningPopupComponent, message, type, '40%');
        } else if (res.msg === 'already requested') {
          message = 'The download request for additional files has either already been made and is being processed.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        } else if (res?.msg === 'user storage') {
          const message = 'We cannot download the image as the delivery was made to your storage. You can access the image via your storage.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        } else {
          message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        }
      } else {
        message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      }    
    });

  }

  releaseVADP(taskId: any, sensor: any) {
    let productName: any,productId: any, product: any;
    if (sensor?.superResolutions?.length > 0) {
      productName = 'superResolutions';
      product = 'Super Resolution'
    }
    else {
      productName = 'valueAddedOption';
      productId = sensor?.valueAddedOption[0]?.product_id;
      product = 'vadp';
    }

    let message: any;
    let sensorObj = {
      sensorId: sensor.id,
      taskId: taskId,
      vadpId: productId,
      productName: productName
    }

    let action = 'all';
    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';

    let params = {
      taskId, sensorId: sensor.id, product, action
    }

    this.apiService.returnRefundStatus(params).subscribe((resp: any) => {
      if (resp.status != 'found' || (resp.status === 'found' && resp?.refund)) {
        message = 'You have requested a refund for the value-added data products. You cannot request the products anymore.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return
      } else {
        this.apiService.processVADP(sensorObj).subscribe((res: any) => {
          if (res) {
            if (res.msg === 'success') {
              const type = 'download'
              message = 'Thank you for submitting value added products for releasing. You will be notified via email when the files are ready.';
              this.popupService.openPopup(WarningPopupComponent, message, type, '40%');
              for (const sensor of this.collection.sensors || []) {
                if (sensor?.valueAddedOption?.length > 0) {
                  sensor.valueAddedOption.releaseRequest = true;
                  for (const option of sensor.valueAddedOption || []) {
                    option.releaseRequest = true;
                  }
                }

                if (sensor.superResolutions?.length > 0) {
                  sensor.superResolutions.releaseRequest = true;
                  for (const option of sensor.superResolutions || []) {
                    option.releaseRequest = true;
                  }
                }    
               
            }
              
            } else if (res.msg === 'already requested') {
              message = 'The release request for value added products has either already been made and is being processed.';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            } else {
              message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            }
          } else {
            message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          }    
        });
      }
      
    });

  }

  handleAnnotation() {
    this.checkSeceneSelected();

    const annotateHandler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);

    annotateHandler.setInputAction((click) => {
      const mousePosition = this.viewer.camera.pickEllipsoid(click.position, this.viewer.scene.globe.ellipsoid);
      const position: Cesium.Cartesian2 = click.position;
    
      if (Cesium.defined(mousePosition) && this.annotateClicked) {
        // Iterate through imagery layers to check if the mouse position is within any layer's rectangle
        for (const [layer, data] of this.imageryLayerMap.entries()) {
          if (this.isPositionInsideRectangle(mousePosition, data.rectangle)) {
            this.annotateCollection(position,data.sensorId,data.taskId,data.sceneId);
            break;
          }
        }
      }
    }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
  }

  handleJsonAnnotation() {
    this.checkSeceneSelected();
    
    const annotateHandler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);
    annotateHandler.setInputAction((click) => {
      const mousePosition = this.viewer.camera.pickEllipsoid(click.position, this.viewer.scene.globe.ellipsoid);
      const position: Cesium.Cartesian2 = click.position;

      if (Cesium.defined(mousePosition) && this.annotateClicked) {
        // Iterate through bounding boxes to check if the mouse position is within any bounding box
        for (const [bbox, data] of this.boundingBoxMap.entries()) {          
          if (this.isPositionInsideRectangle(mousePosition, bbox)) {
            this.annotateCollection(position,data.sensorId,data.taskId,data.sceneId);
            break;
          }
        }
      }
    }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
  }

  isPositionInsideRectangle(position, rectangle) {
    const cartographic = Cesium.Cartographic.fromCartesian(position);
    return Cesium.Rectangle.contains(rectangle, cartographic);
  }

  annotateImage() {
    this.annotateClicked = !this.annotateClicked;
    if (this.annotateClicked) {
      this.getAnnotations();
    } else this.clearAnnotations();
  }

  annotateCollection(position: Cesium.Cartesian2, sensorId: any, taskId: any, sceneId: any) {
    const cartesian = this.viewer.camera.pickEllipsoid(position);
    if (cartesian) {
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      const longitude = Cesium.Math.toDegrees(cartographic.longitude);
      const latitude = Cesium.Math.toDegrees(cartographic.latitude);
      const cartesianPosition = Cesium.Cartesian3.fromDegrees(longitude, latitude);

      var boxEntity = this.viewer.entities.add({
        name: 'annotationPoint',
        position: cartesianPosition,
        billboard: {
          image: 'assets/images/notes.png',
          show: true,
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          alignedAxis: Cesium.Cartesian3.ZERO,
          width: 20,
          height: 20,
        },
      });

      this.createAnnotationPopup(boxEntity,longitude,latitude)
      this.currentLongitude = longitude;
      this.currentLatitude = latitude;
      this.currentTaskId = taskId;
      this.currentSensorId = sensorId;
      this.sceneId = sceneId;
    } 
  }

  getAnnotations() {
    // Create a promise chain to sequentially handle API calls and display annotations
    let promise = Promise.resolve();

    for (const sensor of this.collection.sensors) {
      for (const scene of sensor.scenes) {
        if (scene.checked) {
          promise = promise.then(() => {
            return new Promise<void>((resolve) => {
              this.apiService.getAnnotations(this.taskid, sensor.id, scene.id).subscribe((res: any) => {
                if (res?.msg === 'Success') {
                  scene.identifiers = {
                    taskId: this.taskid,
                    sensorId: sensor.id,
                    sceneId: scene.id
                  }
                  scene.annotation = res.data;
                }
                resolve(); // Resolve the promise to continue to the next iteration
              });
            });
          });
        }
      }
    }

    // After all promises are resolved (i.e., all API calls are completed), execute displayAnnotations
    promise.then(() => {
      this.displayAnnotations();
    });
  }

  clearAnnotations() {
    let entitiesToRemove: any = [];
    this.annotateClicked = false;
    this.newTaskButtonClicked = false;

    this.viewer.entities.values.forEach((entity) => {
      if (entity.name === 'annotation' || entity.name === 'annotationPoint') {
        entitiesToRemove.push(entity);
      }
    });

    entitiesToRemove.forEach((entity) => {
      this.viewer.entities.remove(entity);
    });

    this.activePopups.forEach((popup) => {
      popup.element.remove();
    });

    this.activeTooltips.forEach((tooltip) => {
      tooltip.remove();
    });
  }

  displayAnnotations(): void {
    this.clearAnnotations();
    // Iterate through collections -> sensors -> annotations -> features
    for (const sensor of this.collection.sensors) {
      for (const scene of sensor.scenes) {
        if (scene.checked) {
          this.annotateClicked = true;
          scene?.annotation?.features.forEach(feature => {
            this.createAnnotationEntity(feature, scene.identifiers);
          });
        };
      }
    }
  }

  createAnnotationEntity(feature: any, identifiers: any) {
    let featureProperties = {
      feature: feature,
      identifiers: identifiers
    }
    var boxEntity = this.viewer.entities.add({
      name: 'annotation',
      properties: featureProperties,
      position: Cesium.Cartesian3.fromDegrees(feature.coordinates.longitude, feature.coordinates.latitude),
      billboard: {
        image: 'assets/images/notes.png',
        show: true,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        alignedAxis: Cesium.Cartesian3.ZERO,
        width: 20,
        height: 20,
      },
      // point: {
      //   pixelSize: 10,
      //   color: Cesium.Color.YELLOW,
      // },
    });

    this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);

    this.viewer.screenSpaceEventHandler.setInputAction((click) => {
      const pickedObject = this.viewer.scene.pick(click.position);
      if (Cesium.defined(pickedObject) && pickedObject.id) {
        const entity = pickedObject.id;
        this.openAnnotationPopup(entity, click.position);
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    this.viewer.scene.postRender.addEventListener(this.updatePopups.bind(this));

  }

  createAnnotationPopup(entity: any,long,lat) {

    if (this.lastAnnotation) {
      this.viewer.entities.remove(this.lastAnnotation);
      this.lastAnnotation = null;
    }
    if (this.lastTooltip) {
      this.lastTooltip.remove();
      this.lastTooltip = null;
    }
    
    const cesiumContainer = document.getElementById('cesiumContainer1');
    const tooltip = document.createElement('div') as AnnotatedDivElement;
    tooltip.style.height = '140px';
    this.applyPopupStyles(tooltip);

    // Create the arrow element
    const arrow = document.createElement('div');
    this.applyArrowStyles(arrow);
    tooltip.appendChild(arrow);

    tooltip.style.display = 'flex';
    // tooltip.style.justifyContent = 'space-between';

    // Create a textarea for editing
    const textarea = document.createElement('textarea');
    textarea.style.width = '250px';
    textarea.style.height = '95px';
    textarea.style.lineHeight = '1.2';
    // textarea.style.overflow = 'hidden';
    textarea.style.resize = 'none';
    tooltip.innerHTML = '';
    tooltip.appendChild(textarea);

    // Create coordinates container
    const coordinatesContainer = document.createElement('div');
    coordinatesContainer.style.position = 'absolute';
    coordinatesContainer.style.bottom = '0';
    coordinatesContainer.style.padding = '5px';
    coordinatesContainer.style.fontSize = '13px';
    coordinatesContainer.style.fontWeight = '400';
    coordinatesContainer.style.left = '11px'
    coordinatesContainer.innerHTML = `Lng: ${long.toFixed(8)}, Lat: ${lat.toFixed(8)}`;
    tooltip.appendChild(coordinatesContainer);
    

    const buttonsContainer = document.createElement('div');
    buttonsContainer.style.display = 'flex';
    buttonsContainer.style.justifyContent = 'space-between';
    buttonsContainer.style.flexDirection = 'column-reverse';
    buttonsContainer.style.marginTop = '-4px';

    const saveButton = document.createElement('span');
    saveButton.innerHTML = '<i class="material-icons" style="font-size:20px;">save</i>';
    this.buttonStyle(saveButton);

    const cancelButton = document.createElement('span');
    cancelButton.innerHTML =  '<i class="material-icons" style="font-size:20px;">close</i>';
    this.buttonStyle(cancelButton);

    buttonsContainer.appendChild(saveButton);
    buttonsContainer.appendChild(cancelButton);

    tooltip.appendChild(buttonsContainer);
    tooltip.sceneId = this.sceneId;
    this.activeTooltips.push(tooltip);

    // Append the tooltip to the cesiumContainer
    if (cesiumContainer) {
      cesiumContainer.appendChild(tooltip);
    }

    const updateCreateTooltipPosition = () => {
      const screenPosition = this.viewer.scene.cartesianToCanvasCoordinates(entity.position.getValue(this.viewer.clock.currentTime));
      if (screenPosition) {
        // Get the canvas dimensions
        const canvas = this.viewer.scene.canvas;
        const canvasRect = canvas.getBoundingClientRect();
        const canvasWidth = canvasRect.width;
        const canvasHeight = canvasRect.height;
    
        // Get the tooltip dimensions
        const tooltipWidth = tooltip.offsetWidth;
        const tooltipHeight = tooltip.offsetHeight;
    
        // Calculate adjusted positions
        let adjustedLeft = screenPosition.x; // Adjusted for padding or margin
        let adjustedTop = screenPosition.y; // Adjusted for padding or margin
    
        // Check if the annotation point is within the canvas
        if (
          screenPosition.x >= 0 &&
          screenPosition.x <= canvasWidth &&
          screenPosition.y >= 0 &&
          screenPosition.y <= canvasHeight
        ) {
          // Adjust left position if tooltip exceeds right edge
          if (adjustedLeft + tooltipWidth > canvasWidth) {
            // adjustedLeft = canvasWidth - tooltipWidth; // Adjusted for padding or margin
          }
    
          // Adjust top position if tooltip exceeds bottom edge
          if (adjustedTop + tooltipHeight > canvasHeight) {
            // adjustedTop = canvasHeight - tooltipHeight; // Adjusted for padding or margin
          }
    
          // Update tooltip position and display it
          tooltip.style.left = adjustedLeft + 'px';
          tooltip.style.top = adjustedTop + 'px';
          tooltip.style.display = 'flex';
        } else {
          // Hide the tooltip if the annotation point is outside the canvas
          tooltip.style.display = 'none';
        }
      }
    };
    updateCreateTooltipPosition();

    saveButton.addEventListener('click', () => {
      if (textarea.value) {
        const annotation = {
          "customerid": "",
          "taskid": this.currentTaskId,
          "sensorid": this.currentSensorId,
          "sceneid": this.sceneId,
          "property": textarea.value,
          "lat": this.currentLatitude,
          "lng": this.currentLongitude
        }
        tooltip.remove();
        this.apiService.addAnnotation(annotation).subscribe((res: any) => {
          if (res?.msg === 'Success') {
            this.getAnnotations();
          }
        });
      } else {
        this.viewer.entities.remove(entity);
        tooltip.remove();
      }
    });

    cancelButton.addEventListener('click', () => {
      this.viewer.entities.remove(entity);
      tooltip.remove();
    });

    this.lastAnnotation = entity;
    this.lastTooltip = tooltip;

    // Update the position of the tooltip on camera move
    this.viewer.scene.preRender.addEventListener(updateCreateTooltipPosition);
  }

  openAnnotationPopup(entity: any, position: any) {
    const cesiumContainer = document.getElementById('cesiumContainer1');
    const existingPopup = this.activePopups.find(popup => popup.entity === entity);
 
    if (existingPopup) {
      // Remove the existing popup
      existingPopup.element.remove();
      this.activePopups = this.activePopups.filter(popup => popup !== existingPopup);
    } else if (entity.name === 'annotation') {
      // Create a new popup element
      const tooltip = document.createElement('div') as AnnotatedDivElement;
      this.applyPopupStyles(tooltip);

      // Create the arrow element
      const arrow = document.createElement('div');
      this.applyArrowStyles(arrow);

      // Create a container for the close button
      const closeContainer = document.createElement('div');
      closeContainer.classList.add('close-container'); 
      closeContainer.style.display = 'flex';
      closeContainer.style.justifyContent = 'flex-end';

      // Create close button
      const closeIcon = document.createElement('span');
      closeIcon.innerHTML = '<i class="material-icons" style="font-size:20px;">close</i>';
      this.buttonStyle(closeIcon);
      closeIcon.addEventListener('click', () => {
          tooltip.remove();
          this.activePopups = this.activePopups.filter(popup => popup.entity !== entity);
      });

      closeContainer.appendChild(closeIcon);
      tooltip.appendChild(closeContainer);

      // Append the arrow to the tooltip
      tooltip.appendChild(arrow);

      let feature = entity?.properties?.feature.getValue();
      const content = document.createElement('div');
      content.style.overflow = 'auto';
      content.style.maxHeight = '142px';
      content.style.lineHeight = '1.17';
      // content.style.paddingRight = '15px';
      content.style.wordWrap = 'break-word';
      content.innerHTML = feature?.property;
      tooltip.appendChild(content);

      // Create coordinates container
      const coordinatesContainer = document.createElement('div');
      coordinatesContainer.style.position = 'absolute';
      coordinatesContainer.style.bottom = '5px';
      coordinatesContainer.style.padding = '5px';
      coordinatesContainer.style.fontSize = '13px';
      coordinatesContainer.style.fontWeight = '400';
      coordinatesContainer.style.left = '8px'
      coordinatesContainer.innerHTML = `Lng: ${feature.coordinates.longitude.toFixed(8)}, Lat: ${feature.coordinates.latitude.toFixed(8)}`;
      tooltip.appendChild(coordinatesContainer);

      // Create edit and delete icons
      const iconsContainer = document.createElement('div');
      iconsContainer.style.display = 'flex';
      iconsContainer.style.justifyContent = 'end';
      iconsContainer.style.marginTop = '30px';
      // iconsContainer.style.marginTop = '-2px';

      const editIcon = document.createElement('span');
      editIcon.innerHTML = '<i class="material-icons" style="font-size:20px;">edit</i>';
      editIcon.style.paddingRight = '10px'
      this.buttonStyle(editIcon);

      const deleteIcon = document.createElement('span');
      deleteIcon.innerHTML =  '<i class="material-icons" style="font-size:20px;">delete</i>';
      this.buttonStyle(deleteIcon);

      iconsContainer.appendChild(editIcon);
      iconsContainer.appendChild(deleteIcon);
      tooltip.appendChild(iconsContainer);
      tooltip.sceneId = this.sceneId;

      // Append the tooltip to the cesiumContainer
      if (cesiumContainer) {
        cesiumContainer.appendChild(tooltip);
      }

      // Add the new popup to the activePopups array
      this.activePopups.push({ entity, element: tooltip });

      // Initially set the popup's position and clamp to container bounds
      // const screenPosition = this.viewer.scene.cartesianToCanvasCoordinates(entity.position.getValue(this.viewer.clock.currentTime));
      // if (screenPosition) {
      //   tooltip.style.left = screenPosition.x + 1 + 'px';
      //   tooltip.style.top = screenPosition.y + 1 + 'px';
      // }
      const updateTooltipPosition = () => {
        const screenPosition = this.viewer.scene.cartesianToCanvasCoordinates(entity.position.getValue(this.viewer.clock.currentTime));
        if (screenPosition) {
          // Get the canvas dimensions
          const canvas = this.viewer.scene.canvas;
          const canvasRect = canvas.getBoundingClientRect();
          const canvasWidth = canvasRect.width;
          const canvasHeight = canvasRect.height;
      
          // Get the tooltip dimensions
          const tooltipWidth = tooltip.offsetWidth;
          const tooltipHeight = tooltip.offsetHeight;
      
          // Calculate adjusted positions
          let adjustedLeft = screenPosition.x + 10; // Adjusted for padding or margin
          let adjustedTop = screenPosition.y + 10; // Adjusted for padding or margin
      
          // Check if the annotation point is within the canvas
          if (
            screenPosition.x >= 0 &&
            screenPosition.x <= canvasWidth &&
            screenPosition.y >= 0 &&
            screenPosition.y <= canvasHeight
          ) {
            // Adjust left position if tooltip exceeds right edge
            if (adjustedLeft + tooltipWidth > canvasWidth) {
              adjustedLeft = canvasWidth - tooltipWidth - 100; // Adjusted for padding or margin
            }
      
            // Adjust top position if tooltip exceeds bottom edge
            if (adjustedTop + tooltipHeight > canvasHeight) {
              // adjustedTop = canvasHeight - tooltipHeight - 10; // Adjusted for padding or margin
            }
      
            // Update tooltip position and display it
            tooltip.style.left = adjustedLeft + 'px';
            tooltip.style.top = adjustedTop + 'px';
            tooltip.style.display = 'block';
          } else {
            // Hide the tooltip if the annotation point is outside the canvas
            tooltip.style.display = 'none';
          }
        }
      };
  
      // Initially set the popup's position and clamp to container bounds
      updateTooltipPosition();

     // Add event listeners for edit and delete icons
     editIcon.addEventListener('click', () => {
        // Remove the close container when the edit button is clicked
        const closeContainerDiv = tooltip.querySelector('.close-container');
        if (closeContainerDiv) {
            closeContainerDiv.remove();
        }
        this.editAnnotation(entity, content, iconsContainer, closeContainer, tooltip ,coordinatesContainer);
      });
      deleteIcon.addEventListener('click', () => this.deleteAnnotation(entity));
      // Update the position of the tooltip on camera move
      this.viewer.scene.preRender.addEventListener(updateTooltipPosition);
    }

  }

  deleteAnnotation(entity: any): void {
    let feature = entity.properties.feature.getValue();
    let identifiers = entity.properties.identifiers.getValue()

    let deleteObj = {
      "customerid": "",
      "taskid": identifiers.taskId,
      "sensorid": identifiers.sensorId,
      "sceneid": identifiers.sceneId,
      "featureid": feature._id,
    }
    this.apiService.deleteAnnotations(deleteObj).subscribe((res: any) => {
      if (res?.msg === 'Success') {
        this.getAnnotations();
      }
    });
  }

  editAnnotation(entity: any, content: HTMLElement, iconsContainer: HTMLElement, closeContainer: HTMLElement | null = null, tooltip: HTMLElement | null = null, coordinatesContainer: HTMLElement) {
    const feature = entity.properties.feature.getValue();
    iconsContainer.style.display = 'none';
    coordinatesContainer.style.display = 'none';

    // Create a textarea for editing
    const textarea = document.createElement('textarea');
    textarea.value = feature.property;
    textarea.style.width = '250px';
    textarea.style.height = '95px';
    textarea.style.lineHeight = '1.17';
    // textarea.style.overflow = 'hidden';
    textarea.style.resize = 'none';
    content.innerHTML = '';
    content.appendChild(textarea);

    content.style.display = 'flex';
    content.style.justifyContent = 'space-between';

    const buttonsContainer = document.createElement('div');
    buttonsContainer.style.display = 'flex';
    buttonsContainer.style.justifyContent = 'space-between';
    buttonsContainer.style.flexDirection = 'column-reverse';

    const saveButton = document.createElement('span');
    saveButton.innerHTML = '<i class="material-icons" style="font-size:20px;">save</i>';
    this.buttonStyle(saveButton);

    const cancelButton = document.createElement('span');
    cancelButton.innerHTML =  '<i class="material-icons" style="font-size:20px;">close</i>';
    this.buttonStyle(cancelButton);

    buttonsContainer.appendChild(saveButton);
    buttonsContainer.appendChild(cancelButton);

    content.appendChild(buttonsContainer);

    saveButton.addEventListener('click', () => {
      if(textarea.value)
      {
        feature.property = textarea.value;
        content.innerHTML = feature.property;
        iconsContainer.style.display = 'flex';
        coordinatesContainer.style.display = 'flex';

        let identifiers = entity.properties.identifiers.getValue()

        let deleteObj = {
          "customerid": "",
          "taskid": identifiers.taskId,
          "sensorid": identifiers.sensorId,
          "sceneid": identifiers.sceneId,
          "featureid": feature._id,
          "property": textarea.value
        }
        this.apiService.editAnnotations(deleteObj).subscribe((res: any) => {
          if (res?.msg === 'Success') {
            this.getAnnotations();
          }
        });
      }
    });

    cancelButton.addEventListener('click', () => {
      content.innerHTML = feature.property;
      iconsContainer.style.display = 'flex';
      content.style.display = 'block';
      coordinatesContainer.style.display = 'flex';

      // Append the close container back to the tooltip if provided
      if (closeContainer && tooltip) {
        tooltip.insertBefore(closeContainer, content);
    }
    });
  }

  applyPopupStyles(tooltip) {
    tooltip.style.position = 'absolute';
    tooltip.style.fontSize = '15px';
    tooltip.style.fontFamily = 'Barlow, sans-serif';
    tooltip.style.lineHeight = '1.8';
    tooltip.style.backgroundColor = 'white';
    tooltip.style.color = 'black';
    tooltip.style.border = '0 solid white';
    tooltip.style.padding = '15px 10px 15px 15px';
    tooltip.style.zIndex = '1000';
    tooltip.style.minWidth = '300px';
    tooltip.style.maxWidth = '300px';
    tooltip.style.borderRadius = '9px';

    return tooltip;
  }

  applyArrowStyles(arrow) {
    arrow.style.position = 'absolute';
    arrow.style.top = '-5px';
    arrow.style.left = '4px';
    arrow.style.width = '0';
    arrow.style.height = '0';
    arrow.style.borderRight = '20px solid transparent';
    arrow.style.borderBottom = '8px solid white';

    return arrow;
  }

  buttonStyle(button) {
    button.style.cursor = 'pointer';
    button.style.color ='rgb(182 182 186)';

    return button;
  }

  updatePopups() {
    const cesiumContainer = document.getElementById('cesiumContainer1');
    if (!cesiumContainer) return;

    const containerRect = cesiumContainer.getBoundingClientRect();

    this.activePopups.forEach(popup => {
      const entity = popup.entity;
      const element = popup.element;

      // Get the entity's screen position
      const position = this.viewer.scene.cartesianToCanvasCoordinates(entity.position.getValue(this.viewer.clock.currentTime));

      if (position) {
        // Calculate the popup position relative to the container
        let left = position.x + 1;
        let top = position.y + 1;

        // Clamp the position to the container bounds
        left = Math.min(Math.max(left, 0), containerRect.width - element.offsetWidth);
        top = Math.min(Math.max(top, 0), containerRect.height - element.offsetHeight);

        element.style.left = left + 'px';
        element.style.top = top + 'px';
      }
    });
  }
  
  clearAnnotationsByScene(sceneId?: string) {
    let entitiesToRemove: any = [];

    this.viewer.entities.values.forEach((entity) => {
      if ((entity.name === 'annotation' && entity?.properties?.identifiers)) {
        let featureSceneId = entity.properties.identifiers.getValue();

        if (featureSceneId.sceneId === sceneId) {
          entitiesToRemove.push(entity);
        }
      } else if (entity.name === 'annotationPoint') {
        entitiesToRemove.push(entity);
      }
    });

    entitiesToRemove.forEach((entity) => {
      this.viewer.entities.remove(entity);
    });

    this.activePopups.forEach((popup) => {
      if (popup?.entity?.properties?.identifiers) {
        let featureSceneId = popup.entity.properties.identifiers.getValue();
        if (featureSceneId.sceneId === sceneId) {
          popup.element.remove();
        }
      }
    });

    this.activeTooltips.forEach((tooltip) => {
      tooltip.remove();
    });

    this.checkSeceneSelected();
  }

  checkSeceneSelected() {
    let imageryLayers = this.imageryLayerMap;
    let jsonData = this.boundingBoxMap;
    let isAnySceneChecked = false;
    this.imageLoaded = false;

    for (const sensor of this.collection.sensors) {
      for (const scene of sensor.scenes) {
        if (scene.checked && (checkLayerSceneID(scene.id) || checkJsonSceneID(scene.id))) {
          isAnySceneChecked = true;
          this.imageLoaded = true;
          break;
        }
      }
      if (isAnySceneChecked) {
        break;
      } else {
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
      }
    }

    function checkLayerSceneID(sceneId) {
      for (const [layer, data] of imageryLayers.entries()) {
        if (data.sceneId === sceneId) {
          return true;
          break;
        }
      }
      return false
    }

    function checkJsonSceneID(sceneId) {
      for (const [json, data] of jsonData.entries()) {
        if (data.sceneId === sceneId) {
          return true;
          break;
        }
      }
      return false
    }
    if(this.annotateClicked) this.getAnnotations();
  }

  getBoundingBox(BBpoints: any) {
    return Cesium.Rectangle.fromDegrees(
      Math.min(...BBpoints.filter((_, i) => i % 2 === 0)),
      Math.min(...BBpoints.filter((_, i) => i % 2 !== 0)),
      Math.max(...BBpoints.filter((_, i) => i % 2 === 0)),
      Math.max(...BBpoints.filter((_, i) => i % 2 !== 0))
    );
  }

  setJsonData(scenes, taskId, sensorId) {
    let USLcoverage;

    if (scenes?.metadata?.features) {
      USLcoverage = scenes.metadata.features[0].geometry.coordinates[0];
    } else if (scenes?.footprint) {
      USLcoverage = scenes?.footprint.coordinates[0];
    }

    const BBpoints = USLcoverage.flat();
    const sceneId = scenes.id;
    const boundingBox = this.getBoundingBox(BBpoints);
    this.boundingBoxMap.set(boundingBox, {
      sceneId: sceneId,
      taskId: taskId, sensorId: sensorId
    });

    this.handleJsonAnnotation();
  }

  handleSelection(item: any, collectionIndex: number, i: number, event: Event): void {
    this.selectRecurrency(item, 'normal');
    this.saveSelectedData(collectionIndex, i, undefined, event, 'dropdown', 'Month', 'dateSelection');
  }

  handleSiteSelection(item: any, collectionIndex: number, i: number, event: Event): void {
    this.selectSite(item.siteId);
    this.saveSelectedSites(item);
  }

  saveSelectedData(collectionIndex: any, sensorIndex: any, scenesIndex: any, event: any, type: any, task: any, selectedType: string) {
    this.currentCollectionIndex = collectionIndex;
    this.currentSensorIndex = sensorIndex;
    this.currentSceneIndex = scenesIndex;
    this.currentEvent = {
     checked : true
    };
    this.currentType = type;
    this.currentTask = task;
   }

   saveSelectedSites(item: any) {
    this.dateSelected = false;
    this.selectedDropdownType = '';
    this.selectedDropdownType = 'sites';
    let selectedSite = {
      checked: false,
      disabled: false,
      siteId: item.siteId,
      siteName: item.siteName,
      target: item.target,
      value: item.siteId
     }
    this.currentEvent = {
      checked : true
     };
     this.currentSites = selectedSite;
     if (this.timeseries) {
      this.groupedScenes = this.groupRecurrencyCollections(this.selectedRecurrencyArray);
      if (this.slider) this.slider.value = 0;
      this.currentSliderValue = 0;
      this.previousIndex = -1;
      const entities = this.viewer.entities.values;
      for (const entity of entities) {
        if (entity?.name === 'trendline') {
          this.viewer.entities.remove(entity);
        }
      }
      this.sourceRateArray = [];
    }  
 }

 getTooltipMessage(sensor) {
  this.tooltipDisabled = false;
  if (sensor.operatorKey === OPERATORS.CAPELLA) {
    this.downloadTooltip = 'Click here for additional GEO, SLC and SICD files available for download';
  } else if (sensor.operatorKey === OPERATORS.UMBRA && sensor?.isAdditionalProducts) {
    this.downloadTooltip = 'Click here for additional CPHD, SIDD, and SICD files available for download';
  } else if (sensor.operatorKey === OPERATORS.UMBRA && sensor?.isAdditionalCSIProducts) {
    this.downloadTooltip = 'Click here for additional CSI-TIFF and CSI-SIDD files available for download';
  } else if (sensor.operatorKey === OPERATORS.SATELLOGIC) {
    this.downloadTooltip = 'Click to request for the Orthorectified (L1D) product';
  }
}

onMouseOut() {
  this.tooltipDisabled = true;
  this.downloadTooltip = '';
}

checkDownloaded(scene: any): boolean {
  const isDownloaded = this.downloadedScene.includes(scene.id) || scene.downloaded;

  return isDownloaded;
}

checkSensorDownloaded(sensor: any): boolean {
  const isDownloaded = this.downloadedSensor.includes(sensor.id) || sensor.downloaded;

  return isDownloaded;
}

createNewTask() {
  this.newTaskButtonClicked = !this.newTaskButtonClicked;
  if (this.newTaskButtonClicked) {
    this.handleNewTaskCreation();
  }
}

handleNewTaskCreation() {
  this.checkSelectedSecene();

  if (!this.createNewTaskHandler) {
    this.createNewTaskHandler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);

    this.createNewTaskHandler.setInputAction((click) => {
      const mousePosition = this.viewer.camera.pickEllipsoid(click.position, this.viewer.scene.globe.ellipsoid);
      const position: Cesium.Cartesian2 = click.position;
      if (!this.newTaskButtonClicked) {
        // Prevent the default right-click action
        click.cancel = true;
    } else {
    
      if (Cesium.defined(mousePosition) && this.newTaskButtonClicked) {
        this.handleNewTaskClick(position);
      }
    }
    }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
  }

    // Remove the event handler if the task button is not clicked
    if (!this.newTaskButtonClicked && this.createNewTaskHandler) {
      this.createNewTaskHandler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
      this.createNewTaskHandler.destroy();
      this.createNewTaskHandler = null;
    }
}

handleNewTaskClick(position: Cesium.Cartesian2) {
  const cartesian = this.viewer.camera.pickEllipsoid(position);
  if (cartesian) {
    const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
    const longitude = Cesium.Math.toDegrees(cartographic.longitude);
    const latitude = Cesium.Math.toDegrees(cartographic.latitude);
    const cartesianPosition = Cesium.Cartesian3.fromDegrees(longitude, latitude);

    // Add a marker at the clicked position
    const marker = this.viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(longitude, latitude),
      billboard: {
        image: 'assets/images/marker-icon.png',
        show: true,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        alignedAxis: Cesium.Cartesian3.ZERO,
        width: 20,
        height: 30,
      },
    });

    setTimeout(() => {
      const message = `Do you want to create a new task with the selected point?`;
    
      const dialogRef = this.dialog.open(CreateTaskConfirmDialog, {
        backdropClass: 'blurr', disableClose: true,
        data: { message: message, longitude: longitude, latitude: latitude, task: this.collection, user: this.currentUser },
      });
    
      dialogRef.afterClosed().subscribe(result => {
        this.viewer.entities.remove(marker);
      });
    }, 1);

  } else {
  }
}

loadUserDetails(userId): void {
  if (userId) {
    this.userService.personalInfo(userId).subscribe({
      next: (res: any) => {
        this.currentUser = res;
        this.getProjects();
      },
      error: (error) => {
      }
    });
  }
}
// List of options
  getValueAddedOption(dataArray: any) {
    let productsData: any;
    productsData = dataArray[0];
    
    const productsInfo = ((productsData || {}).products || []).map(product => ({
      ...product,
      product_id: productsData.product_id,
      sensorid: productsData.sensorId,
      releaseRequest: dataArray[0]?.releaseRequest
    }));

    productsInfo.sort((a, b) => {
      const actionA = a.product || '';
      const actionB = b.product || '';
      return actionA.localeCompare(actionB);
    });

    return productsInfo;
  }

  // Disabling Options
  shouldDisableValueAddedOption(sensor, type) {
    if(!this.isSensorInList(sensor.id)) return true;
    if (this.selectedSensors.length > 0) {
      if(this.selectedSensors.length > 1) return true;
      if(this.selectedSensors.length === 1) {
        if(sensor.scenes.filter(scene => scene.checked === true).length === 0) return true;
        return sensor.scenes.filter(scene => scene.checked === true).length > 1
      };
    }
    return true;
  }
  
  // Check if sensor exist in selected sensor list
  isSensorInList(sensorId: number): boolean {
    return this.selectedSensors.some(sensor => sensor.id === sensorId);
  }

  // setting selcted value added options
  setValueAddedOption(valAdOption, sensor, event, collectionIndex, sensorIndex) { 
    this.handleOptionError(event, `Value-added data products can only be downloaded now and cannot be visualised on the map here.`);
  }

  handleOptionError(event, message) {

      event.source.checked = false; 
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  }
  hasPendingOptions(sensor: any, currentScene: any): boolean {
    return sensor.valueAddedOption.some((opt: any) => {
      return opt.sceneid === currentScene.id && opt.product_status === 'PENDING';
    });
  }
  isValueAddedOptionChecked(sensor, option) {
    if (this.selectedSensors.length !== 1) {
      return false;
    }

    return this.isSensorInList(sensor.id) && this.isOptionInList(option);
  }
  isOptionInList(option: string): boolean {
    return this.selectedOptions.some(item => item === option);
  }

  getSelectedSensorSingle(collectionIndex, sensorIndex)
  {
    return this.collections[collectionIndex].sensors[sensorIndex].scenes.find((i) => i.checked === true);
  }
  downloadValueAddedData(valAdOption, collectionIndex, sensor, sensorIndex)
  {
    if (this.freeze) {
      const message = 'A download is in progress. Please wait until the current download finishes to continue downloading others.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    } else if (valAdOption?.isDownloaded) {
      const message = 'download_vadp';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    } else {
      this.currentDownloadingVADP = { collectionIndex: collectionIndex, sensorIndex:  sensorIndex, product: valAdOption.product};
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
  
      let sensorObj = {
        product: valAdOption.product,
        id: valAdOption.product_id
      }
      
      this.apiService.getValueAddedData(sensorObj).subscribe(async (res: any) => {
        let url = res.response.imageUrl;

        if(url) {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url);
          xhr.responseType = 'blob';
    
          xhr.onprogress = (event) => {
            if (event.lengthComputable) {
              const percentComplete = ((event.loaded / event.total) * 100);
              this.progress = percentComplete.toFixed(2);
              const sensorObj = { progress: this.progress, taskId: this.collections[collectionIndex].taskId, sensorId: sensor.id, download: this.downloadClick, product: valAdOption.product};
              this.downloadService.setProgress(sensorObj);
            }
          };
    
          xhr.onload = () => {
            if (xhr.status === 200) {
              const blob = xhr.response;
              const fileName = this.getFileNameFromS3SignedUrl(url);
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              URL.revokeObjectURL(link.href);
    
              // Reset progress after download
              this.progress = 0;
              this.spinnerService.hide();
              this.freeze = false;
              this.disable = false;
            } else {
            this.showDownloadError();
            }
          };
    
          xhr.onerror = () => {
            // Handle errors
          this.showDownloadError();
          };
          xhr.send();
        }
      }) 
    }
  }
  refundValueAddedData(collectionIndex, sensorIndex, valAdOption)
  {
    this.OpenReturnRequestVADP(collectionIndex,
      sensorIndex,
      null,
      null,
      valAdOption.product,
      valAdOption
    )
  }
  refundValueAddedStatus(valAdOption: any) {
    if (valAdOption?.refundRequest && (valAdOption?.returnRefundAccept || valAdOption?.returnRefundReject)) {
      let message = 'return-refund-accepted';
      if (valAdOption?.returnRefundReject) {
        message = 'return-refund-rejected';
      }
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    }
  }
  downloadedWarning()
  {
    const message = 'download_vadp';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  }
  setDownloadedVADP()
  {
    this.collections[this.currentDownloadingVADP.collectionIndex].sensors[this.currentDownloadingVADP.sensorIndex].valueAddedOption.forEach((row) => {
      if(row.product == this.currentDownloadingVADP.product) {
        row.isDownloaded = true;
      }
    })
    this.currentDownloadingVADP = {};
  }
  OpenReturnRequestVADP(i: any, j: any, k: any, scene: any, product: string = '', vadpData:any) {
    const sensor = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sceneId: any = scene?.id;
    let sensorId: any = sensor?.id;

    let sensorObj = {
      taskId, sensorId, sceneId, product
    }
  
    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if(this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === "found") {
        let message =  'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }
  
        if (res?.returnRefundReject || (res?.returnRefundAccept)) {
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          return
        } else {
          this.handleRefundRequestVADP(scene, taskId, sensorId, sceneId, product, vadpData);
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return
      }
    });
  }
  
  handleRefundRequestVADP(scene: any, taskId: any, sensorId: any, sceneId: any, product: any = '', vadpData:any) {
      const dialog = this.matdialog.open(ReturnRefundComponent, {
        minWidth: '50%',
        data: {type: 'return', taskId: taskId, sensorId: sensorId, sceneId: sceneId, product: product},
        backdropClass: 'blurred',
        disableClose: true
      });
  
      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          const message = 'return-refund-success';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          this.refundRequestVADP.push({sensorId: sensorId, product: vadpData?.product});
          this.valueAddedProductLocalUpdate(sensorId, vadpData?.product);
        }
      });
  }
  valueAddedProductLocalUpdate(sensorId:any, product:any)
  {
    (this.collections || []).forEach((item) => {
      (item.sensors || []).forEach(sensor => {
        if(sensor.id === sensorId)
        {
          (sensor.valueAddedOption || []).forEach(element => {
            if(element.product === product)
            {
              element.refundRequest = true;
            }
          });
        }
      });
    })
  }
  
  getSignals(signalOfInterest) {
    let signals;
    if (signalOfInterest) {
      signals = [
        {
          features: [],
          product: "All",
          type: "FeatureCollection"
        },
        ...signalOfInterest
      ];
    }

    return signals;
  }

  selectSignals(sensor: any, signals: any) {
    let geoJsonFiles;
    this.signalSelected = signals;
    this.removeDataSourceByName('signal');
    this.removeEntitiesByName('audio');
    this.removeEntitiesByName('signal');
    this.audioAvailable = false;
    this.currentRfSignals = []

    if (!this.showDailyRecurrencyCheckboxes && this.signalBands) {
      this.setJsonData(this.signalBands,this.bandTaskId,this.signalSensorId);  
    }
     
    let collectionData: any = {};

    if (this.showDailyRecurrencyCheckboxes && !this.showSubDailyList) {
      collectionData.sensors = this.selectedCheckboxes;
    } else if (this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
      collectionData.sensors = this.subDailyFinalArray;
    } else collectionData = this.collection;

    const features = this.getFeaturesByProduct(collectionData,this.signalSelected);
    geoJsonFiles = features;
    this.loadSignals(geoJsonFiles,this.signalSelected);
  }

  getFeaturesByProduct(collectionData: any, targetProduct: string): any[] {
    const features: any[] = [];
  if (collectionData?.sensors) {
    for (const [sensorIndex, sensor] of collectionData.sensors.entries()) {
      for (const scene of sensor.scenes) {
        if(scene.checked && scene.operatorKey === OPERATORS.LBAND) {
          for (const signal of scene.signalOfInterest) {
            const signalWithSceneId = { ...signal, sceneId: scene.id, sensorIndex: sensorIndex };
            if (targetProduct === 'All') {
              features.push(signalWithSceneId);
            }
            else if (signal.product === targetProduct) {
              features.push(signalWithSceneId);
            }
          }
        }
      }
    }
  }
  
    return features;
  }

  loadSignals (geoJsonFiles,signal) {
    const signalImageMap = {
      VHF: 'YELLOW',
      UHF: 'DARKGRAY',
      'GPS L1': 'GREEN',
      'GPS L2': 'HOTPINK',
      'GPS L5': 'YELLOWGRAY',
      'L-band (ADS-B)': 'MAGENTA',
      'L-band (GNSS)': 'BLUE',
      'L-band (SATCOM)': 'DARKGREEN'
    };

    let signalColor: any;
    this.audioAvailable = false;
    this.currentRfSignals = [];
    this.currentSignal = signal;

    for (let i = 0; i < geoJsonFiles.length; i++) {
      const currentGeoJsonFile = geoJsonFiles[i];
      const polygonColor = signalImageMap[currentGeoJsonFile.product];
      const multiPolygons = currentGeoJsonFile.features.filter(feature => (feature.geometry?.type === 'MultiPolygon' || 
        feature.geometry?.type === 'Polygon'
      ));
      signalColor = this.recurrentColorCode[geoJsonFiles[i].sensorIndex];

      const geoJsonData = {
        type: 'FeatureCollection',
        features: multiPolygons,
        product: currentGeoJsonFile.product
      };
      const selectData = Cesium.GeoJsonDataSource.load(geoJsonData);
      selectData.then((dataSource) => {
        dataSource.name = 'signal';
        const entities = dataSource.entities.values;
      
        for (let j = 0; j < entities.length; j++) {
          const entity = entities[j];
          entity.name = 'signal';
          if (entity.polygon) {
            const properties = entity.properties;
            
            if (properties) {
              const title = properties['title'] ? properties['title'].getValue() : '';
              const description = properties['description'] ? properties['description'].getValue() : '';
      
              if (title === "Estimated Emitter and Error Ellipse") {
                entity.polygon.material = new Cesium.ColorMaterialProperty(Cesium.Color[polygonColor]); // Set fill color
                if (entity.properties) entity.properties[signal] = currentGeoJsonFile.product
                
                // Get the coordinates of the polygon
                if (entity.polygon.hierarchy) {

                  const positions = entity.polygon.hierarchy.getValue(Cesium.JulianDate.now()).positions;

                  // Calculate the centroid of the polygon
                  const centroid = Cesium.BoundingSphere.fromPoints(positions).center;
                  const cartographic = Cesium.Cartographic.fromCartesian(centroid);
                  const longitude = Cesium.Math.toDegrees(cartographic.longitude);
                  const latitude = Cesium.Math.toDegrees(cartographic.latitude);
  
                  // Add a point at the centroid of the polygon
                  this.viewer.entities.add({
                    name: 'signal',
                    position: Cesium.Cartesian3.fromDegrees(longitude, latitude),
                    point: {
                      pixelSize: 8,
                      color: Cesium.Color[signalColor],
                    },
                    properties: entity.properties
                  });  
                }
              } else {
                entity.polygon.material = new Cesium.ColorMaterialProperty(Cesium.Color.BLUE.withAlpha(0.1)); // Set fill color

                if (entity.polygon && entity.polygon.hierarchy) {
                  // Get the coordinates of the polygon and calculate the bounding box
                  const polygonHierarchy = entity.polygon.hierarchy.getValue(Cesium.JulianDate.now());
                  const positions = polygonHierarchy.positions;

                  const degreesArray: any = [];
                  for (let pos of positions) {
                    const cartographic = Cesium.Cartographic.fromCartesian(pos);
                    degreesArray.push(Cesium.Math.toDegrees(cartographic.longitude), Cesium.Math.toDegrees(cartographic.latitude));
                  }

                  // Compute and store the bounding box for the blue circle polygon
                  const boundingBox = this.getBoundingBox(degreesArray);
                  this.boundingBoxMap.set(boundingBox, {
                    sceneId: currentGeoJsonFile.sceneId,
                    taskId: this.bandTaskId,
                    sensorId: this.signalSensorId
                  });
                }
              }
            } else {
                entity.polygon.material = new Cesium.ColorMaterialProperty(Cesium.Color.BLUE.withAlpha(0.5)); // Set fill color
                // Enable the outline and set its color
                entity.polygon.outline = new Cesium.ConstantProperty(true); // Enable outline
                entity.polygon.outlineColor = new Cesium.ColorMaterialProperty(Cesium.Color.BLUE.withAlpha(0.1)); // Set outline color to red
                
                if (entity.polygon && entity.polygon.hierarchy) {
                  // Get the coordinates of the polygon and calculate the bounding box
                  const polygonHierarchy = entity.polygon.hierarchy.getValue(Cesium.JulianDate.now());
                  const positions = polygonHierarchy.positions;

                  const degreesArray: any = [];
                  for (let pos of positions) {
                    const cartographic = Cesium.Cartographic.fromCartesian(pos);
                    degreesArray.push(Cesium.Math.toDegrees(cartographic.longitude), Cesium.Math.toDegrees(cartographic.latitude));
                  }

                  // Compute and store the bounding box for the blue circle polygon
                  const boundingBox = this.getBoundingBox(degreesArray);
                  this.boundingBoxMap.set(boundingBox, {
                    sceneId: currentGeoJsonFile.sceneId,
                    taskId: this.bandTaskId,
                    sensorId: this.signalSensorId
                  });
                }
            }
          }
        }
      
        this.viewer.dataSources.add(dataSource);
        // this.viewer.scene.globe.depthTestAgainstTerrain = false;
        this.viewer.flyTo(dataSource, { duration: 3 });
        if (currentGeoJsonFile?.product === 'VHF') {
          this.audioAvailable = true;
          this.currentRfSignals.push(currentGeoJsonFile);
        }
      }).catch(error => {
      });
      
    }
    this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    this.displayProperties(this.currentSignal);
  }

  openAudioSignals() {
    const hasAudioFiles = this.currentRfSignals.some(item => item.audioFiles && item.audioFiles.length > 0);
    if (hasAudioFiles) {
      const sensorId = this.signalSensorId;
      const action = "audioDownload"
      const taskId = this.bandTaskId;
      const sensorObj = { sensorId: sensorId, sceneId: this.currentRfSignals.sceneId, action: action, fileType: 'audio', taskId: taskId };
      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '30%',
        backdropClass: 'blurr',
        disableClose: true,
        data: { type: 'audio', signals: this.currentRfSignals, sensorData: sensorObj, currentUser: this.currentUser }
      });
    } else {
      const message = 'There is no audio recording within the AOI for this task.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
  }

  removeDataSourceByName(name: string) {
    let dataSourcesToRemove: any = [];

    const dataSourceCollection = this.viewer.dataSources;
    for (const dataSource of dataSourceCollection._dataSources) {
      if (dataSource?.name === name) {
        dataSourcesToRemove.push(dataSource);
      }
    }

    for (let i = 0; i < dataSourcesToRemove.length; i++) {      
      dataSourceCollection.remove(dataSourcesToRemove[i]);
    }
  }

  removeEntitiesByName(name) {
    let entitiesToRemove: any = [];

    this.viewer.entities.values.forEach((entity) => {
      if (entity.name === name) {
        entitiesToRemove.push(entity);
      }
    });

    entitiesToRemove.forEach((entity) => {
      this.viewer.entities.remove(entity);
    });
  }

  removeDataSourceById(type: string, id: any) {
    let datasourceoRemove: any = [];
    const dataSources = this.viewer.dataSources;
    
    for (let i = 0; i < dataSources.length; i++) {
      const dataSource = dataSources.get(i) as CustomGeoJsonDataSource;
      if (type === 'sensor' && dataSource.sensorId === id) {
        datasourceoRemove.push(dataSource);
      }     
      else if (type === 'scene' && dataSource.sceneId === id) {
        datasourceoRemove.push(dataSource);
      }
      else if (type === 'aisData' && dataSource.refreshId === id) {
        datasourceoRemove.push(dataSource);
      }
    }

    datasourceoRemove.forEach((dataSource) => {      
      dataSources.remove(dataSource, true);
    });
  }
    
  checkSelectedSecene() {
    let isAnySceneChecked = false;
    this.noScene = true;
    let collectionData: any = {};

    if (this.showDailyRecurrencyCheckboxes && !this.showSubDailyList) {
      collectionData.sensors = this.selectedCheckboxes;
    } else if (this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
      collectionData.sensors = this.subDailyFinalArray;
    } else collectionData = this.collection;    

    if (collectionData?.sensors) {
      for (const sensor of collectionData.sensors) {
        if (sensor.checked && this.timeseries) {
          isAnySceneChecked = true;
          this.noScene = false;
          break;
        }
        for (const scene of sensor.scenes) {
          if (scene.checked) {
            isAnySceneChecked = true;
            this.noScene = false;
            break;
          }
        }
      }
      if (isAnySceneChecked) {
        this.noScene = false;
      } else {
        this.noScene = true;
        this.newTaskButtonClicked = false;
      }
      return this.noScene;
    }
    return true;
  }
  
  getFilteredData(jsonData: any, className: string) {
    const filteredFeatures = jsonData.features.filter(feature => feature?.properties?.class != className);
    return {
      type: jsonData.type,
      crs: jsonData.crs,
      features: filteredFeatures,
      metadata: jsonData?.metadata,
      feed_results: jsonData?.feed_results
    };
  }
  selectSuperResolution(
    collectionIndex: number,
    sensorIndex: number,
    superResolutionIndex: number,
    event,
    superResolution: any
  ): void {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    if(event.checked) {
      this.collections[collectionIndex].sensors[sensorIndex].superResolutions[superResolutionIndex].checked = true;
      this.spinnerService.show();
      this.mapLoad = true;
      this.displaySR(superResolution, sensor, event, collectionIndex, sensorIndex)
    } else {
        this.selectedSR = null;
        if (this.currentProductLayer) {
            this.viewer.imageryLayers.remove(this.currentProductLayer);
            this.currentProductLayer = null;
        }

        this.removeBoundingBoxesAndLegends()

        // Handle toggling the sensor state
        const newEvent = { ...event, checked: true };
        const currentSceneIndex = sensor.scenes.findIndex(scene => scene.checked === true);
        this.toggleSensor(
            collectionIndex,
            sensorIndex,
            currentSceneIndex,
            newEvent,
            sensor.scenes[currentSceneIndex]
        );
    }
  }
  shouldDisableSuperResolution(collectionIndex,sensorIndex,scene: any,superResolution) {
    let isDisable: boolean = true;
    const selectedScenes =  this.collections[collectionIndex].sensors[sensorIndex].scenes.filter((i) => i.checked === true);
    if((selectedScenes || []).length === 1)
    {
      isDisable = false;
    }
    return isDisable;
  }
  displaySR(superResolution, sensor, event, collectionIndex, sensorIndex) {
    this.selectedSR = superResolution;
    this.selectedScene  = '';
    //Removing last added layer
    var allImageryLayers = this.viewer.imageryLayers._layers;
    var lastLayer = allImageryLayers[allImageryLayers.length - 1];
    this.viewer.imageryLayers.remove(lastLayer);

    const currentScene = sensor.scenes.find(scene => scene.checked === true);
    this.selectedScene  = currentScene;

    let sensorObj = {
        taskId: this.taskid,
        sensorId: superResolution.sensorId,
        sceneId: currentScene.id,
        product: superResolution.product,
        type: 'display'
    };

    this.apiService.getValueAddedDataImgUrl(sensorObj).subscribe(async (res: any) => {
        let scnRectangle: any;
        let pngFp: any;
        var bbox = turf.bbox(currentScene.footprint);

        if (currentScene?.png_footprint) {
            pngFp = currentScene?.png_footprint[0];
            scnRectangle = Cesium.Rectangle.fromDegrees(
                pngFp[0],
                pngFp[1],
                pngFp[2],
                pngFp[3]
            );
        } else {
            scnRectangle = Cesium.Rectangle.fromDegrees(
                bbox[0],
                bbox[1],
                bbox[2],
                bbox[3]
            );
        }

        const productProvider = new Cesium.ImageryLayer(
            new Cesium.SingleTileImageryProvider({
                url: res.response.imageUrl,
                rectangle: scnRectangle,
            }), {
            splitDirection: Cesium.SplitDirection.LEFT,
            alpha: 1
        });

        this.viewer.imageryLayers.add(productProvider);
        this.imageryLayerMap.set(productProvider, {
            sceneId: currentScene.id,
            rectangle: scnRectangle,
            taskId: this.taskid,
            sensorId: superResolution.sensorId
        });

        // Store the current product layer to remove it later
        this.currentProductLayer = productProvider;

        this.spinnerService.hide();
        this.mapLoad = false;
    });
  }
  downloadSR(superResolution, collectionIndex, sensor, sensorIndex)
  {
    const currentScene = sensor.scenes.find(scene => scene.checked === true);
    let isDownloaded = superResolution.products.some(element => {
      return element.sceneId === currentScene.id && element.isDownloaded;
    });
    if (this.freeze) {
      const message = 'A download is in progress. Please wait until the current download finishes to continue downloading others.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    } else if (isDownloaded) {
      const message = 'download_vadp';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    } else {
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      this.currentDownloadingSR = { 
        collectionIndex: collectionIndex, 
        sensorIndex:  sensorIndex,
        sceneId : currentScene.id,
        product: superResolution.product
      };
  
      let sensorObj = {
        taskId: this.taskid,
        sensorId: superResolution.sensorId,
        sceneId: currentScene.id,
        product: superResolution.product,
        type: 'download'
    };

    this.apiService.getValueAddedDataImgUrl(sensorObj).subscribe(async (res: any) => {
        let url = res.response.imageUrl;

        if(url) {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url);
          xhr.responseType = 'blob';
    
          xhr.onprogress = (event) => {
            if (event.lengthComputable) {
              const percentComplete = ((event.loaded / event.total) * 100);
              this.progress = percentComplete.toFixed(2);
              const sensorObj = { 
                progress: this.progress, 
                taskId: this.collections[collectionIndex].taskId, 
                sensorId: sensor.id,
                sceneId: currentScene.id, 
                download: this.downloadClick, 
                product: superResolution.product
              };
              this.downloadService.setProgress(sensorObj);
            }
          };
    
          xhr.onload = () => {
            if (xhr.status === 200) {
              const blob = xhr.response;
              const fileName = this.getFileNameFromS3SignedUrl(url);
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              URL.revokeObjectURL(link.href);
    
              // Reset progress after download
              this.progress = 0;
              this.spinnerService.hide();
              this.freeze = false;
              this.disable = false;
            }
          };
    
          xhr.onerror = () => {
            // Handle errors
          };
          xhr.send();
        }
      }) 
    }
  }
  setDownloadedSR()
  {
    this.collections[this.currentDownloadingSR.collectionIndex].sensors[this.currentDownloadingSR.sensorIndex].superResolutions.forEach((row) => {
      if(row.product == this.currentDownloadingSR.product) {
        (row.products || []).forEach((item) =>  {
          if(item.sceneId === this.currentDownloadingSR.sceneId) {
            item.isDownloaded = true;
          }
        });
      }
    })
    this.currentDownloadingSR = {};
  }
  isDownloadedSR(superResolution, sensor, scene) {
    let currentScene = sensor.scenes.filter(scene => scene.checked === true);
    if(currentScene.length > 1) return false;
    return superResolution.products.some(element => {
      return element.sceneId === currentScene[0]?.id && element.isDownloaded;
    });
  }
  isEnableSR(superResolution, sensor, scene) {
    let currentScene = sensor.scenes.filter(scene => scene.checked === true);
    if(currentScene.length > 1) return false;
    return superResolution.products.some(element => {
      return element.sceneId === currentScene[0]?.id;
    });
  }
  resetSROptions(collectionIndex, sensorIndex, event) {
    this.collections[collectionIndex]?.sensors[sensorIndex].superResolutions.forEach((i) => {
      i.checked = false;
    })
    this.selectedSR = null;
    // Handle toggling the sensor state
    const newEvent = { ...event, checked: event.checked };
    const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];
    const currentSceneIndex = sensor.scenes.findIndex(scene => scene.checked === event.checked);
    this.toggleSensor(
        collectionIndex,
        sensorIndex,
        currentSceneIndex,
        newEvent,
        sensor.scenes[currentSceneIndex]
    );
  }
  refundStatusCheckSR(superResolution, sensor) {
    let currentScene = this.getCurrentScene(sensor);
    
    // Use the some method to return true if any product matches the condition
    return superResolution.products.some((i) => {
      return i.sceneId === currentScene?.id && (i?.returnRefundAccept || i?.returnRefundReject);
    });
  }
  getCurrentScene(sensor)
  {
    let currentScene;
    currentScene = sensor.scenes.find(scene => scene.checked === true);
    return currentScene;
  }
  refundSRStatus(superResolution: any, sensor:any) {
    let currentScene = this.getCurrentScene(sensor);
    let message = '';

    superResolution.products.forEach((i) => {
      if(i.sceneId === currentScene?.id) {
        if (i?.refundRequest && (i?.returnRefundAccept || i?.returnRefundReject)) {
          let message = 'return-refund-accepted';
          if (i?.returnRefundReject) {
            message = 'return-refund-rejected';
          }
        }
      }
    })
    if(message) {
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    return
  }
  
  hideVessels(datasourceName,clickedEntity,showValue) {    
      const dataSources = this.viewer.dataSources;
      for (let i = 0; i < dataSources.length; i++) {
        const dataSource = dataSources.get(i);
        if (dataSource.name === datasourceName) { // Filter by data source name
          const entities = dataSource.entities.values;
          if (showValue) {
            for (let j = 0; j < entities.length; j++) {
              entities[j].billboard.show = true; // Show all entities in this data source
            }
          } else {
            for (let j = 0; j < entities.length; j++) {
              if (entities[j] !== clickedEntity) {
                entities[j].billboard.show = false; // Keep only the clicked entity visible
              }
            }
          }
        }
      }
  }
  shouldDisableIndices(collectionIndex, sensorIndex, scene, indices) {
    let isDisable: boolean = true;
    const selectedScenes =  this.collections[collectionIndex].sensors[sensorIndex].scenes.filter((i) => i.checked === true);

     if(selectedScenes.length === 1 || this.collections[collectionIndex].sensors[sensorIndex].operatorKey === OPERATORS.AXELSPACE ){
    const hasMatchingScene = selectedScenes.some(scene =>
      indices.products.some(product => {
        return product.sceneId == scene.id && product.status == 'success';
      })
    );
    if(hasMatchingScene)
    {
      isDisable = false;
    }
  }
    return isDisable;
  }
   shouldDisableIndicesHourGlass(collectionIndex, sensorIndex, scene, indices) {

    let isDisable: boolean = true;
    const selectedScenes =  this.collections[collectionIndex].sensors[sensorIndex].scenes.filter((i) => i.checked === true);
     if(selectedScenes.length === 1){
      if(indices?.products.length === 0){
        isDisable = false;
      }else {
        const hasMatchingScene = selectedScenes.some(scene =>
      indices.products.some(product => {
        return product.sceneId == scene.id && product.status == 'success';
      })
    );
    if(hasMatchingScene)
    {
      isDisable = true;
    }else {
      isDisable = false
    }
      }
    
  }
    return isDisable;
  }
  resetCurrentProductLayer() {
    if (this.currentProductLayer || (Array.isArray(this.currentProductLayer) && this.currentProductLayer.length > 0)) {
       this.currentProductLayer.forEach(layer => {
        if (this.viewer.imageryLayers.contains(layer)) {
                    this.viewer.imageryLayers.remove(layer);
                } 
                if (this.viewer.dataSources.contains(layer)) {
                    this.viewer.dataSources.remove(layer, true);
                } 
                 if (this.viewer.scene.primitives.contains(layer)) {
                    this.viewer.scene.primitives.remove(layer);
                }
    });
      this.currentProductLayer = null;
      this.hideLegend();
    }
  }
  selectIndices(collectionIndex, sensorIndex, indicesIndex?, event?, indices?) {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    if(event.checked) {
      this.collections[collectionIndex].sensors[sensorIndex].indicesDetails[indicesIndex].checked = true;
        this.collections[collectionIndex].sensors[sensorIndex].indicesDetails.forEach((detail, idx) => {
    if (idx !== indicesIndex) {
      detail.disabled = true;
    } else {
      detail.disabled = false; 
    }
  });
      this.spinnerService.show();
      this.mapLoad = true;
      this.displayIndices(indices, sensor, event, collectionIndex, sensorIndex)
    } else {
      this.collections[collectionIndex].sensors[sensorIndex].indicesDetails.forEach((detail) => {
        delete detail.disabled;
      });
       this.collections[collectionIndex].sensors[sensorIndex]
      .indicesDetails[indicesIndex].checked = false;
        this.selectedIndices = null;

        //remove legend
        this.resetCurrentProductLayer();
        this.removeBoundingBoxesAndLegends()

        // Handle toggling the sensor state
        const newEvent = { ...event, checked: true };
     const checkedScenes = sensor.scenes
      .map((scene, index) => ({ scene, index }))
      .filter(item => item.scene.checked === true);
    checkedScenes.forEach(({ scene, index }) => {
      this.toggleSensor(
        collectionIndex,
        sensorIndex,
        index,
        newEvent,
        scene
      );
    });
    }
  }
  getFileTypeFromUrl(url: string): 'png' | 'geojson' | 'unknown' {
    try {
      const cleanUrl = url.split('?')[0]; // Remove query params
      const filename = cleanUrl.split('/').pop(); // Get the filename
      if (!filename) return 'unknown';

      const ext = filename.split('.').pop()?.toLowerCase();
      if (ext === 'png') return 'png';
      if (ext === 'geojson' || ext === 'json') return 'geojson';

      return 'unknown';
    } catch {
      return 'unknown';
    }
  }

private initLegendContainer(containerId: string = 'cesiumContainer1'): void {
  const cesiumContainer = document.getElementById(containerId);
  if (!cesiumContainer) return;

  const style = window.getComputedStyle(cesiumContainer);
  if (style.position === 'static') {
    (cesiumContainer as HTMLElement).style.position = 'relative';
  }

  let legend = document.getElementById('cesiumLegendContainer') as HTMLDivElement | null;
  if (!legend) {
    legend = document.createElement('div');
    legend.id = 'cesiumLegendContainer';
    legend.style.position = 'absolute';
    legend.style.bottom = '40px';
    legend.style.left = '5px';
    legend.style.zIndex = '999';
    legend.style.background = 'rgba(0, 0, 0, 0.5)';
    legend.style.padding = '10px';
    legend.style.borderRadius = '5px';
    legend.style.color = 'white';
    legend.style.fontFamily = 'Barlow, sans-serif';
    legend.style.fontSize = '13px';
    // legend.style.maxHeight = '300px';
    legend.style.maxWidth = '260px';
    legend.style.overflowY = 'auto';
    legend.style.display = 'flex';
    legend.style.flexDirection = 'column';
    legend.style.alignItems = 'center';
    legend.style.marginRight= '5px';
    cesiumContainer.appendChild(legend);
  }
  this.legendContainer = legend;
}


private showLegend(html: string): void {
  if (!this.legendContainer) return;
  this.legendContainer.innerHTML = html;
  this.legendContainer.style.display = 'block';
}

private hideLegend(): void {
  if (!this.legendContainer) return;
  this.legendContainer.style.display = 'none';
  this.legendContainer.innerHTML = '';
}

private destroyLegend(): void {
  if (this.legendContainer?.parentElement) {
    this.legendContainer.parentElement.removeChild(this.legendContainer);
  }
  this.legendContainer = null;
}

  displayIndices(indices, sensor, event, collectionIndex, sensorIndex) {
    this.selectedIndices = indices;
    this.selectedScene  = '';
    //Removing last added layer
    var allImageryLayers = this.viewer.imageryLayers._layers;
    while (allImageryLayers.length > 1) {
    this.viewer.imageryLayers.remove(allImageryLayers[allImageryLayers.length - 1]);
  
}

    const currentScenes = sensor.scenes.filter(scene => scene.checked === true);
    this.selectedScene  = currentScenes;
    let ndviObj = this.collections[collectionIndex].sensors[sensorIndex].indicesDetails
          .find((item: any) => item.product === indices.product);
currentScenes.forEach((currentScene, index) => {
 let isLastScene = index === currentScenes.length - 1
            let sensorObj = {
        taskId: this.taskid,
        sensorId: indices.sensorId,
        sceneId: currentScene.id,
        product: indices.product,
        type: 'display'
    };

    
        
    let ndviScene = ndviObj.products.find((scene: any) => scene.sceneId === currentScene.id); 

    this.apiService.getIndicesDataImgUrl(sensorObj).subscribe(async (res: any) => {
        let scnRectangle: any;
        let pngFp: any;
        var bbox = turf.bbox(currentScene.footprint);
        if (ndviScene?.ndvi_png_footprint) {
            pngFp = ndviScene?.ndvi_png_footprint[0];
            scnRectangle = Cesium.Rectangle.fromDegrees(
                pngFp[0],
                pngFp[1],
                pngFp[2],
                pngFp[3]
            );
        } else {
            scnRectangle = Cesium.Rectangle.fromDegrees(
                bbox[0],
                bbox[1],
                bbox[2],
                bbox[3]
            );
        }

        var isIndices = true;
        let legendLeft: any;
        let imgUrl = res.response.imageUrl;
        
        if (!ndviScene?.ndviScale || !imgUrl) {
          imgUrl = res.response.signedUrls[0].imageUrl;
        }
        const fileType = this.getFileTypeFromUrl(imgUrl);
        if (fileType === 'png') {
           isIndices = false;
          const productProvider = new Cesium.ImageryLayer(
              new Cesium.SingleTileImageryProvider({
                  url: imgUrl,
                  rectangle: scnRectangle,
              }), {
              splitDirection: Cesium.SplitDirection.LEFT,
              alpha: 1
          });
          this.viewer.imageryLayers.add(productProvider);
          this.imageryLayerMap.set(productProvider, {
              sceneId: currentScene.id,
              rectangle: scnRectangle,
              taskId: this.taskid,
              sensorId: indices.sensorId
          });

          // Store the current product layer to remove it later
        if (!this.currentProductLayer) {
                this.currentProductLayer = [];
            }
            this.currentProductLayer.push(productProvider);
           // Legend
          let legendRight: any;
          
          let entitylLeft: any
          // const currentMode = this.viewer.scene.mode;
           if (isLastScene) {
          const legendData = {
            minValue: -1.0,
            maxValue: 1.0,
            items: [
              { range: '-1.0 to 0', color: ndviScene.ndviScale[0].color },
              { range: '0 to 0.2', color: ndviScene.ndviScale[0].color },
              { range: '0.2 to 0.4', color: ndviScene.ndviScale[1].color },
              { range: '0.4 to 0.6', color: ndviScene.ndviScale[2].color },
              { range: '0.6 to 0.8', color: ndviScene.ndviScale[3].color },
              { range: '0.8 to 1.0', color: ndviScene.ndviScale[4].color }
            ]
          };
          
          // Manually set the display values from -1.0 to 1.0, including both ends
          const displayValues = [-1.0, 0, 0.2, 0.4, 0.6, 0.8, 1.0];
          this.scaleArray = [];
          let legendItems: any = [];
          
          // Create the scale array based on the legend data
          for (let i = 0; i < legendData.items.length; i++) {
            const item = legendData.items[i];
            
            // Push each item with range, color, and display value from displayValues array
            this.scaleArray.push({
              range: item.range,
              color: item.color,
              displayValue: displayValues[i] // Correct index to align with displayValues
            });
          
            // Collect colors for the gradient
            legendItems.push(item.color);
          }
            this.scaleArray.push({
              range: '1.0 to 1.0',
              color: ndviScene.ndviScale[5].color,
              displayValue: '1.0'
            });
          
          // Reverse the array to ensure the order is correct (if needed)
          this.scaleArray.reverse();
          legendItems.reverse();
          
          // Generate the linear gradient from the legend items
              const pngLegendHtml = `
        <div style="font-weight:600;margin-bottom:8px;">NDVI</div>
        <div style="display:flex;">
          <!-- Color bar -->
          <div style="display:flex;flex-direction:column;height:150px;width:25px;">
            ${this.scaleArray.map((item: any) => `
              <div style="flex:1;background:${item.color};"></div>
            `).join('')}
          </div>
          <!-- Values -->
          <div style="display:flex;flex-direction:column;height:150px;width:35px;justify-content:space-between;padding-left:8px;">
            ${this.scaleArray.map((item: any) => `
              <span style="color:white;font-size:12px;">${item.displayValue}</span>
            `).join('')}
          </div>
        </div>
      `;
      this.showLegend(pngLegendHtml);
            }
        }else if(fileType === 'geojson' && ndviScene) {
          ndviScene.ndviScale = [];
          if (indices.product === 'NDRE') {
            ndviScene.ndviScale = this.ndreData;
          } else if (indices.product === 'NDVI') {
            ndviScene.ndviScale = this.ndviData;
          }
          else if (indices.product === 'NCCI') {
            ndviScene.ndviScale = this.ncciData;
          }
          
          ndviScene.png_footprint =  res.response?.signedUrls[0]?.png_footprint[0];

      try {
        this.spinnerService.show();
        this.mapLoad = true;

         const instances: Cesium.GeometryInstance[] = [];
         const allPositions: Cesium.Cartesian3[] = [];

        const geoJsonData = await fetch(imgUrl).then(res => res.json());

        // Convert FeatureCollection → Cesium hierarchies
        const items = geoJsonToHierarchies(geoJsonData);

        items.forEach(({ hierarchy, properties }) => {
        allPositions.push(...hierarchy.positions);

        const classValue = properties?.value;
        if (classValue === undefined) return;

        const cssColor =
        ndviScene.ndviScale.find(i => i.classValue === classValue)?.color ||
        '#ffffff';

        const color = Cesium.Color.fromCssColorString(cssColor);

        instances.push(
        new Cesium.GeometryInstance({
        geometry: new Cesium.PolygonGeometry({
        polygonHierarchy: hierarchy,
        height: 0,
        perPositionHeight: false
      }),
      attributes: {
        color: Cesium.ColorGeometryInstanceAttribute.fromColor(color)
        }
       })
     );
    });
       if (instances.length > 0) {
       const primitive = new Cesium.Primitive({
       geometryInstances: instances,
       appearance: new Cesium.PerInstanceColorAppearance({
         flat: true,
         translucent: false,
         renderState: {
         depthTest: { enabled: true }
        }
       }),
      asynchronous: true
     });

     this.viewer.scene.primitives.add(primitive);
     this.viewer.scene.globe.depthTestAgainstTerrain = false;

     if (!this.currentProductLayer) {
     this.currentProductLayer = [];
    }
    this.currentProductLayer.push(primitive);

    if (isLastScene && allPositions.length > 0) {
    const bs = Cesium.BoundingSphere.fromPoints(allPositions);
    this.viewer.camera.flyToBoundingSphere(bs, { duration: 2 });
    }
   }
          if (isLastScene) {
            if( indices.product === 'NDVI') {
              this.showIndicesCode(indices);
            } else if (indices.product === 'NDRE'  || indices.product === 'NCCI') {
          const infoIconHtml = indices?.products[0]?.message && indices?.products[0]?.message !== '' && indices?.products[0]?.message !== undefined || null
           ? `
         <span class="legend-info" aria-label="Index info">
         ℹ
         <span class="legend-tooltip">
         ${indices?.products[0]?.message}
      </span>
     </span>
      `
      : '';
const classLegendHtml = `
  <div style="
    display:flex;
    align-items:center;
    justify-content:space-between;
    font-weight:600;
    margin-bottom:8px;
  ">
    <span>${indices.product}</span>

    ${infoIconHtml}
  </div>

  ${ndviScene.ndviScale.map((item: any) => `
    <div style="display:flex;align-items:center;margin-bottom:4px;">
      <div style="
        width:18px;
        height:18px;
        margin-right:8px;
        border:1px solid white;
        background:${item.color};
      "></div>
      <span>${item.label}</span>
    </div>
  `).join('')}
`;
        this.showLegend(classLegendHtml);
          }
     }

      } catch (error) {
          console.error('Failed to load NDVI GeoJSON as Primitive:', error);
      } finally {
          this.spinnerService.hide();
          this.mapLoad = false;
      }

        }
          let boundingBox = fileType === 'geojson' ? ndviScene?.png_footprint :ndviScene?.ndvi_tif_footprint;
          let entitylLeftBB: any;
          if (boundingBox && !isIndices) {
            entitylLeftBB = this.viewer.entities.add({
              polyline: {
                positions: Cesium.Cartesian3.fromDegreesArray(boundingBox),
                clampToGround: true,
                material: new Cesium.PolylineOutlineMaterialProperty({
                  outlineWidth: 8,
                  outlineColor: Cesium.Color.YELLOW
                }),
              }
            });
            entitylLeftBB.sceneId = ndviScene?.sceneId;
            this.scnLyr.push(entitylLeftBB);
          }

        if (entitylLeftBB && isLastScene) {
          this.viewer.zoomTo(entitylLeftBB);
        }
        this.spinnerService.hide();
        this.mapLoad = false;
    });
        
    });

          

    
  }
  
  showIndicesCode(indices) {
    const legendData = {
            minValue: -1.0,
            maxValue: 1.0,
            items: this.selectedIndices.product === 'NDVI' ? this.ndviData : this.ncciData
          };
          
          // Manually set the display values from -1.0 to 1.0, including both ends
          //const displayValues = [-1.0, 0, 0.2, 0.4, 0.6, 0.8, 1.0];
          this.scaleArray = [];
          let legendItems: any = [];
          
          // Create the scale array based on the legend data
          for (let i = 0; i < legendData.items.length; i++) {
            const item = legendData.items[i];
            
            // Push each item with range, color, and display value from displayValues array
            this.scaleArray.push({
              range: item.range,
              color: item.color,
              displayValue: item.label // Correct index to align with displayValues
            });
          
            // Collect colors for the gradient
            legendItems.push(item.color);
          }
            // this.scaleArray.push({
            //   range: '1.0 to 1.0',
            //   color: ndviScene.ndviScale[5].color,
            //   displayValue: '1.0'
            // });
          
          // Reverse the array to ensure the order is correct (if needed)
          //this.scaleArray.reverse();
          //legendItems.reverse();
          
          // Generate the linear gradient from the legend items
          const infoIconHtml = indices?.products[0]?.message && indices?.products[0]?.message !== '' && indices?.products[0]?.message !== undefined || null
         ? `
    <span class="legend-info" aria-label="Index info">
      ℹ
      <span class="legend-tooltip">
         ${indices?.products[0]?.message}
      </span>
    </span>
  `
  : '';
const pngLegendHtml = `
  <div style="
    display:flex;
    align-items:center;
    justify-content:space-between;
    font-weight:600;
    margin-bottom:8px;
  ">
    <span>${indices.product}</span>

    ${infoIconHtml}
  </div>

  ${this.scaleArray.map((item: any) => `
    <div style="display:flex;align-items:center;margin-bottom:4px;">
      <div style="width:18px;height:18px;margin-right:8px;border:1px solid white;background:${item.color};"></div>
      <span>${item.displayValue}</span>
    </div>
  `).join('')}
`;
      this.showLegend(pngLegendHtml);
  }
  isDownloadedIndices(indices, sensor, scene) {
    let currentScene = sensor.scenes.filter(scene => scene.checked === true);
    if(currentScene.length > 1) return false;
    return indices.products.some(element => {
      return element.sceneId === currentScene[0]?.id && element.isDownloaded;
    });
  }
  refundStatusCheckIndices(indices, sensor) {
    let currentScene = this.getCurrentScene(sensor);
    
    // Use the some method to return true if any product matches the condition
    return indices.products.some((i) => {
      return i.sceneId === currentScene?.id && (i?.returnRefundAccept || i?.returnRefundReject);
    });
  }
  refundIndicesStatus(indices: any, sensor:any) {
    let currentScene = this.getCurrentScene(sensor);
    let message = '';

    indices.products.forEach((i) => {
      if(i.sceneId === currentScene?.id) {
        if (i?.refundRequest && (i?.returnRefundAccept || i?.returnRefundReject)) {
          let message = 'return-refund-accepted';
          if (i?.returnRefundReject) {
            message = 'return-refund-rejected';
          } 
        }
      }
    })
    if(message) {
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    return
  }
  OpenReturnRequestIndices(collectionIndex, sensorIndex, indices) {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const taskId = this.collections[collectionIndex]?.taskId;
    let currentScene = this.getCurrentScene(sensor);
    let sceneId: any = currentScene?.id;
    let sensorId: any = sensor?.id;
    let product = indices.product;
    let sensorObj = {
      taskId, sensorId, sceneId, product
    }
  
    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (res?.status === "found") {
        let message =  'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }
  
        if (res?.returnRefundReject || (res?.returnRefundAccept)) {
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          return
        } else {
          this.handleRefundRequestSR(currentScene, taskId, sensorId, sceneId, product, indices);
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      }
    });
  }

  downloadIndices(indices, collectionIndex, sensor, sensorIndex)
  {
    const currentScene = sensor.scenes.find(scene => scene.checked === true);
    let isDownloaded = indices.products.some(element => {
      return element.sceneId === currentScene.id && element.isDownloaded;
    });
    let isAxelSensor = sensor.checked == true && sensor.operatorKey === OPERATORS.AXELSPACE;
    if (this.freeze) {
      const message = 'A download is in progress. Please wait until the current download finishes to continue downloading others.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    } else if (isDownloaded) {
      const message = 'download_vadp';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    } else {
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      this.currentDownloadingIndices = { 
        collectionIndex: collectionIndex, 
        sensorIndex:  sensorIndex,
        sceneId : currentScene.id,
        product: indices.product
      };
  
      let sensorObj = {
        taskId: this.taskid,
        sensorId: indices.sensorId,
        sceneId: currentScene.id,
        product: indices.product,
        type: 'download',
        isSensor: isAxelSensor
    };

    this.apiService.getIndicesDataImgUrl(sensorObj).subscribe(async (res: any) => {
        let url = res.response.imageUrl;
        if (!url) {
          url = res.response.signedUrls[0].imageUrl;
        }
        if(url) {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url);
          xhr.responseType = 'blob';
    
          xhr.onprogress = (event) => {
            if (event.lengthComputable) {
              const percentComplete = ((event.loaded / event.total) * 100);
              this.progress = percentComplete.toFixed(2);
              const sensorObj = { 
                progress: this.progress, 
                taskId: this.collections[collectionIndex].taskId, 
                sensorId: sensor.id,
                sceneId: currentScene.id, 
                download: this.downloadClick, 
                product: indices.product
              };
              this.downloadService.setProgress(sensorObj);
            }
          };
    
          xhr.onload = () => {
            if (xhr.status === 200) {
              const blob = xhr.response;
              const fileName = this.getFileNameFromS3SignedUrl(url);
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              URL.revokeObjectURL(link.href);
    
              // Reset progress after download
              this.progress = 0;
              this.spinnerService.hide();
              this.freeze = false;
              this.disable = false;
            } else {
            this.showDownloadError();
            }
          };
    
          xhr.onerror = () => {
            // Handle errors
          this.showDownloadError();
          };
          xhr.send();
        }
      }) 
    }
  }
  setDownloadedIndices()
  {
    this.collections[this.currentDownloadingIndices.collectionIndex].sensors[this.currentDownloadingIndices.sensorIndex].indicesDetails.forEach((row) => {
      if(row.product == this.currentDownloadingIndices.product) {
        (row.products || []).forEach((item) =>  {
          if(item.sceneId === this.currentDownloadingIndices.sceneId) {
            item.isDownloaded = true;
          }
        });
      }
    })
    this.currentDownloadingIndices = {};
  }
  resetIndicesOptions(collectionIndex, sensorIndex, event) {
    this.collections[collectionIndex]?.sensors[sensorIndex].indicesDetails.forEach((i) => {
      i.checked = false;
    })
    this.selectedIndices = null;
    if (this.currentProductLayer) {
        this.viewer.imageryLayers.remove(this.currentProductLayer);
        this.currentProductLayer = null;
    }
    this.removeBoundingBoxesAndLegends()
    this.resetCurrentProductLayer();

    if (this.currentEntity) {
        this.viewer.entities.remove(this.currentEntity);
        this.currentEntity = null;
    }

    // Handle toggling the sensor state
    const newEvent = { ...event, checked: event.checked };
    const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];
    const matchingScenes = sensor.scenes
    .map((scene, index) => ({ scene, index }))
    .filter(item => item.scene.checked === event.checked);
  matchingScenes.forEach(({ scene, index }) => {
    this.toggleSensor(
      collectionIndex,
      sensorIndex,
      index,
      newEvent,
      scene
    );
  });

  }
  // Function to remove bounding boxes and legends
  removeBoundingBoxesAndLegends() {
    if(this.legendContainer) this.legendContainer.style.display = 'none';
    // Loop through the array and remove each entity
    for (let entity of this.scnLyr) {
        this.viewer.entities.remove(entity);
    }
    // Clear the array after removing entities
    this.scnLyr = [];
  }

  selectSite(item: number) {    
    this.filteredCollection = [];
    const collection = this.fullCollection;
    this.subDailyCountarray = []
    this.defaultSubdailyCount = item;
    let scenesList: any = [];
    this.collection.siteData = [];
    this.clearAnnotations();
    this.annotateClicked = false;
    this.imageLoaded = false;
    this.imageryLayerMap.clear();
    this.boundingBoxMap.clear();
    this.newTaskButtonClicked = false;
    this.selectedRecurrency = null;   
    
    for (const [sensorIndex, sensors] of collection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        if (scenes?.siteId == item) {
          sceneArray.push(scenes);
        }
      }

      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });

      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;

      if (sensors.siteData) {
        this.collection.siteData = sensors.siteData;
      }
    }
    this.filteredCollection = JSON.parse(JSON.stringify(this.collection));

    for (const [siteIndex, site] of this.collection?.siteData.entries()) {
      site.checked = false;
      site.value = siteIndex + 1;
      site.siteId = siteIndex + 1;
    }
    this.subDailyCountarray = this.collection?.siteData;
    this.filteredCollection = JSON.parse(JSON.stringify(this.collection));

    this.splitPosition = 1;
    this.clearBandLegends();
    this.USLscnLyr = [];
    if (this.selectedType != 'dateDropdown') {
    this.viewer.entities.removeAll();
    this.resetBackgroundWithChangeInBaseLayer();
    }

    this.selectRecurrency(this.collection?.recurrencyArray[0], 'normal');
    this.selectedRecurrency = this.collection?.recurrencyArray[0] || null;
  }

  selectRecurrency(event, type: any) {
    let scenesList: any = [];
    const collection = this.fullCollection;
    this.sceneBands = '';
    this.signalBands = '';
    this.bandTaskId = '';
    this.bandSensorId = '';
    this.signalSensorId = '';
    this.selectedStartDate = '';
    this.selectedEndDate = '';
    this.imageryLayerMap.clear();
    this.boundingBoxMap.clear();
    
    const startDate = new Date(event.start);
    const endDate = new Date(event.end);
    this.selectionChange.next(event);

    this.selectedStartDate = event.start;
    this.selectedEndDate = event.end;

    this.clearAnnotations();
    this.annotateClicked = false;
    this.imageLoaded = false;
    this.newTaskButtonClicked = false;

      for (const [sensorIndex, sensors] of this.filteredCollection.sensors.entries()) {
        let sceneArray: any = [];

        for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
          let datePredicted = new Date(scenes.predictedDate);
          const predictedDate = scenes.predictedDate;

          scenes.checked = false;
          if (event?.repeatFrequency === 'Daily' && (datePredicted >= startDate && datePredicted <= endDate)) {
            sceneArray.push(scenes);
          } else if (event?.repeatFrequency === 'Sub-daily' && predictedDate !== undefined) {
            const PredictedDateOnly = new Date(scenes.predictedDate).toISOString().split('T')[0];
            const startDateOnly = new Date(startDate).toISOString().split('T')[0];
            const endDateOnly = new Date(endDate).toISOString().split('T')[0];
            if (PredictedDateOnly == startDateOnly && PredictedDateOnly == endDateOnly) {
              sceneArray.push(scenes);
            }
          } else if (datePredicted >= startDate && datePredicted <= endDate) {
            sceneArray.push(scenes);
          }
        }

        sceneArray.forEach((element, index) => {
          element.sceneIdx = index + 1;
          if (element?.id != null && element?.status != 'failed') {
            scenesList.push({ id: element.id });
          }
        });

        this.collection.sensors[sensorIndex].scenesList = scenesList;
        this.collection.sensors[sensorIndex].scenes = sceneArray;
      }

    if ((type !== 'split' && ((this.previousSelection !== null && JSON.stringify(this.previousSelection) !== JSON.stringify(event)) || this.previousSelection === null)) || type === 'split') {
      this.previousSelection = event;
      if (type != 'split') {
        this.splitPosition = 1;
        this.viewer.entities.removeAll();
        this.clearBandLegends();
        this.USLscnLyr = [];
      
        this.resetBackgroundWithChangeInBaseLayer();
      }
    }
  }
  OpenReturnRequestSR(collectionIndex, sensorIndex, superResolution) {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const taskId = this.collections[collectionIndex]?.taskId;
    let currentScene = this.getCurrentScene(sensor);
    let sceneId: any = currentScene?.id;
    let sensorId: any = sensor?.id;
    let product = superResolution.product;

    let sensorObj = {
      taskId, sensorId, sceneId, product
    }
  
    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (res?.status === "found") {
        let message =  'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }
  
        if (res?.returnRefundReject || (res?.returnRefundAccept)) {
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          return
        } else {
          this.handleRefundRequestSR(currentScene, taskId, sensorId, sceneId, product, superResolution);
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      }
    });
  }
  handleRefundRequestSR(scene, taskId, sensorId, sceneId, product, superResolution) {
      const dialog = this.matdialog.open(ReturnRefundComponent, {
        minWidth: '50%',
        data: {type: 'return', taskId: taskId, sensorId: sensorId, sceneId: sceneId, product: product,
          action: 'vadp'
        },
        backdropClass: 'blurred',
        disableClose: true
      });
  
      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          const message = 'return-refund-success';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          this.refundRequestSR.push({sensorId: sensorId, sceneId: sceneId, product: superResolution?.product});
          this.valueAddedProductLocalUpdateSR(sensorId, sceneId, superResolution?.product);
        }
      });
  }
  valueAddedProductLocalUpdateSR(sensorId:any, sceneId:any, product:any)
  {
    (this.collections || []).forEach((item) => {
      (item.sensors || []).forEach(sensor => {
        if(sensor.id === sensorId)
        {
          (sensor.superResolutions || []).forEach(element => {
            if(element.product === product)
            {
              (element.products || []).forEach((row) => {
                if(row.sceneId === sceneId) {
                  row.refundRequest = true;
                }
              })
            }
          });
        }
      });
    })
  }

  getRefundStatus(sensor) {
    let status = sensor?.operatorKey == OPERATORS.AZISTA && sensor.downloaded;
    return status;
  }

  inactivateRefundStatus(sensor) {
    let status = sensor?.operatorKey == OPERATORS.AZISTA && !sensor.downloaded;
    return status;
  }
  refundVADP(collectionIndex, sensorIndex,sensor) {
    const taskId = this.collections[collectionIndex]?.taskId;
    let sensorId: any = sensor?.id;
    let productVadp = 'vadp';
    let action = 'all';
    if (sensor?.superResolutions?.length > 0) productVadp = 'Super Resolution';
    let product = sensor?.operatorKey === OPERATORS.AZISTA ? OPERATORS.AZISTA : productVadp;
    let sensorObj = {
      taskId, sensorId, product, action
    }

    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (res?.status === "found") {
        if (res?.refund) {
          let message =  'return-refund-accepted';
          if (res?.returnRefundReject) {
            message = 'return-refund-rejected';
          }
    
          if (res?.returnRefundReject || (res?.returnRefundAccept)) {
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            return
          }
        } else {
          const dialog = this.matdialog.open(ReturnRefundComponent, {
            minWidth: '50%',
            data: {type: 'return', taskId: taskId, sensorId: sensorId, product: product,
              action: action
            },
            backdropClass: 'blurred',
            disableClose: true
          });
      
          dialog.afterClosed().subscribe((result) => {
            if (result != 'close') {
              const message = 'return-refund-success';
              this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
              for (const sensor of this.collection.sensors || []) {
                for (const option of sensor.valueAddedOption || []) {
                  option.refundRequest = true;
                }
                
                for (const option of sensor.superResolutions || []) {
                  option.refundRequest = true;
                }
              }
            }
          });
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return
      }
    });
  }

  checkForDelivered(sensor) {
   let vadpRefund: boolean = false;
   let srRefund: boolean = false;

   if (sensor?.valueAddedOption?.length > 0) {
    vadpRefund = sensor.valueAddedOption.every(item => item.product_status === "DELIVERED");
   } else if (sensor?.superResolutions?.length > 0){
      if (sensor?.superResolutions[0]?.product_status === 'DELIVERED') {
        srRefund = true;
      }
   }

   return srRefund || vadpRefund;
  }

  checkForRelease (sensor) {
    let vadp: boolean = false;
    let sr: boolean = false;
 
    if (sensor?.valueAddedOption?.length > 0) {
      vadp = sensor.valueAddedOption.every(item => item?.releaseRequest == true);
    } else if (sensor?.superResolutions?.length > 0){
       if (sensor?.superResolutions[0]?.releaseRequest == true) {
        sr = true;
       }
    }
 
    return vadp || sr;
  }

  checkForRefund (sensor) {
    let vadpRefund: boolean = false;
    let srRefund: boolean = false;
 
    if (sensor?.valueAddedOption?.length > 0) {
     vadpRefund = sensor.valueAddedOption.every(item => item.returnRefundReject) || 
     sensor.valueAddedOption.every(item => item.returnRefundAccept);
    } else if (sensor?.superResolutions?.length > 0){
      srRefund = sensor?.superResolutions[0].products.some((i) => i.returnRefundReject) ||
      sensor?.superResolutions[0].products.some((i) => i.returnRefundAccept);
    }
 
    return srRefund || vadpRefund;
  }

  displayProperties(signal) {
  const tooltip = document.getElementById('feedTooltip');

  if (this.signalhHandlers) {
    this.signalhHandlers.destroy();
  }

  this.signalhHandlers = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);

  this.signalhHandlers.setInputAction((movement) => {
    const pickedObject = this.viewer.scene.pick(movement.endPosition);
    const entity = pickedObject?.id;

    if (
      entity && entity.properties &&
      (entity?.type === 'spire' || entity?.type === 'clyde' ||
        entity?.name === 'broRf' ||
        (entity?.name === 'signal' &&
          entity.properties['title'] &&
          entity.properties['title'].getValue() === "Estimated Emitter and Error Ellipse"))
    ) {
      if (!tooltip) return;

      let content = '';

      // Build content
      if (entity?.type === 'spire' || entity?.type === 'clyde') {
        entity.properties.propertyNames.forEach(propertyName => {
          content += `<strong>${propertyName} : </strong> ${entity.properties[propertyName]}<br>`;
        });
      } else if (entity?.name === 'signal') {
        const lon = entity.properties.lon?.getValue();
        const lat = entity.properties.lat?.getValue();
        const utc = entity.properties.utc?.getValue();
        const errorRadius = entity.properties['error_radius']?.getValue();
        const signalValue = entity.properties[signal]?.getValue
          ? entity.properties[signal].getValue()
          : entity.properties[signal];

        content += `<strong>Signal:</strong> ${signalValue}<br>`;

        if (lon !== undefined) {
          content += `<strong>Lng:</strong> ${lon}<br>`;
        }
        if (lat !== undefined) {
          content += `<strong>Lat:</strong> ${lat}<br>`;
        }
        if (utc) {
          let date = new Date(utc).toISOString();
          content += `<strong>Timestamp UTC:</strong> ${date}<br>`;
        }
        if (errorRadius !== undefined) {
          content += `<strong>Error radius:</strong> ${errorRadius.toFixed(2)}<br>`;
        }

      } else if (entity?.name === 'broRf') {
        entity.properties.propertyNames.forEach(propertyName => {
          content += `<strong>${propertyName} : </strong> ${entity.properties[propertyName]}<br>`;
        });
      }

      tooltip.innerHTML = content;
      
      tooltip.style.position = 'absolute';
      tooltip.style.display = 'block';
      tooltip.style.fontSize = '15px';
      tooltip.style.fontFamily = '"Barlow", sans-serif';
      tooltip.style.lineHeight = '1.8';
      this.tooltipHandlers(tooltip, movement);
    } else if (tooltip) {
      tooltip.style.display = 'none';
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
}


tooltipHandlers(tooltip, mouseMove: any) {
  if (!tooltip || !mouseMove) return;

  // 1) Compute scale between canvas drawing buffer and CSS size
  const canvas = this.viewer.scene.canvas;
  const parent = canvas.parentElement as HTMLElement;          // tooltip should be appended here
  if (!parent) return;

  // Make sure the parent is the positioning context
  if (getComputedStyle(parent).position === 'static') {
    parent.style.position = 'relative';
  }

  // Cesium canvas actual pixels vs CSS pixels (HiDPI fix)
  const scaleX = canvas.clientWidth  / canvas.width  || 1;     // ≈ 1 / devicePixelRatio
  const scaleY = canvas.clientHeight / canvas.height || 1;

  // 2) Convert endPosition (drawing-buffer px) → CSS px in the same space as parent
  let left = mouseMove.endPosition.x * scaleX;
  let top  = mouseMove.endPosition.y * scaleY;

  // 3) Measure tooltip to clamp inside parent
  const margin = 10;
  tooltip.style.visibility = 'hidden';
  tooltip.style.display = 'block';

  const W = parent.clientWidth;
  const H = parent.clientHeight;
  const w = tooltip.offsetWidth;
  const h = tooltip.offsetHeight;

  // Prefer bottom-right; clamp if needed
  left += margin;
  top  += margin;

  if (left + w + margin > W) left = Math.max(margin, W - w - margin);
  if (top  + h + margin > H) top  = Math.max(margin, H - h - margin);

  // 4) Apply
  tooltip.style.left = `${left}px`;
  tooltip.style.top  = `${top}px`;
  tooltip.style.visibility = 'visible';
}


  destroyHandlers() {
    const mapContainer = document.getElementById('cesiumContainer1');
    const tooltip = document.getElementById('feedTooltip');

    if (mapContainer && tooltip) {
      mapContainer.addEventListener('mouseleave', () => {
        tooltip.style.display = 'none';
      });
    }
  }

  displayRefreshData(event,scene,sensor,action,refreshData) {
    if (event?.checked || action === 'download') {
      this.displaySpireRefreshData(scene, action,sensor,refreshData);
    } else {
      this.removeDataSourceById("aisData", refreshData.refreshId);
      this.removeEntitiesByName(refreshData.refreshId);
      if(this.isObservation(sensor)) {
        const updated = { ...this.selectedHistory };
        delete updated[refreshData.refreshId];
        this.selectedHistory = updated;
      }
    }

    if (action === 'display') {
      for (const [index, history] of sensor.refreshHistory.entries()) {
        if (history.refreshId === refreshData.refreshId) {          
          history.checked = event.checked;
          break;
        }
      }
    }
  }

  isObservation(sensor: any) {
    return sensor?.tnqSensorType === 'Tipping' && sensor?.Observation.length > 0 && (sensor?.Observation[0]?.ais_observation === true || sensor?.Observation[0]?.rf_observation === true);
  }

  displaySpireRefreshData(scene: any, type: any, sensor: any, refreshData: any) {
    let sensorId;
    let taskId;
    let currentCrossImage: any,boundingBox,item,iconCanvas,iconUrl;

    sensorId = sensor.id;

    if (sensor.operatorKey === OPERATORS.SPIRE) {
      currentCrossImage = 'assets/images/hot-pink.png';
      item = 'SPIRE';
    }
    else {
      currentCrossImage = 'assets/images/light-blue.png';
      item = 'CLYDE';
      iconCanvas = this.createHistoricalNavigationIcon('Orange');
      iconUrl = iconCanvas.toDataURL();
    }

      taskId = this.collection?.taskId;
      const aisReq = {
        sensorId: sensorId,
        refreshId: refreshData?.refreshId,
        taskid: taskId,
        action: type
      }
      if (type !== 'download') {
        this.spinnerService.show();
        this.mapLoad = true;
      }

      this.apiService.getAISRefreshData(aisReq).subscribe((res: any) => {

        if (type !== 'download') {
          this.spinnerService.show();
          this.mapLoad = true;
        }

        if (res?.msg === 'failed') {
          const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          this.spinnerService.hide();
          this.mapLoad = false;
          this.freeze = false;
        } else {
          this.httpClient.get(res?.result?.imageUrl).subscribe(
            (data) => {
              const updatedAis = this.convertToGeoJSON(data, item);
              if (this.isObservation(sensor)) {
                this.selectedHistory = {
                  ...this.selectedHistory,
                  [refreshData.refreshId]: updatedAis
                };
              }
              // Add the bounding box as a new feature to the existing GeoJSON FeatureCollection
              let BBpoints = scene?.footprint?.coordinates[0];
              if (type === 'download') {
                // Check if the bounding-box feature is already added
                const boundingBoxExists = updatedAis.features.some(feature => feature.id === 'bounding-box');
              
                if (!boundingBoxExists) {
                  updatedAis.features.push({
                    type: 'Feature',
                    id: 'bounding-box',
                    geometry: {
                      type: 'Polygon',
                      coordinates: [BBpoints], // Directly use BBpoints as it is an array of [lon, lat] pairs
                    },
                    properties: {
                      description: 'Bounding Box',
                    },
                  });
                }
              } else if (type === 'display') {
                // Remove the bounding box feature if it exists
                updatedAis.features = updatedAis.features.filter(feature => feature.id !== 'bounding-box');
              }

              if (type === 'display') {
                this.resetBackgroundWithChangeInBaseLayer();
                let shipType,iconColor,iconCanvas;
                const selectData = Cesium.GeoJsonDataSource.load(updatedAis);
                selectData.then((dataSource: CustomGeoJsonDataSource) => {
                  dataSource.refreshId = refreshData?.refreshId;
                  dataSource.name = 'refreshDataSource';
                  dataSource.type = sensor.operatorKey;

                  const entities = dataSource.entities.values;
                  for (let j = 0; j < entities.length; j++) {
                    const entity = entities[j] as CustomEntity;
                    entity.name = 'refreshData';
                    entity.type = 'spire';
                    
                    if (entity.properties) {
                      if (sensor.operatorKey === OPERATORS.SPIRE) {
                        shipType = entity.properties['Ship Type'].getValue() || 'OTHER';
                        iconColor = this.utilsService.getHistoricalShipColor(shipType);
                        iconCanvas = this.createHistoricalNavigationIcon(iconColor);
                        iconUrl = iconCanvas.toDataURL();
                      }

                      const course = entity.properties['Course']?.getValue(); // Get the course value

                      entity.billboard = new Cesium.BillboardGraphics({ 
                        image: iconUrl,
                        show: true,
                        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
                        alignedAxis: Cesium.Cartesian3.ZERO,
                        width: 22,
                        height: 22,
                        // Add rotation based on course
                        rotation: course ? Cesium.Math.toRadians(-course) : 0, // Negative because Material Icon 'navigation' points up by default
                        // Keep icon oriented with screen
                        pixelOffset: new Cesium.Cartesian2(0, 0),
                        // Ensure icon stays upright relative to screen
                        verticalOrigin: Cesium.VerticalOrigin.CENTER,
                        horizontalOrigin: Cesium.HorizontalOrigin.CENTER
                      });

                      entity.show = this.refreshFilterObject ? this.checkEntityExist(entity,this.refreshFilterObject) : true
                    }
                  }

                    boundingBox = BBpoints.toString().split(',').map(Number);
              
                    this.viewer.entities.add({
                      name: refreshData?.refreshId,
                      polyline: {
                        positions: Cesium.Cartesian3.fromDegreesArray(boundingBox),
                        clampToGround: true,
                        material: new Cesium.PolylineOutlineMaterialProperty({
                          outlineWidth: 3,
                          outlineColor: Cesium.Color.fromRandom({
                            alpha: 1.0,
                          }),
                        }),
                      },
                    });

                  this.spinnerService.hide();
                  this.mapLoad = false;

                  this.viewer.dataSources.add(dataSource);
                  this.viewer.scene.globe.depthTestAgainstTerrain = false;
                  this.viewer.flyTo(dataSource, { duration: 3 });
                });

                let tooltip = document.getElementById('feedTooltip');
                if (this.refreshHandler) {
                  this.refreshHandler.destroy();
                }
                // Add click event listener                
                let previousEntity = null;
                this.refreshHandler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);

                this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
                // Add hover event listener for tooltip
                this.refreshHandler.setInputAction((movement) => {
                  const pickedObject = this.viewer.scene.pick(movement.endPosition);
                  const entity = pickedObject?.id;

                  if (entity && entity.properties && entity?.name != 'annotation' && entity?.name != 'signal') {
                    if (tooltip) {
                      let content = '';
                      entity.properties.propertyNames.forEach(propertyName => {
                        content += `<strong>${propertyName} : </strong> ${entity.properties[propertyName]}<br>`;
                      });
                      tooltip.innerHTML = content;
                      tooltip.style.fontSize = '15px';
                      tooltip.style.fontFamily = 'Barlow", sans-serif';
                      tooltip.style.lineHeight = '1.8';
                      tooltip.style.display = 'block';
                      this.tooltipHandlers(tooltip, movement);
                    }
                  } else if (tooltip) {
                    tooltip.style.display = 'none';
                  }
                }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);


              } else if (type === 'download') {
                const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: this.downloadClick, action: 'aisDownload' };
                this.downloadService.setProgress(sensorObj);
                const blob = new Blob([JSON.stringify(updatedAis)], { type: 'application/json' });
                const url = window.URL.createObjectURL(blob);
                const fileName = res?.result?.imageUrl.split('/').pop().split('?')[0];
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                link.click();

                // Clean up
                window.URL.revokeObjectURL(url);
                this.progress = 0;
                this.spinnerService.hide();
                this.freeze = false;
                this.disable = false;
              }
            },
            (error) => {
            }
          );
        }
      });
  }

  filterByDate() {
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%', backdropClass: 'blurr',
      disableClose: true,
      data: {type:'date', startDate: this.collection?.openWindow, endDate: this.collection?.closeWindow,currentUser: this.currentUser}
    });
    dialogRef.afterClosed().subscribe((result) => {         
      if (result) {
        this.filterStart = this.formatDates(result.start);
        this.filterEnd = this.formatDates(result.end);
        this.dateRangeArray = [];
        this.clearBandLegends();
        this.removeImages();
        this.viewer.entities.removeAll();
        this.currentSliderValue = 0;
        this.sliderShow = false;
        this.previousIndex = -1;
        this.filterEnd = this.formatDates(result.end);
        this.groupedScenes = this.groupCollections();
      } else {
      }
    });
   }

   formatDates(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
   }
   
  AISDownload(sensor: any) {    
    let sensorId;
    let taskId;
    let currentCrossImage: any;
    let downloadAction: any;

    sensorId = sensor.id;
    taskId = this.collection?.taskId;
      const aisReq = {
        sensorId: sensorId,
        taskid: taskId,
        action: 'zipDownload'
      }
     
     if (sensor?.operatorKey === OPERATORS.CLYDE) downloadAction = 'aisDownload';
     else downloadAction = '';

      this.apiService.getAISRefreshData(aisReq).subscribe((res: any) => {        
        if (res?.msg === 'failed') {
          const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
          this.spinnerService.hide();
          this.mapLoad = false;
          this.freeze = false;
        } else {
                let url = res.result?.imageUrl;
        
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url);
                xhr.responseType = 'blob';
        
                xhr.onprogress = (event) => {
                  if (event.lengthComputable) {
                    const percentComplete = ((event.loaded / event.total) * 100);
                    this.progress = percentComplete.toFixed(2);
                    const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: sensor.scenes[0].id, download: this.downloadClick, action: downloadAction };
                    this.downloadService.setProgress(sensorObj);
                  }
                };
        
                xhr.onload = () => {
                  if (xhr.status === 200) {
                    const blob = xhr.response;
                    const fileName = this.getFileNameFromS3SignedUrl(url);
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    URL.revokeObjectURL(link.href);
        
                    // Reset progress after download
                    this.progress = 0;
                    this.spinnerService.hide();
                    this.freeze = false;
                    this.disable = false;
                  } else {
                 this.showDownloadError();
            }
                };
        
                xhr.onerror = () => {
                  // Handle errors
                this.showDownloadError();
                };
                xhr.send();
        }
      });
  }
  
  // filterByDate() {
  //   const dialogRef = this.matdialog.open(FilterPopupComponent, {
  //     width: '35%', backdropClass: 'blurr',
  //     disableClose: true,
  //     data: {type:'date', startDate: this.collection?.openWindow, endDate: this.collection?.closeWindow, currentUser: this.currentUser}
  //   });
  //   dialogRef.afterClosed().subscribe((result) => {         
  //     if (result) {
  //       this.filterStart = this.formatDates(result.start);
  //       this.filterEnd = this.formatDates(result.end);
  //       this.dateRangeArray = [];
  //       this.clearBandLegends();
  //       this.removeImages();
  //       this.viewer.entities.removeAll();
  //       this.currentSliderValue = 0;
  //       this.sliderShow = false;
  //       this.previousIndex = -1;
  //       this.filterEnd = this.formatDates(result.end);
  //       this.groupedScenes = this.groupCollections();
  //     } else {
  //     }
  //   });
  //  }

  //  formatDates(date: Date): string {
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const hours = String(date.getHours()).padStart(2, '0');
  //   const minutes = String(date.getMinutes()).padStart(2, '0');
  //   const seconds = String(date.getSeconds()).padStart(2, '0');
  //   return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
  //  }

  // createNavigationIcon(color: string, style: 'filled' | 'dotted' | 'dashed' = 'filled', glow: boolean = false): HTMLCanvasElement {
  //   const canvas = document.createElement('canvas');
  //   const size = 24;
  //   canvas.width = size;
  //   canvas.height = size;

  //   const ctx = canvas.getContext('2d');
  //   if (!ctx) return canvas;

  //   ctx.font = '24px "Material Icons"';
  //   ctx.textAlign = 'center';
  //   ctx.textBaseline = 'middle';

  //   // --- line styles ---
  //   if (style === 'dotted') ctx.setLineDash([1, 3]);
  //   else if (style === 'dashed') ctx.setLineDash([4, 4]);
  //   else ctx.setLineDash([]);

  //   // --- Glow effect ---
  //   if (glow) {
  //     ctx.shadowColor = '#fffff';
  //     ctx.shadowBlur = 30;   // increased blur for visibility
  //     ctx.shadowOffsetX = 0;
  //     ctx.shadowOffsetY = 0;
  //   }

  //   // --- main stroke ---
  //   ctx.strokeStyle = color;
  //   ctx.lineWidth = style === 'dotted' ? 2.2 : 1.8;
  //   ctx.strokeText('\ue55d', size / 2, size / 2);

  //   // reset shadow to avoid affecting future icons
  //   ctx.shadowBlur = 0;
  //   return canvas;
  // }

  createNavigationIcon(
  color: string,
  style: 'filled' | 'dotted' | 'dashed' = 'filled',
  glow: boolean = false
): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  const size = 70;
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');
  if (!ctx) return canvas;

  //ctx.font = '24px "Material Icons"';
  ctx.font = `70px "Material Icons"`; // scale font automatically
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // --- Glow effect (apply before drawing) ---
  if (glow) {
    ctx.shadowColor = color;
    ctx.shadowBlur = 18;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
  }

  if (style === 'filled') {
    // FILLED ARROW
    ctx.fillStyle = color;
    ctx.fillText('\ue55d', size / 2, size / 2);
  } else {
    // DOTTED / DASHED ARROW - stroked
    ctx.strokeStyle = color;
    ctx.lineWidth = style === 'dotted' ? 2.2 : 2.5;
    ctx.setLineDash(style === 'dotted' ? [2, 4] : style === 'dashed' ? [6, 4] : []);
    ctx.strokeText('\ue55d', size / 2, size / 2);
  }

  // Remove glow for future icons
  ctx.shadowBlur = 0;
  ctx.setLineDash([]);

  return canvas;
}


  createHistoricalNavigationIcon(color: string): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const size = 24; // Material icon default size
    canvas.width = size;
    canvas.height = size;
    
    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;
    
    // Set up the canvas for material icons
    ctx.font = '24px Material Icons';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    ctx.lineWidth = 3;
    ctx.strokeStyle = color;
    ctx.strokeText('\ue55d', size / 2, size / 2);
    
    return canvas;
  }

    getLegend(operator: any,type:any) {
      this.selectedOperator = operator;
      if (operator === OPERATORS.SPIRE) {
        this.shipTypes = this.utilsService.getShips();
        if(type === 0) this.refreshData = false;
        else this.refreshData = true;
        this.shipTypes = this.shipTypes
        .sort((a, b) => {
          if (a.type === 'OTHER') return 1;  
          if (b.type === 'OTHER') return -1;
          return a.type.localeCompare(b.type); 
        });     
      }
    }

  openFilterPopup() {
    const spireVessels = this.spireJsonData;
    let updatedFeatures = this.displayedSpireData;

    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: { type: 'aisVessel', vesselData: spireVessels, filterObject: this.filterObject,
        refreshData: false, currentUser: this.currentUser
       }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.filterObject = result;
        const filters: FilterCriteria = {
          destination: result.destination,
          flag: result.flag,
          length: result.length,
          isGreater: result.isGreater,
          vesselType: result.vesselType,
          vesselSpeed: result.vesselSpeed,
          isSpeedGreater: result.isSpeedGreaterThan,
          vesselName: result.vesselName,
          MMSI: result.MMSI,
          IMO: result.IMO
        };

        let filteredFeatures = this.applyVesselFilters(spireVessels, filters);
        updatedFeatures.features = filteredFeatures;

        if (filteredFeatures.length === 0) {
          const message = `There are no vessels meeting the search criteria.`;
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        } else {
          this.removeDataSourceByName('spireDataSource')
          this.updateSpire(updatedFeatures);
          this.vesselFilter = true;
        }
      }
    });
  }

  applyVesselFilters(data: any, filterCriteria: FilterCriteria) {
    return data.features.filter(feature => {
      const properties = feature.properties;

      // Check all filter criteria
      for (const [key, value] of Object.entries(filterCriteria)) {
        if (value === undefined || value === null || value === "") continue; // Skip empty values

        switch (key) {
          case 'destination':
            if (properties.Destination !== value) return false;
            break;

          case 'flag':
            if (properties.Flag !== value) return false;
            break;

          case 'vesselType':
            if (value === 'OTHER') {
              if (properties['Ship Type'] !== null && properties['Ship Type'] !== 'OTHERS') {
                return false;
              }
            } else if (properties['Ship Type'] !== value) {
              return false;
            }
            break;

          case 'length':
            if (properties['Vessel Length'] === 'N/A' || properties['Vessel Length'] === null || properties['Vessel Length'] === undefined) {
              return false;
            }
            const vesselLength = Number(properties['Vessel Length']); // Convert to number
            const filterLength = Number(value); // Convert filterCriteria.length to number

            if (!isNaN(vesselLength) && !isNaN(filterLength)) { // Ensure it's a valid number before comparison
              if (filterCriteria.isGreater) {
                if (vesselLength <= filterLength) return false;
              } else {
                if (vesselLength >= filterLength) return false;
              }
            }
            break;

            case 'vesselSpeed':
              if (properties.Speed === 'N/A' || properties.Speed === null || properties.Speed === undefined) {
                return false;
              }
              const speed = Number(properties.Speed); // Convert to number
              const filterValue = Number(value); // Convert filterCriteria.length to number
  
              if (!isNaN(speed) && !isNaN(speed)) { // Ensure it's a valid number before comparison
                if (filterCriteria.isSpeedGreater) {
                  if (speed <= filterValue) return false;
                } else {
                  if (speed >= filterValue) return false;
                }
              }
              break;

          case 'vesselName':
            if (properties.Name !== value) return false;
            break;

          case 'MMSI':
            if (properties.MMSI !== value) return false;
            break;

          case 'IMO':
            if (properties.IMO !== value) return false;
            break;  
        }
      }

      return true;
    });
  }

  // Function to update the Cesium map with filtered GeoJSON data
  updateSpire(filteredGeoJson: any) {
    const selectData = Cesium.GeoJsonDataSource.load(filteredGeoJson);
    selectData.then((dataSource: CustomGeoJsonDataSource) => {
      dataSource.sensorId = this.spireSensorId;
      dataSource.name = 'spireDataSource';
      const entities = dataSource.entities.values;
      for (let j = 0; j < entities.length; j++) {
        const entity = entities[j] as CustomEntity;
        entity.name = 'vessel';
        entity.type = 'spire';

        // Get ship type from properties
        if (entity.properties) {
          const shipType = entity.properties['Ship Type'].getValue() || 'OTHER';
          const iconColor = this.utilsService.getShipColor(shipType);
          const course = entity.properties['Course']?.getValue(); // Get the course value

          // Create the icon with the appropriate color
          const iconCanvas = this.createNavigationIcon(iconColor);

          entity.billboard = new Cesium.BillboardGraphics({
            image: iconCanvas.toDataURL(),
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 24,
            height: 24,
            rotation: course ? Cesium.Math.toRadians(-course) : 0, // Negative because Material Icon 'navigation' points up by default
            pixelOffset: new Cesium.Cartesian2(0, 0),
            verticalOrigin: Cesium.VerticalOrigin.CENTER,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER
          });
        }
      }

      this.viewer.dataSources.add(dataSource);
      this.viewer.scene.globe.depthTestAgainstTerrain = false;
      this.viewer.flyTo(dataSource, { duration: 3 });
    });
  }

  clearFilter() {
    this.removeDataSourceByName('spireDataSource')
    this.updateSpire(this.spireJsonData);
    this.filterObject = null;
  }

  clearFilterData() {
    this.vesselFilter = false;
    this.spireJsonData = null;
    this.spireSensorId = null;
    this.displayedSpireData = null;
    this.filterObject = null;
  }

  checkForRefreshData(operator) {
    const exists = this.viewer.dataSources._dataSources.some(
      (ds: any) => ds.name === 'refreshDataSource' && ds.type === operator
    );

    if (!exists) this.refreshFilterObject = undefined;

    return exists;
  }

  filterHistoricalData(operator) {
    const uniqueFlags = new Set<string>();
    const uniqueDestination = new Set<string>();
    const uniquevesselTypes = new Set<string>();
    const uniqueIMONumbers = new Set<string>();
    const uniqueMMSIList = new Set<string>();
    const uniquevesselNames = new Set<string>();

    // Iterate over all data sources in Cesium
    this.viewer.dataSources._dataSources.forEach((ds: any) => {
      if (ds.name === 'refreshDataSource' && ds.type === operator) {
        ds.entities.values.forEach((entity: any) => {
          const flag = entity.properties?.Flag?.getValue(); // Get flag value
          const destination = entity.properties?.Destination?.getValue(); // Get destination value
          const vesselType = entity.properties['Ship Type']?.getValue();
          const MMSI = entity.properties?.MMSI?.getValue();
          const vesselName = entity.properties?.Name?.getValue();
          const IMO = entity.properties?.IMO?.getValue();

          if (flag && flag !== 'N/A') {
            uniqueFlags.add(flag); // Add unique flags
          }

          if (destination && destination !== 'N/A') {
            uniqueDestination.add(destination); // Add unique destination
          }

          if (vesselType && vesselType !== 'N/A') {
            uniquevesselTypes.add(vesselType); // Add unique vesselType
          }

          if (IMO && IMO !== 'N/A') {
            uniqueIMONumbers.add(IMO);
          }

          if (MMSI && MMSI !== 'N/A') {
            uniqueMMSIList.add(MMSI);
          }

          if (vesselName && vesselName !== 'N/A') {
            uniquevesselNames.add(vesselName);
          }
        });
      }
    });

    // Convert Set to an array (optional)
    const flagArray = Array.from(uniqueFlags);
    const detinationArray = Array.from(uniqueDestination);
    const vesselTypeArray = Array.from(uniquevesselTypes);
    const IMONumbers = Array.from(uniqueIMONumbers);
    const MMSIList = Array.from(uniqueMMSIList);
    const vesselNames = Array.from(uniquevesselNames);

    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: { type: 'aisVessel', refreshData: true, flagArray: flagArray,
        detinationArray: detinationArray, filterObject: this.refreshFilterObject,
        vesselTypeArray: vesselTypeArray, IMONumbers, MMSIList, vesselNames, currentUser: this.currentUser
       }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let hasVisibleEntities = false;
        let currentVisibleEntities: any[] = [];

        this.refreshFilterObject = result;
        const filters: FilterCriteria = {
          destination: result.destination,
          flag: result.flag,
          length: result.length,
          isGreater: result.isGreater,
          vesselType: result.vesselType,
          vesselSpeed: result.vesselSpeed,
          isSpeedGreater: result.isSpeedGreaterThan,
          vesselName: result.vesselName,
          MMSI: result.MMSI,
          IMO: result.IMO
        };
    
        // Iterate over all data sources
        this.viewer.dataSources._dataSources.forEach((ds: any) => {
          if (ds.name === 'refreshDataSource' && ds.type === operator) {
            ds.entities.values.forEach((entity: any) => {
              entity.show = this.checkEntityExist(entity,filters);
              if (entity.show) {
                hasVisibleEntities = true; // At least one entity is visible
                currentVisibleEntities.push(entity); // Store visible entities
              }
            });
          }
        });

        if (hasVisibleEntities) {
          this.lastVisibleEntities = [...currentVisibleEntities];
        } else {
          const message = `There are no vessels meeting the search criteria.`;
          this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');

          if(this.lastVisibleEntities?.length === 0) {
            this.viewer.dataSources._dataSources.forEach((ds: any) => {
              if (ds.name === 'refreshDataSource' && ds.type === operator) {
                ds.entities.values.forEach((entity: any) => {
                  entity.show = true;
                });
              }
            });
          } else {
            this.viewer.dataSources._dataSources.forEach((ds: any) => {
              if (ds.name === 'refreshDataSource' && ds.type === operator) {
                ds.entities.values.forEach((entity: any) => {
                  entity.show = this.lastVisibleEntities.includes(entity);
                });
              }
            });
          }
       
        }
      }
    }); 
  }

  resetRefreshFilter(operator) {
    this.viewer.dataSources._dataSources.forEach((ds: any) => {
      if (ds.name === 'refreshDataSource' && ds.type === operator) {
        ds.entities.values.forEach((entity: any) => {
          entity.show = true;
        });
      }
    });
    this.refreshFilterObject = undefined;
  }

  checkEntityExist(entity,filters) {
    let isVisible = true;

    const flag = entity.properties?.Flag?.getValue();
    const destination = entity.properties?.Destination?.getValue();
    const vesselLength = Number(entity.properties?.['Vessel Length']?.getValue()); // Convert length to number
    const vesselType = entity.properties?.['Ship Type']?.getValue();
    const MMSI = entity.properties?.MMSI?.getValue();
    const vesselName = entity.properties?.Name?.getValue();
    const IMO = entity.properties?.IMO?.getValue();

    let speed;
    let speedValue = entity.properties?.Speed?.getValue();
    if (entity.properties?.Speed?.getValue() !== 'N/A' && entity.properties?.Speed?.getValue() !== null && entity.properties?.Speed?.getValue() !== undefined) {
      speed = Number(entity.properties?.Speed?.getValue()); // Convert speed to number
    }

    // Apply Flag filter (Check for exact match)
    if (filters.flag) {
      isVisible = isVisible && flag === filters.flag;
    }

    // Apply Destination filter (Check for exact match)
    if (filters.destination) {
      isVisible = isVisible && destination === filters.destination;
    }

    if (filters.vesselType) {
      isVisible = isVisible && (vesselType === filters.vesselType || (filters.vesselType === 'OTHER' && vesselType === null));
    }

    if (filters.MMSI) {
      isVisible = isVisible && MMSI === filters.MMSI;
    }

    if (filters.IMO) {
      isVisible = isVisible && IMO === filters.IMO;
    }

    if (filters.vesselName) {
      isVisible = isVisible && vesselName === filters.vesselName;
    }

    // Apply Length filter
    if (!isNaN(filters.length) && !isNaN(vesselLength)) {
      if (filters.isGreater) {
        isVisible = isVisible && vesselLength > filters.length;
      } else {
        isVisible = isVisible && vesselLength < filters.length;
      }
    }

    // Apply Speed filter
    if (!isNaN(filters.vesselSpeed) && typeof filters.vesselSpeed === 'number') {      
      if (!isNaN(speed)) {
        if (filters.isSpeedGreater) {
          isVisible = isVisible && speed > filters.vesselSpeed;
        } else {
          isVisible = isVisible && speed < filters.vesselSpeed;
        }
      } else if (speedValue === 'N/A') {
        isVisible = false;
      }
  
    }

    return isVisible;
  }

  filterClosestTimestamp(history: any[], start: string, end: string): any {
    // Convert start and end times to UTC timestamps
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
  
    // Filter timestamps within the range
    const filtered = history
      .map(item => ({
        ...item,
        timestamp: new Date(item.name).getTime(), // Convert to UTC timestamp
      }))
      .filter(item => item.timestamp >= startTime && item.timestamp <= endTime);
  
    // Find the closest timestamp to the end time
    if (filtered.length === 0) return null; // No results in the range
  
    return filtered.reduce((closest, item) =>
      Math.abs(item.timestamp - endTime) < Math.abs(closest.timestamp - endTime) ? item : closest
    );
  }

  applyFilter(selectedDates,sensor) {
    if (!selectedDates.startDateTime || !selectedDates.endDateTime) {
      return;
    }    
  
    const startTimestamp = selectedDates.startDateTime;
    const endTimestamp = selectedDates.endDateTime;
    const result = this.filterClosestTimestamp(sensor.refreshHistory, startTimestamp, endTimestamp);
    if (result) {      
      let currentEvent = {
        checked : true
       };
      this.displayRefreshData(currentEvent,sensor.scenes[0],sensor, 'display', result);
    } else {
      const message = `There are no vessels meeting the search criteria.`;
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    
  }

  filterByDateTime(sensor) {
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%', backdropClass: 'blurr',
      disableClose: true,
      data: {type:'refreshDateFilter', refreshHistory: sensor.refreshHistory, currentUser: this.currentUser}
    });
    dialogRef.afterClosed().subscribe((result) => {         
      if (result) {
        this.applyFilter(result,sensor);
      } else {
      }
    });
   }
  
   resetRefreshData(sensor) {
    if (sensor.refreshHistory) {
      for (const [index, history] of sensor.refreshHistory.entries()) {
        history.checked = false;
        this.removeDataSourceById("aisData", history.refreshId);
        this.removeEntitiesByName(history.refreshId);
        if(this.isObservation(sensor)) {
          const updated = { ...this.selectedHistory };
          delete updated[history.refreshId];
          this.selectedHistory = updated;
        }
      }
    }
   }

 resetDownload() {
  this.downloadService.unsubscribeProgress();
  this.spinnerService.hide();
  this.mapLoad = false;
  this.freeze = false;
 }

showDownloadError() {
  const message = 'Something interrupted your previous download and prevented its completion. Please download again.';
  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  this.resetDownload(); 
}

showNoPreview(event, scenes?: any) {
  if (scenes?.isNonImagery ) {
    if (scenes.operatorKey === 'USL'&& !scenes.s_band && !scenes.x_band) 
      this.handleOptionError(event, `We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.`);
    else
      this.handleOptionError(event, `The observation delivered can only be downloaded now and cannot be visualised on the map here.`);
  }else if(!scenes?.isNonImagery) {
    this.handleOptionError(event, `The imagery delivered can only be downloaded now and cannot be visualised on the map here.`);
  }
}

getMessage() {
  let message = 'The scene does not have metadata mapped. However, full metadata is included in the zip with the download.'
  this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
}
  shouldShowRawIqRow(scene) {
    return this.currentUser?.raw_iq_approved && scene.operatorKey == OPERATORS.LBAND;
  }

  getAvailableSignals(scene: any): string {
    if (scene?.signalOfInterest?.length) {
      return scene.signalOfInterest
        .map((s: any) => s.product)
        .filter((p: string) => !!p) // removes falsy values like undefined/null
        .join(', ');
    }
    return scene?.name || 'N/A';
  }

  isGrayedOut(scene: any, sensor: any): boolean {
    if (!scene?.id) return true;
    if (scene?.status === 'failed') return true;
    if (sensor?.status === 'archived') return true;
    if (sensor?.status === 'restored' && sensor?.restoreOption === 'view') return true;
    return false;
  }

  hasAnnotationFeature(): boolean {
    return this.hasFeature(ANNOTATION);
  }
  hasCollectionPointTaskingFeature(): boolean {
     return this.hasFeature(POINT_TASKING);
  }
   hasFeature(featureKey: string): boolean {
    return this.currentUser?.planDetails?.features?.some(feature => 
      feature.key.toLowerCase() === featureKey.toLowerCase()
    ) || false;
  }

  getPreviousVesselDate(date: string): string | null {
    const dates = Object.keys(this.vesselData);
    const index = dates.indexOf(date);

    if (index === -1) {
      return null;
    }

    if (index === 0) {
      return 'baseDate';
    }

    return dates[index - 1];
  }

  groupVesselsByDatePredict(dateRangeArray, data: any = false) {
    this.vesselData = {};
    this.dateRangeArray = dateRangeArray;
    this.sliderShow = true;

    // Determine if we are in time-only mode (e.g., ["09:00", "10:00"])
    const isTimeOnly = this.dateRangeArray.every(d => d.length === 5 && d.includes(':'));
    const isDateOnly = this.dateRangeArray.every(d => d.length === 10 && d.includes('-'));
    let predictData:any  = '';
    if (data){
      predictData = data;
    } else {
      predictData = this.historicalVesselData;
    }
    for (const range of this.dateRangeArray) {
      this.vesselData[range] = predictData.filter(data => {
        const timestamp = new Date(data.location_time);
        const isoDate = timestamp.toISOString().split('T')[0];
        const isoHour = timestamp.toISOString().split('T')[1].substring(0, 5); // "HH:MM"

        if (isTimeOnly) {
          // same-day hourly grouping → match by time
          return isoHour === range;
        } else if (isDateOnly) {
          // multi-day grouping → match by date
          return isoDate === range;
        } else {
          // mixed/ISO → fallback to previous logic
          return timestamp.toISOString().startsWith(range);
        }
      });
    }
  }

  getMapIcon(vesselData: any, color: string = 'Yellowgreen') {
    let iconCanvas, iconUrl;
    let rotation = 0;
    iconCanvas = vesselData[0]?.course ? this.createNavigationIcon(color, vesselData[0]?.course ? 'filled' : 'dotted', true) : createCircleIcon(color, 'filled', true);
    iconUrl = iconCanvas.toDataURL();
    return iconUrl;
  }

  displayPastPrediction(date, vesselData: any) {
    if (this.currentDataSources[date]) {
      this.viewer.dataSources.remove(this.currentDataSources[date]);
    }
    const dataSource = new Cesium.CustomDataSource('prediction');

    let rotation = 0;
    let mapIcon = this.getMapIcon(vesselData);
    const previousDate = this.getPreviousVesselDate(date);
    if (previousDate === 'baseDate') {
      this.predictionLastPoint = {
        lat: Number(this.pastVesselData.location.LAT),
        lon: Number(this.pastVesselData.location.LON),
      };
    }
    vesselData.forEach((item, index) => {
    let currentLat = Number(item.location.LAT);
    let currentLon = Number(item.location.LON);
    if (!this.predictionLastPoint) {
      this.predictionLastPoint = { lat: currentLat, lon: currentLon };
      return;
    }
    const prevLat = this.predictionLastPoint.lat;
    const prevLng = this.predictionLastPoint.lon;
    const bearing = this.bearingDeg(prevLat, prevLng, currentLat, currentLon);
    rotation = item?.course? item?.course+ 90 : Cesium.Math.toRadians(bearing+90);
    this.predictionLastPoint = { lat: currentLat, lon: currentLon };
    const entity = dataSource.entities.add({
          position: Cesium.Cartesian3.fromDegrees(currentLon, currentLat),
          billboard: {
            image: mapIcon,
            width: 30,
            height: 35,
            rotation: rotation,
            verticalOrigin: Cesium.VerticalOrigin.CENTER,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          },
          properties: {
          step: item.locations,
          timestamp: item.location_time,
          lon: item.location.LON,
          lat: item.location.LAT
        }
        });
        (entity as any).isPrediction = true;
      });

      this.viewer.dataSources.add(dataSource);
      this.viewer.flyTo(dataSource, { duration: 2 });
      this.currentDataSources[date] = dataSource;
      this.drawPredictionPath(date, vesselData);
      this.showPredictTooltip(vesselData, 'pastPrediction');
      
  }
 
  drawPredictionPath(date: string, vesselData: any, color: string = 'Yellowgreen') {
    const positions = vesselData
      .filter((v: any) => v?.location?.LAT && v?.location?.LON)
      .map((v: any) => Cesium.Cartesian3.fromDegrees(v.location.LON, v.location.LAT));

    // if (this.lastPosition && positions.length > 0) {
    //   positions.unshift(this.lastPosition);
    // }

    // if (positions.length > 0) {
    //   this.lastPosition = positions[positions.length - 1];
    // }
    // Use previous stored end point if exists
    const prevDateIndex = this.dateRangeArray.indexOf(date) - 1;
    if (prevDateIndex >= 0) {
      const prevDate = this.dateRangeArray[prevDateIndex];
      if (this.pathMemory[prevDate]) {
        positions.unshift(this.pathMemory[prevDate]);
      }
    }

    // Store last point for future connection
    if (positions.length > 0) {
      this.pathMemory[date] = positions[positions.length - 1];
    }


    if (positions.length < 2) return;

    //Remove old path if it exists
    if (this.currentDataSources[`${date}_path`]) {
      this.viewer.dataSources.remove(this.currentDataSources[`${date}_path`]);
    }

    const pathSource = new Cesium.CustomDataSource(`predictionPath_${date}`);

    //Create a crisp arrow pattern texture
    const arrowCanvas = document.createElement('canvas');
    arrowCanvas.width = 256;
    arrowCanvas.height = 64;

    const ctx = arrowCanvas.getContext('2d')!;
    ctx.clearRect(0, 0, arrowCanvas.width, arrowCanvas.height);

    // Arrow style
    ctx.strokeStyle = color;
    ctx.lineWidth = 6;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';

    // Draw arrow only on left half
    for (let i = 0; i < arrowCanvas.width; i += 128) {
      ctx.beginPath();
      ctx.moveTo(i + 10, 32);   // tail
      ctx.lineTo(i + 90, 32);   // shaft
      ctx.lineTo(i + 70, 16);   // upper wing
      ctx.moveTo(i + 90, 32);
      ctx.lineTo(i + 70, 48);   // lower wing
      ctx.stroke();
    }
    //let repeatX = this.getRepeat(positions)
    let repeatX = 10;
    //Create repeating texture material
    const arrowColor = Cesium.Color.fromCssColorString(color).withAlpha(1.0);
    // const arrowMaterial = new Cesium.ImageMaterialProperty({
    //   image: arrowCanvas,
    //   repeat: new Cesium.Cartesian2(repeatX, 1), // smaller number = fewer, larger arrows
    //   color: arrowColor,
    //   transparent: true,
    // });
    const dashMaterial = new Cesium.PolylineDashMaterialProperty({
      color: Cesium.Color.fromCssColorString(color),
      dashLength: 20, // increase to make dash longer
      gapColor: Cesium.Color.TRANSPARENT,
    });

    //Add the polyline entity with smooth arrows
    const entity = pathSource.entities.add({
      name: `Path_${date}`,
      polyline: {
      positions,
      width: 4, // thicker line helps the arrow texture show clearly
      material: dashMaterial,
      clampToGround: false,
    },
    });
    //Add to viewer
    this.viewer.dataSources.add(pathSource);
    this.currentDataSources[`${date}_path`] = pathSource;
  }

  getRepeat(positions: Cesium.Cartesian3[]): number {
    let totalDistance = 0;
    for (let i = 1; i < positions.length; i++) {
      const carto1 = Cesium.Cartographic.fromCartesian(positions[i - 1]);
      const carto2 = Cesium.Cartographic.fromCartesian(positions[i]);
      const geodesic = new Cesium.EllipsoidGeodesic(carto1, carto2);
      totalDistance += geodesic.surfaceDistance;
    }
    // Adjust scaling factor to your liking
    const baseArrowLength = 500; // one arrow every 50 km
    const repeatX = Math.max(totalDistance / baseArrowLength, 1);
    return repeatX;
  }

  showPredictTooltip(vesselData, picked:string) {
    if (this.prediction || this.pastPrediction) {
      if (this.handlers) {
        this.handlers.destroy();
      }
      this.handlers = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
      let stepLocations = vesselData[0]?.locations;
      this.handlers.setInputAction((movement: any) => {
      const tooltip = document.getElementById('feedTooltip');
      if (!tooltip) return;

      // Fix: handle undefined endPosition
      const position = movement.endPosition || movement.position;
      if (!position) return;

      const pickedObjects = this.viewer.scene.drillPick(position);
      tooltip.style.display = 'none';

      if (!pickedObjects || pickedObjects.length === 0) return;

      //Find correct entity depending on mode
      let pickedPrediction:any = '';
      if (picked === 'pastPrediction') {
        pickedPrediction = this.pastPrediction;
      } else {
        pickedPrediction = this.prediction;
      }
      const pickedEntity = pickedObjects
        .map((p: any) => p.id as Cesium.Entity)
        .find((entity: any) =>
          pickedPrediction ? entity.isPrediction : !entity.isPrediction
        );
      const pickedObject = this.viewer.scene.pick(movement.endPosition);
      const entity = pickedObject?.id;  

      if ((!pickedEntity || !pickedEntity.properties) && !entity) return;
      
      if (pickedEntity?.properties && pickedEntity?.properties['locations']) {
      const step = Number(pickedEntity.properties['locations']?.getValue?.()) - 1;
      const timestamp = pickedEntity.properties['timestamp']?.getValue?.() ?? '';
      const lat = pickedEntity.properties['lat']?.getValue?.() ?? '';
      const lon = pickedEntity.properties['lon']?.getValue?.() ?? '';

      tooltip.innerHTML = `
        <strong>Locations:</strong> ${step}<br>
        <strong>Timestamp(UTC):</strong> ${timestamp}<br>
        <strong>Lng:</strong> ${lon}<br>
        <strong>Lat:</strong> ${lat}<br>
      `;
      tooltip.style.fontSize = '15px';
      tooltip.style.fontFamily = '"Barlow", sans-serif';
      tooltip.style.lineHeight = '1.8';
      tooltip.style.display = 'block';
      } else {
        let selectedEntity: any = '';
        if (pickedEntity)
          selectedEntity = pickedEntity
        else if (entity)
          selectedEntity = entity;
        let content = '';
        selectedEntity?.properties.propertyNames.forEach(propertyName => {     
          let formattedName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
          let value = selectedEntity.properties[propertyName];
          if (propertyName.toLowerCase() === 'lon') {
            formattedName = 'Lng';
          } else if (propertyName.toLowerCase() === 'step') {
            formattedName = 'Locations';
            value = Number(value.getValue()) - 1;
          } else if (propertyName.toLowerCase() === 'timestamp') {
            formattedName = 'Timestamp(UTC)';
          }
          content += `<strong>${formattedName} : </strong> ${value}<br>`;
        });
        tooltip.innerHTML = content;
        tooltip.style.fontSize = '15px';
        tooltip.style.fontFamily = 'Barlow", sans-serif';
        tooltip.style.lineHeight = '1.8';
        tooltip.style.display = 'block';
      }

      // Use your existing position handler
      this.tooltipHandlers(tooltip, movement);
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }
  }

  displayPredictionData(date, vesselData: any) {

    // Prediction Mode
    if (this.prediction === true) {
      let color = this.predictedVesselData.color?? 'Yellowgreen';

     
      //let liveVesselTimestamp = this.predictedVesselData.timestamp;

      if (this.currentDataSources[date]) {
        this.viewer.dataSources.remove(this.currentDataSources[date]);
      }
    
      const dataSource = new Cesium.CustomDataSource('prediction');
      let previousLiveLat: any;
      let prevousLiveLon: any;
      vesselData.forEach((item, index) => {
        const currLat = Number(item.location.LAT);
        const currLng = Number(item.location.LON);
        let rotation = 0;
        let previousDate = this.getPreviousVesselDate(date);

        if ( previousDate === 'baseDate'){
          let liveVesselLng = Number(this.predictedVesselData.lng);
          let liveVesselLat = Number(this.predictedVesselData.lat);
          let firstPoint = {
            location: {
              LAT: liveVesselLat,
              LON: liveVesselLng
            }
          };

          // Take current point
          let secondPoint = {
            location: {
              LAT: Number(item.location.LAT),
              LON: Number(item.location.LON)
            }
          };

          // Build 2-point array
          let pathPoints = [firstPoint, secondPoint];

          // Now it has 2 points → path draws
          this.drawPredictionPath(date, pathPoints, color);
          this.predictionLastPoint = {lat: liveVesselLat, lon: liveVesselLng};
          previousLiveLat = liveVesselLat;
          prevousLiveLon = liveVesselLng
        } else if (previousDate !== null ) {
          this.drawPredictionPath(date, vesselData, vesselData[0]?.locations === 7 ?'Yellowgreen' : color);
          previousLiveLat = this.predictionLastPoint?.lat;
          prevousLiveLon = this.predictionLastPoint?.lon;
        }
        let mapIcon = this.getMapIcon(vesselData, vesselData[0]?.locations === 7 ?'Yellowgreen' : color);
        const bearing = this.bearingDeg(previousLiveLat, prevousLiveLon, currLat, currLng);
        rotation = Cesium.Math.toRadians(bearing + 90);
        const entity = dataSource.entities.add({
          position: Cesium.Cartesian3.fromDegrees(item.location.LON, item.location.LAT),
          billboard: {
            image: mapIcon,
            width: 40,
            height: 35,
            rotation: rotation,
            //alignedAxis: Cesium.Cartesian3.ZERO,
            alignedAxis: Cesium.Cartesian3.UNIT_Z,
            color: Cesium.Color.fromCssColorString(vesselData[0]?.locations === 7 ?'Yellowgreen' : color),
            verticalOrigin: Cesium.VerticalOrigin.CENTER,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          },
          properties: {
          locations: item.locations,
          timestamp: item.location_time,
          lon: item.location.LON,
          lat: item.location.LAT
        }
        });
        (entity as any).isPrediction = true;
        this.predictionLastPoint ={lat: currLat, lon: currLng};
      })

      this.viewer.dataSources.add(dataSource);
      this.viewer.flyTo(dataSource, { duration: 2.5 });
      this.currentDataSources[date] = dataSource;

      // Tooltip section
      if (!this.handlers) {
        this.handlers = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
      } else {
        this.handlers.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      }
      this.showPredictTooltip(vesselData, 'isPrediction')
    } 
  }

  // Bearing (initial course) in degrees, clockwise from North
  // bearingDeg(lat1: number, lon1: number, lat2: number, lon2: number): number {
  //   const φ1 = Cesium.Math.toRadians(lat1);
  //   const φ2 = Cesium.Math.toRadians(lat2);
  //   const Δλ = Cesium.Math.toRadians(lon2 - lon1);
  
  //   const y = Math.sin(Δλ) * Math.cos(φ2);
  //   const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
  //   const θ = Math.atan2(y, x); // -π..π, counter-clockwise from East
  //   const deg = (Cesium.Math.toDegrees(θ) + 360) % 360; // 0..360, clockwise from North
  //   return deg;
  // }

  bearingDeg(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const toRad = (v: number) => (v * Math.PI) / 180;

  const dLon = toRad(lon2 - lon1);
  const y = Math.sin(dLon) * Math.cos(toRad(lat2));
  const x =
    Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
    Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLon);

  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
  }

  generateSliderDateRangePredict(end: string, start: string) {
    this.dateRangeArray = [];
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate.getTime() - startDate.getTime();
    const diffMins = diffMs / (1000 * 60);
    const diffHours = diffMs / (1000 * 60 * 60);
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    const dateArray: string[] = [];
    const sameDay = startDate.toISOString().split('T')[0] === endDate.toISOString().split('T')[0];

  if (sameDay) {
  const step = 2 * 60 * 1000;
  let count = 0;
  let time = startDate.getTime();

  while (time <= endDate.getTime() && count < 5) {
    const dt = new Date(time);

    const hh = String(dt.getUTCHours()).padStart(2, '0');
    const mm = String(dt.getUTCMinutes()).padStart(2, '0');

    dateArray.push(`${hh}:${mm}`);
    time += step;
    count++;
   }

  const endDt = new Date(endDate.getTime());
  const endHh = String(endDt.getUTCHours()).padStart(2, '0');
  const endMm = String(endDt.getUTCMinutes()).padStart(2, '0');

  dateArray.push(`${endHh}:${endMm}`);
  }
    return dateArray;
  }

  getGroupedVessels (sensor, taskId) {
    let getVessels = this.taskid === taskId && sensor.pastPrediction && Object.keys(sensor.pastPrediction).length > 0 && this.isVesselInfoService(sensor.InfoServices);
    if (getVessels) {
      this.groupedVessels = sensor.pastPrediction;
      return true;
    } else {
      this.groupedVessels = {};
      return false;
    }
  }
  displayPastPredicitionList (predictedId, date, type, sensor, scene) {
    this.progressing = false;   
    this.spinnerService.show();
    this.mapLoad = true;
    this.previousIndex = -1;
    this.previousLat = null;
    this.previousLon = null;
    if (this.selectedPredictionId === predictedId) {
      this.selectedPredictionId = null;
      this.clearSilder();
      this.resetPreviousEntity();
      this.spinnerService.hide();
      this.mapLoad = false;
      this.freeze = false;
      this.viewer.camera.flyHome(2); 
      return;
    }

    if (this.selectedPredictionId && this.selectedPredictionId !== predictedId) {
      this.clearSilder();
      this.resetPreviousEntity();
      this.viewer.camera.flyHome(2); 
    }
    this.selectedPredictionId = predictedId;
    let sensorId = sensor.id;
    let taskId = this.collection?.taskId;
    const predictData = {
        sensorId: sensorId,
        predictionId: predictedId,
        taskid: taskId,
        action: type
    }
    this.apiService.getPastPredictedData(predictData).subscribe((res: any) => {

    if (res?.msg === 'failed') {
      const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      this.mapLoad = false;
      this.freeze = false;
    } else {
      this.httpClient.get<any>(res?.result?.imageUrl).subscribe((data) => {
        // const updatedAis = this.convertToGeoJSON(data, item);
        this.mapLoad = false;
        this.freeze = false;
        const parsedData = JSON.parse(data);
        if (type === 'display') {
          let result = this.setVesseDataForPrediction(parsedData);
          const startTime = result[0].location_time;
          const endTime = result[result.length - 1].location_time;
          let dateRangeArray = this.generateSliderDateRangePredict(endTime, startTime); // Reusable now
          this.groupVesselsByDatePredict(dateRangeArray, result);
          this.sliderView = false;
          this.pastPrediction = true;

        }
      });
      }
    });
  }
  
  isFeedBased(InfoService) {
    if (InfoService?.ais_observation || InfoService?.rf_observation) {
      return false;
    }
    return true;
  }

  isVesselInfoService(infoService: any[]): boolean {
    if (infoService?.length > 0 && infoService[0]?._id) {
      const config = feedsConfig[infoService[0]._id];
      if (config && config.type === VESSEL_PREDICTION) {
        return true;
      }
    }
    return false;
  }

  downloadPastPredicitionList(predictedId, date, type, sensor, scene) {
    let sensorId = sensor.id;
    let taskId = this.collection?.taskId;
    const predictData = {
        sensorId: sensorId,
        predictionId: predictedId,
        taskid: taskId,
        action: type
    }
    this.apiService.getPastPredictedData(predictData).subscribe((res: any) => {
      if (res?.msg === 'failed') {
        const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        this.spinnerService.hide();
        this.mapLoad = false;
        this.freeze = false;
      } else {
        this.httpClient.get<any>(res?.result?.imageUrl).subscribe((data) => {
          const parsedData = JSON.parse(data);
          const sensorObj = { progress: 100, taskId, sensorId: sensorId, sceneId: scene.id, download: true, action: 'aisDownload' };
          this.downloadService.setProgress(sensorObj);
          const blob = new Blob([JSON.stringify(parsedData)], { type: 'application/json' });
          const url = window.URL.createObjectURL(blob);
          const fileName = res?.result?.imageUrl.split('/').pop().split('?')[0];
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();

          // Clean up
          window.URL.revokeObjectURL(url);
          this.progress = 0;
          this.spinnerService.hide();
          this.freeze = false;
          this.disable = false;
        });
      }
    });
  }

  removePredictionData(date: string) {
    const pathKey = `${date}_path`;
    if (this.currentDataSources[pathKey]) {
      this.viewer.dataSources.remove(this.currentDataSources[pathKey]);
      delete this.currentDataSources[pathKey];
    }

    // Remove stored chain continuity
    delete this.pathMemory[date];
    }

  unSubscribeAPI() {
    // If already fetching prediction → cancel it
    if (this.predictionSubscription) {
      this.predictionSubscription.unsubscribe();
      this.predictionSubscription = null;
      this.progressing = false;
    }
  }
  setVesseDataForPrediction(vesselData, type: string = 'pastPrediction') {
    if (type === 'livePrediction') {
      this.livePredictedVesselData = vesselData?.vessel_predict[0];
    } else {
      this.pastVesselData = vesselData?.vessel_predict[0];
    }
    if(type === 'pastPrediction') {
    return vesselData?.vessel_predict;
    } else {
      return vesselData?.vessel_predict.slice(1);
    }
  }
}
 


